import { totemPresenceEsES } from "./totem-presence-messages";
import { giftPreflightEsES } from "./gift-preflight-messages";
import { trailChatV3EsES } from "./trail-chat-v3-messages";
import { giftRefundEsES } from "./gift-refund-messages";
import { roomToolsEsES } from "./room-tools-messages";
import { reportsDashboardEsES } from "./reports-dashboard-messages";

export const esESMessages = {
  totemPresence: totemPresenceEsES,
  quizReview: {
  "title": "Revisión con Jev",
  "scope": "Comprueba la claridad, las alternativas que se confunden y las pistas que revelan la respuesta antes de publicar.",
  "disclaimer": "La revisión es opcional y solo analiza el texto. Los indicios pueden fallar; comprueba el contenido y las respuestas correctas antes de publicar.",
  "button": "Revisar quiz",
  "loading": "Revisando quiz…",
  "retry": "Intentar de nuevo",
  "again": "Revisar de nuevo",
  "summary": "Preguntas: {{attention}} con indicios · {{uncertain}} no concluyentes · {{clear}} sin indicios detectados",
  "question": "Pregunta {{number}}",
  "media": "Las imágenes, los vídeos y otros archivos adjuntos no se han evaluado. Comprueba la pregunta junto con su contenido multimedia.",
  "criteria": {
    "clarity": "Claridad del enunciado",
    "answerOverlap": "Alternativas que se confunden",
    "answerLeak": "Pistas de la respuesta"
  },
  "status": {
    "attention": "Atención",
    "uncertain": "No concluyente",
    "clear": "Ningún indicio detectado",
    "not_applicable": "No se aplica"
  },
  "suggestions": {
    "clarity": "Comprueba que el enunciado indica exactamente qué debe responder el alumno y aporta el contexto necesario.",
    "answerOverlap": "Comprueba que solo una alternativa puede defenderse como correcta. Diferencia las opciones con significados parecidos.",
    "answerLeak": "Comprueba si el enunciado o la redacción de las alternativas revela la respuesta correcta."
  },
  "errors": {
    "incomplete": "Completa el título, los enunciados y las alternativas e indica las respuestas correctas para revisar.",
    "limits": "La revisión admite hasta 30 preguntas y 10 alternativas por pregunta. Límites de texto: título 200, descripción y enunciado 4.000, alternativa 1.000 y total 60.000 caracteres.",
    "unavailable": "No se ha podido revisar ahora. Inténtalo de nuevo en unos instantes.",
    "invalidResponse": "La revisión devolvió datos incompletos. Inténtalo de nuevo."
  }
},
  trailChatV3: trailChatV3EsES,
  giftRefund: giftRefundEsES,
  giftPreflight: giftPreflightEsES,
  debugMenu: {
    trigger: "Debug",
    subscriptionGroup: "Suscripción",
    trialEnded: "Prueba finalizada",
    onboardingGroup: "Incorporación",
    onboardingTitle: "Debug: incorporación",
    school: "Incorporación de la escuela",
    professor: "Incorporación del profesor",
    firstSteps: "Primeros pasos",
    emailGroup: "Emails transaccionales",
    emailTitle: "Debug: emails transaccionales",
    welcomeTrial: "Bienvenida con prueba (14 días)",
    welcomePaid: "Bienvenida sin prueba",
    sending: "Enviando...",
    emailSent: 'Email "{{label}}" enviado a tu correo.',
    emailFailed: 'No se pudo enviar el email "{{label}}".',
    environmentGroup: "Entorno",
    geo: "Geografía y moneda",
  },
  app: {
    defaultTitle: "Gamefik Escuelas al máximo nivel.",
    loadingCachedData: "Actualizando datos",
  },
  accessInstructions: {
    title: "Instrucciones de acceso de {{name}}",
    pageSubtitle: "Ingresa con una de las opciones a continuación",
    step1Title: "Descarga la app de Gamefik",
    step1Stores: "Disponible en App Store y Google Play",
    appStore: "App Store",
    googlePlay: "Google Play",
    step2Title: "Elige cómo iniciar sesión",
    scanQrTitle: "Leer código QR",
    scanQrHint: "Mejor en dispositivo con cámara",
    scanQrHintPage: "Mejor en un dispositivo con cámara",
    scanQrStep1: "1. Abre la cámara del celular",
    scanQrStep2: "2. Escanea el código QR",
    scanQrStep3: "3. El enlace se abrirá automáticamente",
    scanQrStep1Long: "Abre la cámara del celular o un lector de código QR",
    scanQrStep2Long: "Escanea el código QR de arriba",
    scanQrStep3Long: "El enlace de acceso se abrirá automáticamente en el navegador",
    loginLinkTitle: "Enlace de acceso",
    linkHintStart: "Mejor en dispositivo ",
    linkHintEmphasis: "sin",
    linkHintEnd: " cámara",
    linkHintLongStart: "Mejor en un dispositivo",
    linkHintLongMid: "sin",
    linkHintLongEnd: "cámara",
    pasteInBrowser: "Pega el enlace abajo en un navegador",
    generatingLink: "Generando enlace...",
    copyLink: "Copiar enlace",
    copied: "¡Copiado!",
    privacyNote:
      "Los alumnos no podrán acceder ni ver el trabajo de otros alumnos con estas instrucciones",
    helpTitle: "¿Necesitas ayuda?",
    helpSubtitle: "Visita el centro de ayuda para más información",
    generatingAccessLink: "Generando enlace de acceso...",
    modalTrigger: "Instrucciones de acceso para {{name}}",
    resetLink: "Restablecer enlace",
    resetConfirmTitle: "¡Atención: esta acción es irreversible!",
    resetConfirmQuestion: "¿Seguro que deseas restablecer el enlace de {{name}}?",
    resetWarnInvalidate:
      "El enlace actual quedará invalidado permanentemente y se generará uno nuevo.",
    resetWarnQrCard:
      "Si el jugador tiene una tarjeta con código QR impresa, también quedará invalidada: será necesario generar e imprimir una tarjeta nueva.",
    resetting: "Restableciendo...",
  },
  navigation: {
    dashboard: "Dashboard",
    launches: "Lanzamientos",
    players: "Jugadores",
    classes: "Clases",
    attitudes: "Actitudes",
    quizzes: "Quizzes",
    manage: "Gestionar",
    createWithAi: "Crear con IA✨",
    createFromScratch: "Crear desde cero",
    newMissions: "Misiones nuevas",
    missions: "Misiones",
    approve: "Aprobar",
    mural: "Mural",
    studentApp: "App del alumno",
    reports: "Informes",
    shopping: "Shopping",
    overview: "Vista general",
    orders: "Pedidos",
    rewards: "Recompensas",
    giftCards: "Gift cards",
    statement: "Extracto",
    invoices: "Facturas",
    settings: "Configuración",
    history: "Historial",
    games: "Segmentos",
    userManagement: "Gestión de usuarios",
    automations: "Automatizaciones",
    advanced: "Avanzadas",
    home: "Inicio",
    chatIa: "Inicio",
    activities: "Actividades",
    trails: "Rutas",
  },
  pageTitles: {
    dashboard: "Dashboard",
    players: "Jugadores",
    missions: "Misiones",
    approveMissions: "Aprobar misiones",
    quizzes: "Quizzes",
    shop: "Mi tienda",
    shoppingOrders: "Shopping - Pedidos",
    history: "Historial",
    attitudes: "Actitudes",
    newAttitude: "Nueva actitud",
    editAttitude: "Editar actitud",
    createQuiz: "Crear quiz",
    shopping: "Shopping",
    reviewOpenQuestions: "Revisar respuestas abiertas",
    purchases: "Pedidos",
    rewards: "Mi tienda",
    requests: "Shopping - Pedidos",
  },
  activities: {
    title: "Actividades",
    subtitle: "{{count}} actividades · {{active}} activas",
    subtitleLoading: "Cargando...",
    createManual: "Crear manual",
    createManualShort: "Manual",
    createShort: "Crear",
    createWithAi: "Crear con IA",
    createWithAiShort: "IA",
    createManualModal: {
      title: "¿Qué quieres crear?",
      hint: "Elige el tipo de actividad para crear desde cero, sin IA.",
      quiz: "Quiz",
      quizDesc: "Preguntas con alternativas o respuestas abiertas.",
      quizFormatTitle: "¿Qué formato de quiz quieres crear?",
      quizFormatHint: "Elige el tipo de respuesta. Podrás editar todas las preguntas después.",
      quizMultiple: "Opción múltiple",
      quizMultipleDesc: "El alumno selecciona una alternativa y recibe corrección automática.",
      quizDiscursive: "Respuesta abierta",
      quizDiscursiveDesc: "El alumno escribe una respuesta abierta para evaluación.",
      mission: "Misión",
      missionDesc: "Tarea con entrega de comprobante por el alumno.",
      flashcards: "Flashcards",
      flashcardsVf: "Flashcards V o F",
    },
    createWithAiDialog: {
      title: "Crear actividad con IA",
      hint: "Describe lo que quieres (tema, curso, tipo de actividad). Al continuar, la IA ya empieza a generar a partir de tu pedido.",
      placeholder:
        "Ej.: Quiz sobre fracciones para 5º grado, con 10 preguntas de opción múltiple…",
      submit: "Crear actividad",
      cancel: "Cancelar",
      promptRequired: "Describe lo que deseas crear",
      typeAuto: "Tipo: automático",
    },
    tabs: {
      all: "Todos",
      quizzes: "Quizzes",
      missions: "Misiones",
      flashcards: "Flashcards",
    },
    searchPlaceholder: "Buscar...",
    filterClasses: "Clases",
    filterClassesSearch: "Buscar clase...",
    filterStatus: "Estado",
    filterCreatorsSearch: "Buscar profesor...",
    deletedTeacher: "Profesor eliminado {{index}}",
    filterClassesNoResults: "Sin resultados",
    filterClassesClear: "Limpiar selección",
    filterPending: "Con pendientes",
    createdBy: "Creado por",
    creatorUnavailable: "Usuario eliminado o no disponible",
    filters: "Filtros",
    filtersAriaLabel: "Abrir filtros",
    clearFilters: "Limpiar filtros",
    showResults: "Ver {{count}} actividades",
    createAriaLabel: "Crear actividad",
    editAriaLabel: "Editar actividad",
    toggleAriaLabel: "Cambiar estado de {{title}}",
    moreActionsAriaLabel: "Más acciones",
    status: {
      active: "Activa",
      ended: "Finalizada",
      scheduled: "Programada",
      draft: "Borrador",
    },
    actions: {
      edit: "Editar",
      duplicate: "Duplicar",
      duplicating: "Duplicando...",
      delete: "Eliminar",
      report: "Informe",
      reviewProofs: "Revisar comprobantes",
      reviewAnswers: "Corregir respuestas",
      fullResults: "Resultados",
      reviewProofsCount: "Revisar {{count}} comprobantes",
      apply: "Aplicar",
      playLiveTooltip: "Jugar en vivo con la clase",
      presentTooltip: "Presentar en TV o proyector",
      copyLinkTooltip: "Copiar enlace de la actividad",
      copyLinkSuccess: "¡Enlace copiado!",
    },
    typeSelection: {
      title: "Nuevo tipo de actividad",
      subtitle: "Elige una opción abajo",
      quiz: "Quiz",
      quizDescription: "Preguntas de opción múltiple",
      mission: "Misión",
      missionDescription: "Tareas con comprobante",
    },
    emptyState: {
      title: "No se encontraron actividades",
      withSearch: "Intenta buscar con otro término",
      withoutSearch: "Crea tu primera actividad",
    },
    duplicateSuccess: "\"{{title}}\" duplicada con éxito",
    deleteDialog: {
      title: "Eliminar actividad",
      description: "¿Seguro que deseas eliminar {{title}}? Esta acción no se puede deshacer.",
      cancel: "Cancelar",
      confirm: "Eliminar",
      deleting: "Eliminando...",
    },
    toast: {
      duplicateError: "Error al duplicar la actividad. Inténtalo de nuevo.",
      editError: "No se pudo identificar la actividad para editar.",
      loadQuizError: "No se pudo cargar el quiz original para editar.",
      loadMissionError: "No se pudo cargar la misión original para editar.",
      prepareEditError: "No se pudo preparar la edición ahora. Inténtalo de nuevo.",
      deleteError: "Error al eliminar la actividad. Inténtalo de nuevo.",
      deleteSuccess: "¡Actividad eliminada con éxito!",
      statusUpdateSuccess: "¡Estado de la actividad actualizado con éxito!",
    },
  },
  shopping: {
    smartRewardsTitle: "Sistema inteligente de recompensas",
    smartRewardsDescription: "Crea recompensas personalizadas y usa IA para sugerencias automáticas.",
    watchTutorial: "Ver tutorial",
    deleteSelected: "Eliminar seleccionadas",
    newReward: "Nueva recompensa",
    storeSuggestion: "Sugerencia de tienda",
    searchRewardPlaceholder: "Buscar recompensa por nombre",
    rewardsCount: "{{count}} recompensas",
    selectedCount: "{{count}} seleccionada",
    selectedCountPlural: "{{count}} seleccionadas",
    unselectAll: "Deseleccionar todas",
    selectAll: "Seleccionar todas",
    inStock: "Disponible",
    outOfStock: "Agotado",
    viewMode: "Vista:",
    grid: "Cuadrícula",
    list: "Lista",
    table: "Tabla",
    ordersPageTitle: "[Tienda] - Pedidos | Gamefik Escuelas al máximo nivel.",
    walletBalanceTitle: "Mi saldo en cartera",
    addBalance: "Añadir saldo",
    rewardsSuggestion: "Sugerencia de recompensas",
    giftCardsStock: "Stock de gift cards",
    giftCardsDescription: "Selecciona un gift card para ponerlo a disposición en la tienda",
    buyGiftCard: "Comprar gift card",
    errorMakingAvailable: "Error al poner disponible en la tienda",
  },
  languages: {
    ptBR: "Português",
    enUS: "English",
    esES: "Español",
  },
  languageSelector: {
    label: "Idioma",
    description: "Elige el idioma de la plataforma",
  },
  common: {
    close: "Cerrar",
    cancel: "Cancelar",
    save: "Guardar",
    help: "Ayuda",
    logout: "Salir",
    settings: "Configuración",
    helpAndSupport: "Ayuda y Soporte",
    language: "Idioma",
    login: "Iniciar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    selectUnit: "Seleccionar unidad",
    selectGender: "Selecciona un género",
    requiredField: "Campo obligatorio",
    ok: "Ok",
    send: "Enviar",
    loading: "Cargando",
    fetchErrorTitle: "No se pudo cargar",
    fetchErrorDescription:
      "Algo salió mal al obtener los datos. Comprueba tu conexión e inténtalo de nuevo.",
    tryAgain: "Intentar de nuevo",
    back: "Volver",
    create: "Crear",
    edit: "Editar",
    change: "Cambiar",
    success: "Éxito",
    error: "Error",
    add: "Agregar",
    remove: "Eliminar",
    confirm: "Confirmar",
    selectGame: "Elige tu segmento",
    previous: "Anterior",
    next: "Siguiente",
    all: "Todos",
    allGames: "Todos los segmentos",
    allClasses: "Todas las clases",
    allTeachers: "Todos los profesores",
    searchByName: "Buscar por nombre",
    selectAGame: "Selecciona un segmento",
    selectAClass: "Selecciona una clase",
    selectATeacher: "Selecciona un profesor",
    itemsPerPage: "Elementos por página",
    perPage: "por página",
    watchTutorial: "Ver tutorial",
    noResultsTitle: "No se encontraron resultados",
    noResultsDescription: "Cambia los filtros o añade nuevos elementos.",
    testEnvironmentOnly: "Solo HMG",
    testEnvironmentBadge: "HMG",
    testEnvironmentDescription: "Disponible solo en el entorno de pruebas por ahora.",
    testEnvironmentTemporary: "Temporal en HMG",
  },
  login: {
    pageTitle: "Inicio de sesión | Gamefik Escuelas al máximo nivel.",
    title: "Iniciar sesión",
    description: "Ingresa tus datos para entrar en Gamefik",
    emailPlaceholder: "Ingresa tu correo electrónico",
    passwordPlaceholder: "Ingresa tu contraseña",
    submit: "Iniciar sesión",
    forgotPassword: "¿Olvidaste tu contraseña?",
    needHelp: "¿Necesitas ayuda?",
    clickHere: "Haz clic aquí",
    invalidCredentials: "¡Usuario o contraseña no válidos!",
    footerLabel: "Idioma de la plataforma",
  },
  forgotPassword: {
    heading: "¿Olvidaste tu contraseña?",
    subtitle: "Escribe el correo electrónico de tu cuenta para recibir un enlace para cambiar la contraseña",
    emailLabel: "Correo electrónico",
    invalidEmail: "Correo electrónico no válido",
    submit: "Recibir enlace",
    back: "Volver",
    successMessage: "¡Enviamos un enlace para cambiar tu contraseña a tu correo electrónico!",
    userNotFound: "Lo sentimos, no encontramos ningún usuario registrado con este correo electrónico.",
    userNotVerified: "Tu cuenta aún no ha sido verificada. Hemos enviado una nueva invitación a tu correo electrónico.",
    genericError: "Lo sentimos, ocurrió un error al enviar el enlace a tu correo electrónico. Ponte en contacto con soporte.",
  },
  loginCode: {
    continueSubmit: "Continuar",
    invalidEmail: "Correo electrónico no válido",
    verifyHeading: "Revisa tu correo",
    verifySubtitle: "Enviamos un código de inicio de sesión a {{email}}",
    codeLabel: "Código de inicio de sesión",
    codePlaceholder: "Introduce el código de 6 dígitos",
    helper: "Enviamos un código a {{email}}. Revisa tu bandeja de entrada y el spam.",
    sentToast: "¡Código enviado! Revisa tu correo.",
    userNotFound: "No encontramos ninguna cuenta con este correo. Verifica la dirección o crea una cuenta.",
    sendError: "No pudimos enviar el código. Inténtalo de nuevo en unos instantes.",
    invalidCode: "Código incorrecto o caducado. Revisa tu correo o reenvía el código.",
    changeEmail: "Cambiar correo",
    usePassword: "Entrar con contraseña",
    useCode: "Entrar con código por correo",
  },
  signup: {
    tabLogin: "Iniciar sesión",
    tabSignup: "Crear cuenta",
    loginHeading: "Bienvenido de vuelta",
    loginSubheading: "Inicia sesión para continuar tu viaje épico",
    profileHeading: "Selecciona tu perfil",
    profileSubheading: "Comienza tu viaje épico ahora",
    formHeading: "Crea tu cuenta",
    formSubheading: "Elige cómo prefieres continuar: Google, Apple o tu correo electrónico",
    verifyHeading: "Verifica tu email",
    verifySubheading: "Introduce el código enviado a {{email}}",
    profileSchools: "Escuelas",
    profileTeachers: "Profesores",
    profileNext: "Avanzar",
    toastResendSuccess: "Enviamos un nuevo código a tu correo electrónico.",
    toastResendError: "No se pudo reenviar el código.",
    firstName: "Nombre",
    firstNamePlaceholder: "Escribe tu nombre",
    lastName: "Apellido",
    lastNamePlaceholder: "Escribe tu apellido",
    email: "Correo electrónico",
    emailPlaceholder: "tu@correo.com",
    emailInvalid: "Correo electrónico no válido",
    firstNameRequired: "El nombre es obligatorio",
    lastNameRequired: "El apellido es obligatorio",
    password: "Contraseña",
    passwordPlaceholder: "••••••••",
    passwordMin: "Mínimo 6 caracteres",
    confirmPassword: "Confirmar contraseña",
    passwordMismatch: "Las contraseñas no coinciden",
    rememberMe: "Recordarme",
    forgotPassword: "Olvidé mi contraseña",
    termsText: "Al crear tu cuenta, declaras que has leído y aceptas los",
    termsAnd: "y la",
    termsOfUse: "Términos de uso",
    privacyPolicy: "Política de privacidad",
    loginSubmit: "Iniciar sesión en Gamefik",
    signupSubmit: "Crear cuenta",
    appleLogin: "Iniciar sesión con Apple",
    appleSignup: "Registrarse con Apple",
    dividerLogin: "O INICIA SESIÓN CON",
    dividerSignup: "O REGÍSTRATE CON",
    noAccount: "¿Aún no tienes cuenta?",
    startFree: "Comenzar gratis",
    hasAccount: "¿Ya tienes cuenta?",
    loginLink: "Iniciar sesión",
    verificationCode: "Código de verificación",
    verificationPlaceholder: "Introduce el código recibido",
    verificationHelper: "Enviamos un código a {{email}}. Revisa tu bandeja de entrada.",
    verifySubmit: "Verificar y continuar",
    resendCode: "Reenviar código",
    resendCountdown: "Reenviar código en {{countdown}}s",
    toastFillAllFields: "Por favor, completa el correo, la contraseña y la confirmación correctamente.",
    toastAccountCreated: "Cuenta creada. Enviamos un código a tu correo electrónico.",
    toastEnterCode: "Por favor, introduce el código recibido por correo electrónico.",
    toastInvalidCode: "Código no válido. Inténtalo de nuevo.",
    toastVerified: "Cuenta verificada correctamente.",
    toastLoginError: "Correo electrónico o contraseña no válidos",
    toastGoogleError: "Error al autenticar con Google",
    toastGoogleNotFound: "No se encontró ninguna cuenta para este correo de Google",
    toastAppleSoon: "Inicio de sesión con Apple próximamente",
    toastAppleError: "Error al autenticar con Apple",
    toastAppleNotFound: "No se encontró ninguna cuenta para este Apple ID",
    toastAppleNotConfigured: "Inicio de sesión con Apple no configurado en este entorno",
    toastSignupError: "No se pudo crear tu cuenta en este momento.",
  },
  schoolOnboarding: {
    pageTitle: "Configurar escuela — Gamefik",
    step1Title: "¡Cuéntanos un poco sobre ti!",
    step2Title: "Cuéntanos sobre tu escuela",
    step3Title: "¿Qué quieres lograr con Gamefik?",
    step4Title: "Personaliza el entorno de tu escuela",
    panel1Title: "Donde las aulas se convierten en aventuras",
    panel2Title: "+1.000 escuelas ya han convertido el compromiso en rutina",
    panel3Title: "Las escuelas gamificadas tienen hasta un 40% más de participación",
    panel4Title: "Tus alumnos accederán a un entorno con la identidad de tu escuela",
    roleLabel: "¿Cuál es tu cargo en la escuela?",
    rolePlaceholder: "Selecciona tu cargo",
    roleDirector: "Director(a)",
    roleCoordinator: "Coordinador pedagógico",
    roleMaintainer: "Mantenedor",
    roleOther: "Otro",
    countryLabel: "¿En qué país está ubicada tu escuela?",
    countryPlaceholder: "Selecciona el país",
    countrySearch: "Buscar país...",
    countryEmpty: "No se encontró ningún país",
    schoolNameLabel: "Nombre de la escuela",
    schoolNamePlaceholder: "Escribe el nombre de la escuela",
    studentCountLabel: "Número de alumnos",
    studentCountPlaceholder: "Selecciona la cantidad",
    studentUpTo100: "Hasta 100",
    student100to200: "De 100 a 200",
    student200to500: "De 200 a 500",
    student500to1000: "De 500 a 1.000",
    studentAbove1000: "Más de 1.000",
    teacherCountLabel: "Número de profesores",
    teacherUpTo5: "Hasta 5",
    teacher5to20: "De 5 a 20",
    teacher20to50: "De 20 a 50",
    teacherAbove50: "Más de 50",
    goalEngagement: "Aumentar la participación de los alumnos",
    goalPerformance: "Mejorar el rendimiento académico",
    goalPedagogy: "Facilitar el seguimiento pedagógico",
    goalMotivate: "Motivar a los profesores a usar tecnología",
    goalRetention: "Reducir el abandono escolar",
    goalOther: "Otro",
    goalOtherPlaceholder: "Describe tu objetivo...",
    uploadHelp: "Arrastra una foto aquí o elige desde tu dispositivo",
    uploadLater: "Puedes hacer esto más tarde en la configuración",
    back: "Volver",
    next: "Avanzar",
    finish: "Finalizar",
    phoneLabel: "Teléfono / celular de contacto",
    phonePlaceholder: "(55) 1234-5678",
    errorRole: "Selecciona tu cargo en la escuela.",
    errorCountry: "Selecciona el país de la escuela.",
    errorPhone: "Introduce el número de teléfono.",
    errorPhoneInvalid: "Número de teléfono no válido.",
    errorSchoolName: "Introduce el nombre de la escuela.",
    errorStudentCount: "Selecciona el número de alumnos.",
    errorTeacherCount: "Selecciona el número de profesores.",
    errorGoals: "Selecciona al menos un objetivo.",
    errorSave: "No se pudo guardar la información. Inténtalo de nuevo.",
  },
  teacherOnboarding: {
    welcomeTitleNoName: "Tu próxima clase empieza aquí.",
    welcomeSubtitle: "Vamos a hacer que tu primera clase brille.",
    welcomeMicro: "Una pregunta y la IA crea tu primera actividad.",
    nameQuestion: "¿Cuál es tu nombre?",
    namePlaceholder: "Tu nombre",
    countryQuestion: "¿En qué país enseñas?",
    countryPlaceholder: "Selecciona tu país",
    countrySearch: "Buscar país",
    countryEmpty: "Ningún país encontrado",
    phoneLabel: "WhatsApp (opcional)",
    phonePlaceholder: "Tu número",
    phoneInvalid: "Número inválido. Incluye el prefijo, solo dígitos.",
    phoneWhy: "Solo para avisarte cuando tu actividad esté lista. Sin spam.",
    ctaContinue: "Continuar",
    subjectTitle: "¿Qué materia enseñas?",
    subjectSubtitle: "La IA crea la actividad correcta para tu clase.",
    topicLabel: "¿Qué vas a enseñar esta semana?",
    topicPlaceholder: "Ej.: fracciones, la Revolución Francesa",
    ctaCreate: "Crear mi primera actividad",
    welcomeCta: "Empezar",
    activitySubtitle: "Escribe el tema. Del resto nos encargamos.",
    suggestionsLabel: "O empieza con una idea de {subjects}",
    suggestionsLabelGeneric: "O empieza con una de estas ideas",
    topic: {
      matematica_fractions: "Fracciones",
      matematica_linear_equations: "Ecuaciones lineales",
      matematica_plane_geometry: "Geometría plana",
      matematica_percentages: "Porcentajes",
      portugues_text_interpretation: "Comprensión lectora",
      portugues_figures_of_speech: "Figuras retóricas",
      portugues_verb_agreement: "Concordancia verbal",
      portugues_spelling: "Ortografía",
      ingles_verb_tenses: "Tiempos verbales",
      ingles_phrasal_verbs: "Phrasal verbs",
      ingles_daily_vocabulary: "Vocabulario cotidiano",
      ingles_reading_comprehension: "Comprensión lectora",
      espanhol_present_tense: "Verbos en presente",
      espanhol_basic_vocabulary: "Vocabulario básico",
      espanhol_false_friends: "Falsos amigos",
      espanhol_pronunciation: "Pronunciación",
      ciencias_solar_system: "Sistema solar",
      ciencias_ecosystems: "Ecosistemas",
      ciencias_human_body: "Cuerpo humano",
      ciencias_states_of_matter: "Estados de la materia",
      fisica_kinematics: "Cinemática",
      fisica_newtons_laws: "Leyes de Newton",
      fisica_electricity: "Electricidad",
      fisica_thermodynamics: "Termodinámica",
      quimica_periodic_table: "Tabla periódica",
      quimica_chemical_reactions: "Reacciones químicas",
      quimica_stoichiometry: "Estequiometría",
      quimica_organic_chemistry: "Química orgánica",
      biologia_genetics: "Genética",
      biologia_evolution: "Evolución",
      biologia_digestive_system: "Sistema digestivo",
      biologia_cell_biology: "Citología",
      historia_french_revolution: "Revolución Francesa",
      historia_world_war_2: "Segunda Guerra Mundial",
      historia_middle_ages: "Edad Media",
      historia_ancient_civilizations: "Civilizaciones antiguas",
      geografia_world_climates: "Climas del mundo",
      geografia_landforms: "Relieve",
      geografia_globalization: "Globalización",
      geografia_cartography: "Cartografía",
      filosofia_socrates_plato: "Sócrates y Platón",
      filosofia_ethics: "Ética",
      filosofia_enlightenment: "La Ilustración",
      filosofia_modern_philosophy: "Filosofía contemporánea",
      sociologia_culture_identity: "Cultura e identidad",
      sociologia_work: "Mundo laboral",
      sociologia_social_movements: "Movimientos sociales",
      sociologia_citizenship: "Ciudadanía",
      ed_fisica_team_sports: "Deportes de equipo",
      ed_fisica_olympic_history: "Historia olímpica",
      ed_fisica_athletics: "Atletismo",
      ed_fisica_game_rules: "Reglas de juego",
      arte_renaissance: "El Renacimiento",
      arte_impressionism: "Impresionismo",
      arte_modern_art: "Arte moderno",
      arte_color_composition: "Color y composición",
      musica_notes_rhythm: "Notas y ritmos",
      musica_great_composers: "Grandes compositores",
      musica_instruments: "Instrumentos musicales",
      musica_world_music: "Música del mundo",
      computacao_algorithms: "Algoritmos básicos",
      computacao_how_internet_works: "Cómo funciona internet",
      computacao_programming_logic: "Lógica de programación",
      computacao_digital_safety: "Seguridad digital",
      financas_interest_rates: "Interés simple y compuesto",
      financas_personal_budget: "Presupuesto personal",
      financas_investments: "Inversiones",
      financas_financial_literacy: "Educación financiera",
      redacao_argumentation: "Argumentación",
      redacao_essay_structure: "Estructura del ensayo",
      redacao_cohesion: "Cohesión y coherencia",
      redacao_writing_techniques: "Técnicas de escritura",
      religiao_world_religions: "Religiones del mundo",
      religiao_ethics_values: "Ética y valores",
      religiao_religious_tolerance: "Tolerancia religiosa",
      religiao_mythology: "Mitología",
      outra_citizenship: "Ciudadanía",
      outra_sustainability: "Sostenibilidad",
      outra_critical_thinking: "Pensamiento crítico",
      outra_current_affairs: "Actualidad",
    },
    stepProgress: "Paso {current} de {total}",
    ctaToEditor: "Abrir en el editor",
    submitError: "No pude abrir el editor ahora. Inténtalo de nuevo.",
    creating: "Creando…",
    nextStepsLabel: "Tus próximos pasos",
    loadingPulse1: "Analizando tu tema…",
    loadingPulse2: "Creando las preguntas…",
    loadingPulse3: "Volviéndolo un segmento…",
    loadingPulse4: "Puliendo los detalles…",
    loadingTitle: "Ya casi, {name}…",
    loadingTitleNoName: "Ya casi…",
    loadingSubtitle: "Mientras la IA crea tu actividad, mira cómo transformar tu escuela.",
    card1Title: "Crea tu clase",
    card1Desc: "Organiza a tus alumnos en segundos y comparte actividades con todos.",
    card2Title: "Invita a tus alumnos",
    card2Desc: "Un enlace o código y tus alumnos entran. Ellos juegan, tú haces seguimiento.",
    card3Title: "Sigue los resultados",
    card3Desc: "Mira quién participó, aciertos y engagement, en tiempo real.",
    celebrationTitle: "Listo, {name}. Tu clase ahora es un juego.",
    celebrationTitleNoName: "Listo. Tu clase ahora es un juego.",
    celebrationSubtitle: "Abre el editor para darle tu toque antes de publicar.",
    ctaPublish: "Publicar para mis alumnos",
    ctaAdjust: "Ajustar antes",
    previewUnavailable: "No pude cargar la vista del alumno ahora, pero tu actividad está lista.",
    back: "Volver",
    handoffPrompt: "Crea una actividad gamificada de {subjects}{topic}.",
    handoffPromptTopic: " sobre {topic}",
    subject: {
      matematica: "Matemáticas",
      portugues: "Lengua",
      ingles: "Inglés",
      espanhol: "Español",
      ciencias: "Ciencias",
      fisica: "Física",
      quimica: "Química",
      biologia: "Biología",
      historia: "Historia",
      geografia: "Geografía",
      filosofia: "Filosofía",
      sociologia: "Sociología",
      ed_fisica: "Ed. Física",
      arte: "Arte",
      musica: "Música",
      computacao: "Tecnología",
      financas: "Finanzas",
      redacao: "Redacción",
      religiao: "Religión",
      outra: "Otra",
    },
  },
  profile: {
    referAndEarn: "Recomienda y gana",
    accountNameFallback: "Mi cuenta",
    editUser: "Editar usuario",
    emailLabel: "Correo electrónico",
    finalizeTitle: "Completa tu registro",
    editTitle: "Edita tu usuario",
    missingFieldsFinalize: "Para completar tu registro, rellena los campos: {{fields}}",
    missingFieldsEdit: "Por favor, rellena todos los campos obligatorios: {{fields}}",
    fullName: "Nombre completo",
    fullNamePlaceholder: "Nombre",
    birthDate: "Fecha de nacimiento",
    gender: "Género",
    whatsappNumber: "Número de WhatsApp",
    finishing: "Finalizando...",
    saving: "Guardando...",
    finishRegistration: "Completar registro",
    saveChanges: "Guardar",
    missingFieldNames: {
      fullName: "Nombre completo",
      email: "Correo electrónico",
      whatsappNumber: "Número de WhatsApp",
      gender: "Género",
      birthDate: "Fecha de nacimiento",
    },
    genderOptions: {
      female: "Femenino",
      male: "Masculino",
      preferNot: "Prefiero no decirlo",
    },
    modal: {
      title: "Mi Perfil",
      changePhoto: "Cambiar foto",
      firstName: "Nombre",
      firstNamePlaceholder: "Tu nombre",
      firstNameRequired: "El nombre es obligatorio",
      firstNameMinLength: "El nombre debe tener al menos 2 caracteres",
      lastName: "Apellido",
      lastNamePlaceholder: "Tu apellido",
      lastNameRequired: "El apellido es obligatorio",
      lastNameMinLength: "El apellido debe tener al menos 2 caracteres",
      email: "Email",
      userType: "Tipo de usuario",
      accountType: "Tipo de cuenta",
      userTypes: {
        manager: "Gestor",
        teacher: "Profesor",
        secretary: "Secretaría",
        financial_admin: "Administrador financiero",
      },
      accountTypes: {
        individual_teacher: "Profesor individual",
        new_manager_school: "Escuela New Manager",
        legacy_school: "Escuela Legacy",
      },
      phone: "Teléfono",
      phonePlaceholder: "Tu número de teléfono",
      school: "Escuela donde enseñas",
      schoolPlaceholder: "Nombre de la escuela",
      schoolRequired: "La escuela es obligatoria",
      subjects: "Materias que enseñas",
      subjectsPlaceholder: "Selecciona las materias",
      subjectsSelected: "{{count}} materia seleccionada",
      subjectsSelectedPlural: "{{count}} materias seleccionadas",
      subjectsRequired: "Selecciona al menos una materia",
      subjectLabels: {
        Matematica: "Matemáticas",
        Portugues: "Portugués",
        Historia: "Historia",
        Geografia: "Geografía",
        Ciencias: "Ciencias",
        Fisica: "Física",
        Quimica: "Química",
        Biologia: "Biología",
        Ingles: "Inglés",
        Espanhol: "Español",
        "Educacao Fisica": "Educación Física",
        Artes: "Artes",
        Filosofia: "Filosofía",
        Sociologia: "Sociología",
        Outros: "Otros",
      },
      cancel: "Cancelar",
      save: "Guardar",
      saved: "Guardado",
    },
  },
  sidebar: {
    unitDialogTitle: "Seleccionar unidad",
    unitLabel: "Unidad",
    accountCodeLabel: "Código de la cuenta:",
    accountCodeCopyTitle: "Copiar código de la escuela",
    accountCodeCopied: "¡Copiado!",
    help: "Ayuda",
    helpAriaLabel: "Abrir centro de ayuda",
    supportSectionLabel: "Soporte",
    menuAriaLabel: "Abrir menú de navegación",
    logout: "Salir",
    launchMenu: "Menú de lanzamientos",
    changeUnitError: "Error al cambiar de unidad",
    newBadge: "Nuevo",
    comingSoonBadge: "En breve",
    activities: "Actividades",
    trails: "Rutas",
    firstSteps: "Primeros pasos",
    collapseSidebar: "Contraer barra lateral",
    expandSidebar: "Expandir barra lateral",
  },
  premiumModal: {
    exclusiveBadge: "Funcionalidad exclusiva",
    title: "{{funcionalidade}} es una funcionalidad {{planName}}",
    features: {
      rewards: "Recompensas",
    },
    description: "Esta funcionalidad forma parte del plan {{planName}}. Actualiza para desbloquear todas las ventajas exclusivas.",
    planName: "Teacher Shiny",
    planNameSchool: "School Pro",
    includesLabel: "Incluye:",
    highlight1: "Moneda personalizada",
    highlight2: "IA ilimitada",
    highlight3: "Recompensas exclusivas",
    highlight4: "Tienda de recompensas",
    includedBadge: "Incluido",
    ctaButton: "Desbloquear con {{planName}}",
    viewPlans: "Ver planes",
    dismiss: "Ahora no",
  },
  novaRecompensa: {
    notifyStudents: "Notificar a los alumnos",
    notifyStudentsDescription: "Enviar una notificación de nueva recompensa a los alumnos de los segmentos seleccionados.",
    title: "Nueva Recompensa",
    back: "Atrás",
    close: "Cerrar",
    step: "Paso {{current}} de {{total}}",
    next: "Siguiente",
    creating: "Creando...",
    createReward: "Crear Recompensa",
    payAndCreate: "Pagar y Crear",
    stepType: "Tipo",
    stepDetails: "Detalles",
    stepValues: "Valores",
    stepClasses: "Clases",
    stepGiftCards: "Gift Cards",
    stepCheckout: "Checkout",
    typeTitle: "Tipo de Recompensa",
    typeDescription: "Elige el tipo de recompensa que deseas crear.",
    normalTitle: "Recompensa Normal",
    normalDescription: "Pegatinas, regalos, privilegios y otras recompensas",
    giftcardTitle: "Gift Card",
    giftcardDescription: "Compra gift cards para que tus alumnos canjeen",
    comingSoon: "Próximamente",
    detailsTitle: "Detalles de la Recompensa",
    detailsDescription: "Añade imagen, nombre y descripción.",
    imageLabel: "Imagen",
    imageOptional: "Opcional",
    uploadLabel: "Subir",
    nameLabel: "Nombre de la recompensa",
    namePlaceholder: "Ej: Pegatina Especial",
    nameMinError: "El nombre debe tener al menos 3 caracteres",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Describe la recompensa para los alumnos...",
    descriptionRequiredError: "La descripción es obligatoria",
    advanced: "Avanzadas",
    availabilityDateLabel: "Fecha de disponibilidad",
    availabilityDateDescription: "La recompensa estará disponible para canje a partir de esta fecha.",
    valuesTitle: "Valores y Cantidades",
    valuesDescription: "Define el valor en monedas y la disponibilidad de la recompensa.",
    coinValueLabel: "Valor en monedas",
    stockLabel: "Stock disponible",
    limitLabel: "Límite por alumno",
    previewSentence: "{{stock}} unidades disponibles. Cada alumno puede canjear hasta {{limit}} {{times}} por {{price}} monedas cada una.",
    timesOne: "vez",
    timesMany: "veces",
    classesTitle: "Selecciona las Clases",
    classesDescription: "Elige qué clases tendrán acceso a esta recompensa.",
    allClasses: "Todas las clases",
    noClasses: "No se encontraron clases",
    selectedCount: "{{selected}} de {{total}} seleccionada{{plural}}",
    giftcardsTitle: "Arma tus Gift Cards",
    giftcardsDescription: "Selecciona la marca, valor y cantidad de cada gift card.",
    brandColumn: "Marca",
    valueColumn: "Valor",
    qtyColumn: "Cant.",
    addGiftcard: "Agregar otro gift card",
    giftcardTotal: "Total ({{count}} gift cards)",
    checkoutTitle: "Confirmar Compra",
    checkoutDescription: "Revisa tu pedido antes de proceder al pago.",
    orderSummary: "Resumen del Pedido",
    totalToPay: "Total a pagar",
    howItWorks: "Cómo funciona:",
    checkoutInfo: "Después del pago, los gift cards se agregarán como borradores en tu lista de recompensas. Podrás configurar el valor en monedas y el stock antes de ponerlos a disposición de los alumnos.",
    brandInfoWhere: "Dónde se puede usar",
    brandInfoInstructions: "Instrucciones de canje",
    brandInfoValues: "Valores disponibles",
    brandInfoTerms: "Ver términos y condiciones",
    successToast: "¡Recompensa creada con éxito!",
    errorToast: "Error al crear la recompensa. Inténtalo de nuevo.",
  },
  editarRecompensa: {
    title: "Editar Recompensa",
    subtitle: "Modifica los detalles de la recompensa",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Descripción opcional...",
    coinValueLabel: "Valor en monedas",
    stockLabel: "Stock",
    stockGiftCardLocked: "El stock lo definen los gift cards comprados — no editable",
    limitLabel: "Límite por alumno",
    classesLabel: "Clases",
    selectAll: "Seleccionar todas",
    noClasses: "No se encontraron clases",
    selectedCount: "{{selected}} de {{total}} seleccionadas",
    nameMinError: "Mínimo 3 caracteres",
    uploadImage: "Cambiar imagen",
    uploadingImage: "Subiendo...",
    removeImage: "Eliminar imagen",
    changeImage: "Cambiar imagen",
    imageUploadError: "Error al subir la imagen. Inténtalo de nuevo.",
    cancel: "Cancelar",
    save: "Guardar Cambios",
    saving: "Guardando...",
    successToast: "¡Recompensa actualizada con éxito!",
    errorToast: "Error al guardar los cambios.",
  },
  calculadoraCoins: {
    trigger: "Calculadora",
    title: "Calculadora de coins",
    description: "Indica cuánto vale la recompensa en dinero para ver el valor sugerido en monedas.",
    reaisLabel: "Valor en dinero",
    reaisPlaceholder: "Ej: 10,00",
    suggestedLabel: "Valor sugerido",
    rarityLabel: "Rareza:",
    useValue: "Usar este valor",
  },
  rewardCard: {
    giftBadge: "Gift",
    autoDeliveryBadge: "Entrega automática",
    autoDeliveryBadgeShort: "Auto",
    enableAutoDelivery: "Activar entrega automática",
    disableAutoDelivery: "Desactivar entrega automática",
    inactiveBadge: "Inactiva",
    edit: "Editar",
    delete: "Eliminar",
    coinsUnit: "monedas",
    stockPrefix: "Stock",
    stockCount: "{{count}} en stock",
    moreActions: "Más acciones",
  },
  excluirRecompensa: {
    title: "Eliminar Recompensa",
    description: "¿Estás seguro de que deseas eliminar {{name}}? Esta acción no se puede deshacer.",
    stockInfo: "{{coins}} monedas — {{stock}} en stock",
    cancel: "Cancelar",
    confirm: "Eliminar",
    deleting: "Eliminando...",
  },
  orderStatus: {
    todos: "Todos",
    pendentes: "Pendientes",
    created: "Pendiente",
    accepted: "Aceptado",
    delivered: "Entregado",
    cancelled: "Cancelado",
    acceptTitle: "Aceptar",
    rejectTitle: "Rechazar",
    cancelTitle: "Cancelar",
    markDelivered: "Entregar",
  },
  helpChat: {
    title: "Centro de Ayuda",
    subtitle: "¿Cómo podemos ayudar?",
    closeAriaLabel: "Cerrar centro de ayuda",
    successTitle: "¡Mensaje enviado!",
    successThanks: "Gracias por ponerte en contacto.",
    successReply: "Nuestro equipo responderá en {{hours}} horas.",
    nameLabel: "Nombre",
    namePlaceholder: "Tu nombre",
    emailLabel: "Email",
    emailPlaceholder: "tu@email.com",
    typeLabel: "Tipo de solicitud",
    typePlaceholder: "Selecciona el tipo",
    typeFeedback: "Feedback",
    typeDuvidas: "Dudas",
    typeSugestoes: "Sugerencias",
    typeBugs: "Bugs",
    typeOutros: "Otros",
    messageLabel: "Mensaje",
    messagePlaceholder: "Describe tu solicitud en detalle...",
    attachmentsLabel: "Adjuntos (opcional)",
    attachButton: "Adjuntar imágenes o vídeos",
    removeAttachmentAriaLabel: "Quitar adjunto {{name}}",
    submitButton: "Enviar mensaje",
    submitting: "Enviando...",
  },
  unitSelector: {
    title: "Seleccionar Unidad",
    subtitle: "Elige la unidad que deseas gestionar",
    searchPlaceholder: "Buscar unidad...",
    emptyTitle: "Ninguna unidad encontrada",
    emptySubtitle: "Intenta buscar con otro término",
    addUnit: "Agregar nueva unidad",
  },
  clearTheme: {
    loadingAria: "Cargando contenido",
  },
  account: {
    createPageTitle: "Crear cuenta | Gamefik Escuelas al máximo nivel.",
  },
  notFound: {
    pageTitle: "404 - Página no encontrada | Gamefik Escuelas al máximo nivel.",
    title: "Página no encontrada...",
    goBack: "Volver",
  },
  suspendedAccount: {
    permanentlySuspendedTitle: "Tu cuenta está suspendida.",
    suspendedForPaymentTitle: "¡Tu cuenta está suspendida por falta de pago!",
    payOverdueInvoices: "Pagar facturas atrasadas",
    payInvoice: "Pagar factura",
    permanentlySuspendedDescription:
      "Tu cuenta está suspendida de forma definitiva por falta de pago durante más de {{days}} días después del vencimiento de tu factura. Realiza el pago y la cuenta se desbloqueará en 30 minutos o ponte en contacto con soporte.",
    suspendedForPaymentDescription:
      "Para desbloquear tu cuenta, paga las facturas atrasadas haciendo clic en el botón \"Pagar factura\". Después del pago, tu cuenta se desbloqueará automáticamente.",
  },
  publicPost: {
    defaultTitle: "Comunicado",
    notFoundTitle: "Comunicado no encontrado",
    notFoundDescription: "Es posible que este enlace haya caducado o que el comunicado se haya eliminado.",
    eventBadge: "EVENTO",
    noReactions: "Aún no hay reacciones",
    reactionsCount: {
      one: "{{count}} reacción",
      other: "{{count}} reacciones",
    },
    viewsCount: {
      one: "{{count}} visualización",
      other: "{{count}} visualizaciones",
    },
    footerBrand: "Gamefik - Escuelas al máximo nivel",
  },
  acceptInvite: {
    pageTitle: "Registro | Gamefik Escuelas al máximo nivel.",
    title: "Crea tu contraseña de acceso",
    description: "Define una contraseña para aceptar la invitación y entrar automáticamente en Gamefik.",
    passwordLabel: "Nueva contraseña",
    confirmPasswordLabel: "Confirmar contraseña",
    invalidPassword: "Contraseña no válida",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres.",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    passwordHint: "Usa al menos 6 caracteres. Podrás cambiar la contraseña después en tu perfil.",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    submit: "Crear contraseña y entrar",
    submitting: "Creando contraseña...",
    loginCta: "Iniciar sesión",
    successMessage: "Tu contraseña ha sido registrada. Ya puedes iniciar sesión.",
    errorMessage: "Error al procesar la solicitud. Es posible que tu token haya caducado. Solicita una nueva invitación o ponte en contacto con soporte.",
    invalidOrExpired: "Esta invitación no es válida, caducó o ya fue utilizada. Solicita una nueva invitación.",
  },
  changePassword: {
    pageTitle: "Registro | Gamefik Escuelas al máximo nivel.",
    title: "Cambiar contraseña",
    description: "La contraseña debe tener al menos 6 caracteres.\nNo debe contener símbolos (@,#,%,ˆ,& )",
    newPasswordLabel: "Nueva contraseña",
    confirmNewPasswordLabel: "Confirmar nueva contraseña",
    invalidPassword: "Contraseña no válida",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    submit: "Cambiar",
    successMessage: "¡Contraseña cambiada!",
    tokenExpiredError: 'Tu token para cambiar la contraseña ha caducado. Solicita otro haciendo clic en "Olvidé mi contraseña" en la pantalla de inicio de sesión.',
    genericError: "Lo sentimos, se produjo un error al cambiar tu contraseña. Ponte en contacto con soporte.",
  },
  missions: {
    createWithAi: "Crear misión con IA",
    createFromScratch: "Crear desde cero",
    searchByName: "Buscar por nombre",
    allGames: "Todos los segmentos",
    allClasses: "Todas las clases",
    allTeachers: "Todos los profesores",
    tabs: {
      all: "Todas",
      active: "Activas",
      inactive: "Inactivas",
    },
    selectGame: "Selecciona un segmento",
    selectClass: "Selecciona una clase",
    selectTeacher: "Selecciona un profesor",
    itemsPerPage: "Elementos por página",
    perPage: "{{count}} por página",
    previous: "Anterior",
    next: "Siguiente",
    closeAll: "Cerrar todas",
    openAll: "Abrir todas",
    emptyTitle: "No se encontró ninguna misión",
    emptySubtitle: "Cambia los filtros o registra más misiones",
    missionUpdatedSuccess: "¡Misión actualizada con éxito!",
    missionUpdatedError: "Hubo un error al actualizar la misión. Inténtalo de nuevo.",
    missionDeletedSuccess: "¡Misión eliminada con éxito!",
    tips: {
      clearObjectivesTitle: "Define objetivos claros",
      clearObjectivesDescription: "Establece claramente lo que el alumno debe hacer para completar la misión.",
      clearObjectivesPlaceholder: "Video mostrando cómo definir objetivos claros para misiones",
      adjustComplexityTitle: "Ajusta la complejidad",
      adjustComplexityDescription: "Adapta la complejidad de la misión al nivel y capacidad de los alumnos.",
      adjustComplexityPlaceholder: "Video demostrando cómo ajustar la complejidad de las misiones",
      quickFeedbackTitle: "Da retroalimentación rápida",
      quickFeedbackDescription: "Valida las misiones lo antes posible para mantener la participación.",
      quickFeedbackPlaceholder: "Video sobre la importancia de la retroalimentación rápida en las misiones",
      aiVariationsTitle: "Usa IA para crear variaciones",
      aiVariationsDescription: "Utiliza IA para crear diferentes versiones de misiones similares.",
      aiVariationsPlaceholder: "Video tutorial sobre cómo usar IA para crear variaciones de misiones",
      curriculumConnectionTitle: "Conecta con el currículo",
      curriculumConnectionDescription: "Relaciona las misiones con el contenido curricular para reforzar el aprendizaje.",
      curriculumConnectionPlaceholder: "Video explicando cómo conectar misiones con el currículo escolar",
    },
    viewProofs: "Ver comprobantes",
    manualValidation: "Validación manual",
    edit: "Editar",
    deleteMission: "Eliminar misión",
    confirmDeletion: "Confirmar eliminación",
    editMission: "Editar misión",
    viewFullBank: "Ver banco completo",
    createdBy: "Creado por",
    creatorUnavailable: "Usuario eliminado o no disponible",
    games: "Segmentos",
    status: "Estado",
    inactive: "Inactiva",
    active: "Activa",
    proofUncollectedAndRemoved: "Comprobante revertido y eliminado",
    errorUncollectingProof: "Error al revertir el comprobante, contacta al soporte",
  },
  rewards: {
    bannerTitle: "Sistema inteligente de recompensas",
    bannerDescription: "Crea recompensas personalizadas y usa IA para sugerencias automáticas.",
    watchTutorial: "Ver tutorial",
    newReward: "Nueva recompensa",
    deleteSelected: "Eliminar seleccionadas",
    rewardSuggestion: "Sugerencia de recompensas",
    searchPlaceholder: "Buscar recompensa por nombre",
    rewardsCount: {
      one: "{{count}} recompensa",
      other: "{{count}} recompensas",
    },
    selectedCount: {
      one: "{{count}} seleccionada",
      other: "{{count}} seleccionadas",
    },
    deselectAll: "Deseleccionar todas",
    selectAll: "Seleccionar todas",
    outOfStock: "Agotado",
    viewMode: "Vista:",
    grid: "Cuadrícula",
    list: "Lista",
    table: "Tabla",
    walletBalanceTitle: "Mi saldo en cartera",
    addBalance: "Añadir saldo",
    giftCardsStock: "Stock de gift cards",
    giftCardsDescription: "Selecciona un gift card para ponerlo a disposición en la tienda",
    buyGiftCard: "Comprar gift card",
    rewardDetails: "Detalles de la recompensa",
    noGamesAssigned: "Sin segmentos",
    sendToStore: "Enviar a la tienda",
    details: "Detalles",
    noRewardFound: "Ninguna recompensa encontrada",
    editTitle: "Editar recompensa",
    rewardSavedSuccess: "¡Recompensa guardada con éxito!",
    smartRewardsSystem: "Sistema inteligente de recompensas",
    shinyOnlyTitle: "Las recompensas están disponibles en el plan Shiny",
    shinyOnlyDescription: "Suscríbete al Shiny para desbloquear recompensas personalizadas, gift cards y la tienda completa para tu clase.",
    shinyOnlyCta: "Suscribirse a Shiny",
    shinyOnlySecondary: "Volver",
    deleteSelectedButton: "Eliminar seleccionadas",
    coinsCalculator: "Calculadora de monedas",
    rarityIs: "La rareza es",
    xpRecommendation: "Recomendamos asignar solo valor en monedas a las recompensas, para que el jugador no pierda experiencia. ¿Deseas continuar?",
    noGames: "Sin segmentos",
    noRewardsFound: "No se encontraron recompensas",
    imageColumn: "Imagen",
    descriptionColumn: "Descripción",
    gamesColumn: "Segmentos",
    statusColumn: "Estado",
    dateColumn: "Fecha",
    actionsColumn: "Acciones",
    tipCreateTitle: "Crea una tienda personalizada",
    tipCreateDesc: "Agrega recompensas reales e integra gift cards. Personaliza con imágenes, descripciones y precios en monedas",
    tipPriceTitle: "Estrategia de precios",
    tipPriceDesc: "Define precios inteligentes para tus recompensas. Usa la calculadora de monedas para ajustar los valores y equilibrar la economía de la tienda",
    tipAITitle: "Recompensas con IA",
    tipAIDesc: "Usa nuestra IA para generar sugerencias de recompensas. Basándose en el perfil de tus alumnos, genera automáticamente ideas de recompensas personalizadas",
    tipStockTitle: "Control de stock",
    tipStockDesc: "Gestiona el stock de tus recompensas. Establece límites por alumno y programa la disponibilidad de tus productos",
    tipPopTitle: "Popularidad y engagement",
    tipPopDesc: "Acompaña las recompensas más buscadas. Analiza datos de canje para entender las preferencias de tus alumnos y optimizar la tienda",
    noButton: "No",
    yesButton: "Sí",
    confirmDeleteTitle: "¿Estás seguro?",
    confirmDeleteDescription: "¿Estás seguro de que deseas eliminar las recompensas seleccionadas? Esta acción no se puede deshacer.",
    pageTitle: "[Tienda] - Recompensas | Gamefik Escuelas al máximo nivel.",
    newRewardPageTitle: "Nueva recompensa | Gamefik Escuelas al máximo nivel.",
    editRewardPageTitle: "Editar recompensa | Gamefik Escuelas al máximo nivel.",
    newRewardTitle: "Nueva recompensa",
    rewardCreatedSuccess: "¡Recompensa creada con éxito!",
    rewardDeletedSuccess: "¡Recompensa eliminada con éxito!",
    productName: "Nombre del producto",
    productNamePlaceholder: "Ej: Camiseta",
    description: "Descripción",
    descriptionPlaceholder: "Ej: Camiseta negra...",
    selectCategory: "Seleccionar categoría",
    noCategoriesFound: "No se encontraron categorías",
    createCategory: "Crear categoría",
    addToStore: "Agregar a la tienda",
    browse: "Buscar",
    removeImage: "Remover",
    quantity: "Cantidad",
    quantityPlaceholder: "Ej: 10",
    limitPerPlayer: "Límite por alumno",
    scheduledStart: "Inicio programado",
    scheduledEnd: "Fin programado",
    notifyStudents: "Notificar alumnos",
    automaticDeliveryLabel: "Entrega automática",
    automaticDeliveryHint: "Los alumnos reciben la recompensa sin validación manual.",
    automaticDeliveryBadge: "Entrega automática",
    automaticDeliveryYes: "Sí",
    automaticDeliveryNo: "No",
    activateAutomaticDelivery: "Activar entrega automática",
    activateAutomaticDeliveryConfirm: "¿Activar entrega automática para las recompensas seleccionadas?",
    activateAutomaticDeliveryDescription: "{{count}} recompensa(s) se entregarán automáticamente a los alumnos sin validación manual.",
    activateAutomaticDeliverySuccess: "Entrega automática activada con éxito.",
    activateAutomaticDeliveryPartialError: "No se pudo actualizar {{count}} recompensa(s).",
    notifyStudentsDescription: "Al activar, los alumnos recibirán una notificación cuando esta recompensa esté disponible.",
    close: "Cerrar",
    rewardsDialogTitle: "Recompensas",
    rewardsDialogDescription: "Selecciona las recompensas que deseas asignar al alumno.",
    totalLabel: "Total: {{value}}",
    cancelButton: "Cancelar",
    redeemButton: "Canjear",
    redeemSuccess: "¡Canje realizado con éxito!",
    redeemError: "Error al canjear recompensa",
    duplicatedTransaction: "Transacción duplicada",
    insufficientBalance: "Saldo insuficiente",
    rewardNotFound: "Recompensa no encontrada",
    playerNotFound: "Alumno no encontrado",
    gameNotFound: "Segmento no encontrado",
    rewardAlreadyRedeemed: "Recompensa ya canjeada",
    noStoreGames: "¡Sin segmentos!",
    outOfStoreStock: "Fuera de la tienda",
    noStockBadge: "Sin stock",
    allGames: "Todos los segmentos",
    rewardsGeneratorClose: "Cerrar",
    inStock: "Disponible",
    createdOn: "Creado el",
    atTime: "a las",
    quantityLabel: "Cantidad",
    reaisLabel: "Reales",
    editPageTitle: "Editar recompensa | Gamefik Escuelas al máximo nivel.",
    requestError: "Ocurrió un error al procesar tu solicitud. Inténtalo de nuevo más tarde.",
    rewardRemovedSuccess: "Recompensa eliminada con éxito.",
    rewardsPageTitle: "Recompensas | Gamefik Escuelas al máximo nivel.",
    myStore: "Mi Tienda",
    smartRewardsDescription: "Crea recompensas personalizadas y usa IA para sugerencias automáticas.",
    newRewardButton: "Nueva Recompensa",
    storeSuggestionButton: "Sugerencia de Tienda",
    searchRewardsPlaceholder: "Buscar recompensas...",
    confirmDeletion: "Confirmar eliminación",
    confirmDeletionMessage: "¿Estás seguro de que deseas eliminar las siguientes recompensas?",
    cancel: "Cancelar",
    deleteAction: "Eliminar",
    editRewardDialog: "Editar Recompensa",
    newRewardDialog: "Nueva Recompensa",
    rewardsDeletedSuccess: "Recompensas eliminadas con éxito",
    processingError: "Ocurrió un error al procesar tu solicitud",
    closeButton: "Cerrar",
    uploadImage: "Sube una imagen",
    productNameLabel: "Nombre que aparecerá para los alumnos",
    descriptionLabel: "Descripción*",
    categoryLabel: "Categoría*",
    availableQuantity: "Cantidad disponible*",
    stockQuantity: "Cantidad en stock",
    playerLimitLabel: "Límite por jugador",
    noLimits: "Sin límites",
    useThisValue: "🪙 Usar este valor 🪙",
    defineCoinsValue: "Define el valor en coins",
    rarityLabel: "Rareza",
    coinsCalculatorButton: "Calculadora de coins 🤑",
    rarityImportantInfo: "Información importante sobre la rareza de la recompensa",
    applicableGames: "¿En qué segmentos aplica esta recompensa?",
    advancedSettings: "Configuración avanzada",
    scheduleLabel: "Programar",
    savingReward: "Espera, guardando recompensa...",
    fillRewardName: "Ingresa el nombre de la recompensa",
    fillRewardDescription: "Ingresa la descripción de la recompensa",
    fillAvailableQuantity: "Ingresa la cantidad disponible",
    selectAtLeastOneGame: "Selecciona al menos un segmento",
    browseButton: "Explorar",
    removeButton: "Eliminar",
    defineValueIn: "Define el valor en {{point}}",
    rarityCommon: "común",
    rarityUncommon: "poco común",
    rarityRare: "raro",
    rarityEpic: "épico",
    rarityLegendary: "legendario",
    rarityCommonTime: "Tiempo hasta el canje: 1 a 2 semanas",
    rarityUncommonTime: "Tiempo hasta el canje: 2 a 4 semanas",
    rarityRareTime: "Tiempo hasta el canje: 1 a 3 meses",
    rarityEpicTime: "Tiempo hasta el canje: 3 a 6 meses",
    rarityLegendaryTime: "Tiempo hasta el canje: 6 a 10 meses",
    chooseRewardsToRedeem: "Elige las recompensas que deseas canjear de la cuenta de",
    rewardsRedeemedSuccess: "Recompensas canjeadas con éxito.",
    insufficientScore: "El alumno no tiene puntuación suficiente para esta compra.",
    insufficientBalanceReward: "Saldo insuficiente para esta recompensa.",
    rewardNotFoundError: "Recompensa no encontrada o no disponible.",
    playerNotFoundError: "Jugador no encontrado.",
    gameNotFoundError: "Segmento no encontrado.",
    purchaseFinishError: "Ocurrió un error al finalizar esta compra. Verifica tu conexión e inténtalo de nuevo.",
    playerNotLinkedToGame: "El jugador seleccionado no está vinculado a un segmento.",
    cannotAssignMultipleGames: "No es posible asignar recompensas a alumnos vinculados a segmentos diferentes.",
    startCreatingRewards: "Comienza creando tu primera recompensa para motivar a tus alumnos.",
    outOfStore: "Fuera de la tienda",
    createdAtLabel: "Creado el",
    sendToStoreButton: "Enviar a la tienda",
    editAction: "Editar",
  },
  purchases: {
    walletBalance: "Mi saldo en cartera",
    addBalance: "Añadir saldo",
    rewardSuggestion: "Sugerencia de recompensas",
    giftCardStock: "Stock de gift cards",
    giftCardDescription: "Selecciona un gift card para ponerlo a disposición en la tienda",
    buyGiftCard: "Comprar gift card",
    cartWizardEntry: "Comprar gift cards (carrito)",
    rewardsSectionTitle: "Recompensas",
    manageStore: "Gestionar Tienda",
    ordersSectionTitle: "Pedidos",
    itemMadeAvailableInStore: "Ítem puesto a disposición en la tienda.",
    addGiftCard: "Agregar Gift Card",
    selectedGiftCard: "Gift Card {{name}}",
    quantityToMakeAvailable: "¿Cuántos gifts quieres poner a disposición?",
    availableCount: "{{count}} disponibles",
    gameLabel: "Segmento",
    costInCoins: "¿Cuánto costará (en monedas)?",
    costInCoinsPlaceholder: "Valor en monedas",
    playerLimit: "Límite por jugador",
    unlimited: "Sin límites",
    limitPerPlayerSummary: "Límite de {{count}} por jugador",
    optional: "Opcional",
    schedule: "Programar",
    scheduleHint: "Ingresa una fecha si deseas que la recompensa esté disponible solo en la fecha seleccionada. Deja este campo en blanco si deseas disponibilizar la recompensa instantáneamente.",
    errorMakingAvailable: "Error al poner disponible en la tienda",
    makeAvailableInStore: "Poner a disposición en la tienda",
    pageTitle: "[Tienda] - Pedidos | Gamefik Escuelas al máximo nivel.",
    currentScores: "Puntuación actual",
    coins: "Monedas:",
    noOrderToApprove: "¡Ningún pedido para aprobar!",
    toDeliver: "Por entregar",
    waiting: "Esperando",
    approved: "Aprobado",
    cancelledStatus: "Cancelado",
    nameColumn: "Nombre",
    priceColumn: "Precio",
    totalColumn: "Total",
    nothingFound: "Nada encontrado",
    quantityLabel: "Cantidad:",
    giftCardUnavailable: "Gift Card no disponible",
    giftCardUnavailableDesc: "Este gift card ya no está disponible en nuestro catálogo",
    selected: "seleccionado",
    bulkProcessingTitle: "Procesando pedidos",
    bulkProcessingProgress: "Procesando {{current}} de {{total}}...",
    successLabel: "Éxito",
    processingLabel: "Procesando...",
    closeAndUpdate: "Cerrar y actualizar",
    importantInfo: "Información importante",
    acceptButton: "Aceptar",
    deliverButton: "Entregar",
    cancelButton: "Cancelar",
    itemsPerPage: "Elementos por página",
    noRewardRequest: "Ningún pedido de recompensa encontrado",
    advancedSettingsLink: "Configuración avanzada",
    pendingStatus: "Pendiente",
    acceptedStatus: "Aceptado",
    acceptAll: "Aceptar todos",
    deliverAll: "Entregar todos",
    cancelAll: "Cancelar todos",
    orderDate: "Fecha del pedido:",
    deliveredBy: "Entregado por:",
    deliveryDate: "Fecha de entrega:",
    createdBy: "Creado por:",
    acceptedBy: "Aceptado por:",
    acceptanceDate: "Fecha de aceptación:",
    cancelledBy: "Cancelado por:",
    statusChangedSuccess: "¡Estado cambiado con éxito!",
    internalError: "Error interno",
    invalidProductCode: "Código de producto inválido",
    insufficientBalance: "Saldo insuficiente",
    playerNotFound: "Alumno no encontrado",
    gameNotFound: "Segmento no encontrado",
    purchaseAlreadyProcessed: "Compra ya procesada",
    processingError: "Error al procesar",
    connectionError: "Error de conexión",
    timeoutError: "Tiempo agotado",
    serverError: "Error del servidor",
    giftCardInstructions: "Instrucciones de uso del gift card",
    redemptionUrl: "URL de Canje:",
    openRedemptionPage: "Abrir página de canje",
    giftCode: "Código del gift:",
    complementaryCode: "Código complementario:",
    printGiftVoucher: "Imprimir vale de regalo",
    viewGiftCardResult: "Ver resultado del gift card",
    selectItem: "Seleccionar elemento",
    deliveredStatus: "Entregado",
    filtersTitle: "Filtros",
    selectStatus: "Selecciona un estado",
    pendingCount: "Pendiente:",
    cancelledCount: "Cancelado:",
    acceptedCount: "Aceptado:",
    deliveredCount: "Entregado:",
    updateError: "Error al actualizar",
    confirmBulkAction: "¿Confirmar acción masiva?",
    unknown: "Desconocido",
    failedToLoadOrders: "Error al cargar pedidos",
    failedToLoadOrdersDesc: "No fue posible buscar los pedidos. Inténtalo de nuevo.",
    retryButton: "Reintentar",
    loadingOrders: "Cargando pedidos...",
    loadingOrdersProgress: "Cargando pedidos... {{loaded}} de {{total}}",
    selectGiftToReplace: "Seleccionar un gift para sustituir el gift card no disponible",
    contactSupportRefund: "Contacte al soporte para realizar el reembolso de este gift card",
    giftCardUnavailableTitle: "Gift Card No Disponible",
    giftCardUnavailableText: "El gift card de la marca {{brand}} con el valor R$ {{value}} ya no está disponible.",
    newValuesAvailable: "Nuevos valores disponibles para esta marca:",
    selectedButton: "Seleccionado",
    selectButton: "Seleccionar",
    closeButton: "Cerrar",
    confirmButton: "Confirmar",
    processingBulkTitle: "Procesando Elementos en Masa",
    processingProgress: "Procesando {{current}} de {{total}}...",
    successResult: "Éxito",
    unknownError: "Error desconocido",
    processingButton: "Procesando...",
    closeAndUpdateButton: "Cerrar y Actualizar",
    selectAllPending: "Seleccionar Todos Pendientes",
    selectAllAccepted: "Seleccionar Todos Aceptados",
    clearSelection: "Limpiar Selección ({{count}})",
    itemsPerPagePlaceholder: "Elementos por página",
    perPage: "{{count}} por página",
    previousPage: "Anterior",
    nextPage: "Siguiente",
    searchOrders: "Buscar pedidos",
    csvPlayerName: "Nombre del Jugador",
    csvItemName: "Nombre del Elemento",
    csvQuantity: "Cantidad",
    csvStatus: "Estado",
    csvCreatedAt: "Fecha de Creación",
    downloadSummary: "Descargar resumen",
    importantInfoTitle: "Información Importante",
    importantInfoAccept: "Verifica si la recompensa que el alumno seleccionó realmente está disponible. Si es así, haz clic en",
    importantInfoAcceptAction: "Aceptar",
    importantInfoCancel: "¿La recompensa solicitada ya no está disponible? Haz clic en",
    importantInfoCancelAction: "Cancelar",
    importantInfoCancelResult: "y el alumno recibirá el reembolso del valor.",
    importantInfoDeliver: "¡Importante! Después de realizar la entrega de la recompensa, siempre haz clic en",
    importantInfoDeliverAction: "Entregar",
    noRequestsMessage: "Ninguna solicitud de recompensa hasta el momento. Verifica si tu tienda está disponible en",
    advancedSettings: "Configuraciones Avanzadas",
    oneItemSelected: "1 elemento seleccionado",
    selectedItemsCount: "{{count}} elementos seleccionados",
    itemsSelectedCount: "{{count}} elemento(s) seleccionado(s)",
    pendingLabel: "Pendiente",
    acceptedLabel: "Aceptado",
    acceptAllButton: "Aceptar Todos",
    deliverAllButton: "Entregar Todos",
    cancelAllButton: "Cancelar Todos",
    confirmBulkStatusChange: "¿Confirmar cambio de estado de {{count}} elementos a {{status}}?",
    confirmSingleStatusChange: "¿Confirmar el cambio de estado de este pedido a {{status}}?",
    cancelAcceptedTitle: "Cancelar pedido aceptado",
    confirmCancelOrder: "¿Cancelar este pedido? Los puntos se devolverán al alumno.",
    confirmBulkCancellation: "¿Cancelar {{count}} pedidos? Los puntos se devolverán a los alumnos.",
    confirmCancellationButton: "Confirmar cancelación",
    selectedOrdersTitle: "Procesar pedidos seleccionados",
    refreshBeforeRetry: "No se pudo confirmar el cambio. Actualiza la página antes de intentarlo de nuevo.",
    errorUpdating: "Error al actualizar",
    unknownName: "Desconocido",
    cancelOrderTooltip: "Cancelar pedido y devolver puntos al alumno",
    makeAvailablePostPaid: "Disponibilizar (pospago)",
    postPaidHint: "El valor en R$ solo se cobra cuando entregas el gift al alumno.",
    postPaidCatalogTitle: "Disponibilizar gift card (pospago)",
    postPaidCatalogDescription: "Elige un gift card del catálogo para agregarlo a la tienda. El valor en R$ solo se cobra al entregar al alumno.",
    makingAvailable: "Disponibilizando...",
    noBalanceToDeliverTitle: "Sin saldo para entregar este gift",
    noBalanceToDeliverBody: "Saldo actual: R$ {{balance}} — necesario: R$ {{required}}. Agrega saldo e intenta entregar de nuevo.",
    addBalanceCta: "Agregar saldo",
    cartWizardTitle: "Comprar gift cards",
    cartStepBuild: "Arma tus gift cards",
    cartStepCheckout: "Checkout",
    cartTotal: "Total a pagar",
    cartPayNow: "Pagar ahora",
    cartAwaitingPayment: "Pago pendiente. Cuando se confirme, definirás monedas y clases aquí mismo.",
    cartStepConfirm: "Confirmación",
    cartStepPublish: "Publicar",
    cartConfirmWaiting: "Esperando la confirmación — esta ventana avanza sola cuando se acredite el pago.",
    cartPublishIntro: "¡Pago confirmado!",
    cartPublishHint: "Ahora define cuántas monedas pagan los alumnos y qué clases pueden canjear el gift card.",
    cartPublishLater: "Dejar para después",
    cartPublishStockMissing: "Stock no encontrado para",
    cartAddRow: "Agregar otro gift card",
    cartSelectBrand: "Marca",
    cartSearchBrand: "Buscar marca...",
    cartBrandNotFound: "Ninguna marca encontrada.",
    cartSelectValue: "Valor",
    cartQuantity: "Cant.",
    cartPaymentMethod: "Forma de pago",
    cartPaymentPix: "Pix",
    cartPaymentBoleto: "Boleto",
    cartPaymentCreditCard: "Tarjeta de Crédito",
    cartOrderSummary: "Resumen del pedido",
    cartFieldName: "Nombre completo",
    cartFieldEmail: "E-mail",
    cartFieldCpf: "CPF / CNPJ",
    cartFieldCardNumber: "Número de tarjeta",
    cartFieldCardHolder: "Nombre en la tarjeta",
    cartFieldExpiryMonth: "Mes de vencimiento",
    cartFieldExpiryYear: "Año de vencimiento",
    cartFieldCcv: "CVV",
    cartFieldPostalCode: "Código postal",
    cartFieldAddressNumber: "Número de dirección",
    cartLoadingCatalog: "Cargando catálogo...",
    cartSuccess: "¡Compra realizada con éxito! Los gift cards aparecerán en tu stock en breve.",
    cartError: "Error al procesar el pago. Inténtalo de nuevo.",
    cartErrorCatalog: "No fue posible cargar el catálogo de gift cards.",
    cartNext: "Siguiente",
    cartBack: "Volver",
    cartProcessing: "Procesando...",
    cartPixCopyPaste: "Pix Copia y Pega",
    cartBoletoOpen: "Abrir boleto",
    cartUseBalance: "Usar saldo (R$ {{balance}} disponible)",
    cartBalanceApplied: "Saldo aplicado",
    cartToPay: "A pagar",
    cartPayWithBalance: "Pagar con saldo",
    addGiftCards: "Agregar gift cards",
    addGiftCardsTitle: "Agregar gift cards",
    addGiftCardsDesc: "Elige cómo agregar gift cards a la tienda.",
    modeCartTitle: "Comprar (carrito)",
    modeCartDesc: "Arma un carrito y paga ahora (pix, boleto, tarjeta o saldo).",
    modePostPaidTitle: "Poner disponible (pospago)",
    modePostPaidDesc: "Ponlo disponible ahora y paga solo cuando lo entregues al alumno.",
    modePrePaidTitle: "Comprar con saldo",
    modePrePaidDesc: "Compra gift cards usando el saldo de la cuenta.",
    tabRewards: "Recompensas",
    tabOrders: "Pedidos",
    rewardsEmpty: "Aún no hay recompensas en la tienda.",
    ordersEmpty: "No hay pedidos pendientes.",
    rewardStock: "Stock",
  },
  attitudes: {
    pageTitle: "Actitudes | Gamefik Escuelas al máximo nivel.",
    positiveAttitudes: "Actitudes positivas",
    negativeAttitudes: "Actitudes negativas",
    recommendation: "Recomendación",
    recommendationDescription: "Recomendamos mantener un máximo de 5 actitudes positivas y 3 negativas para facilitar la comprensión de los alumnos.",
    searchPlaceholder: "Buscar por nombre...",
    filterByGame: "Filtrar por segmento",
    newAttitude: "Nueva actitud",
    showingAttitudes: "Mostrando {{count}} actitudes",
    collapseAll: "Contraer todas",
    expandAll: "Expandir todas",
    emptyTitle: "No se encontró ninguna actitud",
    emptySubtitle: "Intenta ajustar los filtros o crea una nueva actitud",
    deletedSuccess: "Actitudes eliminadas con éxito",
    savedSuccess: "Actitud guardada con éxito.",
    removedSuccess: "Actitud eliminada con éxito.",
    duplicatedSuccess: "Actitud duplicada con éxito",
    appliedSuccess: "Actitud aplicada con éxito",
    attitudesAppliedSuccess: "¡Actitudes aplicadas con éxito!",
    attitudesLaunched: "¡Actitudes lanzadas!",
    playersUpdated: "Jugadores actualizados",
    requestError: "Se produjo un error al procesar tu solicitud. Inténtalo de nuevo más tarde.",
    processingError: "Se produjo un error al procesar tu solicitud",
    applyingAttitudes: "Aplicando actitudes/misiones...",
    errorApplyingAttitudes: "Error al aplicar actitudes",
    contactSupport: "Algo salió mal, contacta al soporte.",
    duplicatedTransaction: "Transacción duplicada.",
    confirmDeleteTitle: "¿Estás seguro de que deseas eliminar las actitudes de abajo?",
    confirmDuplicateTitle: "¿Estás seguro de que deseas duplicar esta actitud?",
    newAttitudePageTitle: "Nueva actitud | Gamefik Escuelas al máximo nivel.",
    editAttitudePageTitle: "Editar actitud | Gamefik Escuelas al máximo nivel.",
    newMission: "Nueva misión",
    deleteMissions: "Eliminar misiones",
    deleteAttitudesButton: "Eliminar actitudes",
    createNewAttitude: "Crear una nueva actitud",
    chooseSuggestion: "Elegir una sugerencia",
    selectButton: "Seleccionar",
    applyButton: "Aplicar",
    editButton: "Editar",
    deleteButton: "Eliminar",
    showMore: "Mostrar más",
    proceedAnyway: "Continuar de todas formas",
    cancelCreation: "Cancelar creación",
    finalizeAndCreate: "Finalizar y Crear",
    finalizeAndSave: "Finalizar y Guardar",
    continueButton: "Continuar",
    nextRecurrence: "Siguiente: Recurrencia",
    selectAll: "Seleccionar todos",
    applyEmoji: "🌟 Aplicar 🌟",
    or: "o",
    ideal: "ideal",
    tooMuch: "mucho",
    attitudeNameHeader: "Nombre de la Actitud",
    descriptionHeader: "Descripción",
    valueHeader: "Valor",
    activeHeader: "Activa",
    nameHeader: "Nombre",
    activeGamesHeader: "Segmentos activos",
    classesHeader: "Clases",
    editHeader: "Editar",
    descriptionPrefix: "Descripción:",
    createdBy: "Creado por:",
    deletedLabel: "eliminada",
    allLabel: "Todas",
    noRewards: "Sin recompensas",
    editMission: "Editar misión",
    editAttitudeLabel: "Editar actitud",
    noPlayerFound: "No se encontró ningún jugador",
    noPlayerFoundSubtitle: "Cambia los filtros o registra más jugadores en los segmentos de la actitud",
    searchByNamePlaceholder: "Buscar por nombre...",
    allClasses: "Todas las Clases",
    studentCount: "{{count}} alumno(s)",
    playersSelected: "{{count}} jugador(es) seleccionado(s)",
    selectAtLeastOneStudent: "Selecciona al menos un alumno",
    applyAttitudeForStudents: "Aplicar actitud para {{count}} alumno(s)",
    applyAttitudeDialogTitle: "Aplicar Actitud: {{name}}",
    receivedTimes: "Recibió {{count}} veces",
    receivedOnce: "Recibió 1 vez",
    notReceivedToday: "No recibió hoy",
    noClass: "Sin clase",
    levelImage: "imagen del nivel",
    configureRecurrence: "Configurar Recurrencia",
    defineAutoApply: "Define cuándo esta actitud se aplicará automáticamente",
    applicationFrequency: "Frecuencia de aplicación",
    howItWorks: "Cómo funciona:",
    autoApplyOnSelectedDays: "Aplicación automática en los días seleccionados",
    validForAllStudents: "Válido para todos los alumnos de las clases",
    canBePausedAnytime: "Se puede pausar en cualquier momento",
    newAttitudeDialogTitle: "Nueva Actitud",
    howToCreateQuestion: "¿Cómo deseas crear esta nueva actitud?",
    suggestionBank: "Banco de Sugerencias",
    suggestionBankDesc: "Explora nuestra biblioteca con actitudes listas para usar.",
    createFromScratch: "Crear desde Cero",
    createFromScratchDesc: "Personaliza completamente el nombre, reglas y recompensas.",
    attitudeLibrary: "Biblioteca de Actitudes",
    searchByNameOrDesc: "Buscar por nombre o descripción...",
    positiveTab: "Positivas",
    negativeTab: "Negativas",
    tryAnotherSearch: "Intenta buscar con otro término",
    showingOptions: "Mostrando {{count}} opciones",
    notFoundCreateFromScratch: "¿No encontraste? Crear desde cero",
    attitudeDetailsTitle: "Detalles de la Actitud",
    customizeDescription: "Personaliza cómo se mostrará y puntuará esta actitud.",
    recurrenceMode: "Modo de Recurrencia",
    recurrenceModeDesc: "Esta actitud se aplicará automáticamente. Solo se permiten actitudes positivas en este modo.",
    impactType: "Tipo de Impacto",
    positiveLabel: "Positiva",
    recognizeGoodBehavior: "Reconocer buenos comportamientos",
    negativeLabel: "Negativa",
    correctBehavior: "Corregir comportamientos",
    attitudeNameLabel: "Nombre de la Actitud",
    attitudeNamePlaceholder: "Ej: Participación en clase",
    attitudeNameRequired: "Por favor, dale un nombre a la actitud.",
    descriptionLabel: "Descripción",
    optionalLabel: "(Opcional)",
    descriptionPlaceholder: "Describe brevemente el motivo de esta actitud...",
    rewardPenalty: "Recompensa / Penalización",
    impactOnXpAndCoins: "Impacto en XP y Monedas",
    impactOnCoins: "Impacto en Monedas",
    selectRewardValue: "Selecciona un valor de recompensa.",
    customRewardValue: "Valor personalizado",
    whereToApply: "¿Dónde aplicar?",
    selectGamesDesc: "Selecciona los segmentos que tendrán acceso a esta actitud.",
    availableGames: "Segmentos Disponibles ({{count}})",
    noGameFound: "No se encontró ningún segmento.",
    limitExceededTitle: "Límite de actitudes excedido",
    limitExceededDesc: "Ya has alcanzado el límite recomendado de 5 actitudes positivas o 3 actitudes negativas. Agregar más actitudes puede hacer que el sistema sea confuso para los alumnos y dificultar la comprensión de las reglas.",
    recommendationsTitle: "Recomendaciones:",
    recommendationKeepMax: "Mantén un máximo de 5 actitudes de cada tipo para facilitar la comprensión",
    recommendationConsolidate: "Considera revisar y consolidar actitudes similares",
    recommendationSimple: "Las actitudes más simples y claras son más efectivas",
    confirmExceedLimit: "Entiendo que estoy excediendo el límite recomendado y que esto puede afectar negativamente la experiencia de los alumnos. Deseo continuar de todas formas y usar Gamefik en modo no recomendado.",
    continueAnyway: "Continuar de todas formas",
    missionsType: "Misiones",
    missionsTooltip: "Las misiones son eventuales, algo que ocurre una o pocas veces.",
    yesOption: "Sí",
    noOption: "No",
    nameLabel: "Nombre",
    positiveRecurrenceInfo: "Esta es una recurrencia positiva. Las recurrencias son siempre positivas y se aplican automáticamente en los días seleccionados.",
    selectType: "Selecciona el tipo",
    gamesApplicableRecurrence: "¿En qué segmentos es aplicable esta recurrencia?",
    gamesApplicableMission: "¿En qué segmentos es aplicable esta misión?",
    gamesApplicableAttitude: "¿En qué segmentos es aplicable esta actitud?",
    pointsToGainMission: "¿Cuántos puntos debe ganar el jugador al realizar esta misión?",
    pointsToGainAttitude: "¿Cuántos puntos debe ganar el jugador al realizar esta actitud?",
    recurrencePriorityNegative: "¿Cuál es la prioridad de esta recurrencia negativa?",
    recurrencePriorityPositive: "¿Cuál es la prioridad de esta recurrencia positiva?",
    recurrenceTitle: "Recurrencia",
    visibleOnlyInHmg: "Visible solo en staging",
    recurrenceSelectTooltip: "Si seleccionas sí, podrás establecer una frecuencia para que esta actitud se aplique automáticamente.",
    mandatoryCollection: "Invalidar puntos no recolectados",
    mandatoryCollectionTooltip: "Cuando está activado, el alumno debe entrar en la app y recolectar los puntos antes de que termine el período. Las automatizaciones diarias deben recolectarse el mismo día; las semanales, antes de que termine la semana. Los puntos no recolectados vencen.",
    classesTitle: "Clases",
    issuesFound: "Problemas encontrados:",
    operationInProgress: "Operación en curso...",
    selectAtLeastOneGame: "Selecciona al menos un segmento",
    fillName: "Completa el nombre",
    fillDescription: "Completa la descripción",
    selectTypeReason: "Selecciona el tipo",
    selectAtLeastOneClass: "Selecciona al menos una clase",
    saveButton: "Guardar",
    continuousMission: "Misión continua",
    continuousMissionInfo1: "Una misión continua sigue disponible para el jugador incluso después de completarla.",
    continuousMissionInfo2: "Si la misión puede realizarse varias veces, marca esta opción.",
    recurrenceAutoApplyInfo: "Esta recurrencia se aplicará automáticamente según la frecuencia seleccionada",
    priorityVeryLow: "Muy Baja",
    priorityLow: "Baja",
    priorityModerate: "Moderada",
    priorityHigh: "alta",
    priorityVeryHigh: "Muy alta",
    difficultyQuick: "Rápida",
    difficultyVeryEasy: "Muy Fácil",
    difficultyEasy: "Fácil",
    difficultyHard: "difícil",
    difficultyVeryHard: "Muy difícil",
    difficultyLasting: "Duradera",
    difficultyMedium: "Media",
    difficultyHardTeacher: "Difícil",
    applyAttitudesTitle: "Aplicar actitudes",
    studentsWhoWillReceive: "Alumnos que recibirán:",
    errorApplyingAttitudeToPlayer: "Error al aplicar la actitud {{attitude}} para {{player}}.",
    otherAttitudesAppliedCorrectly: "Todas las demás actitudes se aplicaron correctamente.",
    playerNotLinkedToGame: "Uno o más jugadores seleccionados no están vinculados a un segmento ({{name}}).",
    selectOneOrMorePlayers: "Selecciona uno o más jugadores",
    positiveAttitudesHeader: "Actitudes positivas",
    negativeAttitudesHeader: "Actitudes negativas",
    missionsHeader: "Misiones",
    closeButton: "cerrar",
    applyWithStars: "🌟 Aplicar 🌟",
    studentsLabel: "alumnos",
    attitudesLabel: "actitudes",
    allStudentsWillReceive: "¡Todos los alumnos recibirán todas las actitudes seleccionadas!",
    noAttitudesSelected: "No hay actitudes seleccionadas",
    manualLaunchTitle: "Lanzando manualmente: {{name}}",
    selectAClass: "Selecciona una clase",
    search: "Buscar",
    clearButton: "Limpiar",
    launchAttitude: "¡Lanzar actitud!",
    launchMission: "¡Lanzar misión!",
    selectAtLeastOnePlayer: "Selecciona al menos un jugador",
    applyAttitudeButton: "Aplicar actitud",
    applyMissionButton: "Aplicar misión",
    general: "General",
    selectAType: "Selecciona un tipo",
    multipliable: "Multiplicable",
    nothingAvailable: "Nada disponible aquí",
    selectAPlayer: "¡Selecciona un jugador!",
    deletedClass: "eliminada",
    allClassesChip: "Todas",
    editAttitudeTitle: "Editar Actitud",
    closeButtonLabel: "Cerrar",
    createdSuccess: "Actitud creada con éxito",
    headTitle: "Actitudes | Gamefik Escuelas al máximo nivel.",
    statusChangedSuccess: "Estado de la actitud cambiado con éxito",
    updatedSuccess: "Actitud actualizada con éxito",
    positiveTitle: "Actitudes positivas",
    negativeTitle: "Actitudes negativas",
    recommendationTitle: "Recomendación",
    showingCount: "Mostrando {{count}} actitudes",
    deleteAttitude: "Eliminar actitud",
    editLabel: "Editar",
    apply: "Aplicar",
    linkedGames: "Segmentos vinculados",
    deleteLabel: "Eliminar",
    objectiveLabel: "Objetivo",
    allGames: "Todos los segmentos",
    statusTabs: {
      all: "Todas",
      active: "Activas",
      inactive: "Inactivas",
    },
    typeTabs: {
      all: "Todas",
      positive: "Positivas",
      negative: "Negativas",
    },
    filterLabel: "Filtrar",
    filterWithType: "Filtrar: {{type}}",
    confirmDeleteDescription:
      "¿Seguro que deseas eliminar esta actitud? Esta acción no se puede deshacer.",
    editAttitudeTooltip: "Editar actitud",
    inactiveBadge: "Inactiva",
    statusLabel: "Estado:",
    detailsSectionTitle: "Detalles",
    systemUser: "Sistema",
    debugJson: "Depurar JSON",
    xpAndCoinAlt: "XP y monedas",
    coinsAlt: "Monedas",
    tips: {
      clearObjective: {
        title: "Define actitudes claras y objetivas",
        description:
          "Crea actitudes con descripciones claras para que los alumnos entiendan qué se espera de ellos.",
        placeholder: "Video mostrando cómo crear una actitud con descripción clara y objetiva",
      },
      balance: {
        title: "Equilibra actitudes positivas y negativas",
        description:
          "Mantén un equilibrio entre reconocer comportamientos positivos y corregir los negativos.",
        placeholder: "Video demostrando el equilibrio entre actitudes positivas y negativas",
      },
      consistency: {
        title: "Sé consistente al aplicar",
        description: "Aplica las actitudes de forma consistente y justa para todos los alumnos.",
        placeholder: "Video mostrando cómo aplicar actitudes de forma consistente",
      },
      revisit: {
        title: "Revísalas con regularidad",
        description: "Revisa periódicamente las actitudes para asegurarte de que sigan siendo pertinentes.",
        placeholder: "Video sobre cómo revisar y actualizar actitudes periódicamente",
      },
      fairValues: {
        title: "Usa valores adecuados",
        description: "Asigna monedas y puntos según la importancia de la actitud.",
        placeholder: "Video explicando cómo definir valores adecuados para actitudes",
      },
    },
    suggestions: {
      positive: {
        presence: { name: "Asistencia", desc: "Asistir a clases con regularidad." },
        punctuality: { name: "Puntualidad", desc: "Llegar a tiempo a las actividades." },
        homework: { name: "Tarea", desc: "Cumplir los deberes dentro del plazo." },
        classwork: { name: "Trabajo en clase", desc: "Realizar las tareas propuestas con dedicación." },
        teamwork: {
          name: "Colaboración y trabajo en equipo",
          desc: "Ayudar a compañeros y trabajar bien en grupo.",
        },
        respect: {
          name: "Respeto a profesores y compañeros",
          desc: "Tratar a todos con educación y consideración.",
        },
        materials: {
          name: "Material completo",
          desc: "Traer todos los materiales e ir correctamente uniformado.",
        },
        participation: {
          name: "Participación activa",
          desc: "Contribuir en las actividades e interactuar en clase.",
        },
      },
      negative: {
        excessTalk: { name: "Exceso de conversación", desc: "Hablar fuera de lugar y molestar la clase." },
        phoneMisuse: {
          name: "Uso inadecuado del celular",
          desc: "Usar el celular sin permiso durante la clase.",
        },
        unexcusedAbsences: {
          name: "Faltas sin justificar",
          desc: "Llegar tarde o faltar sin motivo.",
        },
        carelessMaterial: {
          name: "Descuido con material propio o de la escuela",
          desc: "Dañar libros, pupitres, equipamiento o dejar basura dispersa.",
        },
      },
    },
  },
  quizzes: {
    editQuiz: "Editar quiz",
    alternative: "Alternativa {{index}}",
    removeAlternative: "Eliminar alternativa",
    save: "Guardar",
    cancel: "Cancelar",
    exportToExcel: "Exportar a Excel",
    tipsQuestionTypesTitle: "Varía los tipos de preguntas",
    tipsQuestionTypesDescription: "Mezcla preguntas de opción múltiple, verdadero/falso y respuesta corta.",
    tipsQuestionTypesPlaceholder: "Video mostrando diferentes tipos de preguntas para quizzes",
    tipsDifficultyTitle: "Equilibra la dificultad",
    tipsDifficultyDescription: "Incluye preguntas de diferentes niveles de dificultad para desafiar a todos los alumnos.",
    tipsDifficultyPlaceholder: "Video sobre cómo equilibrar la dificultad de las preguntas",
    tipsResultsTitle: "Analiza los resultados",
    tipsResultsDescription: "Usa los informes para identificar puntos de mejora en el aprendizaje.",
    tipsResultsPlaceholder: "Video tutorial sobre cómo analizar resultados de quizzes",
    tipsExplanationsTitle: "Da explicaciones",
    tipsExplanationsDescription: "Incluye explicaciones para respuestas incorrectas para ayudar en el aprendizaje.",
    tipsExplanationsPlaceholder: "Video demostrando cómo dar explicaciones útiles",
    tipsAiQuestionsTitle: "Usa IA para crear preguntas",
    tipsAiQuestionsDescription: "Aprovecha la generación de preguntas con IA para ahorrar tiempo.",
    tipsAiQuestionsPlaceholder: "Video sobre cómo usar IA para crear preguntas de quiz",
    createQuiz: "Crear Quiz",
    quizzes: "Quizzes",
    loading: "Cargando...",
    checkingIaCredits: "Verificando créditos/plan de IA...",
    iaCheckError: "No fue posible verificar tus créditos de IA en este momento. Intenta nuevamente más tarde.",
    basicInfo: "Información básica",
    selectGames: "Selecciona los segmentos",
    enableCoins: "Habilitar monedas",
    deadlinesAndSettings: "Plazos y configuraciones",
    questionIndex: "Pregunta {{index}}",
    discursiveEvaluation: "Evaluación de respuestas discursivas",
    byAi: "🤖 Por IA",
    manually: "👨‍🏫 Manualmente",
    titleRequired: "El título del quiz es obligatorio.",
    descriptionRequired: "La descripción del quiz es obligatoria.",
    atLeastOneQuestion: "El quiz debe tener al menos una pregunta.",
    questionStatementRequired: "Completa el enunciado de todas las preguntas.",
    alternativesRequired: "Completa todas las alternativas; cada pregunta de opción múltiple necesita al menos dos.",
    correctAlternativeRequired: "Selecciona una respuesta correcta válida en todas las preguntas de opción múltiple.",
    createError: "No se pudo crear el quiz. Revisa los datos e inténtalo de nuevo.",
    rewardsRequired: "Las recompensas del quiz son obligatorias.",
    selectEvaluationMethod: "Selecciona cómo se evaluarán las respuestas discursivas (IA o manual).",
    classesRequired: "Las clases del quiz son obligatorias.",
    cannotExpireNow: "¡La misión no puede terminar ahora! Dé más tiempo a sus alumnos.",
    back: "volver",
    waiting: "Espere...",
    create: "Crear",
    previewTitle: "Vista previa del quiz",
    questionsGenerated: "{{count}} preguntas generadas",
    moreQuestions: "+{{count}} preguntas...",
    difficultyEasy: "Fácil",
    difficultyMedium: "Medio",
    difficultyAdvanced: "Avanzado",
    rename: {
      questions: "pregunta",
      rewards: "recompensas",
      classes: "clases",
      alternatives: "alternativas",
      startDate: "fecha de inicio",
      expirationDate: "fecha de expiración",
      title: "Título",
      description: "Descripción",
      statement: "Enunciado",
      teacherCanValidate: "El profesor puede validar",
      notifyStudents: "Notificar alumnos",
      startsAt: "📅 Comenzará el",
      endsAt: " 📅 Terminará el",
    },
    selectImage: "Selecciona una Imagen",
    searchImages: "Buscar imágenes...",
    imageSearchHint:
      "Busca en la web y elige una imagen. Los resultados aparecen abajo — desplázate por la lista para ver más.",
    imageSearchEmptyTitle: "Busca una imagen",
    imageSearchEmptyHint:
      "Escribe un término (p. ej., «cultura alimentaria») y pulsa Buscar.",
    imageSearchNoResults: "No se encontraron imágenes",
    imageSearchNoResultsHint: "Prueba con otro término o palabras más generales.",
    imageSearchBack: "Volver a la búsqueda",
    imageSearchOpenSource: "Abrir página de origen",
    confidenceHigh: "alta",
    confidenceMedium: "media",
    confidenceLow: "baja",
    search: "Buscar",
    searchFailed: "Error al buscar imágenes. Intenta nuevamente.",
    noTitle: "Sin título",
    image: "Imagen",
    from: "De:",
    unknown: "Desconocido",
    confidence: "Confianza:",
    confidenceUnknown: "desconocida",
    confirmSelection: "Confirmar Selección",
    editImage: "Editar Imagen",
    confirm: "Confirmar",
    reviewDiscursive: "Revisar Discursivas",
    exportToExcelButton: "📊 Exportar a Excel",
    correctAnswers: "Aciertos",
    partialAnswers: "Parciales",
    errors: "Errores",
    averageCorrect: "Promedio aciertos",
    uniqueStudents: "Alumnos únicos",
    resubmissions: "Reenvíos",
    review: "Revisión",
    questionsLabel: "Preguntas",
    answerDistribution: "Distribución de respuestas",
    totalAnswers: "{{count}} respuestas totales",
    submitted: "Enviados",
    pending: "Pendientes",
    correct: "Correctas",
    partialOrWrong: "Parcial/Incorrecto",
    all: "Todos",
    pendingTab: "Pendientes",
    reviewed: "Revisados",
    searchAnswerContent: "Buscar por contenido de respuesta",
    submissions: "Envíos",
    clickToEvaluate: "Haz clic para abrir y evaluar",
    repeated: "REPETIDO",
    answersCount: "{{count}} respuestas",
    players: "Jugadores",
    clickPlayerRow: "Haz clic en la fila del jugador para abrir la revisión",
    name: "Nombre",
    classLabel: "Clase",
    reviewedCount: "Revisadas",
    pendingCount: "Pendientes",
    actions: "Acciones",
    reviewPending: "Revisar pendiente",
    allReviewed: "Todo revisado",
    noSubmissions: "Ningún envío encontrado",
    classRanking: "Ranking de Clases",
    orderedByReviewRate: "Ordenado por tasa de revisión",
    reviewedOfSubmissions: "{{reviewed}} revisadas de {{total}} envíos",
    noClassData: "Sin datos por clase",
    reviewSubmission: "Revisar envío",
    close: "Cerrar",
    statusReviewed: "Revisado",
    statusPending: "Pendiente",
    statusAi: "IA",
    statusCorrect: "CORRECTO",
    statusPartial: "PARCIAL",
    statusWrong: "INCORRECTO",
    toggleCorrect: "Correcto",
    togglePartial: "Parcial",
    toggleWrong: "Incorrecto",
    student: "Alumno",
    sentAt: "Enviado el",
    evaluation: "Evaluación",
    evaluationManual: "Manual",
    evaluationAi: "IA",
    status: "Estado",
    totalResponses: "Total de respuestas",
    statementLabel: "Enunciado",
    studentAnswer: "Respuesta del alumno",
    teacherFeedback: "Comentario del profesor",
    feedbackPlaceholder: "Escriba un comentario/justificación para el alumno",
    aiReasoning: "Razonamiento de la IA",
    coins: "coins",
    totalEstimated: "Total estimado: {{total}} coins",
    saving: "Guardando...",
    saveEvaluation: "Guardar evaluación",
    noDataToExport: "No hay datos para exportar",
    studentName: "Nombre del alumno",
    game: "Segmento",
    noClass: "Sin clase",
    totalCorrect: "Total de aciertos",
    totalErrors: "Total de errores",
    totalPartial: "Total de parciales",
    coinsReceived: "Coins recibidos",
    quizAnswers: "Respuestas del Quiz",
    questions: "Preguntas",
    totalQuestions: "Total: {{count}} preguntas",
    addQuestion: "Agregar pregunta",
    newQuestion: "Nueva pregunta",
    removeQuestion: "Eliminar pregunta",
    addAlternative: "Agregar alternativa",
    multipleChoice: "Opción múltiple",
    discursive: "Discursiva",
    quizTopic: "Tema del Quiz",
    topicPlaceholder: "Ej.: Quiz sobre el Sistema Solar, Historia Universal, Matemáticas Básicas...",
    topicHint: "Sea específico para obtener mejores resultados. Ej.: \"Quiz sobre las capitales de los países de Sudamérica\"",
    detailedDescription: "Descripción detallada (opcional)",
    descriptionPlaceholder: "Describe con más detalle el contenido que deseas abordar en el quiz, temas específicos, enfoque, etc.",
    numberOfQuestions: "Número de preguntas",
    nQuestions: "{{count}} preguntas",
    age6to10: "6 a 10 años",
    age6to10Desc: "Educación infantil, primaria o niños en general",
    simpleLanguage: "Lenguaje simple",
    age10to15: "10 a 15 años",
    age10to15Desc: "ESO o adolescentes",
    deepLanguage: "Lenguaje profundo",
    age15to18: "15 a 18 años",
    age15to18Desc: "Bachillerato o técnico",
    technicalLanguage: "Lenguaje técnico",
    age18plus: "Mayor de 18 años",
    age18plusDesc: "Educación superior o profesional",
    academicLanguage: "Lenguaje académico",
    teacherTip: "Consejo para profesores",
    educationLevelTip: "El nivel educativo ajusta automáticamente el vocabulario y la complejidad de las preguntas para adaptarse al público objetivo.",
    easyDesc: "Preguntas comunes y cotidianas sobre el tema, sin conocimientos previos específicos",
    mediumDesc: "Preguntas más complejas que requieren conocimientos previos sobre el tema",
    advancedDesc: "Preguntas muy inusuales que requieren formación específica en el área",
    difficultyTip: "Elige un nivel de dificultad adecuado para el público objetivo de su quiz y puntuación.",
    goBack: "Volver",
    nextStep: "Siguiente Paso",
    generateQuiz: "GENERAR QUIZ",
    createWithAi: "Crear Quiz con IA",
    createFromScratch: "Crear desde Cero",
    searchQuizByName: "Buscar quiz por nombre",
    selectAGame: "Selecciona un segmento",
    selectAClass: "Selecciona una clase",
    selectATeacher: "Selecciona un profesor",
    allGames: "Todos los segmentos",
    allClasses: "Todas las clases",
    allTeachers: "Todos los profesores",
    allDifficulties: "Todas las dificultades",
    allTab: "Todos",
    activeTab: "Activos",
    inactiveTab: "Inactivos",
    noGameSelected: "Ningún segmento seleccionado",
    more: "+{{count}} más",
    noQuizFound: "No se encontró ningún quiz",
    noQuizFoundSub: "Cambie los filtros o cree más quizzes",
    quizActivated: "Quiz activado con éxito.",
    quizDeactivated: "Quiz desactivado con éxito.",
    quizRemoved: "El quiz fue eliminado con éxito.",
    quizUpdated: "El quiz fue actualizado con éxito.",
    noIaCreditsTitle: "Sin crédito de IA disponible",
    noIaCreditsDesc: "La cuenta de tu escuela no tiene créditos de IA. Crea tu quiz manualmente o contacta al gestor de la cuenta.",
    createManualQuiz: "Crear quiz manual",
    discursiveLabel: "Discursivo",
    multipleChoiceLabel: "Opción múltiple",
    autoApproval: "Aprobación automática",
    aiApproval: "Aprobación con IA",
    manualApproval: "Aprobación manual",
    disabled: "Desactivado",
    createdBy: "Creado por:",
    userFallback: "Usuario",
    difficulty: "Dificultad:",
    creationDate: "Fecha de creación:",
    expirationDate: "Fecha de expiración:",
    noExpiration: "Sin fecha de expiración",
    statusLabel: "Estado:",
    gamesLabel: "Segmentos:",
    classesLabel: "Clases:",
    performance: "Rendimiento:",
    hitRate: "Tasa de aciertos: {{rate}}%",
    results: "Resultados",
    bncc: "BNCC",
    delete: "Eliminar",
    debugJson: "Debug JSON",
    confirmDelete: "Confirmar eliminación",
    confirmDeleteMessage: "¿Estás seguro de que deseas eliminar este quiz?",
    confirmDeleteAction: "Confirmar eliminación",
    discursiveSummary: "Resumen de las discursivas",
    studentsSent: "Alumnos que enviaron: {{count}}",
    awaitingEvaluation: "Esperando evaluación: {{count}}",
    approvedCorrect: "Aprobadas (correcto): {{count}}",
    incomplete: "Incompletas: {{count}}",
    wrong: "Incorrectas: {{count}}",
    awaitingTeacherReview: "{{count}} esperando revisión del profesor",
    reviewAction: "Revisar",
    requiredField: "Campo obligatorio",
    requiredFieldDesc: "Por favor, ingrese el tema del quiz.",
    requiredSelection: "Selección obligatoria",
    requiredSelectionDesc: "Por favor, seleccione el rango de edad del público objetivo.",
    questionType: "Tipo de preguntas",
    multipleChoiceOption: "Opción múltiple",
    discursiveOption: "Discursivas",
    questionTypeHint: "Elige si quiere solo preguntas de opción múltiple o solo discursivas.",
    cancelButton: "CANCELAR",
    backButton: "VOLVER",
    nextStepButton: "SIGUIENTE PASO",
    generatingQuiz: "GENERANDO QUIZ...",
    generateQuizButton: "GENERAR QUIZ",
    preparingQuiz: "Preparando el quiz...",
    generatingQuestion: "Generando pregunta nº {{number}}",
    finishingDetails: "Finalizando últimos detalles",
    createWithFiles: "Crear Quiz con archivos",
    createWithFilesTitle: "Crear Quiz con Archivos",
    createWithFilesDesc: "Suba archivos para crear un quiz basado en contenido visual",
    upload: "Subir",
    processing: "Procesando",
    completed: "Completado",
    quizTitle: "Título del Quiz",
    quizTitlePlaceholder: "Ej.: Quiz sobre Biología Marina",
    uploadImages: "Subir Imágenes",
    clickToUpload: "Haz clic para subir",
    supportedFormats: "Formatos compatibles: JPG, PNG, WEBP, PDF",
    imagesSelected: "{{count}} imágenes seleccionadas",
    imageSelected: "{{count}} imagen seleccionada",
    clearAll: "Limpiar todo",
    processFiles: "Procesar Archivos",
    limitExceeded: "Límite excedido",
    limitExceededDesc: "Puede subir como máximo 50 imágenes.",
    noImages: "Sin imágenes",
    noImagesDesc: "Por favor, suba al menos una imagen.",
    titleRequiredToast: "Título obligatorio",
    titleRequiredDesc: "Por favor, ingrese un título para el quiz.",
    processingImages: "Procesando imágenes...",
    processingComplete: "¡Procesamiento completado!",
    processingDesc: "Nuestra IA está analizando sus imágenes y generando preguntas relevantes para el quiz. Esto puede tardar unos minutos.",
    processingDoneDesc: "Todas las imágenes fueron procesadas con éxito. Su quiz está listo para revisión.",
    percentComplete: "{{percent}}% completado",
    hundredComplete: "100% completado",
    quizGeneratedSuccess: "¡Quiz generado con éxito!",
    quizGeneratedDesc: "Nuestra IA analizó sus imágenes y creó un quiz personalizado. Ahora puede revisar y ajustar las preguntas antes de publicar.",
    quizSummary: "Resumen del Quiz",
    titleLabel: "Título:",
    processedImages: "Imágenes procesadas:",
    generatedQuestions: "Preguntas generadas:",
    estimatedDifficulty: "Dificultad estimada:",
    reviewQuiz: "Revisar Quiz",
    quizGeneratedToast: "¡Quiz generado con éxito!",
    quizGeneratedToastDesc: "Ahora puede revisar y configurar el quiz antes de publicarlo.",
    undo: "Deshacer",
    redo: "Rehacer",
    heading1: "Título 1",
    heading2: "Título 2",
    bold: "Negrita",
    italic: "Cursiva",
    strikethrough: "Tachado",
    superscript: "Superíndice",
    subscript: "Subíndice",
    bulletList: "Lista con Viñetas",
    orderedList: "Lista Numerada",
    blockquote: "Cita",
    code: "Código",
    textColor: "Color del Texto",
    colorLabel: "Color {{color}}",
    insertLink: "Insertar Enlace",
    link: "Enlace",
    insertImage: "Insertar Imagen",
    insertVideo: "Insertar vídeo",
    insertVideoPrompt: "Pega el enlace de YouTube o la URL del vídeo",
    videoDialogHint: "Elige cómo quieres añadir el vídeo.",
    videoSourceChoose: "¿Cómo quieres añadirlo?",
    videoSourceYoutube: "Vídeo de YouTube",
    videoSourceYoutubeDesc: "Pega el enlace de YouTube — incrustamos el reproductor en el texto.",
    videoSourceUpload: "Subir archivo",
    videoSourceUploadDesc: "MP4, WebM y otros formatos alojados en Gamefik.",
    videoSourceLink: "Enlace de vídeo",
    videoSourceLinkDesc: "URL directa de un archivo .mp4 o similar.",
    videoBack: "Volver a opciones",
    videoYoutubePanelHint: "Sigue los pasos para incrustar un vídeo de YouTube.",
    videoUploadPanelHint: "Sube el archivo de vídeo desde tu ordenador.",
    videoLinkPanelHint: "Pega la URL pública del archivo de vídeo.",
    videoYoutubeStep1: "Abre el vídeo en YouTube.",
    videoYoutubeStep2: "Pulsa Compartir → Copiar enlace.",
    videoYoutubeStep3: "Pega el enlace abajo y revisa la vista previa del embed.",
    videoYoutubeFieldLabel: "Enlace de YouTube",
    videoYoutubePlaceholder: "https://www.youtube.com/watch?v=…",
    videoYoutubeInvalid: "No reconocemos este enlace. Usa la URL completa del vídeo en YouTube.",
    videoYoutubeValid: "Enlace válido — revisa el reproductor abajo.",
    videoYoutubeConfirm: "Usar este embed",
    videoYoutubeReady: "El embed de YouTube está listo. Pulsa Insertar para añadirlo al texto.",
    videoEmptyTitle: "Ningún vídeo seleccionado",
    videoPreviewLabel: "Vista previa",
    videoLinkLabel: "URL del vídeo",
    videoLinkPlaceholder: "https://ejemplo.com/video.mp4",
    videoLinkApply: "Usar enlace",
    videoUpload: "Subir vídeo",
    imageLabel: "Imagen",
    imageDialogHint:
      "Sube una imagen, busca en la web o elige del banco de imágenes educativas.",
    imageEmptyTitle: "Ninguna imagen seleccionada",
    imagePreviewLabel: "Vista previa",
    insertAttachment: "Insertar Adjunto",
    attachmentDialogHint:
      "Sube un archivo, busca en la web o elige del banco de imágenes educativas.",
    attachmentUpload: "Subir archivo",
    attachmentSearch: "Buscar en la web",
    attachmentBank: "Banco de imágenes",
    attachmentReady: "Archivo listo para insertar",
    attachment: "Adjunto",
    mobilePreview: "Vista Previa Móvil",
    viewOnMobile: "Ver en celular",
    formattingToolbar: "Formato de texto",
    mediaToolbar: "Insertar medios y vista previa",
    insert: "Insertar",
    closeModal: "Cerrar modal",
    iphonePreview: "iPhone 12/13 (375 × 812 px)",
    imageBank: "Banco de Imágenes Educativas",
    coverDefaultsTitle: "Portada predeterminada de la escuela",
    coverDefaultsDescription: "Elige el origen y, abajo, la asignatura usada en las actividades nuevas.",
    coverSourceLabel: "Origen de las portadas",
    coverDefaultCategoryLabel: "Asignatura predeterminada",
    coverSourceSubject: "Asignatura seleccionada",
    coverSourceCharacters: "Personajes de Gamefik",
    coverSourceMixed: "Asignatura y personajes",
    saveCoverDefault: "Guardar predeterminado",
    coverDefaultSaved: "Predeterminado guardado para esta escuela.",
    coverDefaultSaveError: "No se pudo guardar. Comprueba tu permiso e inténtalo de nuevo.",
    selectCategoryForCoverDefault: "Selecciona una asignatura o categoría abajo para guardar este valor.",
    categoriesLabel: "Categorías",
    allCategories: "Todas",
    searchCategories: "Buscar categorías...",
    noResults: "No se encontraron resultados.",
    loadingCategories: "Cargando categorías...",
    noImagesCategory: "Sin imágenes en esta categoría",
    tryAnotherCategory: "Intente seleccionar otra categoría o subcategoría.",
    exploreImageBank: "Explore el Banco de Imágenes",
    selectCategoryToStart: "Selecciona una categoría arriba para comenzar.",
    clearSelection: "Limpiar selección",
    useImage: "Usar imagen",
    previousImage: "Imagen anterior",
    nextImage: "Siguiente imagen",
    addToFavorites: "Agregar a favoritos",
    removeFromFavorites: "Quitar de favoritos",
    closePreview: "Cerrar vista previa",
    resultsTitle: "Resultados:",
    participation: "Participación",
    completionRate: "{{rate}}% de finalización",
    hitRateTitle: "Tasa de Aciertos",
    information: "Información",
    difficultyLabel: "Dificultad:",
    valueLabel: "Valor:",
    createdByLabel: "Creado por:",
    dateLabel: "Fecha:",
    questionsByHitRate: "Preguntas por Tasa de Acierto",
    questionsByHitRateDesc: "Ordenadas de mayor a menor tasa de acierto",
    hitsCount: "{{count}} aciertos ({{rate}}%)",
    errorsCount: "{{count}} errores ({{rate}}%)",
    noQuestionsFound: "No se encontraron preguntas para este quiz",
    playersTitle: "Jugadores",
    playersDesc: "Lista de alumnos que completaron el quiz",
    allClassesFilter: "Todas las clases",
    searchByName: "Buscar por nombre",
    nameNotAvailable: "Nombre no disponible",
    classNotAvailable: "Clase no disponible",
    noPlayersFound: "No se encontraron jugadores con los filtros seleccionados",
    showingPlayers: "Mostrando {{filtered}} de {{total}} jugadores",
    classRankingTitle: "Ranking de Clases",
    classRankingDesc: "Rendimiento por clase ordenado por tasa de aciertos",
    hitPercentage: "{{rate}}% de aciertos",
    studentsCount: "{{completed}}/{{total}} alumnos ({{rate}}%)",
    hitsOfResponses: "{{hits}} aciertos de {{total}} respuestas",
    questionDetails: "Detalles de la Pregunta",
    correctAnswer: "Respuesta Correcta: {{answer}}",
    hitsTab: "Aciertos ({{count}})",
    errorsTab: "Errores ({{count}})",
    noStudentsCorrect: "Ningún alumno acertó esta pregunta",
    allStudentsCorrect: "Todos los alumnos acertaron esta pregunta",
    nameErrorNotAvailable: "Error: Nombre del alumno no disponible",
    classStudents: "Alumnos de la Clase",
    completedCount: "{{completed}}/{{total}} completaron",
    hitRateLabel: "Tasa de aciertos",
    studentsTookQuiz: "Alumnos que hicieron el quiz",
    participationRate: "Tasa de participación",
    studentList: "Lista de Alumnos",
    position: "Pos.",
    date: "Fecha",
    noStudentsTookQuiz: "Ningún alumno de esta clase hizo el quiz aún",
    showingStudents: "Mostrando {{count}} alumnos que hicieron el quiz",
    studentPerformance: "Rendimiento del Alumno",
    questionsCorrect: "Preguntas acertadas",
    allQuestions: "Todas ({{count}})",
    hitsTabPlayer: "Aciertos ({{count}})",
    errorsTabPlayer: "Errores ({{count}})",
    correctLabel: "CORRECTO",
    wrongLabel: "INCORRECTO",
    studentAnswerLabel: "Respuesta del alumno:",
    correctAnswerLabel: "Respuesta correcta:",
    answerLabel: "Respuesta:",
    noQuestionsAnswered: "El alumno no respondió ninguna pregunta",
    noCorrectAnswers: "El alumno no acertó ninguna pregunta",
    allQuestionsCorrect: "¡El alumno acertó todas las preguntas!",
    noAnswersYet: "Sin respuestas aún",
    noStudentsCompleted: "Ningún alumno completó este quiz hasta el momento.",
    refresh: "Actualizar",
    errorOccurred: "Ocurrió un error",
    errorLoadingData: "Error al cargar datos del quiz o jugadores. Verifica su conexión e intente nuevamente.",
    dataNotAvailable: "Datos del quiz no disponibles.",
    tryAgain: "Intentar nuevamente",
    undoQuiz: "Deshacer quiz (HMG)",
    itemsRemoved: "Ítems eliminados",
    undoQuizDesc: "El quiz \"{{title}}\" fue deshecho para este alumno. Las transacciones y el comprobante a continuación fueron eliminados y el registro fue enviado al historial.",
    undoQuizGeneric: "El quiz fue deshecho para este alumno. Las eliminaciones fueron enviadas al historial.",
    receipt: "Comprobante",
    receiptRemoved: "Comprobante marcado como eliminado",
    noReceiptReturned: "Ningún comprobante devuelto.",
    transactionsRemoved: "Transacciones eliminadas",
    transactionsCount: "{{count}} transacciones eliminadas",
    transactionsSummary: "Resumen de transacciones eliminadas",
    noTransactionsFound: "No se encontraron transacciones para eliminar.",
    historyNote: "Obs.: Un registro detallando las eliminaciones fue enviado al historial de esta cuenta.",
    undoConfirm: "¿Estás seguro de que deseas deshacer este quiz? Esta acción elimina las transacciones asociadas.",
    receiptNotFound: "Comprobante no encontrado para este alumno",
    quizUndone: "Quiz deshecho con éxito",
    undoFailed: "Error al deshacer el quiz, contacte al soporte",
    nameHeader: "Nombre",
    classHeader: "Clase",
    hitsHeader: "Aciertos",
    rateHeader: "Tasa",
    descriptionHeader: "Descripción",
    pointHeader: "Punto",
    valueHeader: "Valor",
    createdAtHeader: "Creado en",
    idLabel: "ID:",
    descriptionFieldLabel: "Descripción:",
    correctFieldLabel: "Correctas:",
    wrongFieldLabel: "Incorrectas:",
    totalFieldLabel: "Total:",
    createdAtFieldLabel: "Creado en:",
    classesResult: "Clases",
    studentLabel: "Alumno",
    studentHitRate: "Tasa de acierto",
    viewBtn: "Ver",
    downloadBtn: "Descargar",
    imageFallback: "Imagen {{index}}",
    descriptionPlaceholderModal: "📝 Describe detalles adicionales sobre el contenido...",
    addNewQuestionTooltip: "Agregar nueva pregunta",
    multipleSubmissionsTooltip: "Este jugador tiene múltiples envíos",
    allClassesShort: "Todas",
  },
  history: {
    loadingStarting: "Iniciando...",
    loadingHistory: "Cargando historial...",
    loadedPeriods: "{{loaded}} de {{total}} periodos cargados",
    loadedRecordsHint: "{{count}} registros cargados hasta ahora — ya puedes usar los filtros mientras llega el resto.",
    filtersAndSearch: "Filtros y búsqueda",
    search: "Buscar",
    searchActivities: "Buscar actividades...",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    category: "Categoría",
    allCategories: "Todas las categorías",
    type: "Tipo",
    noTypesAvailable: "Ningún tipo disponible",
    allTypes: "Todos los tipos",
    playerHistory: {
      title: "Historial del alumno",
      description: "Registros de actitudes, misiones y transacciones de este alumno.",
      searchPlaceholder: "Buscar en el historial",
      filterByGame: "Filtrar por segmento",
      allGames: "Todos los segmentos",
      gameLabel: "Segmento",
      appliedBy: "Aplicado por",
      collectDate: "Fecha de recolección",
      createdAt: "Fecha",
      activities: "Actividades",
      collected: "Recolectado",
      pendingCollect: "Pendiente de recolección",
      noGame: "Sin segmento",
      empty: "No existen registros de actitudes para este alumno.",
      sectionToday: "Hoy",
      sectionYesterday: "Ayer",
      sectionThisWeek: "Esta semana",
      sectionMoreTimeAgo: "En un pasado no tan lejano",
      print: "Imprimir historial",
      close: "Cerrar",
      details: {
        title: "Detalles del Registro",
        tabDetails: "Detalles",
        tabTechnical: "JSON Técnico",
        registerId: "ID del Registro",
        type: "Tipo",
        typeManual: "Actividad Manual",
        typeGame: "Actividad de Juego",
        titleLabel: "Título/Descripción",
        gameName: "Nombre del Segmento",
        appliedBy: "Aplicado por",
        points: "Puntos Obtenidos",
        noPoints: "Ningún punto especificado",
        createdAt: "Fecha de Creación",
        collectDate: "Fecha de Recolección",
        stackedIds: "IDs Apilados ({{count}})",
        technicalData: "Datos Técnicos (JSON)",
        technicalHint: "Copia este JSON para análisis técnico o debugging.",
        close: "Cerrar",
      },
      remove: {
        title: "Confirmar eliminación",
        body: "¿Estás seguro de que deseas eliminar este registro?",
        confirm: "Eliminar",
        cancel: "Cancelar",
      },
      normalizeGames: {
        button: "Normalizar segmentos",
        buttonTitle: "Unificar game_id de todas las transacciones al segmento actual del alumno",
        viewJson: "Ver JSON",
        hideJson: "Ocultar JSON",
        viewJsonTitle: "Mostrar JSON completo del historial",
        title: "Normalizar segmentos",
        description:
          "Reasigna todas las transacciones (hot y cold) al segmento actual del alumno. El saldo por tipo de punto no cambia — solo cambia la partición por segmento.",
        loadingDryRun: "Calculando vista previa…",
        errorTitle: "No se pudo cargar la vista previa",
        errorGeneric: "Error al normalizar segmentos",
        retry: "Reintentar",
        targetGame: "Segmento objetivo",
        targetBadge: "objetivo",
        otherGames: "Otros segmentos",
        before: "Antes (por segmento)",
        after: "Después (consolidado)",
        alreadyNormalized: "Todas las transacciones ya están en el segmento objetivo. Nada que cambiar.",
        saldNoteTitle: "Saldo consolidado (sin cambios)",
        saldNoteBody:
          "La suma por tipo de punto es la misma antes y después. Esta operación solo corrige el game_id en las transacciones.",
        confirmApply: "Confirmar normalización",
        applying: "Aplicando…",
        successTitle: "Segmentos normalizados con éxito",
        filtersTitle: "Incluir transacciones",
        includeCollected: "Puntos recolectados",
        includeUncollected: "Puntos no recolectados",
        noFilterSelected: "Selecciona al menos un tipo de punto para continuar.",
        journeyConflictTitle: "Bonos de jornada duplicados",
        journeyConflictBody:
          "{{count}} transacción(es) de bono de jornada se eliminarán para evitar conflicto de índice único (mismo cycleKey en el segmento objetivo).",
      },
    },
  },
  historyPage: {
    startLoading: "Iniciando...",
    loadingHistory: "Cargando historial...",
    loadedPeriods: "{{loaded}} de {{total}} periodos cargados",
    progressText: "{{count}}%",
    loadedRecords: "{{count}} registros cargados hasta ahora — ya puedes usar los filtros mientras llega el resto.",
    filtersAndSearch: "Filtros y búsqueda",
    search: "Buscar",
    searchPlaceholder: "Buscar actividades...",
    startDate: "Fecha de inicio",
    endDate: "Fecha de fin",
    category: "Categoría",
    allCategories: "Todas las categorías",
    type: "Tipo",
    noTypeAvailable: "Ningún tipo disponible",
    allTypes: "Todos los tipos",
    khanBonus: "Bono Khan Academy",
    otherTypes: "Otros tipos",
    previousPage: "Anterior",
    nextPage: "Siguiente",
  },
  historyCategory: {
    players: "Jugadores",
    game: "Segmento",
    launch: "Lanzamiento",
    class: "Clase",
    shop: "Tienda",
    attitude: "Actitud",
    block: "Bloqueo",
    missions: "Misiones",
    transactions: "Transacciones",
    system: "Sistema",
    khan: "Khan Academy",
    recurrence: "Recurrencia",
    ai: "IA",
    missionProofs: "Comprobantes",
    quizzes: "Quizzes",
    nullifiedTransactions: "Transacciones anuladas",
    security: "Seguridad",
    aiCredits: "Créditos IA",
    letrus: "Letrus",
  },
  historyType: {
    create: "Creación",
    update: "Actualización",
    remove: "Eliminación",
    delete: "Borrado",
    accepted: "Aceptado",
    delivered: "Entregado",
    canceled: "Cancelado",
    changeClass: "Cambio de clase",
    changeGame: "Cambio de segmento",
    generateQrCode: "Generación de QR Code",
    resetGame: "Reinicio de segmento",
    apply: "Aplicación",
    edit: "Edición",
    freeze: "Congelamiento",
    prove: "Comprobación",
    tempUnlock: "Desbloqueo temporal",
    khanDailyBonus: "Bono diario Khan",
    khanWeeklyBonus: "Bono semanal Khan",
    khanMonthlyBonus: "Bono mensual Khan",
    khanWeeklyMasteryBonus: "Bono de dominio Khan (semanal)",
    khanMonthlyMasteryBonus: "Bono de dominio Khan (mensual)",
    khanOccasionalPercentBonus: "Bono porcentual Khan",
    nullify: "Anulación",
    applyRecurrence: "Aplicar recurrencia",
    startApplyRecurrence: "Iniciar recurrencia",
    aiActivate: "Activar IA",
    aiDeactivate: "Desactivar IA",
    aiScheduleCancel: "Cancelar programación IA",
    aiChangePlan: "Cambiar plan IA",
    aiApplyDiscount: "Aplicar descuento IA",
    aiToggle: "Alternar IA",
    aiSelectStudents: "Seleccionar alumnos con IA",
    aiSelectStudentsV2: "Selección de alumnos IA 2.0",
    aiGenerateAttempt: "Generación IA iniciada",
    aiGenerateSuccess: "Generación IA completada",
    aiGenerateFailure: "Fallo en la generación IA",
    generateQrCodeVoleimania: "Generación QR Code Voleimania",
    khanMarcosBonus: "Bono de hitos Khan",
    xpDisable: "Desactivación de XP",
    xpEnable: "Activación de XP",
    spent: "Gasto",
    adjust: "Ajuste",
    dailyAlert: "Alerta diaria",
    impersonationTokenGenerated: "Token de acceso generado",
    impersonationLoginSuccess: "Inicio de sesión de acceso",
    letrusMonthly: "Informe mensual Letrus",
  },
  historyDialog: {
    noData: "No hay datos disponibles",
    activityDetails: "Detalles de la actividad",
    overview: "Resumen general",
    details: "Detalles",
    technicalData: "Datos técnicos",
    dateAndTime: "Fecha y hora",
    categoryAndType: "Categoría y tipo",
    affectedPlayers: "Jugadores afectados ({{count}})",
    identifiers: "Identificadores",
    account: "Cuenta",
    completeDataJson: "Datos completos (JSON)",
    showJson: "Mostrar JSON",
    hideJson: "Ocultar JSON",
    downloadQrCode: "Descargar QR Code",
    submissions: "Envíos",
    pending: "Pendientes",
    reviewed: "Revisados",
    searchAnswerContent: "Buscar por contenido de la respuesta",
    answerDistribution: "Distribución de las respuestas",
    totalAnswers: "{{count}} respuestas en total",
    submitted: "Enviadas",
    correct: "Correctas",
    partialOrWrong: "Parcial/Incorrecta",
    repeat: "Reenvío",
    reviewRate: "Revisión",
    uniqueStudents: "Alumnos únicos",
    averageCorrect: "Promedio de aciertos",
    questions: "Preguntas",
    responses: "Respuestas",
    partial: "Parciales",
    errors: "Errores",
    repeated: "REPETIDO",
    submittedAt: "Enviado el {{date}}",
    unknownDate: "Fecha desconocida",
    missionNotFound: "Misión no encontrada",
    backToSelection: "Volver a la selección",
    selectMission: "Selecciona una misión",
    pendingOne: "{{count}} pendiente",
    pendingOther: "{{count}} pendientes",
    noMissionAvailable: "No hay misiones disponibles",
    exportCsv: "Exportar CSV",
    loadErrorTitle: "Se produjo un error al cargar los datos.",
    loadErrorDescription: "Comprueba tu conexión e inténtalo de nuevo.",
    retry: "Intentar de nuevo",
    loadingData: "Cargando datos...",
    updating: "Actualizando...",
    approvedOne: "{{count}} premiado",
    approvedOther: "{{count}} premiados",
    activities: "{{count}} actividades",
    students: "{{count}} alumnos",
    periodSummary: "Resumen del período",
    processedMonthReport: "Informe del mes procesado",
    generatedAt: "Generado el {{date}}",
    writes: "Redacciones",
    rewrites: "Reescrituras",
    totalDistributed: "Total distribuido",
    operationPerformed: "Operación realizada:",
    monthlyLetrusReport: "Informe mensual Letrus",
    pageSummary: "Página {{page}} de {{totalPages}} • {{count}} actividades",
    noActivityFound: "No se encontró ninguna actividad",
    noActivityDescription: "Prueba a ajustar los filtros o realiza algunas acciones en el sistema",
    applyingFilters: "Aplicando filtros...",
    processingData: "Procesando datos",
    clearFilters: "Limpiar filtros",
    allUsers: "Todos los usuarios",
    processed: "Procesados",
    awarded: "Premiados",
    allGames: "Todos los segmentos",
    allClasses: "Todas las clases",
    noStudentFound: "Ningún alumno encontrado",
    adjustFilters: "Intenta ajustar los filtros",
    noClass: "Sin clase",
    searchingTransactions: "Buscando transacciones con",
    noTransactionFound: "Ninguna transacción encontrada",
    transactionsRemovedOrNotSaved: "Las transacciones pueden haber sido eliminadas o no guardadas",
    attitudeRemovedNoDetails: "Actitud eliminada sin datos detallados",
    removalRecordKeptInHistory: "Solo el registro de eliminación se mantuvo en el historial",
    noPlayersAffected: "Ningún jugador afectado",
    noScoringSystemConfigured: "Ningún sistema de puntuación configurado",
    noPointTypeSpecified: "Ningún tipo de punto especificado",
    progressZeroed: "Progreso reiniciado a cero",
    missionsReset: "Misiones reiniciadas",
    productImage: "Imagen del producto",
    removedProductImage: "Imagen del producto eliminado",
    noGameLinked: "Ningún segmento vinculado",
    showingTransactions: "Mostrando transacciones con",
    user: "Usuario",
    actions: "Acciones",
  },
  sharedInfoModal: {
    trigger: "Buenas prácticas",
    title: "Buenas prácticas: {{pageName}}",
    videosTab: "Vídeos",
    textTab: "Texto",
    understood: "Entendido",
  },
  legacyAlertDialog: {
    cancel: "Cancelar",
    accept: "Aceptar",
  },
  gift: {
    pageTitle: "[GiftCard] - GiftCard | Gamefik Escuelas al máximo nivel.",
    overview: "Visión general",
    buyGifts: "Comprar gifts",
    giftCardDetails: "Detalles del gift card",
    giftCardDescriptionTitle: "Descripción",
    copyIssuedCode: "Copiar código de {{name}}",
    issuedTitle: "Gift cards emitidos",
    issuedStudent: "Alumno",
    issuedStudentUnavailable: "No informado",
    receiptDetails: "Detalles del recibo",
    receiptMessageTitle: "Mensaje de recibo",
    howToUse: "Cómo usar",
    termsAndConditions: "Términos y condiciones",
    termsAndConditionsLink: "Términos y condiciones",
    redeemInstructionsFallback: "Consulta las instrucciones de canje a continuación.",
    readAndAcceptTerms: "He leído y acepto los términos de uso",
    cancel: "Cancelar",
    confirmAndAdd: "Confirmar y agregar",
    details: "Detalles",
    viewSpecifications: "Ver especificaciones",
    specificationsDescription: "Lee las reglas, desplázate hasta el final y acepta los términos para continuar la compra.",
    termsPending: "Términos pendientes. Revisa y acepta",
    termsAccepted: "Términos leídos y aceptados",
    reviewAndAcceptTerms: "Revisar y aceptar los términos",
    scrollTermsToEnd: "Desplázate hasta el final para habilitar la aceptación de los términos.",
    termsEndReached: "Llegaste al final. Ahora marca la confirmación a continuación.",
    acceptTermsExplicitly: "He leído todas las especificaciones y acepto los términos de esta tarjeta regalo.",
    acceptTermsAction: "Aceptar los términos de esta tarjeta regalo",
    search: "Buscar",
    loadError: "No se pudieron cargar los gift cards.",
    tryAgain: "Intentar de nuevo",
    balance: "Saldo",
    addBalance: "Añadir saldo",
    selectValue: "Seleccionar valor",
    available: "{{count}} disponibles",
    gameLabel: "Segmento *",
    costInCoins: "¿Cuánto costará (en monedas)? *",
    coinsPlaceholder: "Valor en monedas",
    playerLimit: "Límite por alumno",
    unlimited: "Ilimitado",
    advancedSettings: "Configuración avanzada",
    optional: "Opcional",
    schedule: "Programar",
    noLimits: "Sin límites",
    limitPerStudent: "{{count}} por alumno",
    clearCart: "Vaciar carrito",
    finishWithBalance: "Finalizar con saldo",
    purchaseSummary: "Resumen de compra",
    items: "Artículos",
    subtotal: "Subtotal",
    confirm: "Confirmar",
    close: "Cerrar",
    viewTerms: "ver términos",
    filtersTitle: "Filtros",
    valueLabel: "Valor",
    myBalance: "Mi Saldo",
    availableValues: "Valores disponibles",
    continueButton: "Continuar",
    congratsPurchase: "¡Felicitaciones por tu compra!",
    makeCardsAvailable: "¡Pon las tarjetas a disposición de los alumnos!",
    finishButton: "Concluir",
    startingFrom: "Desde R$ {{value}}",
    viewProduct: "Ver Producto",
    makeAvailableInStore: "Disponibilizar en la Tienda",
    howToUseLabel: "Cómo Usar",
    continueShopping: "Continuar Comprando",
    sendToStore: "Enviar a la tienda",
    buyGift: "Comprar Gift",
    refundButton: "Reembolso",
    selectGiftForDelivery: "Selecciona un gift para realizar la entrega",
    giftCardDiscontinued: "Lamentablemente, este gift card fue descontinuado",
    requestRefund: "Solicitar reembolso",
    deliverGiftToStudent: "Entregar gift al alumno",
    usageLocations: "Dónde se puede usar",
    description: "Descripción",
    receiptMessage: "Mensaje del recibo",
    usageTermsAccept: "He leído y acepto los términos de uso",
    stock: "Saldo",
    emptyCart: "Vaciar",
    finalizeWithBalance: "Finalizar con Saldo",
    minimumValueDescription: "Puedes agregar un saldo igual o superior a R$50,00.",
  },
  balance: {
    walletBalanceTitle: "Mi saldo en cartera",
    updated: "Actualizado",
    totalDeposits: "Total de depósitos",
    totalPurchases: "Total de compras",
    totalTransactions: "Total de transacciones",
    back: "Volver",
    overviewExtractTitle: "Visión general - Extracto",
    overviewExtractDescription: "Acompaña todas tus transacciones financieras",
    refresh: "Actualizar",
    tutorial: "Tutorial",
    addBalanceTitle: "Agrega saldo y deleita a tus alumnos con nuestros gift cards",
    addBalanceDescription: "Puedes agregar un saldo igual o superior a R$50,00.",
    minimumValueDescription: "Puedes agregar un saldo igual o superior a R$50,00.",
    enterValue: "Introduce el monto",
    addBalanceAction: "Agregar saldo",
    fullName: "Nombre completo",
    cpfOrCnpj: "Identificación fiscal",
    acceptTerms: "Acepto los términos y condiciones",
    continue: "Continuar",
    pay: "Pagar",
    overview: "Visión general",
    addBalancePage: "Agregar Saldo",
    namePlaceholder: "Nombre",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "Correo electrónico",
    termsTitle: "TÉRMINOS DE USO DE SALDO Y GIFT CARDS DE GAMEFIK",
    cancelButton: "Cancelar",
    acceptButton: "Aceptar",
    invalidName: "Nombre inválido",
    invalidCpfCnpj: "Identificación fiscal inválida",
    invalidEmail: "Correo electrónico inválido",
    acceptTermsError: "Acepta los términos de uso",
    payValue: "Pagar R${{value}},00",
    backButton: "Volver",
    refundNotice: "Saldo reembolsable solo para solicitudes realizadas dentro de los 7 días posteriores al pago",
    cardData: "Datos de la tarjeta",
    cardNumber: "Número de la tarjeta",
    month: "Mes",
    year: "Año",
    holderData: "Datos del titular",
    holderName: "Nombre del titular",
    cardHolder: "Titular de la tarjeta",
    cellphoneLabel: "Celular",
    zipCode: "Código postal",
    creditCard: "Tarjeta de crédito",
    paymentSuccess: "Pago realizado con éxito",
    pixKey: "Clave Pix:",
    pixInstruction: "Usa la clave pix de arriba, o el código QR en tu app bancaria para realizar el pago.",
    finalize: "Finalizar",
    pixPayment: "¡Pago vía PIX!",
    boletoGenerated: "¡Tu boleto ha sido generado!",
    boletoInstruction: "Paga tu boleto ahora o antes de la fecha de vencimiento. Para pagar, copia el código de barras, abre la app o sitio web de tu banco y realiza el pago.",
    orderDetails: "Detalles del pedido",
    taxesAndFees: "Impuestos y Tasas",
    includingTaxes: "Incluyendo impuestos",
    extractDetailedTitle: "Extracto detallado",
    extractType: "Tipo",
    extractDetails: "Detalles",
    extractValue: "Valor",
    extractPurchaseValue: "Valor de compra",
    extractMethod: "Forma",
    extractQuantity: "Cantidad",
    extractDate: "Fecha",
    accumulatedBalance: "Saldo Acumulado",
    receipt: "Comprobante",
    noTransactions: "No se encontraron transacciones",
    transactionsWillAppear: "Tus transacciones aparecerán aquí cuando estén disponibles.",
    giftPurchase: "Compra de Gift",
    refund: "Reembolso",
    userOrigin: "Usuario",
    adminAddBalance: "Admin - Agregar saldo",
    adminRemoveBalance: "Admin - Quitar saldo",
    boletoPix: "Boleto/Pix",
    boletoMethod: "Boleto",
    creditCardMethod: "Tarjeta de crédito",
    adminMethod: "Admin",
    pixMethod: "PIX",
    notInformed: "No informado",
    balanceMethod: "Saldo",
    paymentTitle: "Pago",
    payWith: "Pagar con",
    pixLabel: "Pix",
    cardDataTitle: "Datos de la Tarjeta",
    cardNumberLabel: "Número de la Tarjeta",
    monthLabel: "Mes",
    yearLabel: "Año",
    cvvLabel: "CVV",
    holderDataTitle: "Datos del Titular",
    holderNameLabel: "Nombre del Titular",
    holderNamePlaceholder: "Titular de la Tarjeta",
    cpfCnpjLabel: "CPF/CNPJ",
    cpfCnpjPlaceholder: "¡Ingresa el CPF/CNPJ del titular!",
    phoneLabel: "Teléfono",
    mobilePhoneLabel: "Celular",
    postalCodeLabel: "Código Postal",
    numberLabel: "Número",
    complementLabel: "Complemento",
    complementPlaceholder: "Casa/Apto",
    saveCardData: "Guardar mis datos de la Tarjeta",
    payAmount: "Pagar R${{value}}.00",
    creditCardTitle: "Tarjeta de crédito",
    paymentSuccessTitle: "Pago completado con éxito",
    thankYouPurchase: "Gracias por su compra",
    returnToHome: "Volver al inicio",
    privacyNotice: "Sus datos personales se utilizarán para procesar su pedido, respaldar su experiencia en todo este sitio y para otros fines descritos en nuestra política de privacidad.",
    pixKeyLabel: "Clave Pix:",
    pixInstructions: "Use la clave Pix de arriba, o el código QR en su aplicación bancaria para realizar el pago.",
    finalizeButton: "Finalizar",
    pixPaymentTitle: "¡Pago via PIX!",
    emailCopySent: "Enviamos una copia a su correo electrónico",
    valueLabel: "Valor: R${{value}}.00",
    extractButton: "Extracto",
    boletoGeneratedTitle: "¡Su boleto ha sido generado!",
    boletoPayInstructions: "Pague su boleto ahora o hasta la fecha de vencimiento.",
    boletoPayDetails: "Para pagar, copie el código de barras, abra la aplicación o sitio web de su banco y realice el pago.",
    viewBoleto: "Ver Boleto",
    orderDetailsTitle: "Detalles del Pedido",
    balanceRecharge: "Recarga de saldo",
    subtotalLabel: "Subtotal",
    feesLabel: "Tasas y Cargos",
    totalLabel: "Total",
    includingFees: "Incluyendo tasas",
    refundNoticePayment: "Saldo reembolsable solo para solicitudes realizadas hasta un máximo de 7 días después del pago",
    januaryMonth: "Enero",
    februaryMonth: "Febrero",
    marchMonth: "Marzo",
    aprilMonth: "Abril",
    mayMonth: "Mayo",
    juneMonth: "Junio",
    julyMonth: "Julio",
    augustMonth: "Agosto",
    septemberMonth: "Septiembre",
    octoberMonth: "Octubre",
    novemberMonth: "Noviembre",
    decemberMonth: "Diciembre",
  },
  communication: {
    pageTitle: "Mural",
    pageSubtitle: "Gestiona comunicados, eventos y plazos de la escuela",
    viewing: "Viendo:",
    selectClass: "Selecciona la clase",
    feed: "Feed",
    shinyOnlyTitle: "El Mural está disponible en el plan Shiny",
    shinyOnlyDescription: "El Mural forma parte del plan Shiny. Suscríbete a Shiny para desbloquear comunicados, eventos y el feed completo de la clase.",
    shinyOnlySecondary: "Volver",
    calendar: "Calendario",
    metrics: "Métricas",
    announcements: "Comunicados",
    views: "Visualizaciones",
    events: "Eventos",
    upcomingDeadlines: "Próximos Plazos",
    viewAll: "Ver todos",
    noScheduledDeadline: "Ningún plazo agendado",
    mostViewed: "Más Vistos",
    noAnnouncementForClass: "Ningún comunicado para esta clase",
    allDeadlines: "Todos los Plazos",
    noActivityThisDay: "Ninguna actividad este día",
    createActivityThisDay: "Crear actividad este día",
    details: "Detalles",
    description: "Descripción",
    studentCompletion: "Progreso de los alumnos",
    studentsCompleted: "{{percent}}% de los alumnos completaron",
    noStudentAssigned: "Ningún alumno asignado aún",
    edit: "Editar",
    delete: "Eliminar",
    whatToCreate: "¿Qué deseas crear?",
    eventLabel: "Evento",
    eventDesc: "Reuniones, fiestas, presentaciones",
    quizLabel: "Quiz",
    quizDesc: "Preguntas y evaluaciones rápidas",
    missionLabel: "Misión",
    missionDesc: "Desafíos y actividades con plazo",
    newEvent: "Nuevo Evento",
    newQuiz: "Nuevo Quiz",
    newMission: "Nueva Misión",
    eventTitleLabel: "Título del evento",
    quizTitleLabel: "Título del quiz",
    missionTitleLabel: "Título de la misión",
    eventTitlePlaceholder: "Ej: Reunión de padres",
    quizTitlePlaceholder: "Ej: Quiz de Matemáticas",
    missionTitlePlaceholder: "Ej: Lectura Mensual",
    schedule: "Horario",
    deadlineTime: "Plazo (horario)",
    location: "Lugar",
    locationPlaceholder: "Ej: Auditorio",
    coins: "Coins",
    numberOfQuestions: "Número de preguntas",
    descriptionOptional: "Descripción (opcional)",
    describeEvent: "Describe el evento...",
    describeQuiz: "Describe el quiz...",
    describeMission: "Describe la misión...",
    cancel: "Cancelar",
    createEvent: "Crear Evento",
    createQuiz: "Crear Quiz",
    createMission: "Crear Misión",
    deleteEvent: "Eliminar evento",
    deleteQuiz: "Eliminar quiz",
    deleteMission: "Eliminar misión",
    deleteConfirm: "¿Estás seguro de que deseas eliminar",
    actionCannotBeUndone: "Esta acción no se puede deshacer.",
    viewAnnouncementTitle: "Ver comunicado",
    duplicatedSuccess: "Comunicado duplicado con éxito",
    duplicateError: "Error al duplicar comunicado",
    createPostError: "Error al crear publicación. Inténtalo de nuevo.",
    createEventError: "Error al crear evento. Inténtalo de nuevo.",
    deleteSuccess: "Eliminado con éxito",
    deleteError: "Error al eliminar. Inténtalo de nuevo.",
    editSuccess: "Cambios guardados con éxito",
    editError: "Error al guardar cambios. Inténtalo de nuevo.",
    createEventSuccess: "Evento creado con éxito",
    questions: "preguntas",
    completed: "completaron",
    participants: "participantes",
    monthNames: "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",
    weekDays: "Dom,Lun,Mar,Mié,Jue,Vie,Sáb",
    now: "Ahora",
    minAgo: "hace {{count}} min",
    hoursAgo: "hace {{count}} hora{{suffix}}",
    daysAgo: "hace {{count}} día{{suffix}}",
    roleTeacher: "Profesor",
    roleSecretary: "Secretaria",
    roleFinancial: "Financiero",
    roleManager: "Gestor",
    more: "+{{count}} más",
    wholeSchool: "Toda la escuela",
    allClasses: "Todas las clases",
    teachers: "Profesores",
    students: "Alumnos",
    teachingStaff: "Cuerpo docente",
    editAction: "Editar",
    duplicateAction: "Duplicar",
    shareLink: "Compartir enlace",
    deleteAction: "Eliminar",
    inspectJson: "Inspeccionar JSON",
    reactions: "reacciones",
    noReactionsYet: "Sin reacciones aún",
    viewsCount: "visualizaciones",
    viewsTitle: "Visualizaciones ({{count}})",
    reactionsTitle: "Reacciones ({{count}})",
    seeMore: "Ver más ({{count}})",
    deleteAnnouncement: "Eliminar comunicado",
    deleteAnnouncementConfirm: "¿Estás seguro de que deseas eliminar este comunicado? Esta acción no se puede deshacer.",
    linkCopied: "Enlace copiado",
    noReactionYet: "Ninguna reacción aún",
    whatToCommunicate: "¿Qué te gustaría comunicar?",
    postTitleRequired: "Título *",
    eventName: "Nombre del evento *",
    eventDescOptional: "Descripción del evento (opcional)",
    date: "Fecha",
    time: "Horario",
    bold: "Negrita",
    italic: "Cursiva",
    underline: "Subrayado",
    list: "Lista",
    numberedList: "Lista numerada",
    insertLink: "Insertar enlace",
    enterLinkUrl: "Ingresa la URL del enlace:",
    photo: "Foto",
    video: "Vídeo",
    attachment: "Adjunto",
    addImage: "Agregar imagen",
    addVideo: "Agregar vídeo",
    attachFile: "Adjuntar archivo",
    embedQuiz: "Incrustar quiz",
    embedMission: "Incrustar misión",
    createEventAction: "Crear evento",
    backToAnnouncement: "Volver al comunicado",
    publishAction: "Publicar",
    published: "¡Publicado!",
    sendingProgress: "Enviando {{done}}/{{total}}...",
    publishing: "Publicando...",
    publishError: "Error al publicar. Inténtalo de nuevo.",
    publishWhen: "Cuándo publicar",
    publishNow: "Publicar ahora",
    schedulePost: "Programar",
    muralAiButton: "Crear con IA",
    muralAiOpen: "Crear texto del Mural con IA",
    muralAiTitle: "Crear texto con IA",
    muralAiDescription: "Describe el comunicado. La IA sugerirá un título y un texto que podrás editar antes de publicar.",
    muralAiPromptLabel: "¿Qué deseas comunicar?",
    muralAiPromptPlaceholder: "Ej.: Escribe un aviso acogedor sobre la feria cultural del viernes.",
    muralAiCost: "Esta sugerencia cuesta {{cost}} créditos de IA.",
    muralAiGenerate: "Generar sugerencia",
    muralAiGenerating: "Generando...",
    muralAiPromptRequired: "Describe el comunicado que deseas crear.",
    muralAiError: "No fue posible generar el texto ahora. Tu contenido fue preservado; inténtalo de nuevo.",
    scheduleDateTime: "Fecha y hora",
    scheduleHint: "Las notificaciones push y los demás efectos se enviarán en el horario elegido.",
    scheduleFutureError: "Elige una fecha y una hora futuras.",
    scheduleAction: "Programar",
    scheduling: "Programando...",
    scheduledSuccess: "¡Programado!",
    scheduledPosts: "Programadas",
    scheduledPostsHint: "Edita el contenido, reprograma o cancela publicaciones pendientes.",
    backToFeed: "Volver al mural",
    noScheduledPosts: "No hay publicaciones programadas.",
    scheduledBadge: "Programada",
    untitledPost: "Publicación sin título",
    rescheduleAction: "Reprogramar",
    cancelScheduledAction: "Cancelar programación",
    rescheduledSuccess: "Publicación reprogramada correctamente.",
    scheduledCancelledSuccess: "Programación cancelada correctamente.",
    scheduledConflictError: "Esta publicación ya fue publicada o modificada. Actualiza el Mural para ver su estado actual.",
    scheduledActionError: "No se pudo cambiar la programación. Inténtalo de nuevo.",
    scheduledEditorHint: "Cambia el horario en el área Programadas.",
    schedulingCapabilityError: "No se pudo comprobar si la programación está disponible.",
    retryAction: "Intentar de nuevo",
    emptyContentError: "Escribe un texto o adjunta una imagen/archivo antes de guardar.",
    notifyPushLabel: "Notificar a los alumnos por push",
    notifyPushHint: "Los alumnos reciben una notificación en el móvil con el inicio del aviso.",
    where: "Dónde:",
    classes: "Clases:",
    all: "Todas",
    classesCount: "{{count}} clases",
    embeddedQuiz: "Quiz incrustado",
    embeddedMission: "Misión incrustada",
    quizAvailable: "Quiz disponible",
    missionAvailable: "Misión disponible",
    selectQuiz: "Seleccionar Quiz",
    selectMission: "Seleccionar Misión",
    searchQuiz: "Buscar quiz...",
    searchMission: "Buscar misión...",
    noQuizFound: "Ningún quiz encontrado",
    noMissionFound: "Ninguna misión encontrada",
    editAnnouncement: "Editar Comunicado",
    duplicateAnnouncement: "Duplicar Comunicado",
    saveChanges: "Guardar cambios",
    publishCopy: "Publicar copia",
    sending: "Enviando...",
    uploadError: "Error al enviar archivos:",
    current: "Actual",
    future: "Futuro",
    until: "Hasta",
    legendEvents: "Eventos",
    legendQuizzes: "Quizzes",
    legendMissions: "Misiones",
    linkUrlPrompt: "URL del enlace:",
    schoolBadge: "Escuela",
    quizBadge: "QUIZ",
    missionBadge: "MISIÓN",
    eventBadgeLabel: "EVENTO",
    moreStudentsCount: "+{{count}} alumnos",
    coinsUnit: "coins",
    freeLimitBannerTitle: "Límite del plan Free alcanzado",
    freeLimitBannerDescription: "El plan Free permite hasta {{limit}} comunicados en el muro. Mejora a Shiny para publicar sin límites.",
    freeUnavailableBannerTitle: "Muro no disponible en el plan Free",
    freeUnavailableBannerDescription: "El plan Free no incluye comunicados en el muro. Mejora a Shiny para publicar.",
    freeLimitBannerCta: "Ver planes",
    freeLimitUsageLabel: "Comunicados publicados",
    freeLimitModalTitle: "Has alcanzado el límite del plan Free",
    freeLimitModalDescription: "Ya publicaste {{count}} de {{limit}} comunicados disponibles en el plan Free. Suscríbete a Shiny para publicar sin límites.",
    freeLimitModalCta: "Suscribirse a Shiny",
    freeLimitModalDismiss: "Entendido",
  },
  recurrence: {
    pageTitle: "Automatizaciones y Recurrencias",
    eyebrow: "Automatización",
    pageDescription: "Programa actitudes recurrentes, controla lo que está activo y decide cuándo vencen los puntos no recolectados.",
    summaryTitle: "Resumen de automatizaciones",
    summaryActive: "Automatizaciones activas",
    summaryPaused: "Automatizaciones pausadas",
    summaryExpiring: "Con vencimiento de puntos",
    listTitle: "Tus automatizaciones",
    listDescription: "Gestiona frecuencia, segmentos, recolección y estado en un solo lugar.",
    totalCount: "{{count}} automatizaciones",
    rewardsLabel: "Recompensa",
    createDialogDescription: "Configura la actitud, la frecuencia y las reglas de recolección de esta automatización.",
    creating: "Creando...",
    createNew: "Crear Nueva Recurrencia",
    coinDistributionAnalysis: "Análisis de Distribución de Monedas por Recurrencia",
    analyzedRecurrences: "Recurrencias Analizadas",
    totalCoins: "Total de Monedas",
    totalTransactions: "Total de Transacciones",
    monthlyDistributionHistory: "Historial de Distribución Mensual de Monedas",
    detailByRecurrence: "Detalle por Recurrencia",
    attitudeNotFound: "Actitud no encontrada",
    active: "Activa",
    inactive: "Inactiva",
    createdAt: "Creada el:",
    transactions: "transacciones",
    monthlyDistribution: "Distribución mensual de esta recurrencia:",
    aboutAnalysis: "Sobre este análisis:",
    analysisInfo1: "Este análisis muestra el historial real de distribución de monedas por recurrencias",
    analysisInfo2: "Los datos se basan en transacciones efectivamente realizadas",
    analysisInfo3: "Cada recurrencia puede tener patrones de distribución mensual diferentes",
    analysisInfo4: "Usa esta información para optimizar tus estrategias de gamificación",
    progressAnalysis: "Análisis de Progreso: Distribuido vs Previsto",
    alreadyDistributed: "Ya Distribuido",
    predictedRemaining: "Previsto (Restante)",
    yearTotal: "Total del Año",
    progress: "Progreso",
    annualDistributionProgress: "Progreso Anual de Distribución",
    yearStart: "Inicio del año",
    yearEnd: "Fin del año",
    distributed: "Distribuido:",
    remaining: "Restante:",
    timelineHistoryVsPrediction: "Línea Temporal: Historial vs Previsión",
    historicalData: "Datos Históricos (monedas ya distribuidas)",
    predictionForPeriod: "Previsión para el período",
    greenBarExplanation: "La barra verde aparece sobre la azul para comparar rendimiento real frente al previsto",
    progressInsights: "Perspectivas de Progreso:",
    distributionRhythm: "Ritmo de Distribución:",
    coinsPerMonth: "Promedio de {{count}} monedas/mes",
    annualGoal: "Meta Anual:",
    completedOfTotal: "{{percent}}% completado del total proyectado",
    projection: "Proyección:",
    coinsUntilDecember: "Quedan {{count}} monedas hasta diciembre",
    efficiency: "Eficiencia:",
    transactionsCompleted: "{{count}} transacciones realizadas",
    detailedCoinPredictions: "Cálculo Detallado de las Previsiones de Monedas",
    activeRecurrences: "Recurrencias Activas",
    daysUntilYearEnd: "Días hasta fin de año",
    totalPredicted: "Total Previsto",
    detailedCalcByRecurrence: "Cálculo Detallado por Recurrencia",
    totalOfThisRecurrence: "Total de esta recurrencia",
    stepByStepCalc: "Cálculo paso a paso:",
    applicationFrequency: "Frecuencia de aplicación",
    applications: "aplicaciones",
    coinsPerApplication: "Monedas por aplicación",
    configuredInAttitude: "Valor configurado en la actitud",
    eachTimeApplied: "Cada vez que la actitud se aplica a un alumno",
    coinsLabel: "monedas",
    affectedStudents: "Alumnos afectados",
    totalStudentsReceiving: "Total de alumnos que recibirán la actitud",
    studentsLabel: "alumnos",
    finalCalc: "Cálculo final",
    applicationsTimesCoinsTimesStudents: "{{apps}} aplicaciones × {{coins}} monedas × {{students}} alumnos",
    distributionByGame: "Distribución por segmento:",
    unknownGame: "Segmento desconocido",
    calcFormula: "Fórmula de Cálculo:",
    formulaTotalCoins: "Total de Monedas",
    formulaApplications: "Aplicaciones",
    formulaCoinsPerApp: "Monedas por Aplicación",
    formulaStudentCount: "Número de Alumnos",
    formulaApplicationsDesc: "Calculado según la frecuencia (diaria, semanal, mensual) y los días restantes del año",
    formulaCoinsPerAppDesc: "Valor configurado en la actitud",
    formulaStudentCountDesc: "Alumnos activos en los segmentos asociados a la recurrencia",
    individualPrediction: "Previsión Individual: Monedas por Alumno",
    averagePerStudent: "Promedio por Alumno",
    averageCalc: "Cálculo del Promedio:",
    totalCoinsLabel: "Total de monedas:",
    numberOfStudents: "Número de alumnos:",
    average: "Promedio:",
    yearlyPreviewByGame: "Previsión Total de Monedas hasta Fin de Año por Segmento",
    generalTotal: "Total General",
    coinsDistributedTo: "Monedas que se distribuirán a {{count}} alumnos",
    untilDate: "hasta 31/12/{{year}}",
    detailByGame: "Desglose por Segmento",
    studentsCount: "{{count}} alumnos",
    perStudent: "{{count}} por alumno",
    gameTotal: "Total del segmento",
    activeRecurrencesInGame: "Recurrencias activas en este segmento:",
    totalOfThisRecurrenceShort: "Total de esta recurrencia",
    applicationsLabel: "Aplicaciones:",
    perApplication: "Por aplicación:",
    days: "Días:",
    daysOfMonth: "Días del mes:",
    importantInfo: "Información importante:",
    info1: "Esta previsión solo considera recurrencias activas",
    info2: "Cada recurrencia se aplica 1 vez al día por alumno según el patrón configurado",
    info3: "Los valores muestran el total de monedas a distribuir por segmento",
    info4: "El cálculo considera todos los alumnos activos en cada segmento",
    info5: "La previsión se calcula desde hoy hasta el 31/12/{{year}}",
    noRecurrenceFound: "Ninguna recurrencia encontrada",
    createFirstRecurrence: "Crea tu primera recurrencia para automatizar actitudes",
    createFirstButton: "Crear Primera Recurrencia",
    mandatoryCollection: "Recolección obligatoria:",
    yes: "Sí",
    no: "No",
    everyDay: "Todos los días",
    everyWeekdays: "Todos los {{days}}",
    monthDays: "Día(s) {{days}} del mes",
    createdOn: "Creada el",
    gamesLabel: "Segmentos:",
    deleteButton: "Eliminar",
    invalidateUncollectedPoints: "Invalidar puntos no recolectados",
    invalidateUncollectedPointsDescription: "El alumno debe recolectar en la app durante el período de la automatización. De lo contrario, los puntos vencen.",
    pauseButton: "Pausar",
    reactivateButton: "Reactivar",
    createNewRecurrence: "Crear Nueva Recurrencia",
    confirmDeletion: "Confirmar Eliminación",
    confirmDeleteMessage: "¿Estás seguro de que deseas eliminar esta recurrencia? Esta acción no se puede deshacer.",
    recurrenceLabel: "Recurrencia:",
    frequencyLabel: "Frecuencia:",
    cancelButton: "Cancelar",
    deleting: "Eliminando...",
    deleteAction: "Eliminar",
    loadError: "Error al cargar recurrencias",
    createSuccess: "¡Recurrencia creada con éxito! 🎉",
    createError: "Error al crear recurrencia",
    activatedSuccess: "¡Recurrencia activada con éxito!",
    deactivatedSuccess: "¡Recurrencia desactivada con éxito!",
    mandatoryCollectionActivatedSuccess: "Los puntos no recolectados ahora vencerán.",
    mandatoryCollectionDeactivatedSuccess: "Los puntos futuros no vencerán por falta de recolección.",
    toggleError: "Error al actualizar recurrencia",
    deleteSuccess: "¡Recurrencia eliminada con éxito!",
    deleteError: "Error al eliminar recurrencia",
    recurrenceNotFound: "Recurrencia no encontrada",
    daily: "Diaria",
    weekly: "Semanal",
    monthly: "Mensual",
    dailyApplication: "Aplicación diaria",
    weeklyApplication: "Aplicación semanal: {{days}}",
    monthlyApplication: "Aplicación mensual: días {{days}}",
    daysRemainingCalc: "{{days}} días restantes × 1 aplicación por día",
    daysPerWeekCalc: "{{daysPerWeek}} días por semana × {{weeks}} semanas",
    daysPerMonthCalc: "{{daysPerMonth}} días por mes × {{months}} meses",
    dayNameSun: "Dom",
    dayNameMon: "Lun",
    dayNameTue: "Mar",
    dayNameWed: "Mié",
    dayNameThu: "Jue",
    dayNameFri: "Vie",
    dayNameSat: "Sáb",
    monthNameShort: "Ene,Feb,Mar,Abr,May,Jun,Jul,Ago,Sep,Oct,Nov,Dic",
    current: "Actual",
    future: "Futuro",
  },
  bncc: {
    pageTitle: "Selección BNCC",
    pageSubtitle: "Selecciona una competencia de la Base Nacional Común Curricular a través del modal interactivo",
    openSelection: "Abrir Selección BNCC",
    selectedCompetency: "Competencia Seleccionada",
    id: "ID: ",
    title: "Título: ",
    descriptionLabel: "Descripción: ",
    area: "Área: ",
    levels: "Niveles: ",
  },
  details: {
    pageTitle: "Jugadores | Gamefik Escuelas al máximo nivel.",
    playersTitle: "Jugadores",
    playersSubtitle: "Gestiona alumnos, aplica actitudes y ajusta coins sin salir de la lista.",
    filteredPlayersCount: "{{filtered}} de {{total}}",
    loadingPlayers: "Cargando jugadores...",
    filtersLabel: "Filtros",
    historyButton: "Historial",
    aiSelectionButton: "Seleccionar con IA",
    actionsPanelTitle: "Acciones en lote",
    selectedPlayersCount: "{{count}} seleccionado(s)",
    selectPlayersHint: "Selecciona alumnos en la cuadrícula para activar acciones en lote, actitudes y ajustes de coins.",
    quickCoinsTitle: "Ajuste rápido de coins",
    quickCoinsEmptyHint: "Selecciona alumnos para aplicar",
    searchByName: "Buscar por nombre",
    appliedAttitudesHistory: "Historial de actitudes aplicadas",
    selectStudentsWithAi: "Seleccionar alumnos con IA",
    loadingHistory: "Cargando historial...",
    playersUpdated: "Jugadores actualizados",
    updatingPlayers: "Actualizando {{count}} jugadores",
    attitudesAppliedSuccess: "¡Actitudes aplicadas con éxito!",
    inStudents: "en {{count}} alumno{{suffix}}",
    andMore: "... y {{count}} más",
    clickToSeeAttitudes: "Haz clic aquí para ver las actitudes",
    addAction: "Agregar",
    removeAction: "Quitar",
    coinsAndXp: "coins y xp",
    confirmAddRemoveTitle: "{{action}} {{amount}} coins {{xpText}}",
    confirmAddRemoveMessage: "¿Estás seguro de que deseas {{action}} {{amount}} coins {{xpText}} de los alumnos:",
    confirmButton: "Confirmar",
    cancelButton: "Cancelar",
    quickCoinApplication: "Aplicación rápida de coins",
    selectYourClasses: "Selecciona tus clases",
    classesPlaceholder: "Clases",
    saveButton: "Guardar",
    appliedAttitudesTitle: "Historial de Actitudes Aplicadas",
  },
  requestAttitude: {
    attitudeValidatedSuccess: "Actitud validada con éxito.",
    requestError: "Ocurrió un error al procesar tu solicitud. Inténtalo de nuevo más tarde.",
    points: "Puntos:",
    creationDate: "Fecha de creación:",
    reject: "Rechazar",
    accept: "Aceptar",
  },
  news: {
    systemUpdates: "Novedades del sistema 🎉",
    newUpdates: "Novedades",
    alreadySeen: "Ya Vistas",
    allUpToDate: "¡Todo al día!",
    allUpdatesViewed: "Ya has visto todas las novedades.",
    noUpdateSeen: "Ninguna actualización vista",
    seenUpdatesAppearHere: "Tus actualizaciones vistas aparecerán aquí.",
    newLabel: "Nuevo",
    accessPage: "Ir a la página",
    close: "Cerrar",
    dashboardTitle: "Página del dashboard",
    dashboardDetails: "Ahora tienes acceso a datos en tiempo real sobre engagement, datos de tienda, uso de los profesores y mucho más...",
    recurrencesTitle: "Página de recurrencias",
    recurrencesDetails: "Automatiza la entrega de coins a los alumnos, una excelente práctica para garantizar siempre la recolección para todos los alumnos matriculados.",
    quizzesTitle: "Página de Quizzes",
    quizzesDetails: "Crea y aplica quizzes gamificados con corrección automática. ¡Una revolución en la evaluación!",
    attitudesTitle: "Actualización en la página de actitudes",
    attitudesDetails: "Nuevo diseño, y ahora es posible aplicar actitudes desde esta pantalla, y verificar todos los jugadores que recibieron el lanzamiento.",
  },
  acessoAluno: {
    pageTitle: "Acceso del alumno",
    pageDescription: "Visualiza cómo aparece la aplicación para cada alumno y copia los datos de acceso",
    browserTitle: "Acceso del alumno | Gamefik",
    bannerTitle: "Tip",
    bannerBody: 'Haz clic en "Copiar acceso" junto al nombre del alumno para copiar el enlace, o usa "Imprimir accesos de la clase" para generar un PDF/planilla con los enlaces.',
    bannerDismissAria: "Descartar tip",
    printButton: "Imprimir accesos de la clase",
    printButtonAllClassesTooltip: "Selecciona una clase para imprimir los accesos",
    copyAccess: "Copiar acceso",
    accessCopied: "¡Copiado!",
    copyAccessUnavailable: "No disponible para este alumno",
    credentialsCardAccessLinkLabel: "Enlace de acceso",
    credentialsCardCopyButton: "Copiar datos de acceso",
    credentialsCardCopiedButton: "¡Datos copiados!",
    openInNewTab: "Abrir en nueva pestaña",
  },
  classes: {
    general: "General",
    pageTitle: "Clases | Gamefik Escuelas",
    pageDescription: "Administra las clases y estudiantes de tu escuela en Gamefik.",
    editPageTitle: "Editar clase | Gamefik Escuelas al nivel máximo.",
    newPageTitle: "Nueva clase | Gamefik Escuelas al nivel máximo.",
    newPageDescription: "Crea una nueva clase para organizar a tus estudiantes y aplicar gamificación al aprendizaje.",
    errorLoadingClasses: "Error al cargar clases",
    errorLoadingClassesTitle: "Error al cargar clases",
    errorLoadingClassesDescription: "No pudimos cargar tus clases ahora. Inténtalo de nuevo: tus clases no se han eliminado.",
    retryLoadingClasses: "Intentar de nuevo",
    deleteSelected: "Eliminar Seleccionadas ({{count}})",
    newClass: "Nueva Clase",
    classList: "Lista de Clases",
    classesFound: "{{count}} clase(s) encontrada(s)",
    searchPlaceholder: "Buscar clases...",
    sortBy: "Ordenar por:",
    alphabetical: "Alfabético",
    studentsLabel: "Estudiantes",
    clear: "Limpiar",
    noClassFound: "Ninguna clase encontrada",
    noClassCreated: "Ninguna clase creada",
    adjustSearchTerms: "Intente ajustar los términos de búsqueda",
    startCreatingClass: "Comienza creando tu primera clase para organizar a los estudiantes",
    createFirstClass: "Crear primera clase",
    clickToSortByName: "Clic para ordenar por nombre",
    clickToSortByStudents: "Clic para ordenar por cantidad de estudiantes",
    classColumn: "Clase",
    gameColumn: "Segmento",
    actionsColumn: "Acciones",
    confirmDeletion: "Confirmar Eliminación",
    confirmDeletionDescription: "¿Estás seguro de que deseas eliminar las clases seleccionadas? Esta acción no se puede deshacer.",
    classesToBeDeleted: "Clases que serán eliminadas:",
    deleting: "Eliminando...",
    deleteClasses: "Eliminar Clases",
    classStudents: "Estudiantes de la Clase",
    noStudentFound: "Ningún estudiante encontrado",
    noStudentsRegistered: "Esta clase aún no tiene estudiantes registrados.",
    studentsFound: "{{count}} estudiante(s) encontrado(s)",
    gamesLabel: "Segmentos:",
    moreGames: "+{{count}} más...",
    noGame: "Ningún segmento",
    gamesNotFound: "Segmentos no encontrados",
    classDeletedSuccess: "Clase eliminada con éxito",
    classesDeletedSuccess: "Clases eliminadas con éxito",
    processingError: "Ocurrió un error al procesar tu solicitud",
    classSavedSuccess: "Clase guardada con éxito.",
    classRemovedSuccess: "Clase eliminada con éxito.",
    requestError: "Ocurrió un error al procesar tu solicitud. Inténtalo de nuevo más tarde.",
    creatingClass: "Creando clase...",
    classCreatedSuccess: "¡Clase creada con éxito!",
    readyForStudents: "¡La clase ha sido creada y está lista para recibir estudiantes!",
    configuring: "Configurando...",
    settings: "Configuración",
    classLabel: "Clase",
    finalization: "Finalización",
    guidedSetup: "Configuración Guiada",
    preselectedGameHint: "El segmento fue preseleccionado para facilitar el proceso",
    newClassTitle: "Nueva Clase",
    configureNewClass: "Configura una nueva clase para sus estudiantes",
    editClass: "Editar Clase",
    classFormDescription: "Configura los detalles de la clase y seleccione el segmento correspondiente",
    className: "Nombre de la Clase",
    classNameHint: "(Ingresa un nombre descriptivo)",
    classNamePlaceholder: "Ej: 6to Grado A, Clase de la Mañana...",
    classNameRequired: "El nombre de la clase es obligatorio",
    classNameMinLength: "El nombre debe tener al menos 2 caracteres",
    classNameMaxLength: "El nombre debe tener como máximo 50 caracteres",
    characters: "{{count}}/50 caracteres",
    nearLimit: "Cerca del límite",
    classGame: "Segmento de la Clase",
    classGameHint: "(Selecciona el segmento de la clase)",
    classGameRequired: "Selecciona un segmento para la clase",
    preselectedGame: "Segmento Preseleccionado",
    preselectedGameDescription: "El segmento fue definido automáticamente",
    updateClass: "Actualizar Clase",
    createClass: "Crear Clase",
    completeRequiredFields: "Completa todos los campos obligatorios para continuar",
    confirmDeleteTitle: "Confirmar Eliminación",
    confirmDeleteDescription: "¿Estás seguro de que deseas eliminar esta clase? Esta acción es <strong>irreversible</strong> y todos los datos relacionados con la clase se perderán permanentemente.",
    deleteWhatWillBeDeleted: "Lo que se eliminará:",
    deleteClassData: "Datos de la clase",
    deleteActivityHistory: "Historial de actividades",
    deleteStudentLinks: "Vínculos con estudiantes",
    deleteReportsAndStats: "Informes y estadísticas",
    deletePermanently: "Eliminar Permanentemente",
    errorDuplicateName: "Ya existe una clase con este nombre. Elige otro nombre.",
    errorInvalidGame: "El segmento seleccionado no es válido. Verifica si el segmento aún está activo.",
    errorTeacherNotFound: "Profesor no encontrado. Verifica si el profesor aún está activo.",
    errorInsufficientPermissions: "No tiene permiso para crear clases.",
    errorMaxClassesReached: "Límite máximo de clases alcanzado.",
    errorGeneric: "Error al crear clase. Verifica los datos e inténtelo de nuevo.",
    errorConnection: "Problema de conexión. Verifica su internet e inténtelo de nuevo.",
    errorTimeout: "La operación tardó demasiado en responder. Inténtalo de nuevo.",
    errorServerCommunication: "Error de comunicación con el servidor.",
    editClassTitle: "Editar clase",
    nameColumn: "Nombre",
    createdColumn: "Creado",
    editColumn: "Editar",
    nothingFound: "Nada encontrado",
    allClasses: "TODAS LAS CLASES",
    all: "TODAS",
    some: "ALGUNAS",
    allYourClasses: "Todas sus clases",
    allClassesLabel: "Todas las clases",
    allYourClassesCanSee: "Todas sus clases podrán ver esta misión",
    allClassesCanSee: "Todas las clases de los segmentos seleccionados podrán ver esta misión",
    selectClasses: "Selecciona las clases",
    selectAClass: "Selecciona una clase",
    selectGameFirst: "Selecciona un segmento para ver las clases",
    noOptionFound: "Ninguna opción encontrada",
    selected: "{{count}} seleccionadas",
    studentsCount: "{{count}} alumnos",
    turmasHeading: "Clases",
    turmasToolbarSearchPlaceholder: "Buscar...",
    turmasSortNameAsc: "Nombre A-Z",
    turmasSortNameDesc: "Nombre Z-A",
    turmasSortRecent: "Más recientes",
    turmasSortOldest: "Más antiguos",
    turmasSortPerformance: "Mejor desempeño",
    turmasSortMostStudents: "Más alumnos",
    turmasSortFewestStudents: "Menos alumnos",
    turmasSortMostXp: "Más XP",
    turmasSortMostCoins: "Más monedas",
    importTemplateColClass: "Clase",
    importTemplateColStudent: "Nombre del alumno",
    importTemplateFileName: "plantilla_importacion_clases.csv",
    turmasSelectMultiple: "Seleccionar varias",
    turmasExitSelectionMode: "Salir de la selección",
    turmasSelectAll: "Seleccionar todas",
    turmasCancelSelection: "Cancelar selección",
    turmasSortByLabel: "Ordenar por",
    turmasMoreOptionsAria: "Más opciones",
    turmasImportLong: "Importar clases",
    turmasImportShort: "Importar",
    turmasPedagogicalReport: "Generar informe pedagógico",
    turmasPedagogicalReportShort: "Informe",
    turmasLaunch: "Registrar ({{count}})",
    turmasMoreActionsAria: "Más acciones",
    turmasAccessStudents: "Acceso alumnos ({{count}})",
    turmasEditClassAction: "Editar clase",
    turmasDeleteWithCount: "Eliminar ({{count}})",
    noStudentsInSelection: "No hay alumnos en las clases seleccionadas.",
    accessInstructionsDownloadStarted: "Descarga de instrucciones de acceso iniciada.",
    turmasPaginationSelection: "{{selected}} de {{total}} {{label}} seleccionada(s)",
    turmasPaginationPage: "Página {{current}} de {{total}}",
    turmasLabelShort: "clase(s)",
    turmasPrevPageAria: "Página anterior",
    turmasNextPageAria: "Página siguiente",
    turmasAllStudentsCard: "Todos los alumnos",
    turmasUnlinkedStudentsCard: "Alumnos desvinculados",
    turmasUnlinkedStudentsCount: "{{count}} sin clase o sin segmento",
    turmasLimitReached: "Límite alcanzado",
    turmasAtLimitToast: "Alcanzó el límite de {{limit}} clase(s) de su plan.",
    turmasGameRequired: "Registre o seleccione un segmento antes de crear clases.",
    turmasImportSuccess: "Importación completada.",
    turmasImportError: "Error al importar clases o alumnos.",
    importTurmasProgressToast: "Importando {{current}} de {{total}} alumnos...",
    turmasModalNewTitle: "Nueva clase",
    turmasModalEditTitle: "Editar clase",
    turmasModalClassNameLabel: "Nombre de la clase",
    turmasModalClassNamePlaceholder: "Ej.: Clase 3A",
    turmasModalSegmentLabel: "Segmento",
    turmasModalSegmentPlaceholder: "Selecciona el segmento",
    turmasModalCancel: "Cancelar",
    turmasModalCreate: "Crear clase",
    turmasModalSave: "Guardar cambios",
    turmasModalCloseAria: "Cerrar",
    turmasAccessModalTitle: "Acceso de los alumnos",
    turmasAccessModalSubtitle: "Descargue los datos de acceso de los alumnos",
    turmasAccessFormatLabel: "Formato del archivo",
    turmasAccessPdfHint: "Documento para impresión",
    turmasAccessSpreadsheetLabel: "Hoja de cálculo",
    turmasAccessSpreadsheetHint: "Excel / Google Sheets",
    turmasAccessInfoBox:
      "El archivo incluirá los datos de acceso de cada alumno: nombre, usuario, contraseña y código QR para acceso rápido a la app.",
    turmasAccessDownloaded: "¡Descargado!",
    turmasAccessGenerating: "Generando...",
    turmasAccessDownloadButton: "Descargar {{format}}",
    accessMissingWarning: "{{count}} alumno(s) aún sin código de acceso — saldrían sin enlace en el archivo. Al descargar, pediremos confirmación para generarlos automáticamente.",
    accessMissingConfirmTitle: "¿Generar códigos de acceso?",
    accessMissingConfirmDesc: "{{count}} alumno(s) aún no tienen código de acceso.",
    accessMissingConfirmHint: "Generaremos automáticamente el código de acceso de {{count}} alumno(s) y continuaremos la descarga. Los códigos de los demás alumnos no cambian.",
    accessMissingGenerate: "Generar y descargar",
    accessMissingGenerating: "Generando códigos...",
    accessGenerateError: "Error al generar los códigos de acceso. Inténtalo de nuevo.",
    accessGeneratePartial: "{{count}} alumno(s) siguen sin código — el archivo se generó sin esos enlaces.",
    accessZipOptionTitle: "QR Codes",
    accessZipOptionHint: "ZIP con tarjetas para imprimir",
    accessZipModeLabel: "Códigos de los alumnos",
    accessZipKeepTitle: "Mantener códigos actuales",
    accessZipKeepHint: "Usa los QR codes ya vinculados — las tarjetas impresas siguen funcionando.",
    accessZipOverwriteTitle: "Generar códigos nuevos",
    accessZipOverwriteHint: "Sobrescribe los códigos de todos los alumnos seleccionados — los QR codes y tarjetas antiguos dejan de funcionar.",
    accessZipMissingWarning: "{{count}} alumno(s) aún sin código de acceso — saldrían en el ZIP con un QR desvinculado. Elige \"Generar códigos nuevos\" para vincularlos.",
    accessZipInfoBox: "El ZIP contendrá una tarjeta con QR Code por alumno, organizada en carpetas por clase — lista para enviar a imprimir.",
    accessZipGeneratingInfo: "Generando el ZIP en el servidor — puede tardar unos minutos. El archivo también estará disponible en la página Historial.",
    accessZipReadyInfo: "¡ZIP listo! Haz clic en \"Descargar ZIP\" para guardar el archivo.",
    accessZipTimeout: "La generación está tardando más de lo esperado. Sigue ejecutándose en el servidor — revisa la página Historial en unos minutos para descargar el archivo.",
    accessZipRequestError: "No se pudo iniciar la generación del ZIP (error {{status}}). Inténtalo de nuevo.",
    accessZipOverwriteConfirmTitle: "¿Generar códigos nuevos?",
    accessZipOverwriteConfirmDesc:
      "Los QR codes actuales de {{count}} alumno(s) se sobrescribirán — los códigos antiguos y las tarjetas impresas dejan de funcionar de inmediato. Esta acción es irreversible.",
    accessZipGenerateButton: "Generar ZIP",
    accessZipGeneratingButton: "Generando ZIP...",
    accessZipDownloadButton: "Descargar .zip",
    accessZipPrintOptionButton: "Listo para imprimir",
    accessZipPrintTitle: "Impresión de las tarjetas",
    accessZipPrintDesc: "Elige cómo se disponen las tarjetas en la hoja A4",
    accessZipPrintPresetLabel: "Disposición en la página",
    accessZipPrintPresetOption: "{{count}} por página ({{grid}})",
    accessZipPrintPageIndicator: "Página {{page}} de {{total}}",
    accessZipPrintLoading: "Preparando las tarjetas...",
    accessZipPrintLoadError: "No se pudieron cargar las imágenes del ZIP. Descarga el .zip directamente o inténtalo de nuevo.",
    accessZipPrintDownloadButton: "Descargar PDF",
    accessZipPrintGeneratingPdf: "Generando PDF...",
    accessZipPrintPdfError: "No se pudo generar el PDF. Inténtalo de nuevo.",
    searchEllipsis: "Buscar...",
    classesForCreation: "Clases para Creación",
    classCount: "{{count}} clase",
    classesCountLabel: "{{count}} clases",
    viewJsonClasses: "Ver JSON - Clases para Creación ({{count}})",
    viewJsonPlayersAndClasses: "Ver JSON - Jugadores y Clases ({{playersCount}} jugadores, {{classesCount}} clases)",
    playersForCreation: "Jugadores para Creación ({{count}}):",
    existingClasses: "Clases Existentes en el Sistema ({{count}}):",
    createNClasses: "Crear {{count}} Clase",
    createNClassesPlural: "Crear {{count}} Clases",
    classesCreatedSuccess: "¡Clases creadas con éxito!",
    errorCreatingClasses: "Error al crear las clases",
    creatingClasses: "Creando clases...",
    classCreatedToast: "¡Clase creada con éxito!",
    errorCreatingClass: "Error al crear clase.",
    configureNewClassForStudents: "Configura una nueva clase para organizar a sus alumnos",
    detailPageTitle: "Gestión de clase | Gamefik",
    detailPageDescription: "Gestión de clase — visualiza y administra alumnos.",
    classNotFoundHeadTitle: "Clase no encontrada | Gamefik",
    classNotFoundPageMessage: "Clase no encontrada.",
    detailLoadErrorTitle: "No se pudo cargar la clase",
    detailLoadErrorHint: "Comprueba tu conexión e inténtalo de nuevo.",
    tryAgain: "Intentar de nuevo",
    detailClassMissingTitle: "Clase no encontrada",
    detailClassMissingDescription: "La clase solicitada no fue encontrada.",
    backToClasses: "Volver a las clases",
    staleDataBanner: "Error al actualizar — mostrando datos anteriores.",
    editClassButtonAria: "Editar clase",
    refreshingDataAria: "Actualizando datos",
    refreshingTitle: "Actualizando...",
    refreshingInline: "Actualizando…",
    balanceLoading: "Actualizando el saldo del alumno",
    balanceUnavailable: "Saldo no disponible. Actualiza la página.",
    updatedAt: "Actualizado a las {{time}}",
    lastUpdatedTooltip: "Última actualización a las {{time}}",
    toastSelectStudentForLaunch: "Selecciona al menos un alumno para registrar",
    toastSelectStudentForBulk: "Selecciona al menos un alumno para usar acciones en masa",
    detailLaunchWithCount: "Registrar ({{count}})",
    moveClassWithCount: "Cambiar de clase ({{count}})",
    noStudentMatchSearchTitle: "No se encontraron alumnos",
    noStudentMatchSearchHint: "Prueba a ajustar los términos de búsqueda",
    turmasStudentsLabelShort: "alumno(s)",
    playersDeletedSuccess: "Alumno(s) eliminado(s) correctamente",
    playersDeleteError: "Error al eliminar alumno(s)",
    playersDeletePartialError: "No se pudo eliminar a {{count}} alumno(s).",
    alunoCardViewMenu: "Ver alumno",
    alunoCardEditMenu: "Editar",
    novoAlunoCardLabel: "Nuevo alumno",
    studentsMovedClassSuccess: "¡Alumnos movidos de clase correctamente!",
    studentsMoveClassError: "Error al mover alumnos de clase.",
    playerUpdatedSuccess: "Alumno actualizado correctamente",
    playerUpdateError: "Error al actualizar alumno",
    deleteStudentsTitleOne: "Eliminar alumno",
    deleteStudentsTitleMany: "Eliminar alumnos",
    deleteStudentConfirmIntro: "¿Seguro que deseas eliminar",
    deleteStudentConfirmOutro: "? Esta acción no se puede deshacer.",
    thisStudentFallback: "este alumno",
    nStudentsCount: "{{count}} alumnos",
    deletingStudentsAria: "Eliminando alumnos...",
    editStudentModalTitle: "Editar alumno",
    editStudentSegmentLabel: "Segmento (segmento)",
    editStudentSegmentHint:
      "El segmento lo definen las clases y no se puede modificar directamente aquí.",
    newStudentTitle: "Nuevo alumno",
    importManyStudentsLink: "Importar varios alumnos a la vez",
    importStudentsShort: "Importar alumnos",
    studentFirstNameLabel: "Nombre",
    studentFirstNamePlaceholder: "Ej.: Juan",
    studentLastNameLabel: "Apellido",
    studentLastNamePlaceholder: "Ej.: García",
    studentEmailLabel: "Correo del alumno",
    studentEmailPlaceholder: "alumno@escuela.com",
    studentEmailHint: "Opcional. Vacía el campo para desvincular el correo.",
    studentEmailInvalid: "Ingresa un correo válido.",
    studentClassesFieldLabel: "Clases",
    selectClassesPrompt: "Selecciona las clases",
    oneClassSelectedSummary: "1 clase",
    nClassesSelectedSummary: "{{count}} clases seleccionadas",
    searchClassPlaceholder: "Buscar clase...",
    noClassInFilter: "No se encontró ninguna clase.",
    clearClassesSelection: "Limpiar selección",
    studentMultipleClassesHint: "El alumno puede pertenecer a varias clases",
    addingStudent: "Añadiendo...",
    addStudentCta: "Añadir alumno",
    studentAddedToast: "Alumno {{name}} añadido correctamente",
    createStudentError: "Error al crear alumno",
    lancarSidebarLabel: "Registrar",
    lancarExpandAria: "Expandir",
    lancarBackAria: "Volver",
    lancarSubmitting: "Registrando...",
    lancarTabAttitudes: "Actitudes",
    lancarTabFeedback: "Feedback",
    lancarAttitudesTitle: "Actitudes",
    lancarAttitudesSubtitle: "Selecciona las actitudes a registrar",
    lancarDefaultAttitudesBalanceDescription: "Actitudes predeterminadas (sin catálogo): {{summary}}",
    lancarPositive: "Positiva",
    lancarNegative: "Negativa",
    lancarAttitudeOrderSaving: "Guardando orden...",
    lancarAttitudeReorderHandle: "Reordenar {{name}}",
    lancarAttitudeOrderSaveError: "No se pudo guardar el orden de las actitudes.",
    lancarAddAttitudeType: "Añadir {{type}}",
    lancarAddTypePositive: "positiva",
    lancarAddTypeNegative: "negativa",
    lancarFeedbackTitle: "Feedback personalizado",
    lancarFeedbackSubtitle: "Envía feedback personalizado con monedas a los alumnos seleccionados.",
    lancarReasonLabel: "Motivo",
    lancarReasonPlaceholder: "Indica el motivo por el que se modifica el saldo...",
    lancarAddCoins: "Añadir",
    lancarRemoveCoins: "Quitar",
    lancarCoinsLabel: "Monedas",
    lancarSetCoins: "Definir saldo",
    lancarManualBalanceDescription: "Ajuste manual de monedas",
    lancarTabChests: "Cofres",
    lancarChestsHmgBadge: "HMG",
    lancarChestsHmgNotice: "Función exclusiva de homologación (localhost/hmg) — no aparece en producción.",
    lancarChestsTitle: "Dar cofres",
    lancarChestsSubtitle: "Concede cofres sorpresa para que los alumnos seleccionados los abran en la app",
    lancarChestsQuantityLabel: "Cantidad de cofres",
    lancarStudentsListHeading: "Alumnos ({{count}})",
    lancarHeaderManyStudents: "{{count}} alumnos",
    lancarCoverageWarningSingle:
      "\"{{attitude}}\" no se registrará para {{count}} de {{total}} alumnos seleccionados porque la actitud no está configurada para el segmento de esos alumnos.",
    lancarCoverageWarningMulti:
      "{{count}} de {{total}} alumnos seleccionados no recibirán todas las actitudes ({{attitudes}}) porque no están configuradas para el segmento de esos alumnos.",
    lancarSearchAttitudePlaceholder: "Buscar actitud...",
    lancarNoAttitudeFound: "Ninguna actitud encontrada",
    quickLaunchBarLabel: "Registro rápido",
    quickLaunchValueAria: "Registrar {{value}} monedas",
    quickLaunchOpenFullPanel: "Registro completo",
    quickLaunchTitleAdd: "Añadir {{count}} monedas",
    quickLaunchTitleRemove: "Quitar {{count}} monedas",
    quickLaunchSubtitleOne: "al alumno seleccionado",
    quickLaunchSubtitleMany: "a {{count}} alumnos seleccionados",
    quickLaunchReasonOptional: "(opcional)",
    quickLaunchReasonPlaceholder: "Ej.: participación en clase",
    quickLaunchConfirm: "Registrar ahora",
    quickLaunchDefaultDescription: "Registro rápido",
    quickLaunchApplying: "Registrando monedas...",
    quickLaunchSuccess: "{{value}} monedas registradas",
    quickLaunchError: "No se pudieron registrar las monedas.",
    viewStudentModalTitle: "Alumno(a)",
    studentProfileTab: "Perfil",
    studentHistoryTab: "Historial",
    studentCollectionTab: "Colección",
    studentRowCreatedAt: "Creado el",
    collectionLoading: "Cargando colección...",
    collectionError: "No se pudo cargar la colección. Inténtalo de nuevo.",
    collectionEmptyTitle: "Aún no hay coleccionables",
    collectionEmptyHint: "Los coleccionables que el alumno gane o compre aparecerán aquí.",
    collectionObtainedAt: "Obtenido el {{date}}",
    historicoTypeOther: "Otros",
    historySearchPlaceholder: "Buscar en el historial...",
    historyFilterAll: "Todos",
    historyTypeFilterLabel: "Tipo de registro",
    historyViewModeLabel: "Visualización",
    historyViewSimple: "Simple",
    historyViewComplete: "Completa",
    historyFilterEmpty: "No se encontró nada con estos filtros.",
    historyProgressLoading: "Cargando historial completo... ({{loaded}} de {{total}})",
    historyLoadError: "No se pudo cargar el historial. Inténtalo de nuevo.",
    studentRowClass: "Clase",
    studentRowEmail: "Correo electrónico",
    studentRowCoins: "Monedas",
    studentRowGems: "Gemas",
    studentRowXp: "XP",
    studentRowCollectibles: "Coleccionables",
    studentQrCode: "Código QR",
    studentCopied: "¡Copiado!",
    studentAccessLink: "Enlace de acceso",
    studentAppButton: "Acceder a la app del alumno",
    studentNoHistoryTitle: "Sin registros",
    studentNoHistoryHint: "El historial del alumno aparecerá aquí",
    historicoTypeAttitude: "Actitud",
    historicoTypeMission: "Misión",
    historicoTypeQuiz: "Quiz",
    studentHistoryAt: "{{date}} a las {{time}}",
    studentHistoryLaunchedBy: "Registrado por {{author}}",
    studentHistoryUnknownAuthor: "Responsable no identificado",
    studentHistoryCollectedAt: "Recolectado el {{date}} a las {{time}}",
    studentHistoryApplicationDate: "Fecha de aplicación",
    studentHistoryCollectionDate: "Fecha de recolección",
    studentHistoryResponsible: "Responsable",
    studentHistoryCollectionStatus: "Estado de recolección",
    studentHistoryCollected: "Recolectada",
    studentHistoryPending: "Pendiente",
    studentHistoryDateUnavailable: "Fecha no informada",
    studentHistoryNotCollected: "No recolectada",
    studentHistoryRewards: "Recompensas",
    studentHistoryNoRewards: "Ninguna recompensa registrada",
    historyPartialLoadError: "Parte del historial anterior no pudo cargarse. Los registros disponibles siguen visibles.",
    undoLaunchAria: "Deshacer registro",
    deleteStudentButton: "Eliminar alumno",
    editStudentButton: "Editar alumno",
    studentNoClass: "Sin clase",
    importTurmasTitleUpload: "Importar clases y alumnos",
    importTurmasTitleValidating: "Validando hoja de cálculo...",
    importTurmasTitlePreview: "Revisar importación",
    importTurmasTitleImporting: "Importando...",
    importTurmasTitleResult: "Importación completada",
    importTurmasHowTitle: "Cómo funciona",
    importTurmasHowBody:
      "Descarga la plantilla y repite el mismo nombre completo en todas las clases del alumno. El sistema creará un único alumno asociado a todas ellas.",
    importTurmasTemplateTitle: "Plantilla de hoja de cálculo",
    importTurmasTemplateHint: "Usa la plantilla para asegurar el formato correcto",
    importTurmasDownloadCsv: "Descargar plantilla (.csv)",
    importTurmasOr: "o",
    importTurmasDropHere: "Suelta el archivo aquí",
    importTurmasDragOrClick: "Arrastra el archivo o haz clic para seleccionar",
    importTurmasFormats: "Formatos aceptados: .csv, .xlsx, .xls",
    importTurmasErrorUnsupportedFile: "Usa un archivo .csv, .xlsx o .xls.",
    importTurmasErrorEmptyFile: "El archivo no contiene clases y alumnos para importar.",
    importTurmasErrorInvalidColumns: "La hoja debe tener exactamente dos columnas: clase y nombre del alumno.",
    importTurmasErrorMalformedCsv: "El CSV tiene comillas sin cerrar. Corrige el archivo e inténtalo de nuevo.",
    importTurmasErrorReadFile: "No se pudo leer el archivo. Comprueba que no esté dañado o protegido con contraseña.",
    importTurmasStructureTitle: "Estructura de la hoja",
    importTurmasColClass: "Clase",
    importTurmasColStudent: "Nombre del alumno",
    importTurmasValidatingTitle: "Validando hoja de cálculo",
    importTurmasValidatingHint: "Comprobando estructura y datos...",
    importTurmasClassesFoundLabel: "clases encontradas",
    importTurmasStudentsTotalLabel: "alumnos en total",
    importTurmasProblemsFound: "Atención: {{count}} problema(s) encontrado(s)",
    importTurmasProblemsHint:
      "Los ítems con errores se omitirán. Puedes corregir la hoja e importar de nuevo.",
    importTurmasValidatedTitle: "Hoja validada correctamente",
    importTurmasValidatedHint: "Todos los datos son correctos y están listos para importar.",
    importTurmasListToCreate: "Clases a crear",
    importTurmasClassNamed: "Clase {{name}}",
    importTurmasNStudentsInClass: "{{count}} alumno(s)",
    importTurmasNWithErrors: "- {{count}} con error",
    importTurmasImportingTitle: "Importando clases y alumnos",
    importTurmasImportingCounts: "{{classes}} — {{students}}",
    importTurmasCountTurmasOne: "{{count}} clase",
    importTurmasCountTurmasMany: "{{count}} clases",
    importTurmasCountAlunosOne: "{{count}} alumno",
    importTurmasCountAlunosMany: "{{count}} alumnos",
    importTurmasResultTitle: "¡Importación completada!",
    importTurmasResultSubtitle: "Todas las clases y asociaciones de alumnos se procesaron correctamente.",
    importTurmasCreatedClassesLabel: "clases creadas",
    importTurmasAddedStudentsLabel: "alumnos procesados",
    importTurmasSkippedRecords: "{{count}} registro(s) omitido(s) por error",
    importTurmasLocalOnly: "Todos los datos se procesan localmente",
    importTurmasNewSheet: "Nueva hoja",
    importTurmasImportNClasses: "Importar {{count}} clase(s)",
    importTurmasImportingBtn: "Importando...",
    importTurmasImportMore: "Importar más",
    importTurmasDone: "Listo",
    importTurmasErrStudentName: "Nombre obligatorio",
    importTurmasErrClassName: "Nombre de clase obligatorio",
    importTurmasUnnamedClass: "Sin nombre",
    importAlunosTitleInput: "Importar alumnos",
    importAlunosTitlePreview: "Revisar alumnos",
    importAlunosModeCopyPaste: "Copiar/pegar",
    importAlunosModeExcel: "Importar Excel",
    importAlunosPasteListTitle: "Pega tu lista de alumnos",
    importAlunosExcelImportTitle: "Importar desde Excel",
    importAlunosPasteHint: "Procesaremos tu lista automáticamente y eliminaremos duplicados.",
    importAlunosExcelHint: "Selecciona un archivo Excel (.xlsx, .xls) o .csv con la lista de alumnos.",
    importAlunosTargetClass: "Clase de destino:",
    importAlunosDownloadTemplate: "Descargar plantilla de hoja",
    importAlunosClickSelectFile: "Haz clic para seleccionar un archivo",
    importAlunosFileTypesShort: ".xlsx, .xls o .csv",
    importAlunosFileContentPlaceholder: "Contenido del archivo...",
    importAlunosPastePlaceholder:
      "Pega aquí los nombres de los alumnos. Pon cada nombre en una línea nueva.\n\nEjemplos:\n\nJuan García\nMaría López\nPedro Sánchez",
    importAlunosFoundLine: "{{count}} alumno(s) encontrado(s)",
    importAlunosReviewHeading: "Revisa los alumnos antes de importar",
    importAlunosReviewHint: "Puedes editar o quitar alumnos de la lista antes de confirmar.",
    importAlunosToImportLine: "{{count}} alumno(s) para importar",
    importAlunosErrorReadFile: "Error al leer el archivo",
    importAlunosErrorImport: "Error al importar alumnos",
    importAlunosNoSegment: "Esta clase no tiene segmento definido. Define un segmento para la clase antes de importar alumnos; de lo contrario los alumnos no reciben recompensa ni aparecen en el ranking.",
    importAlunosNothingToImport: "Ningun alumno valido para importar. Completa al menos un nombre.",
    importAlunosReviewList: "Revisar lista",
    importAlunosImporting: "Importando...",
    importAlunosImportN: "Importar {{count}} alumno(s)",
    importAlunosSuccessToast: "{{count}} alumno(s) importado(s) correctamente",
    importAlunosFailToast: "Fallo al importar {{count}} alumno(s)",
    importAlunosSuccessCount: "{{count}} éxito(s)",
    importAlunosErrorCount: "{{count}} error(es)",
    moveClassDialogTitle: "Cambiar de clase",
    moveClassSelectedLine: "{{count}} alumno(s) seleccionado(s)",
    moveClassHowApply: "¿Cómo aplicar las clases?",
    moveClassReplace: "Reemplazar",
    moveClassReplaceHint: "Quita de las clases actuales y mueve a las nuevas",
    moveClassAdd: "Añadir",
    moveClassAddHint: "Mantiene las clases actuales y añade las nuevas",
    moveClassSelectTarget: "Seleccionar clases de destino",
    moveClassSearchPlaceholder: "Buscar clase...",
    moveClassNoResults: "No se encontró ninguna clase",
    moveClassNClassesSelected: "{{count}} clase(s) seleccionada(s)",
    moveClassTabClasses: "Clases",
    moveClassTabStudents: "Alumnos ({{count}})",
    moveClassSegmentHint:
      "Cada alumno queda en un solo segmento — el de la clase elegida.",
    moveClassAddSegmentHint:
      "En el modo Agregar el alumno mantiene sus clases actuales, así que solo se pueden elegir clases del segmento {{segment}}. Para cambiar de segmento, usa Reemplazar.",
    moveClassSegmentBlocked: "Clase de otro segmento",
    segmentChangeWarningTitle: "Los alumnos también cambian de segmento",
    segmentChangeWarning:
      "Todos los alumnos de la clase \"{{turma}}\" pasan al nuevo segmento.",
    segmentChangeWarningWithCount:
      "Los {{count}} alumno(s) de la clase \"{{turma}}\" pasan al nuevo segmento.",
    segmentChangeConfirmCta: "Confirmar cambio de segmento",
    segmentConflictTitle: "{{count}} alumno(s) también están en otras clases",
    segmentConflictDesc:
      "Tienen otras clases en el segmento actual. Elige qué hacer:",
    segmentConflictMore: "y {{count}} más",
    segmentConflictOptionMove: "Llevarlos al nuevo segmento",
    segmentConflictOptionMoveDesc:
      "Salen de las otras clases y quedan solo en esta.",
    segmentConflictOptionKeep: "Mantenerlos en el segmento actual",
    segmentConflictOptionKeepDesc:
      "Salen de esta clase y siguen en las otras.",
    segmentFixAlertTitle: "Alumnos fuera del segmento de la clase",
    segmentFixAlertDescription:
      "{{students}} alumno(s) en {{turmas}} clase(s) necesitan corrección.",
    segmentFixAlertCta: "Corregir ahora",
    segmentFixModalTitle: "Corregir segmentos",
    segmentFixModalCount: "{{count}} alumno(s) por corregir",
    segmentFixModalDescription:
      "Elige para cada alumno: moverlo al segmento de la clase o quitarlo de esta clase.",
    segmentFixTurmaSegment: "Segmento de la clase: {{segment}}",
    segmentFixStudentSegment: "Segmento actual del alumno: {{segment}}",
    segmentFixOptionMove: "Mover a {{segment}}",
    segmentFixOptionRemove: "Quitar de la clase",
    segmentFixCancel: "Ahora no",
    segmentFixApply: "Corregir {{count}} alumno(s)",
    segmentFixApplying: "Corrigiendo...",
    segmentFixSuccess: "Segmentos corregidos.",
    segmentFixError: "No se pudo corregir: {{names}}. Inténtalo de nuevo.",
    multipleGamesAlertTitle: "Clases con más de un segmento",
    multipleGamesAlertDescription: "{{count}} clase(s) necesitan elegir un único segmento.",
    multipleGamesAlertCta: "Corregir ahora",
    multipleGamesModalTitle: "Corregir segmentos de las clases",
    multipleGamesModalCount: "{{count}} clase(s) para corregir",
    multipleGamesModalDescription:
      "Elige qué segmento debe permanecer en cada clase. Los alumnos no se moverán en este paso.",
    multipleGamesChooseSegment: "Elige el segmento que se mantendrá",
    multipleGamesCancel: "Ahora no",
    multipleGamesApply: "Corregir {{count}} clase(s)",
    multipleGamesApplying: "Corrigiendo...",
    multipleGamesSuccess: "Segmentos de las clases corregidos.",
    multipleGamesError: "No se pudo corregir: {{names}}. Inténtalo de nuevo.",
    settingsTurmasColName: "Clase",
    settingsTurmasColSegment: "Segmento",
    settingsTurmasColStudents: "Alumnos",
    settingsTurmasEmpty: "No se encontraron clases.",
    settingsTurmasDeleteCta: "Eliminar clase",
    settingsTurmasDeleteTitle: "¿Eliminar la clase \"{{turma}}\"?",
    settingsTurmasDeleteDesc:
      "Esta acción no se puede deshacer. {{count}} alumno(s) están en esta clase y dejarán de pertenecer a ella.",
    settingsTurmasDeleteDescStudents:
      "Esta acción no se puede deshacer. {{count}} alumno(s) de esta clase serán eliminados permanentemente, junto con sus puntos e historial.",
    settingsTurmasDeleteDescEmpty: "Esta acción no se puede deshacer.",
    settingsTurmasDeleteDescShared:
      "{{count}} alumno(s) también pertenecen a otras clases y no serán eliminados — solo dejarán de pertenecer a la(s) clase(s) eliminada(s).",
    deleteClassStudentsCheckbox:
      "Entiendo que {{count}} alumno(s) serán eliminados permanentemente, con todos sus puntos e historial.",
    deleteClassStudentsError:
      "No se pudo eliminar {{count}} alumno(s). La(s) clase(s) no fue(ron) eliminada(s) — inténtalo de nuevo.",
    settingsTurmasDeleted: "Clase eliminada.",
    moveClassStudentsListTitle: "Alumnos que se moverán",
    moveClassMoving: "Moviendo...",
    moveClassConfirm: "Mover alumnos",
    lancarAtitude: {
      ajudar: "Ayudar al prójimo",
      participacao: "Participación",
      criatividade: "Creatividad",
      persistencia: "Persistencia",
      "trabalho-equipe": "Trabajo en equipo",
      esforco: "Esfuerzo",
      respeito: "Respeto",
      dedicacao: "Dedicación a los estudios",
      lideranca: "Liderazgo",
      superacao: "Superación",
      indisciplina: "Indisciplina",
      conversa: "Conversación excesiva",
      atraso: "Retraso",
      desrespeito: "Falta de respeto",
      desatencao: "Desatención",
      "nao-participacao": "No participación",
    },
    editarAtitudeTitulo: "Editar actitud",
    editarAtitudeTipoLabel: "Tipo",
    editarAtitudePositiva: "Positiva",
    editarAtitudeNegativa: "Necesita mejorar",
    editarAtitudeNomeLabel: "Nombre",
    editarAtitudeNomePlaceholder: 'Ej: "Participación"',
    editarAtitudeNomeRequired: "Por favor, ingresa un nombre para la actitud.",
    editarAtitudeMoedasLabel: "Monedas",
    editarAtitudeMoedasCustomPlaceholder: "Valor personalizado",
    atitudeMoedasCustomOption: "Personalizado",
    atitudeMoedasCustomInvalid: "Ingresa un número entero entre 1 y {{max}}.",
    editarAtitudeGamesLabel: "Segmentos",
    editarAtitudeGamesPlaceholder: "Selecciona los segmentos",
    editarAtitudeGamesAll: "Todos los segmentos",
    editarAtitudeGamesRequired: "Selecciona al menos un segmento.",
    editarAtitudeGamesSearchPlaceholder: "Buscar segmento...",
    editarAtitudeGamesNoResults: "No se encontraron segmentos",
    editarAtitudeSalvar: "Guardar cambios",
    excluirAtitudeTitulo: "Eliminar actitud",
    excluirAtitudeDescricao: "¿Estás seguro de que quieres eliminar la actitud \"{{name}}\"?",
    excluirAtitudeAviso: "Esta acción no se puede deshacer.",
    excluirAtitudeConfirmar: "Eliminar actitud",
    printAccessAllStudents: "Imprimir accesos de toda la clase",
    printAccessSelectedStudents: "Imprimir accesos de {{count}} alumnos seleccionados",
    printAccessButton: "Imprimir accesos",
    alunoCardAccessMenu: "Datos de acceso",
    alunoCardAccessCopied: "¡Copiado!",
    classAccessLinkModalTitle: "Enlace de Acceso",
    classAccessLinkModalScanHint: "Escanea el código QR o copia el enlace de abajo",
    classAccessLinkModalShareHint:
      "Comparte este enlace con tus alumnos. Al acceder, crean una cuenta y entran automáticamente en la clase.",
    classAccessLinkModalPrintPdf: "Imprimir PDF",
    classAccessLinkModalPrintTitle: "Acceso - {{name}}",
    classAccessLinkModalPrintSubtitle: "Plataforma de Gamificación Educativa",
    classAccessLinkModalPrintCardLabel: "Enlace de Acceso de la Clase",
    classAccessLinkModalPrintInstructions:
      "Escanea el código QR de arriba o accede al enlace de abajo para entrar en la clase",
    classAccessLinkModalQrAlt: "Código QR",
    classAccessLinkCopy: "Copiar",
    classAccessLinkCopied: "Copiado",
    classAccessLinkButtonAria: "Enlace de acceso de la clase",
    classAccessLinkButtonLabel: "Enlace de acceso",
  },
  players: {
    pageTitle: "Jugadores | Gamefik Escuelas al nivel máximo.",
    total: "Total",
    playersUpdated: "Jugadores actualizados",
    errorUpdatingPlayers: "Error al actualizar jugadores",
    qrCodesBeingGenerated: "¡Los códigos QR se están generando! ¡Espera 5 minutos y consulta el historial!",
    qrCodesGenerationError: "Error al generar códigos QR. Inténtalo de nuevo.",
    qrCodesDownloadError: "Error al descargar códigos QR. Inténtalo de nuevo.",
    errorDeleting: "Error al eliminar",
    errorChangingClass: "Error al cambiar de clase",
    errorChangingGame: "Error al cambiar de segmento",
    editPageTitle: "Editar jugador | Gamefik Escuelas al nivel máximo.",
    editPlayerTitle: "Editar jugador",
    requestError: "Ocurrió un error al procesar tu solicitud. Inténtalo de nuevo más tarde.",
    playerRemovedSuccess: "Usuario eliminado con éxito.",
    createPageTitle: "Crear Alumno | Gamefik - Escuelas al nivel máximo",
    createPageDescription: "Registre nuevos alumnos de forma rápida e intuitiva",
    createNewPlayer: "Crear Nuevo Alumno",
    registrationForm: "Formulario de Registro",
    completeSteps: "Completa todas las etapas para finalizar el registro",
    createGameClassTooltip: "Los botones de creación de Segmento y Clase están disponibles dentro del formulario",
    playerCreatedSuccess: "¡Alumno registrado con éxito!",
    playerCreatedMessage: "¡Alumno creado con éxito!",
    createPlayerError: "Error al registrar alumno.",
    personalData: "Datos Personales",
    basicStudentInfo: "Información básica del alumno",
    complete: "Completo",
    firstName: "Primer nombre",
    surname: "Apellido",
    email: "Correo del alumno",
    emailHint: "Opcional. Este correo se puede usar para el acceso del alumno cuando la unidad active el inicio por correo.",
    emailInvalid: "Ingresa un correo válido.",
    firstNameRequired: "El nombre es obligatorio",
    surnameRequired: "El apellido es obligatorio",
    personalDataComplete: "Datos personales completos",
    selectGameAndClasses: "Seleccionar Segmento y Clases",
    gameAndClassesEnvironment: "Ambiente de segmentos y clases para el alumno",
    selectGame: "Seleccionar Segmento",
    createNewGame: "Crear nuevo segmento",
    selectGameToContinue: "Selecciona un segmento para continuar",
    gameSelectedSuccess: "Segmento seleccionado con éxito",
    chooseClasses: "Elegir Clases",
    createNewClass: "Crear nueva clase",
    selectAtLeastOneClass: "Selecciona al menos una clase",
    classesSelected: "{{count}} clase(s) seleccionada(s)",
    selectGameFirstForClasses: "Selecciona un segmento primero para crear clases",
    saving: "Guardando...",
    saveChanges: "Guardar Cambios",
    registerPlayer: "Registrar Alumno",
    removePlayer: "Eliminar jugador",
    confirmDeletePlayer: "¿Estás seguro de que deseas eliminar este jugador?",
    deletePlayerWarning: "Esta acción es irreversible, todos los puntos e historial se perderán completamente.",
    createNewClassTitle: "Crear Nueva Clase",
    createNewGameTitle: "Crear Nuevo Segmento",
    configureNewGameEnvironment: "Configura un nuevo ambiente de segmentos para sus alumnos",
    gameName: "Nombre del Segmento",
    gameNameRequired: "El nombre del segmento es obligatorio",
    setCoinsLimit: "Definir límite de coins para el segmento",
    coinsLimit: "Límite de Coins",
    creating: "Creando...",
    createGame: "Crear Segmento",
    gameCreatedSuccess: "¡Segmento creado con éxito!",
    createGameError: "Error al crear segmento.",
    changeClassTitle: "Cambiar clase — {{name}}",
    howToChangeClasses: "¿Cómo desea cambiar las clases?",
    replaceClasses: "Reemplazar clases",
    replaceClassesDescription: "Elimina de las clases actuales y coloca solo en las seleccionadas",
    addClasses: "Agregar clases",
    addClassesDescription: "Mantiene las clases actuales y agrega las seleccionadas",
    modeAdd: "Modo: Agregar",
    modeReplace: "Modo: Reemplazar",
    addModeDescription: "El alumno permanecerá en sus clases actuales y será agregado a las clases seleccionadas arriba.",
    replaceModeDescription: "El alumno será eliminado de todas las clases actuales y quedará solo en las clases seleccionadas arriba.",
    classUpdatedSuccess: "Clase actualizada con éxito.",
    classUpdateError: "Error al actualizar clase.",
    changeGameTitle: "Cambiar segmento — {{name}}",
    changeGameWarning: "Esta acción eliminará al alumno de sus clases actuales, ya que las clases están vinculadas al segmento anterior.",
    gameUpdatedSuccess: "Segmento actualizado con éxito.",
    gameUpdateError: "Error al actualizar segmento.",
    profileTitle: "Perfil del Alumno",
    viewProfile: "Ver perfil del alumno",
    basicInfo: "Información Básica",
    fullName: "Nombre Completo",
    accessHash: "Hash de Acceso",
    accessHashCopied: "Hash copiado al portapapeles.",
    accessHashCopyError: "No se pudo copiar el hash.",
    copyLabel: "Copiar",
    accessLink: "Enlace de Acceso",
    classesTitle: "Clases",
    classesEnrolled: "Clases en las que el alumno está inscrito",
    noClassAssigned: "Ninguna clase asignada",
    classSummary: "Resumen de las Clases",
    generalScore: "Puntuación General",
    scoreDescription: "Puntos y experiencia del alumno",
    coins: "Monedas",
    experience: "Experiencia",
    pendingRewards: "Recompensas Pendientes",
    pendingRewardsDescription: "Recompensas por recolectar",
    toCollect: "Para Recolectar",
    totalMissions: "Total de Misiones",
    gamesAndProgress: "Segmentos y Progreso",
    gamesAndProgressDescription: "Detalles de los segmentos en los que participa el alumno",
    coinsToCollect: "Monedas a Recolectar",
    xpToCollect: "XP a Recolectar",
    levelLabel: "Nivel {{order}}",
    progress: "Progreso: {{percent}}%",
    runningQuests: "Misiones en Curso",
    activeQuests: "{{count}} misión(es) activa(s)",
    accessAccount: "Acceder a la cuenta",
    access: "ACCEDER",
    editPlayer: "Editar jugador",
    level: "Nivel",
    name: "Nombre",
    noPlayerFound: "Ningún jugador encontrado para su búsqueda.",
    noPlayerFoundAlt: "Ningún jugador encontrado.",
    selectAll: "Marcar todos",
    selectInBulk: "Marcar en masa",
    selectDuplicates: "Marcar los duplicados",
    selectWithoutQrCode: "Marcar los sin código QR",
    selectWithoutClass: "Marcar los sin clase",
    selectWithoutGame: "Marcar los sin segmento",
    extractData: "Extraer datos",
    generateQrCodesBlank: "Generar QR Codes sin nombre",
    blankQrCodesDescription: "Indique cuántos códigos QR sin nombre deben generarse para imprimir (máximo: {{max}}).",
    blankQrCodesAmountLabel: "Cantidad de códigos QR",
    blankQrCodesProcessing: "Estamos preparando los códigos QR",
    blankQrCodesProcessingDescription: "Mantenga esta ventana abierta mientras se prepara el archivo.",
    blankQrCodesPollingHint: "El estado se actualiza automáticamente cada 5 segundos.",
    blankQrCodesReady: "Sus códigos QR están listos",
    blankQrCodesReadyDescription: "El archivo se generó y ya se puede descargar.",
    blankQrCodesDownload: "Descargar códigos QR",
    blankQrCodesFailed: "No se pudieron generar los códigos QR",
    blankQrCodesFailedDescription: "Intente generar el archivo nuevamente. Si el problema continúa, contacte al soporte.",
    blankQrCodesRetry: "Intentar nuevamente",
    putStudentDataHere: "Coloque aquí los datos de sus alumnos",
    confirm: "Confirmar",
    studentsSelectedSuccess: "¡Alumnos seleccionados con éxito!",
    couldNotFindStudents: "¡No fue posible encontrar los alumnos seleccionados!",
    download: "Descargar",
    qrCodesWillBeGenerated: "Los QR Codes se generarán en máximo 10 minutos, revise el historial",
    generate: "Generar",
    tableLevel: "Nivel",
    tableStudent: "Nombre",
    tableBalance: "Saldo",
    tableClass: "Clase",
    tableGame: "Segmento",
    noStudentFound: "Ningún alumno encontrado.",
    generatingQrCodes: "Generando los QR Codes... Este proceso puede tardar hasta 5 minutos.",
    selectClassesToMove: "Selecciona a qué clases desea mover a los alumnos:",
    selectGamesToMove: "Selecciona a qué segmentos desea mover a los alumnos:",
    removeFromCurrentClasses: "Esta acción eliminará a los alumnos seleccionados de sus clases actuales, manteniéndolos solo en las clases seleccionadas.",
    removeFromCurrentClassesForGames: "Esta acción eliminará a los alumnos seleccionados de sus clases actuales, manteniéndolos solo en las clases seleccionadas.",
    confirmDeletePlayers: "¿Estás seguro de que deseas eliminar estos jugadores?",
    deletePlayersWarning: "Esta acción es irreversible, todos los puntos e historial de los alumnos seleccionados abajo se perderán completamente.",
    playersRemovedSuccess: "Jugadores eliminados con éxito.",
    deletionError: "Error al eliminar",
    playersMovedClassSuccess: "Jugadores movidos de clase con éxito.",
    classChangeError: "Error al cambiar de clase",
    playersMovedGameSuccess: "Jugadores movidos de segmento con éxito.",
    gameChangeError: "Error al cambiar de segmento",
    selectAtLeastOnePlayer: "¡Selecciona al menos un jugador!",
    confirmGenerateQrCodes: "¿Realmente desea generar los QR Codes de {{count}} alumnos?",
    failedToGenerateQrCodes: "Error al generar QR Codes",
    newPlayer: "nuevo jugador",
    newPlayerTooltip: "Si desea agregar solo un alumno al segmento, ¡seleccione esta opción!",
    importPlayers: "importar alumnos",
    importPlayersTooltip: "¿Necesita agregar varios alumnos a la vez? ¡Esta es la mejor opción! Descargue la planilla y siga el paso a paso.",
    bulkMarkWithAi: "marcar en masa con IA",
    bulkMarkWithAiTooltip:
      "Use la IA para seleccionar varios alumnos a la vez según un prompt o archivo.",
    aiAgentV2: "IA 2.0 (Agente)",
    aiAgentV2Tooltip:
      "IA agéntica con herramientas (JS, bash, visión) para selección inteligente de alumnos.",
    applyAttitudes: "Aplicar actitudes/misiones",
    deselectAll: "desmarcar todos",
    adjustBalance: "ajustar saldo",
    setBalance: "definir saldo",
    giveChests: "dar cofres",
    chestQuantity: "Cantidad de cofres",
    chestsGrantedSuccess: "¡Cofres concedidos con éxito!",
    studentsLabel: "Alumnos",
    changeClass: "cambiar de clase",
    changeGame: "cambiar de segmento",
    deleteLabel: "eliminar",
    generateNewQrCodes: "Generar QR Codes NUEVOS",
    downloadExistingQrCodes: "Descargar QR Codes QUE YA EXISTEN",
    studentsSelectedOf: "alumnos seleccionados de",
    studentsSelected: "alumnos seleccionados",
    adjustPlayerCoins: "ajustar coins de los jugadores",
    filtersTitle: "Filtros",
    clearFilters: "Limpiar Filtros",
    onlyPlayersWithoutQrCode: "Solo jugadores sin QR code",
    sortByLabel: "Ordenar por",
    deselectPlayers: "Deseleccionar {{count}} jugadores",
    selectAllPlayers: "Seleccionar todos los {{count}} jugadores",
    noGames: "SIN SEGMENTOS",
    noClasses: "SIN CLASES",
    createdAt: "Fecha de creación:",
    notAvailable: "N/A",
    balanceLabel: "Saldo",
    missionsToCollect: "Misiones por recolectar:",
    attitudesToCollect: "Actitudes por recolectar:",
    chestsToCollect: "Cofres por recolectar:",
    chestsPendingHint: "pendientes de abrir",
    detailsLabel: "Detalles",
    changeClassLabel: "Cambiar clase",
    changeGameLabel: "Cambiar segmento",
    historyLabel: "Historial",
    accessAccountLabel: "Acceder a cuenta",
    generalInfo: "Información General",
    noGameLabel: "Sin segmento",
    noClassLabel: "Sin clase",
    optionsLabel: "Opciones",
    playerUpdatedSuccess: "¡Jugador actualizado con éxito!",
    errorSavingChanges: "Error al guardar cambios.",
    playerRemovedSuccessAlt: "Jugador eliminado con éxito.",
    errorRemovingPlayer: "Error al eliminar jugador.",
    errorLoadingPlayerData: "Error al cargar datos del jugador.",
    editPlayerDialogTitle: "Editar jugador — {{name}}",
    didNotReceiveToday: "no recibió hoy",
    receivedTimes: "recibió {{count}} vez",
    receivedTimesPlural: "recibió {{count}} veces",
    classesLabel: "Clases:",
    noClassText: "Sin Clase",
    gameLabel: "Segmento:",
    noGameText: "Sin Segmento",
    qrCodeTitle: "Vincular QRCode",
    virtualCard: "Tarjeta Virtual",
    approachQrCode: "Acerque el QRCode a la cámara para vincularlo al jugador.",
    generateCard: "Generar tarjeta",
    generateNewCard: "Generar nueva tarjeta",
    downloadCard: "Descargar tarjeta",
    downloadCardError: "No se pudo generar la imagen de la tarjeta. Inténtalo de nuevo.",
    viewCard: "Ver tarjeta",
    confirmNewQrCode: "¿Estás seguro de que deseas vincular otro QRCode para este jugador?",
    qrCodeWarning: "Esta acción es irreversible y el QRCode antiguo perderá de inmediato acceso a todas las plataformas Gamefik.",
    playerSavedSuccess: "Jugador guardado con éxito.",
    searchPlayersPlaceholder: "Buscar jugadores...",
    filtersSubtitle: "Refina la lista de jugadores",
    filterGameLabel: "Segmento",
    filterClassesLabel: "Clases",
    filterSortLabel: "Ordenar",
    filterOtherLabel: "Otros",
    levelShort: "Nv {{order}}",
    chestAlt: "Cofre",
    exportAccessInstructions: "Exportar instrucciones de acceso",
    exportAccessInstructionsTooltip: "Exporta una hoja con el nombre y el enlace de instrucción de acceso de los estudiantes seleccionados.",
    playerCountSingular: "{{count}} jugador",
    playerCountPlural: "{{count}} jugadores",
    cancel: "Cancelar",
    save: "Guardar",
    back: "Volver",
    completeRequiredFields: "Completa todos los campos obligatorios para continuar",
    search: "Buscar",
    selectClasses: "Selecciona las clases",
    selectOneClass: "Selecciona una clase",
    allClassesUpper: "TODAS",
    someClassesUpper: "ALGUNAS",
    searchEllipsis: "Buscar...",
    clearSearch: "Limpiar búsqueda",
    noOptionFound: "Ninguna opción encontrada",
    allYourClasses: "Todas tus clases",
    allClasses: "Todas las clases",
    allYourClassesCanSee: "Todas tus clases podrán ver esta misión",
    allClassesCanSee: "Todas las clases de los segmentos seleccionados podrán ver esta misión",
    selectGameToSeeClasses: "Selecciona un segmento para ver las clases",
    allClassesOption: "TODAS LAS CLASES",
    studentsCount: "alumnos",
    editClassTitle: "Editar clase",
    nothingFound: "Nada encontrado",
    nameColumn: "Nombre",
    gamesColumn: "Segmentos",
    createdColumn: "Creado",
    playersColumn: "Jugadores",
    editColumn: "Editar",
    rowActionView: "Ver alumno",
    rowActionEdit: "Editar alumno",
    rowActionQrCode: "Código QR",
    rowActionOpenApp: "Acceder a la app",
    accessUnavailableGenerateQr: "Genera o vincula el código QR de este alumno antes de acceder a la app.",
    rowActionCopyAccess: "Copiar acceso",
    rowActionAccessCopied: "¡Copiado!",
    importButton: "Importar",
    allPlayersTitle: "Todos",
    allPlayersSubtitle: "Vista consolidada de todos los alumnos",
    allPlayersPageTitle: "Todos los Alumnos | Gamefik",
    refreshingData: "Actualizando…",
    refreshingDataLabel: "Actualizando datos",
    updatedAt: "Actualizado a las {{time}}",
    lastUpdatedAtTitle: "Última actualización a las {{time}}",
    exportButton: "Exportar",
    exportAll: "Todos los alumnos ({{count}})",
    exportSelected: "Seleccionados ({{count}})",
    totalStudents: "Total de alumnos",
    totalClasses: "Total de clases",
    filterAllClasses: "Todas las clases",
    filterClassMobile: "Clase",
    filterSearchClass: "Buscar clase...",
    filterNoClass: "No se encontró ninguna clase.",
    filterSingleClass: "1 clase",
    filterClassCount: "{{count}} clases",
    filterClearClasses: "Limpiar selección ({{count}})",
    aiSelectionLabel: "Seleccionar alumnos con IA",
    aiSelectionButton: "Seleccionar con IA",
    filterAllEngagement: "Todo engagement",
    colEngagement: "Engagement",
    colCollectiblesShort: "Colecc.",
    colCoins: "Monedas",
    colActions: "Acciones",
    selectedCount: "{{count}} seleccionado",
    selectedCountPlural: "{{count}} seleccionados",
    clearSelectionButton: "Limpiar",
    bulkActionsLabel: "Más acciones",
    bulkAccessStudents: "Acceso alumnos ({{count}})",
    bulkMoveClass: "Mover de clase ({{count}})",
    bulkSetBalance: "Definir saldo ({{count}})",
    bulkDelete: "Eliminar ({{count}})",
    filterWithoutAccess: "Sin código de acceso ({{count}})",
    filterWithoutAccessMobile: "Sin acceso",
    filterUnlinked: "Desvinculados ({{count}})",
    filterUnlinkedMobile: "Desvinculados",
    noClassMoveAction: "Alumno sin clase — haz clic para moverlo a una clase",
    selectScopeTitle: "Seleccionar alumnos",
    selectScopeDesc: "La lista tiene {{pages}} páginas ({{total}} alumnos con los filtros actuales). ¿Qué quieres seleccionar?",
    selectScopePage: "Esta página ({{count}})",
    selectScopeAll: "Todas las páginas ({{count}})",
    allHaveAccess: "Todos tienen código de acceso",
    allHaveAccessMobile: "Accesos OK",
    addCta: "Añadir",
    applyCta: "Aplicar",
    exportModalTitle: "Exportar alumnos",
    exportModalSubtitle: "Descarga un CSV con nombre, clase, XP y monedas.",
    exportDownloadCsv: "Descargar CSV",
    setBalanceTitle: "Definir saldo",
    setBalanceSubtitle:
      "Define el saldo objetivo para los {{count}} alumnos seleccionados. El ajuste (añadir o quitar) se calcula automáticamente para cada alumno.",
    setBalanceCoinLabel: "Monedas",
    setBalanceToggleAria: "Cambiar saldo de {{currency}}",
    setBalanceTargetLabel: "Saldo objetivo",
    setBalanceHint:
      "Las monedas desactivadas no se modifican. El cálculo considera el saldo actual más las recompensas por recoger.",
    setBalanceProgress: "Aplicando: {{current}} de {{total}} alumnos...",
    setBalanceApplying: "Aplicando...",
    setBalanceApply: "Definir saldo",
    setBalanceDescription: "[Definir saldo] Ajuste automático para alcanzar el saldo definido",
    setBalanceSuccess: "Saldo definido para {{count}} alumno(s).",
    setBalancePartialError: "Error al ajustar {{count}} alumno(s). Inténtalo de nuevo.",
    emptyStateTitle: "No se encontró ningún alumno",
    emptyStateSubtitle: "Intenta ajustar los filtros de búsqueda",
    loadError: "No se pudieron cargar los alumnos",
    loadErrorSubtitle: "Verifica tu conexión e inténtalo de nuevo.",
    retryButton: "Intentar de nuevo",
    staleDataWarning: "Error al actualizar — mostrando datos anteriores.",
    deleteStudentsTitleOne: "Eliminar alumno",
    deleteStudentsTitleMany: "Eliminar alumnos",
    deleteStudentConfirmIntro: "¿Estás seguro de que deseas eliminar",
    deleteStudentConfirmOutro: "? Esta acción no se puede deshacer.",
    thisStudentFallback: "este alumno",
    nStudentsCount: "{{count}} alumnos",
    deleting: "Eliminando...",
    removedSuccess: "¡Alumnos eliminados con éxito!",
    removeError: "Error al eliminar alumnos.",
    updatedSuccess: "¡Alumno actualizado con éxito!",
    updateError: "Error al actualizar alumno.",
    movedClassSuccess: "¡Alumnos movidos de clase con éxito!",
    movedClassSuccessWithWarning: "Los alumnos fueron movidos, pero algunos registros auxiliares no se completaron. No es necesario intentarlo de nuevo.",
    movedClassPartial: "Se movieron {{success}} alumno(s); no se pudieron mover {{errors}}.",
    movedClassPartialWithWarning: "Se movieron {{success}} alumno(s); no se pudieron mover {{errors}}. También fallaron algunos registros auxiliares de los movimientos completados.",
    moveClassFailed: "No se pudieron mover {{errors}} alumno(s).",
    moveClassError: "Error al mover alumnos de clase.",
    paginationInfo: "Mostrando {{from}} a {{to}} de {{total}} alumnos",
    moreOptionsLabel: "Más opciones",
    selectAllMobileCta: "Seleccionar todos",
    loadMoreButton: "Cargar más ({{count}})",
    normalizeGamesBulk: {
      button: "Normalizar segmentos",
      buttonTooltip: "Unificar el game_id de todos los alumnos seleccionados al segmento actual de cada uno",
      title: "Normalizar segmentos en lote",
      description:
        "Reasigna todas las transacciones (hot y cold) de cada alumno seleccionado a su segmento actual. El saldo por tipo de punto sigue siendo el mismo — solo cambia la partición por segmento. Cada alumno se procesa de forma independiente con su propia transacción.",
      filtersTitle: "Incluir transacciones",
      includeCollected: "Puntos recolectados",
      includeUncollected: "Puntos no recolectados",
      noFilterSelected: "Selecciona al menos un tipo de punto para continuar.",
      progressLabel: "{{current}} de {{total}} alumnos",
      processingPlayer: "Procesando {{name}}",
      statusQueued: "En cola",
      statusPreviewing: "Calculando vista previa",
      statusApplying: "Aplicando",
      statusSuccess: "Normalizado",
      statusFailure: "Falló",
      statusSkipped: "Ya estaba normalizado",
      alreadyNormalized: "No hay cambios necesarios.",
      targetGame: "Segmento destino",
      otherGames: "Otros segmentos",
      affectedTxs: "{{count}} txs afectadas",
      modifiedLabel: "{{hot}} hot · {{cold}} cold",
      summaryLabel: "{{success}} con éxito · {{failures}} fallo(s) · {{skipped}} ya normalizado(s)",
      noPlayersSelected: "Selecciona al menos un alumno para normalizar.",
      cancel: "Cancelar",
      canceling: "Cancelando…",
      close: "Cerrar",
      retry: "Reprocesar fallos",
      runningHint: "Procesando en paralelo (3 a la vez). Puedes cancelar en cualquier momento — los alumnos en curso terminarán su operación actual.",
      completedHint: "Operación completada. Cada alumno fue procesado de forma independiente e idempotente.",
    },
  },
  importPlayers: {
    pageTitle: "Importar Jugadores | Gamefik Escuelas al nivel máximo.",
    back: "Volver",
    title: "Importar Lista de Jugadores",
    subtitle: "Sigue los pasos a continuación para importar tus jugadores de forma simple y rápida",
    stepSelectGame: "Seleccionar Segmento",
    stepDownload: "Descargar",
    stepSend: "Enviar",
    stepCreateClasses: "Crear Clases",
    stepCreatePlayers: "Crear Jugadores",
    selectGameTitle: "Selecciona el Segmento",
    selectGameDescription: "Vincule los jugadores al segmento correspondiente",
    selectGameWarning: "Todo jugador debe estar vinculado a un segmento. Esta etapa es <strong>obligatoria</strong> y fundamental para el proceso.",
    downloadTemplateTitle: "Descargar Planilla Modelo",
    downloadTemplateDescription: "Use nuestra planilla para estandarizar los datos",
    downloadTemplateInstructions: "Es necesario llenar esta planilla correctamente, ya que permitirá que nuestro sistema entienda la información de tus alumnos.",
    important: "IMPORTANTE",
    downloadTemplateWarning: "Coloque en esta planilla <strong>solo los alumnos de este segmento</strong>. Para insertar alumnos de otros segmentos, será necesario repetir el proceso seleccionando el segmento correcto.",
    downloadTemplateButton: "Descargar Planilla Modelo",
    alreadyHaveTemplate: "Ya tengo la planilla completada",
    uploadTitle: "Carga de la Planilla",
    uploadDescription: "Envíe el archivo CSV con los datos de los jugadores",
    manualUpload: "Carga Manual (CSV/TXT)",
    processingFile: "Procesando archivo...",
    dragOrClick: "Arrastra el archivo aquí o haz clic para seleccionar",
    acceptedFormats: "Formatos aceptados: CSV, TXT",
    confirmUpload: "Confirmar Carga",
    fileSelected: "Archivo seleccionado",
    incompatibleFormat: "Formato No Compatible con Carga Manual",
    fileNeedExactColumns: "El archivo debe tener <strong>exactamente</strong> las columnas:",
    expectedFormat: "Formato Esperado",
    yourFile: "Su Archivo",
    columnsDetected: "{{count}} columna detectada",
    columnsDetectedPlural: "{{count}} columnas detectadas",
    noColumnDetected: "Ninguna columna detectada",
    recommendedSolution: "Solución Recomendada",
    useAiUpload: "Use la <strong>Carga con Inteligencia Artificial</strong> abajo. ¡La IA procesará automáticamente cualquier formato de planilla!",
    acceptsAnyStructure: "Acepta cualquier estructura",
    identifiesColumnsAutomatically: "Identifica columnas automáticamente",
    worksWithFormats: "Funciona con CSV, XLSX, PDF y más",
    errorProcessingFile: "Error al Procesar Archivo",
    suggestion: "Sugerencia",
    useAiSuggestion: "Use la <strong>Carga con IA</strong> abajo para procesar automáticamente archivos en cualquier formato.",
    validatingFile: "Validando formato del archivo...",
    fileReadyToProcess: "Archivo listo para ser procesado",
    sendFile: "Enviar Archivo",
    processing: "Procesando...",
    or: "O",
    aiUploadLabel: "Carga con Inteligencia Artificial (SOLO PARA PRUEBAS)",
    aiUploadDescription: "Use IA para procesar automáticamente archivos en cualquier formato. La IA estandarizará a columnas \"nombre\" y \"clase\".",
    codegenMode: "Modo Codegen (Experimental)",
    codegenDescription: "La IA genera código de transformación en vez de JSON directo",
    codegenActive: "Modo Codegen Activo",
    codegenInfo: "La IA generará código JavaScript para transformar los datos. Más rápido, económico y confiable. Soporta solo CSV/XLSX.",
    processingWithAi: "Procesando con IA...",
    selectFileForAi: "Seleccionar Archivo para IA",
    aiAcceptedFormats: "Formatos aceptados: CSV, XLSX, XLS, PDF, TXT",
    studentProcessed: "{{count}} alumno procesado",
    studentsProcessed: "{{count}} alumnos procesados",
    realTime: "En tiempo real",
    downloadBatch: "Descargar Lote {{current}}",
    lastFound: "Últimos Encontrados:",
    previewJson: "Vista previa JSON",
    batchDownloaded: "¡Lote {{current}}/{{total}} descargado!",
    batchCompleted: "Lote {{current}}/{{total}} completado",
    studentsInBatch: "{{count}} alumnos en este lote. Total: {{total}}",
    aiNotFoundValid: "La IA no encontró datos válidos. Intente otro archivo.",
    fileProcessedSuccess: "¡Archivo procesado con éxito! {{count}} jugador encontrado.",
    fileProcessedSuccessPlural: "¡Archivo procesado con éxito! {{count}} jugadores encontrados.",
    aiProcessingFailed: "Error al procesar archivo con IA",
    errorSendingToAi: "Error al enviar el archivo a la IA.",
    csvError: "Por favor, envía un archivo CSV o TXT",
    invalidFormat: "Formato inválido",
    emptyFile: "Archivo vacío o sin datos válidos",
    validationError: "Error al validar archivo. Formato no reconocido.",
    spreadsheetProcessed: "¡Planilla procesada con éxito!",
    spreadsheetReadError: "Error al leer la planilla. Verifica el formato (CSV) y la codificación.",
    classValidation: "Validación de las Clases",
    classValidationDescription: "Confirme las clases que serán creadas en el sistema",
    reviewClassInfo: "Revise y confirme la información sobre las clases que serán creadas:",
    playerValidation: "Validación de los Jugadores",
    playerValidationDescription: "Confirme los jugadores que serán creados en el sistema",
    reviewPlayerInfo: "Revise y confirme la información sobre los jugadores que serán creados:",
    duplicateNamesFound: "{{count}} nombre duplicado encontrado",
    duplicateNamesFoundPlural: "{{count}} nombres duplicados encontrados",
    duplicatesWillBeMerged: "Los jugadores duplicados serán fusionados automáticamente con sus clases combinadas",
    unknown: "Desconocido",
    linesWillBeCombined: "Líneas {{line1}} y {{line2}} - Clases serán combinadas",
    playersForCreation: "Jugadores para Creación",
    playerCount: "{{count}} jugador",
    playersCount: "{{count}} jugadores",
    viewJson: "Ver JSON (Jugadores y Clases)",
    playersLabel: "Jugadores ({{count}}):",
    availableClasses: "Clases Disponibles ({{count}}):",
    createNPlayers: "Crear {{count}} Jugador",
    createNPlayersPlural: "Crear {{count}} Jugadores",
    completed: "¡Completado!",
    progressLabel: "Progreso:",
    of: "de",
    processingComplete: "Procesamiento completo",
    processingLabel: "Procesando...",
    pleaseWait: "Por favor, espere mientras procesamos su solicitud",
    creatingPlayers: "Creando jugadores...",
    creatingPlayersProgress: "Creando jugadores... ({{success}} creados{{errors}})",
    errorsLabel: ", {{count}} errores",
    playersCreatedWithWarning: "{{count}} jugadores creados con éxito",
    failedDescription: "{{count}} fallaron. Verifica la consola para detalles.",
    playersCreatedSuccess: "¡{{count}} jugadores creados con éxito!",
    errorCreatingPlayers: "Error al crear los jugadores",
    invalidServerResponse: "Respuesta inválida del servidor",
    startingProcessing: "Iniciando procesamiento...",
    aiProcessingFail: "Error al procesar archivo",
    batchLabel: "Lote {{current}}/{{total}}",
  },
  homePage: {
    metaTitle: "Home · Gamefik",
    greetingMorning: "Buenos días",
    greetingAfternoon: "Buenas tardes",
    greetingEvening: "Buenas noches",
    hello: "Hola",
    helloName: "Hola, {{name}}",
    tagline: "¡Convirtamos tu clase en el momento favorito de tus alumnos!",
    createWithAi: "Crear con IA",
    onboarding: {
      welcomeBadge: "Misión de bienvenida",
      progress: "Progreso",
      reward: "Recompensa",
      setupTitle: "Configura tu cuenta en ",
      setupHighlight: "4 pasos",
      setupSubtitle: "En menos de 10 minutos estarás listo para jugar.",
      startHere: "¡Empieza aquí!",
      startNow: "Empezar ahora",
      completed: "Hecho",
      stepsCompleted: "pasos completados",
      recommended: "Recomendado",
      tutorialTitle: "Tutorial completo de la plataforma",
      tutorialDescription:
        "Aprende a configurar clases, crear actividades gamificadas y seguir el progreso de tus alumnos en tiempo real.",
      watchNow: "Ver tutorial",
      viewTutorial: "Cómo hacerlo",
      missionComplete: "¡Misión completa!",
      schoolReady: "Tu escuela está lista. Ahora crea actividades increíbles para tus alumnos.",
    },
    steps: {
      alunos: {
        title: "Agrega tus alumnos",
        description: "Crea clases y añade tus primeros alumnos",
      },
      atividade: {
        title: "Crea tu primera actividad",
        description: "Cuestionario o misión con IA en segundos",
      },
      professores: {
        title: "Invita a tus profesores",
        description: "Trae a tu equipo a Gamefik",
      },
      app: {
        title: "Accede a la app de los alumnos",
        description: "Mira cómo la usarán tus alumnos",
      },
    },
    activities: {
      sectionTitle: "Crear actividad",
      sectionSubtitle: "Elige un formato o deja que la IA lo haga por ti.",
      seeAllFormats: "Ver todos los formatos",
      createNow: "Crear ahora",
      comingSoon: "Próximamente",
      comingSoonColon: "Próximamente:",
      footer: "Gamefik — Nivel máximo",
      quiz: {
        title: "Quiz",
        description: "Opción múltiple para evaluar conocimientos",
        fullDescription:
          "El Quiz es una actividad interactiva donde los alumnos responden preguntas de opción múltiple. Cada pregunta puede tener de 2 a 5 alternativas, con feedback al instante. Ideal para repasar, verificar aprendizaje y preparar exámenes. El profesor puede definir tiempo límite, orden aleatorio e intentos.",
      },
      missao: {
        title: "Misión",
        description: "Tareas prácticas con envío de evidencias",
        fullDescription:
          "La Misión es una actividad práctica donde el alumno hace una tarea en el mundo real y envía una prueba (foto, texto o archivo). El profesor o la IA de Gamefik valida la entrega. Perfecta para trabajo práctico, proyectos creativos y deberes que requieren comprobación.",
      },
      flashcard: {
        title: "Flashcard",
        description: "Memorización de contenidos",
        fullDescription:
          "Tarjetas anverso/reverso para repetición espaciada. Ideal para vocabulario, fechas y conceptos. Puede ser término/definición o verdadero/falso.",
      },
      trilha: {
        title: "Ruta",
        description: "Recorridos de aprendizaje con logros",
        fullDescription:
          "La Ruta es un recorrido de aprendizaje con varias etapas. El alumno avanza por fases secuenciales, desbloqueando contenidos y logros. Combina quizzes, misiones y más en una experiencia gamificada.",
      },
      comingCompletePhrase: "Completa la frase",
      comingAssociacao: "Asociación",
      comingRedacao: "Redacción",
      comingDesembaralhe: "Ordena la frase",
      moreAboutAria: "Más información sobre {{type}}",
    },
    dialog: {
      createWithType: "Crear {{type}}",
      describeTheme: "Describe el tema y la IA lo crea para ti",
      assistantAlt: "Asistente IA",
      aiBadge: "IA",
      assistantIntro: "¡Hola! Cuéntame de qué tema quieres crear",
      assistantOutroQuiz: "el quiz",
      assistantOutroMissao: "la misión",
      assistantOutroFlashcard: "el flashcard",
      assistantSuffix: ". Puede ser una asignatura, un tema concreto o incluso pegar un texto.",
      placeholderQuiz: "Ej.: Revolución francesa para 8.º...",
      placeholderMissao: "Ej.: Investigación sobre reciclaje en el barrio...",
      placeholderFlashcard: "Ej.: Vocabulario básico de inglés...",
      submitHint: "Pulsa Enter o el botón para crear con IA",
      aboutActivity: "Sobre esta actividad",
      createType: "Crear {{type}}",
      comingSoonButton: "Próximamente",
    },
  },
  dashboard: {
    exportData: "Exportar datos",
    close: "Cerrar",
    coinsGoal: {
      title: "Contraste: Progreso Temporal vs. Realidad de las Coins",
      descriptionPart1: "Análisis comparativo entre el",
      descriptionIdealProgress: "progreso temporal ideal",
      descriptionPart2: "(basado en el tiempo transcurrido) y el",
      descriptionRealProgress: "progreso real de las coins",
      descriptionPart3: "(basado en el uso efectivo)",
      temporal: "Temporal",
      real: "Real",
      analysisPeriod: "Período de Análisis",
      selectPeriod: "Selecciona el período deseado para el análisis temporal de las coins",
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      predefinedPeriods: "Períodos predefinidos",
      schoolYear: "Año Lectivo",
      schoolYearTooltip: "Año lectivo: de febrero a diciembre del año en curso",
      lastThreeMonths: "Últimos 3 meses",
      lastThreeMonthsTooltip: "Últimos 3 meses: del día 1 del mes 3 meses atrás hasta hoy",
      semester: "Semestre",
      semesterTooltip: "Semestre actual: desde el inicio del semestre hasta hoy",
      timeVsReality: "Contraste: Tiempo vs. Realidad",
      idealTimeProgress: "Progreso Temporal Ideal",
      realCoinsProgress: "Progreso Real de Coins",
      basedOnTimePeriod: "Basado en el tiempo transcurrido en el período",
      basedOnCoinsUsed: "Basado en las coins efectivamente utilizadas",
      inSync: "✅ En sincronía",
      aboveIdeal: "⚠️ Por encima del ideal",
      belowIdeal: "⚠️ Por debajo del ideal",
      difference: "Diferencia:",
      totalDays: "Días totales",
      daysPassed: "Días transcurridos",
      daysRemaining: "Días restantes",
      tabTemporal: "Temporal",
      tabAverage: "Promedio por Alumno",
      tabTop10: "Top 10%",
      temporalContrast: "Contraste Temporal: Ideal vs. Real",
      idealVsRealAnalysis: "Progreso Temporal Ideal vs. Progreso Real de Coins - Análisis comparativo del ritmo esperado vs. realidad",
      temporalProgress: "Progreso temporal",
      temporalProgressIcon: "📊 Progreso Temporal:",
      ofPeriodElapsed: "del período transcurrido",
      realProgressIcon: "💰 Progreso Real:",
      ofCoinsUsed: "de las coins utilizadas",
      resolution: "Resolución:",
      weeklyPoints: "Puntos semanales",
      biweeklyPoints: "Puntos quincenales",
      monthlyPoints: "Puntos mensuales",
      timeVsRealityComparison: "Comparación: Tiempo vs. Realidad",
      basedOnTimeElapsed: "Basado en el tiempo transcurrido",
      upToCurrentMoment: "Hasta el momento actual",
      futureProjection: "Proyección Futura",
      basedOnCurrentRate: "Basada en la tasa actual",
      currentPointToday: "Punto actual (hoy)",
      timeVsCoins: "{{time}}% tiempo vs {{coins}}% coins",
      averageVsMaxPrize: "Contraste: Promedio por Alumno vs. Premio Máximo",
      goalMaxPrizeVsAvg: "Meta de llegar al premio máximo vs. Promedio real de coins por alumno - Análisis del poder de compra",
      temporalGoalIcon: "🎯 Meta Temporal:",
      expectedCoins: "coins esperadas",
      realAverageIcon: "💰 Promedio Real:",
      coinsPerStudent: "coins por alumno",
      maxPrize: "Premio máximo:",
      coins: "coins",
      purchasingPowerGoalVsReality: "Poder de Compra: Meta vs. Realidad",
      temporalGoalLabel: "Meta Temporal",
      towardsMaxPrize: "Hacia el premio máximo",
      realAvgPerStudent: "Promedio Real por Alumno",
      currentCoins: "Coins actuales",
      projection: "Proyección",
      currentPoint: "Punto actual",
      ofMaxPrize: "del premio máximo",
      top10VsMaxPrize: "Contraste: Top 10% vs. Premio Máximo",
      goalMaxPrizeVsTop10: "Meta de llegar al premio máximo vs. Promedio de los top 10% de los alumnos - Élite vs. Meta",
      eliteGoalIcon: "🏆 Meta Élite:",
      top10RealIcon: "⭐ Top 10% Real:",
      eliteVsGoal: "Élite vs. Meta: Top 10% de los Alumnos",
      eliteGoalLabel: "Meta Élite",
      top10RealLabel: "Top 10% Real",
      currentElite: "Élite actual",
      eliteProjection: "Proyección Élite",
      temporalContrastAnalysis: "Análisis del Contraste Temporal",
      syncEvaluation: "Evaluación de la sincronía entre progreso temporal y real, con margen de ±10% para determinar si está en sincronía",
      behind: "Atrasado",
      ahead: "Adelantado",
      onTrack: "A Tiempo",
      scheduleStatus: "Estado del cronograma",
      margin: "Margen: ±10%",
      timeDiffProgress: "Diferencia tiempo/progreso",
      needToAccelerate: "Necesita acelerar el ritmo",
      spendingTooFast: "Gastando demasiado rápido",
      adequateRhythm: "Ritmo adecuado",
      withinMargin: "Dentro del margen de ±10%",
      outsideMargin: "Fuera del margen",
      requiredPacePerDay: "Ritmo necesario/día",
      toRecoverDelay: "Para recuperar el retraso",
      toNotAccelerate: "Para no acelerar más",
      toMaintainPace: "Para mantener el ritmo",
      consideredProblematic: "⚠️ Considerado problemático",
      needsAttention: "⚠️ Necesita atención",
      idealSituation: "✅ Situación ideal",
      totalCoinsVolume: "Volumen Total de Coins",
      totalCoinsVolumeDesc: "Comparación entre coins de los alumnos y disponibles en la tienda",
      totalFromStudents: "Total de los alumnos",
      excludingStoreSpending: "(Sin contar gastos en la tienda)",
      totalAvailableInStore: "Total disponible en la tienda",
      avgCoinsVsMaxPrize: "Promedio de Coins por Alumno vs Premio Máximo",
      avgCoinsVsMaxPrizeDesc: "Relación entre promedio de coins por alumno y el artículo más caro de la tienda",
      averagePerStudent: "Promedio por alumno",
      maxPrizeInStore: "Premio máximo de la tienda",
      top10AvgVsMaxPrize: "Promedio de Coins del Top 10% de alumnos vs Premio Máximo",
      top10AvgVsMaxPrizeDesc: "Relación entre promedio de coins del top 10% de los alumnos y el artículo más caro de la tienda",
      top10Average: "Promedio del top 10%",
      utilizationRate: "Tasa de utilización",
      purchasingPower: "Poder de compra",
      remainingCoins: "Coins restantes:",
      currentVsRequiredPace: "Ritmo actual vs necesario:",
      coinsPerDay: "{{value}} coins/día",
      goalReached: "Meta alcanzada",
      chartIdealProgress: "Progreso Temporal Ideal",
      chartRealProgress: "Progreso Real de Coins",
      chartProjection: "Proyección Basada en la Tasa Actual",
      timeElapsed: "Tiempo Transcurrido",
      coinsUsedLabel: "Coins Utilizadas",
      remaining: "Restante",
      temporalProgressTooltip: "Progreso temporal: {{value}}%",
    },
    coinsPerClass: {
      title: "Monedas por clase",
      totalClasses: "Cantidad total de clases: {{count}}",
      allGames: "Todos los segmentos",
      selectGame: "Selecciona un segmento",
      searchClass: "Buscar por clase...",
      nameCol: "Nombre",
      coinsCol: "Monedas",
      playersCol: "Jugadores",
      averageCol: "Promedio",
    },
    generalInfo: {
      activeGames: "Segmentos Activos",
      viewDetails: "Ver detalles",
      participants: "Participantes",
      classes: "Clases",
      averagePerClass: "Promedio por clase",
      studentsCount: "{{count}} alumnos",
      students: "Alumnos",
      activeMissions: "Misiones Activas",
      pendingCount: "{{count}} pendientes",
      totalStock: "Stock Total",
      averagePerStudent: "Promedio/alumno",
      dataNotLoaded: "Los datos de esta tarjeta no pudieron cargarse en este momento.",
      useRetryGlobal: "Use el retry global del dashboard para intentar cargar nuevamente.",
      gameCreatedSuccess: "¡Segmento creado con éxito! 🎉",
      gameCreatedError: "Error al crear el segmento",
      needGameName: "Necesita definir un nombre para el Segmento",
      whatIsGame: "¿Qué es un Segmento?",
      whatIsGameDesc: "Todos los jugadores estarán bajo las mismas reglas y tienda, jugarán juntos. Es muy común que las escuelas separen el segmento de primaria y secundaria, por ejemplo.",
      studentsLabel: "{{count}} estudiantes",
      active: "Activo",
      inactive: "Inactivo",
      creating: "Creando...",
      newGame: "Nuevo Segmento",
      studentsInGame: "Alumnos",
      language: "Idioma",
      activePoints: "Puntos activos",
      coinsLimit: "Límite de monedas",
      searchStudent: "Buscar alumno",
      editGame: "Editar Segmento",
      studentsOfGame: "Alumnos del segmento",
      studentsBadge: "{{count}} alumnos",
      studentFallback: "Alumno",
      noClass: "Sin clase",
      noStudentFound: "Ningún alumno encontrado.",
      rewardsStore: "Tienda de Recompensas",
      remainingStock: "Stock Restante",
      averagePerStudentDialog: "Promedio por Alumno",
      pendingOrders: "Pedidos Pendientes",
      ordersBadge: "{{count}} pedidos",
      pendingBadge: "Pendiente",
      storeManager: "Administrador de tienda",
      viewPendingOrders: "Ver pedidos pendientes",
      gameDetailsUnavailable: "Detalles del segmento no disponibles",
      gameDetailsUnavailableDesc: "No fue posible cargar los datos completos del modal ahora. Use el retry global del dashboard para intentar nuevamente.",
      loadingGameDetails: "Cargando detalles del segmento",
      loadingGameDetailsDesc: "Estamos preparando la lista completa de segmentos y jugadores para este modal.",
      missionDetailsUnavailable: "Detalles de las misiones no disponibles",
      missionDetailsUnavailableDesc: "No fue posible cargar los datos auxiliares para este modal. Intenta nuevamente desde el dashboard.",
      loadingMissionDetails: "Cargando detalles de las misiones",
      loadingMissionDetailsDesc: "Estamos reuniendo jugadores, clases y segmentos relacionados con cada misión.",
      unknown: "Desconocido",
      expired: "Expirada",
      startsOn: "Inicia el {{date}}",
      createdBy: "Creada por:",
      period: "Período:",
      classesLabel: "Clases:",
      allLabel: "todas",
      gamesLabel: "Segmentos:",
      teachersCanValidate: "Los profesores pueden validar",
      teachersCantValidate: "Los profesores no pueden validar",
      completions: "Conclusiones",
      evaluateProofs: "Evaluar {{count}} comprobantes pendientes",
    },
    links: {
      manuals: "Manuales",
      marketingFolder: "Carpeta de marketing",
      storeSuggestion: "Sugerencia de tienda",
      gamefikInsta: "Instagram de Gamefik",
    },
    loadingStatus: {
      reloadingDashboard: "Recargando el dashboard",
      clearingAndReloading: "Limpiando lo cargado y buscando todo de nuevo.",
      tryingAgain: "Intentando de nuevo",
      loadingDashboard: "Cargando dashboard",
      retryingFailed: "Buscando nuevamente las secciones que fallaron.",
      loadingSections: "Buscando los datos de cada sección del dashboard.",
      couldNotLoad: "No fue posible cargar el dashboard",
      mainNotResponding: "Las partes principales no respondieron. Intente de nuevo o recargue la página.",
      partialNotLoaded: "Parte de los datos no cargó",
      someNotLoaded: "La página se abrió, pero algunas secciones no pudieron cargarse.",
      dashboardReady: "Dashboard listo",
      allDataLoaded: "Todos los datos fueron cargados con éxito.",
      sectionLoaded: "{{count}} sección cargada",
      sectionsLoaded: "{{count}} secciones cargadas",
      of: "de",
      restarting: "REINICIANDO",
      loading: "CARGANDO",
      progress: "Progreso",
      loadingDashboardData: "Cargando datos del dashboard",
      sectionInLoading: "{{count}} sección en carga",
      sectionsInLoading: "{{count}} secciones en carga",
      errorLoading: "Algo salió mal al cargar",
      someNotResponded: "Algunas secciones aún no respondieron. El resultado final aparecerá cuando termine.",
      failure: "FALLA",
      whatFailed: "Lo que falló",
      noEssentialLoaded: "Ninguna parte esencial pudo cargarse en este intento.",
      tryAgain: "Intentar de nuevo",
      restartLoading: "Reiniciar carga",
      restart: "Reiniciar",
      didNotLoad: "No cargaron:",
    },
    missions: {
      title: "Misiones",
      totalMissions: "Cantidad total de misiones: {{count}}",
      nameCol: "Nombre",
      participantsCol: "Participantes",
      approvalsCol: "Aprobaciones",
      rejectionsCol: "Rechazos",
      valueCol: "Valor",
      valueAcquiredCol: "Valor adquirido",
      descriptionLabel: "Descripción:",
      participantsLabel: "Participantes:",
      approvalsLabel: "Aprobaciones:",
      rejectionsLabel: "Rechazos:",
      valueLabel: "Valor:",
      valueAcquiredLabel: "Valor Adquirido:",
    },
    recentActions: {
      title: "Acciones Recientes",
      viewFullHistory: "Ver historial completo",
    },
    engagement: {
      title: "Participación activa en misiones en el año",
      subtitle: "Porcentaje de jugadores que realizaron al menos una misión.",
      players: "Jugadores",
    },
    monthlyAccess: {
      title: "Accesos mensuales",
      chartLabel: "acceso",
    },
    mostRedeemedItems: {
      title: "Productos más canjeados",
      totalRedeemed: "Cantidad de productos ya canjeados: {{count}}",
      totalSpentInStore: "Valor total gastado en la tienda:",
      product: "Producto",
      quantitySold: "Cantidad vendida",
      currentValue: "Valor actual",
      averageValue: "Valor Promedio",
      totalSpent: "Total Gastado",
      stock: "Stock",
      productInfo: "Información del producto: {{name}}",
      productDetails: "Detalles del Producto",
      priceLabel: "Precio:",
      stockLabel: "Stock:",
      playerLimit: "Límite por jugador:",
      unlimited: "Ilimitado",
      categories: "Categorías:",
      startDateLabel: "Fecha de inicio:",
      giftCardLabel: "Tarjeta de regalo:",
      yes: "Sí",
      no: "No",
      giftCardInfo: "Información de la Tarjeta de Regalo",
      provider: "Proveedor:",
      brand: "Marca:",
      valueLabel: "Valor:",
      messageLabel: "Mensaje:",
      instructionsLabel: "Instrucciones:",
      purchaseHistory: "Historial de Compras",
      purchaseId: "ID de la Compra",
      playerName: "Nombre del Jugador",
      purchaseDate: "Fecha de la Compra",
      statusCol: "Estado",
      quantityCol: "Cantidad",
      totalValue: "Valor Total",
      delivered: "Entregado",
      pendingStatus: "Pendiente",
      canceled: "Cancelado",
      noPurchases: "Este producto aún no ha sido comprado por ningún jugador.",
    },
    rewardsSection: {
      title: "Dashboard de Recompensas",
      subtitle: "Análisis completo del sistema de recompensas.",
      spendingRanking: "Ranking de Gastos",
      totalOf: "Total de",
      playersLabel: "Jugadores",
      rewardsLabel: "Recompensas",
      inStore: "En la tienda",
      stockPer: "Stock por",
      playerLabel: "Jugador",
      deliveredLabel: "Entregados",
      deliveredPer: "Entregados por",
      deliveryRate: "Tasa de Entrega",
      purchased: "Compraron",
      percentPurchased: "{{percentage}}% de los estudiantes realizaron",
      atLeastOnePurchase: "al menos una compra en la tienda",
      notPurchased: "No compraron",
      studentSpendingRanking: "Ranking de Gastos de los Alumnos",
      exportXlsx: "📊 Exportar XLSX",
      position: "Posición",
      studentName: "Nombre del Alumno",
      totalSpentCol: "Total Gastado",
      currentBalance: "Saldo Actual",
      totalBalance: "Saldo Total",
      purchases: "Compras",
      items: "Artículos",
      deliveredCol: "Entregados",
      actions: "Acciones",
      viewDetails: "Ver Detalles",
      purchaseDetails: "Detalles de las Compras: {{name}}",
      purchaseId: "ID Compra",
      date: "Fecha",
      itemsCol: "Artículos",
      statusCol: "Estado",
      totalValueCol: "Valor Total",
      deliveredStatus: "Entregado",
      pendingStatus: "Pendiente",
      canceledStatus: "Cancelado",
      includingToCollect: "Incluyendo monedas por recolectar",
    },
    pagination: {
      paginationMode: "Paginación",
      scrollMode: "Desplazamiento",
      perPage: "{{count}} / página",
      of: "de",
      firstPage: "Primera página",
      previousPage: "Página anterior",
      nextPage: "Siguiente página",
      lastPage: "Última página",
    },
    platformUsage: {
      title: "Uso de la plataforma",
      totalRecords: "Cantidad total de registros: {{count}}",
      searchTeacher: "Buscar por profesor...",
      teacher: "Profesor",
      accesses: "Accesos",
    },
    playersAccess: {
      neverCollected: "Nunca recolectó",
      activationList: "Lista de activación ({{count}})",
      activationSubtitle: "Activación, saldo y último canje de los jugadores.",
      exportCsv: "Exportar CSV",
      allGames: "Todos los segmentos",
      allClasses: "Todas las clases",
      selectGame: "Selecciona un segmento",
      selectClass: "Selecciona una clase",
      orderBy: "Ordenar por",
      lastCollection: "Última recolección",
      missionsSent: "Misiones enviadas",
      quizzesSent: "Quizzes enviados",
      direction: "Dirección",
      descending: "Descendente",
      ascending: "Ascendente",
      total: "Total",
      activeLabel: "Activos",
      inactiveLabel: "Inactivos",
      nameCol: "Nombre",
      classesCol: "Clases",
      gamesCol: "Segmentos",
      missionsCol: "Misiones",
      statusCol: "Estado",
      lastRedemption: "Último Canje",
      active: "Activo",
      inactive: "Inactivo",
      lastRedemptionPerPlayer: "Último canje por jugador",
      periodLabel: "Período",
      periodDays: "{{count}} días",
    },
    playersRanking: {
      title: "Ranking de jugadores",
      totalPlayers: "Cantidad total de jugadores: {{count}}",
      searchPlayer: "Buscar por jugador...",
      exportData: "📊 Exportar datos",
      student: "Alumno",
    },
    teacherUse: {
      title: "Uso de los profesores",
      totalTeachers: "Cantidad total de profesores: {{count}}",
      searchTeacher: "Buscar por profesor...",
      nameCol: "Nombre",
      lastPlatformUse: "Último uso",
      ofPlatform: "de la plataforma",
      missionsCreated: "Misiones",
      missionsCreatedSub: "Creadas",
      quizzesCreated: "Quizzes",
      quizzesCreatedSub: "Creados",
      distributedCoins: "Coins",
      distributedCoinsSub: "distribuidas",
      playersCol: "Jugadores",
      avgCoinsPerPlayer: "Promedio de coins por jugador",
      activeTag: "Activo",
      absentTag: "Ausente",
    },
  },
  modal: {
    shopTitle: "Tienda Gamefik",
    coins: "monedas",
    purchased: "Adquirido",
    buy: "Comprar",
    purchaseSuccess: "¡Compra realizada con éxito! El artículo se ha añadido a tu inventario.",
    insufficientBalance: "Saldo insuficiente. Completa más tareas para ganar monedas.",
    availableItems: "Artículos Disponibles",
    myInventory: "Mi Inventario",
    emptyInventory: "Tu inventario está vacío",
    buyItemsToSee: "Compra artículos en la tienda para verlos aquí.",
    viewAvailableItems: "Ver Artículos Disponibles",
    purchasedAt: "Adquirido el",
    code: "Código:",
    copy: "Copiar",
    rankingTitle: "Ranking de Escuelas",
    place: "lugar",
    weekly: "Semanal",
    monthly: "Mensual",
    yearly: "Anual",
    yourSchool: "Tu Escuela",
    completedPercent: "{{percent}}% completado",
    points: "puntos",
    generalRanking: "Ranking General",
    yourSchoolLabel: "Tu escuela",
    students: "alumnos",
    days: "días",
    howPointsCalculated: "Cómo se calculan los puntos",
    pointsDescription: "La puntuación se basa en tres factores principales:",
    completionProgress: "Progreso de conclusión:",
    completionProgressDesc: "Hasta 100 puntos basados en el porcentaje de tareas completadas.",
    accumulatedCoins: "Monedas acumuladas:",
    accumulatedCoinsDesc: "Cada 10 monedas equivalen a 1 punto en el ranking.",
    completionSpeed: "Velocidad de conclusión:",
    completionSpeedDesc: "Hasta 100 puntos de bonificación para escuelas que completan el onboarding más rápidamente.",
    ranking: "Ranking",
    shop: "Tienda",
    earlyBonus: "¡Bonificación anticipada!",
    estimatedTime: "Tiempo estimado:",
    deadlineForCompletion: "Plazo para conclusión",
    start: "Inicio:",
    end: "Fin:",
    tip: "Consejo:",
    completeBefore: "¡Completa esta tarea antes del plazo para ganar +{{bonus}} monedas de bonificación!",
    takesOnly: "Toma solo {{time}}",
    concludeBeforeDeadline: "¡Completa antes del plazo para ganar +{{bonus}} monedas de bonificación!",
    completedEarly: "¡Completado anticipadamente! +{{bonus}} monedas de bonificación",
    dayUnit: "día",
    daysUnit: "días",
    deadlineExpired: "Plazo vencido",
    oneDayRemaining: "1 día restante",
    daysRemaining: "{{count}} días restantes",
    zeroDays: "0 días",
    oneMinute: "1 minuto",
    minutes: "{{count}} minutos",
    oneHour: "1 hora",
    hours: "{{count}} horas",
    easy: "Fácil",
    medium: "Medio",
    advanced: "Avanzado",
    confirmPurchase: "Confirmar Compra",
    aboutToBuy: "Estás a punto de comprar",
    for: "por",
    insufficientMissing: "Saldo insuficiente. Faltan {{count}} monedas.",
    currentBalance: "Tu saldo actual:",
    cancel: "Cancelar",
    section1Title: "¡Bienvenido a Gamefik!",
    section1Desc: "🎯 Etapa 1: ¡Bienvenido a Gamefik! Conoce nuestra plataforma de gamificación educativa.",
    section1Content: "¡Bienvenido a Gamefik! Nuestra plataforma de gamificación educativa te permite transformar el aprendizaje en una experiencia divertida y envolvente.",
    section2Title: "Crea tu primer Segmento",
    section2Desc: "🎮 Etapa 2: ¡Crea tu primer Segmento! Aprende a crear y configurar tu primer segmento en la plataforma.",
    section2Content: "¡Crear tu primer segmento es simple! Define un nombre atractivo, elige un tema visual y establece los objetivos de aprendizaje. Puedes personalizar la experiencia con diferentes niveles, desafíos y sistemas de puntuación para mantener a tus alumnos motivados.",
    section3Title: "¡Crea tus clases y jugadores!",
    section3Desc: "🧑‍🏫 Etapa 3: ¡Crea tus clases y jugadores! Aprende a crear clases y agregar alumnos a tu segmento.",
    section3Content: "Organiza a tus alumnos en clases para facilitar la gestión. Agrega jugadores individualmente o importa una lista. Cada jugador tendrá su propio perfil donde podrá seguir su progreso, logros y recompensas obtenidas.",
    section4Title: "¡Agregando mis misiones (2 misiones)!",
    section4Desc: "🎯 Etapa 4: ¡Agregando mis misiones! Aprende a crear misiones para involucrar a tus alumnos.",
    section4Content: "Las misiones son tareas que los alumnos deben completar para avanzar en el segmento. Crea al menos dos misiones iniciales con objetivos claros, plazos y puntuaciones. Puedes agregar descripciones detalladas, recursos de apoyo y criterios de evaluación para cada misión.",
    section5Title: "¡Agregando mis primeras actitudes (2 Actitudes)!",
    section5Desc: "🧠 Etapa 5: ¡Aprendiendo sobre actitudes! Descubre cómo crear y utilizar actitudes para reconocer comportamientos positivos.",
    section5Content: "Las actitudes son comportamientos positivos que deseas incentivar, como colaboración, puntualidad o creatividad. Define al menos dos actitudes iniciales y establece cómo serán reconocidas y recompensadas dentro del sistema de gamificación.",
    section6Title: "¡Creando mi primera recompensa en la Tienda Gamefik!",
    section6Desc: "🛍️ Etapa 6: ¡Creando mi primera recompensa! Aprende a crear recompensas para motivar a tus alumnos.",
    section6Content: "Las recompensas motivan a los alumnos a participar activamente. En la Tienda Gamefik puedes crear recompensas virtuales o físicas que los alumnos pueden 'comprar' con los puntos acumulados. Define el nombre, descripción, imagen y valor en puntos para cada recompensa.",
    section7Title: "¡Participar en el entrenamiento Gamefik!",
    section7Desc: "Contenido sobre el entrenamiento",
    section7Content: "Aprovecha al máximo la plataforma participando en nuestro entrenamiento completo. Aprende estrategias avanzadas de gamificación, consejos para aumentar la participación y cómo analizar los datos de rendimiento para mejorar continuamente la experiencia de aprendizaje.",
    section8Title: "¡Entrena a tus profesores!",
    section8Desc: "Contenido sobre cómo entrenar a los profesores",
    section8Content: "¡Comparte el conocimiento con tu equipo! Organiza sesiones de entrenamiento para que todos los profesores puedan utilizar Gamefik efectivamente. Muestra cómo crear contenido, seguir el progreso de los alumnos y utilizar los recursos de la plataforma para potenciar el aprendizaje.",
    section9Title: "¡Lanzamiento del Segmento!",
    section9Desc: "Contenido enseñando buenas prácticas de lanzamiento",
    section9Content: "¡Todo está listo para el lanzamiento! Presenta el segmento a los alumnos de forma emocionante, explicando los objetivos, reglas y beneficios. Considera crear un evento especial de lanzamiento para generar entusiasmo y asegurar que todos entiendan cómo participar.",
    shopItem1Name: "Tarjeta Regalo 25€",
    shopItem1Desc: "Tarjeta regalo digital por valor de 25€ para usar en cualquier tienda asociada.",
    shopItem2Name: "Certificado Premium",
    shopItem2Desc: "Certificado digital premium de finalización del curso con diseño exclusivo.",
    shopItem3Name: "Tema Exclusivo",
    shopItem3Desc: "Desbloquea un tema visual exclusivo para personalizar tu experiencia Gamefik.",
    shopItem4Name: "Acceso al Plan de IA",
    shopItem4Desc: "Acceso gratuito al plan de Inteligencia Artificial por 2 meses para crear contenidos personalizados.",
    completionCode: "Código de conclusión:",
    enterCodeHere: "Introduce el código aquí",
    verify: "Verificar",
    coin: "Moneda",
    ob1Heading: "🎯 Paso 1: ¡Bienvenido a Gamefik!",
    ob1WelcomeTitle: "👋 ¡Bienvenido a Gamefik! 🎉",
    ob1WelcomeP1: "Estás a punto de transformar la experiencia de tus alumnos con participación, diversión y aprendizaje real.",
    ob1WelcomeP2: "Este onboarding fue diseñado para guiarte paso a paso, de forma ligera, práctica y gamificada.",
    ob1HowTitle: "🕹️ Cómo funciona el Onboarding Gamificado:",
    ob1HowItem1: "9 pasos simples:",
    ob1HowItem1Desc: "serás guiado por todo lo que necesitas saber para usar Gamefik en la práctica.",
    ob1HowItem2: "Plazo ideal:",
    ob1HowItem2Desc: "¡termina todo en hasta 7 días y ten tu escuela lista para el lanzamiento!",
    ob1HowItem3: "Sistema de puntos:",
    ob1HowItem3Desc: "con cada tarea completada, ganas monedas y puntos. ¡Además de aprender, empiezas a construir tu reputación en la plataforma!",
    ob1VideoTitle: "Tutorial completo de implementación de Gamefik",
    ob1VideoLabel: "👉 ¡Tutorial completo de implementación de Gamefik!",
    ob1TourTitle: "🗺️ Comienza con un tour guiado:",
    ob1TourButton: "👉 HACER TOUR POR EL SISTEMA",
    ob1TourDesc: "Este tour te mostrará los primeros pasos directamente en la plataforma. ¡Es rápido y súper útil!",
    ob1DeepTitle: "📚 ¿Quieres entender más a fondo qué es Gamefik?",
    ob1DeepDesc: "Consulta nuestro artículo con la guía paso a paso completa de implementación:",
    ob1DeepLink: "📖 Guía Simplificada de Gamefik",
    ob1NextTitle: "✅ ¿Qué viene después?",
    ob1NextDesc: "Verás un checklist con los próximos pasos. Con cada tarea completada, ganas puntos y desbloqueas la siguiente.",
    ob1CheckWelcome: "¡Bienvenido a Gamefik! ✅",
    ob1CheckGame: "Crea tu primer Segmento",
    ob1CheckClasses: "Crea tus clases y jugadores",
    ob1CheckMissions: "Agrega 2 misiones",
    ob1CheckAttitudes: "Aprende sobre actitudes",
    ob1CheckRewards: "Crea 2 recompensas en la Tienda",
    ob1CheckTraining: "Participa en el entrenamiento Gamefik",
    ob1CheckTeachers: "Entrena a tus profesores",
    ob1CheckLaunch: "¡Lanzamiento oficial de Gamefik! 🚀",
    ob2Heading: "🎮 Paso 2: ¡Crea tu primer Segmento!",
    ob2Intro1: "¡Ahora es hora de empezar el juego de verdad! 🕹️",
    ob2Intro2: "En Gamefik, todo gira en torno a los Segmentos — son la base de toda la experiencia gamificada de tu escuela.",
    ob2WhatTitle: "🤔 ¿Qué es un Segmento?",
    ob2WhatDesc: "Un Segmento es como el \"universo del juego\" para tus clases. Es donde configuras:",
    ob2WhatItem1: "Qué clases van a participar;",
    ob2WhatItem2: "Cómo los alumnos ganan puntos;",
    ob2WhatItem3: "Misiones, actitudes y recompensas.",
    ob2TipTitle: "💡 Consejo: Crea diferentes segmentos para públicos distintos, como:",
    ob2TipItem1: "Educación Primaria",
    ob2TipItem2: "ESO",
    ob2TipItem3: "Bachillerato",
    ob2TipExtra: "Para escuelas extracurriculares, recomendamos la división por edad:",
    ob2TipAge1: "Niños pequeños: 4 a 6 años",
    ob2TipAge2: "Preadolescentes: 7 a 12 años",
    ob2TipAge3: "Adolescentes: 13 a 17 años",
    ob2TipAge4: "Adultos: 18 años o más",
    ob2TipFreedom: "Esto te da libertad para personalizar la experiencia y adaptar la gamificación a cada grupo de edad.",
    ob2HowTitle: "⚙️ Cómo crear tu Segmento:",
    ob2HowStep1: "Para crear un segmento, solo ve a Configuración > Avanzada en el menú lateral izquierdo",
    ob2HowStep2: "Haz clic en el botón \"+ Nuevo Segmento\".",
    ob2HowScreenAlt: "Pantalla de creación de nuevo segmento",
    ob2HowStep4: "¡Dale un nombre al Segmento!",
    ob2HowStep5: "Termina de configurar los campos restantes.",
    ob2HowStep6: "Haz clic en guardar. ¡Listo! 🚀",
    ob2MoreTitle: "📚 ¿Quieres saber más?",
    ob2MoreDesc: "Si quieres profundizar, consulta nuestro artículo completo:",
    ob2MoreLink: "📖 ¿Qué es un segmento? Cómo crear un segmento",
    ob2CoinTitle: "🪙 ¡Gana tus primeras monedas!",
    ob2CoinDesc: "¡En cuanto crees tu primer Segmento, ganas monedas automáticamente y desbloqueas el siguiente paso! 🎉",
    ob3Heading: "🧑‍🏫 Paso 3: ¡Crea tus clases y jugadores!",
    ob3Intro1: "Es hora de crear tus clases y agregar a los alumnos que participarán en los segmentos. 🚀",
    ob3Intro2: "En Gamefik, los jugadores son los alumnos. Y las clases son grupos donde organizas a los participantes por grado, sala, materia o como quieras.",
    ob3ClassTitle: "🧩 Cómo crear una clase:",
    ob3ClassStep1: "Accede al menú y haz clic en Configuración > Clases.",
    ob3ClassStep2: "Haz clic en \"Nueva clase\".",
    ob3ClassStep3: "Completa la información de la clase.",
    ob3ClassStep4: "Guarda. ¡Listo, tu clase está creada!",
    ob3ClassLink: "📖 Tutorial de cómo crear una clase",
    ob3PlayerTitle: "🧍‍♂️ Cómo agregar jugadores (alumnos):",
    ob3PlayerDesc: "¡Puedes agregarlos manualmente o importar varios alumnos a la vez!",
    ob3ManualTitle: "✅ Agregar manualmente:",
    ob3ManualStep1: "Accede a tu clase creada.",
    ob3ManualStep2: "Ve a Jugadores > Agregar alumno.",
    ob3ManualStep3: "Completa el nombre, clase y otra información.",
    ob3ManualLink: "📖 Cómo incluir un nuevo alumno",
    ob3ImportTitle: "🗂️ Importar en lote (por planilla):",
    ob3ImportDesc: "¡Ideal para escuelas con muchos alumnos!",
    ob3ImportWarning: "¡Crea todas las clases antes de importar los alumnos! 💡",
    ob3ImportGuide: "Sigue el tutorial del artículo a continuación para importar tus alumnos:",
    ob3ImportLink: "📖 Cómo importar lista de alumnos al segmento",
    ob3DoneTitle: "🎯 ¿Cuándo se completa el paso?",
    ob3DoneDesc: "✅ Después de crear 2 clases y agregar alumnos (manual o por planilla), la tarea se completa automáticamente — ¡y ganas más monedas!",
    ob4Heading: "🎯 Agregando mis misiones (2 misiones)",
    ob4VideoTitle: "🎥 Mira primero: Cómo crear una misión",
    ob4VideoLink: "Haz clic aquí para ver el video en YouTube",
    ob4VideoDesc: "¡En menos de 2 minutos aprenderás el paso a paso para crear una misión en la práctica!",
    ob4NowTitle: "✍️ Ahora que viste cómo funciona…",
    ob4NowDesc1: "¡Transformemos el aprendizaje de tus alumnos en un viaje lleno de propósito! 🎮",
    ob4NowDesc2: "Las Misiones son actividades gamificadas que conectan eventos escolares, aprendizaje y participación.",
    ob4NowDesc3: "Son simples de crear — y poderosas en resultados.",
    ob4WhyTitle: "🔥 ¿Por qué usar Misiones?",
    ob4WhyDesc: "Las Misiones te ayudan a:",
    ob4WhyItem1: "Estimular el cumplimiento de tareas.",
    ob4WhyItem2: "Motivar alumnos con metas claras.",
    ob4WhyItem3: "Mejorar el rendimiento comercial →",
    ob4WhyItem3Bold: "+Matrículas +Retención",
    ob4WhyItem4: "Mejorar el desempeño escolar y pedagógico.",
    ob4WhyInsight: "💡 ¡Las escuelas que usan bien las misiones reportan más participación, mejores notas y reducción de deserción!",
    ob4WhyIdeasLink: "Ideas de misiones para comenzar tu Segmento",
    ob4HowTitle: "🛠️ Cómo crear una misión (resumen del video):",
    ob4HowStep1: "Ve al menú Misiones.",
    ob4HowStep2: "Haz clic en \"Gestionar\".",
    ob4HowStep3a: "Crear con IA",
    ob4HowStep3b: "Crear desde cero",
    ob4HowStep3Pre: "Haz clic en el botón de",
    ob4HowStep3Mid: "o",
    ob4HowStep4: "Completa la información necesaria para terminar la configuración de la misión.",
    ob4HowStep5: "Define cuántas monedas, puntos y XP ganarán los alumnos (Usa la escala de dificultad indicada).",
    ob4HowStep6: "Guarda. ¡Misión creada! 🚀",
    ob4MoreTitle: "📚 ¿Quieres profundizar?",
    ob4MoreLink1: "Guía completa de Misiones 2.0",
    ob4MoreLink2: "Cómo crear una nueva misión (sección del artículo)",
    ob4MoreLink3: "Ideas de misiones para tus profesores",
    ob4DoneTitle: "✅ ¿Cuándo se completa el paso?",
    ob4DoneDesc1: "Después de crear 2 misiones en la práctica, la tarea se completará automáticamente.",
    ob4DoneDesc2: "Y claro… ¡ganarás monedas extra para tu segmento! 💰",
    ob5Heading: "🧠 ¡Aprendiendo sobre actitudes!",
    ob5Intro1: "¡Las actitudes son acciones rápidas que valen puntos y ayudan a construir una cultura positiva en la escuela! ✨",
    ob5Intro2: "Mientras las misiones son más estructuradas, con reglas y plazos, las actitudes funcionan como reconocimientos instantáneos — puedes otorgar puntos con pocos clics cada vez que un alumno demuestre un buen comportamiento o actitud deseada.",
    ob5ExamplesTitle: "🌟 Ejemplos de actitudes:",
    ob5Example1: "Ayudar a un compañero en clase",
    ob5Example2: "Ser amable con el personal",
    ob5Example3: "Organizar el espacio después de clase",
    ob5Example4: "Llegar a tiempo por 5 días seguidos",
    ob5Example5: "Esforzarse durante la clase de educación física",
    ob5ExampleInsight: "💡 El secreto está en la frecuencia y consistencia: las actitudes bien usadas crean un refuerzo positivo en la vida escolar diaria.",
    ob5DiffTitle: "🤔 ¿Cuál es la diferencia entre actitudes y misiones?",
    ob5DiffMissionsHeader: "Misiones",
    ob5DiffAttitudesHeader: "Actitudes",
    ob5DiffRow1Col1: "Son desafíos",
    ob5DiffRow1Col2: "Son retroalimentación conductual",
    ob5DiffRow2Col1: "Tienen plazos y reglas definidas",
    ob5DiffRow2Col2: "Son acciones rápidas y puntuales",
    ob5DiffRow3Col1: "Se planifican con anticipación",
    ob5DiffRow3Col2: "Se lanzan en el momento",
    ob5DiffRow4Col1: "Pueden incluir documentos o evidencias",
    ob5DiffRow4Col2: "Se basan en observación directa",
    ob5DiffLink: "Conoce más sobre esta diferencia aquí",
    ob5HowTitle: "⚙️ Cómo crear una actitud:",
    ob5HowStep1: "Accede al menú Actitudes en la barra lateral.",
    ob5HowStep2: "Haz clic en \"Nueva Actitud\".",
    ob5HowStep3: "Dale un nombre a la actitud (ej: \"Ayudó a un compañero\").",
    ob5HowStep4: "Elige el valor en monedas, XP y puntos.",
    ob5HowStep5: "Guarda. ¡Ahora puedes lanzarla cuando quieras con 1 clic!",
    ob5HowLink1: "Cómo crear una actitud",
    ob5HowLink2: "Qué es una actitud",
    ob5LaunchTitle: "🖱️ ¿Cómo lanzar una actitud? Aprende de los materiales a continuación:",
    ob5LaunchLink1: "¿Cómo lanzar una actitud?",
    ob5LaunchLink2: "¿Cómo realizar un lanzamiento rápido?",
    ob5DoneTitle: "✅ ¿Cuándo se completa el paso?",
    ob5DoneDesc1: "Necesitas crear una actitud para desbloquear el siguiente paso.",
    ob5DoneDesc2: "¡Después de eso, las actitudes estarán disponibles para usar con tus alumnos!",
    ob6Heading: "¡Creando mi primera recompensa en la Tienda Gamefik!",
    ob6VideoTitle: "🎥 Comienza viendo:",
    ob6VideoLink: "Cómo crear una recompensa",
    ob6VideoDesc: "¡En menos de 2 minutos, aprenderás el paso a paso para crear una recompensa y activar tu tienda!",
    ob6NowTitle: "✍️ ¡Ahora te toca a ti!",
    ob6NowDesc1: "La Tienda Gamefik es donde los alumnos pueden cambiar las monedas que ganan por recompensas reales o simbólicas. ¡Esto es lo que hace la experiencia gamificada aún más concreta y motivadora!",
    ob6NowDesc2: "Puedes incluir premios simples (como salir 5 minutos antes de clase) hasta artículos físicos (como un mouse gamer, tarjetas de regalo y más).",
    ob6WhyTitle: "🧠 ¿Por qué importa esto?",
    ob6WhyDesc: "El sistema de recompensas activa el llamado Ciclo de Recompensa del Alumno — un mecanismo que:",
    ob6WhyItem1: "Refuerza comportamientos positivos",
    ob6WhyItem2: "Crea motivación constante",
    ob6WhyItem3: "Ayuda a mantener la participación a lo largo del tiempo",
    ob6WhyItem4: "Conecta esfuerzo con resultado de forma clara",
    ob6WhyLink: "Lee más sobre el ciclo de recompensa del alumno",
    ob6HowTitle: "🛠️ Cómo crear una recompensa:",
    ob6HowStep1: "Ve al menú, haz clic en Shopping > Recompensas.",
    ob6HowStep2: "Haz clic en \"Nueva recompensa\".",
    ob6HowStep3: "Dale un nombre creativo.",
    ob6HowStep4: "Completa todos los campos correctamente.",
    ob6HowStep5: "No olvides definir el Stock y número que cada alumno puede canjear. 🚨",
    ob6HowStep6: "Guarda. ¡Listo! ¡Tu tienda ha cobrado vida! 🛍️",
    ob6HowLink: "Guía completa de cómo agregar una recompensa",
    ob6DoneTitle: "🪙 ¿Cuándo se completa el paso?",
    ob6DoneDesc1: "Después de que crees 2 recompensas diferentes, la tarea se completará automáticamente.",
    ob6DoneDesc2: "Y claro: ¡también ganas monedas! 🎉",
    ob7Heading: "🎓 ¡Participa en el entrenamiento Gamefik!",
    ob7VideoTitle: "🎥 Mira el entrenamiento completo:",
    ob7VideoLink: "Entrenamiento Oficial Gamefik (Video)",
    ob7VideoDesc: "Este video es esencial para entender toda la lógica pedagógica, técnica y estratégica de Gamefik.",
    ob7LiveDesc: "O participa en nuestro entrenamiento online en vivo, solo agenda en el enlace a continuación:",
    ob7LiveButton: "Agenda tu entrenamiento online para gestores ✅",
    ob7LearnTitle: "✍️ Lo que aprenderás:",
    ob7LearnItem1: "Cómo usar la gamificación como herramienta pedagógica",
    ob7LearnItem2: "Buenas prácticas para involucrar a alumnos, padres y profesores",
    ob7LearnItem3: "Ejemplos reales de uso en escuelas",
    ob7LearnItem4: "Cómo sacar el máximo provecho de la plataforma día a día",
    ob7LearnInsight: "💡 ¡Este contenido fue hecho con cariño por nuestro equipo de especialistas — es tu mapa para tener éxito con Gamefik!",
    ob7CodeTitle: "🔐 Cómo completar el paso:",
    ob7CodeDesc1: "Al final del video, se revelará un código exclusivo.",
    ob7CodeDesc2: "¡Ingresa este código en el campo a continuación para completar este paso y desbloquear el siguiente!",
    ob7MissionTitle: "🎯 Esta es tu misión:",
    ob7MissionDesc: "¡Ver hasta el final + ingresar el código = tarea cumplida + monedas garantizadas!",
    ob8Heading: "👩‍🏫 ¡Entrena a tus profesores!",
    ob8WhyTitle: "✍️ ¿Por qué es esencial este paso?",
    ob8WhyDesc: "Tus profesores son los protagonistas de la gamificación. Cuando entienden cómo aplicar Gamefik día a día, todo fluye mejor:",
    ob8WhyBold1: "la participación aumenta",
    ob8WhyBold2: "los alumnos se involucran más",
    ob8WhyBold3: "¡los resultados aparecen!",
    ob8HowTitle: "👥 Cómo entrenar a tus profesores",
    ob8HowDesc: "Puedes elegir entre dos formas de capacitar a tu equipo:",
    ob8LiveTitle: "✅ 1. Entrenamiento en vivo con el equipo de Gamefik (MÁS RECOMENDADO)",
    ob8LiveLink: "Agendar entrenamiento de profesores",
    ob8LiveDesc: "Un encuentro dinámico, práctico y con espacio para preguntas, se realizan semanalmente.",
    ob8LiveCode: "🛡️ Al final, los profesores reciben un código exclusivo para validar la participación.",
    ob8AsyncTitle: "▶️ 2. Entrenamiento grabado (asíncrono)",
    ob8AsyncLink: "Ver el entrenamiento grabado",
    ob8AsyncDesc: "Ideal para profesores que prefieren ver a su propio ritmo.",
    ob8AsyncCode: "📝 Al final del video, se mostrará un código exclusivo para validar la conclusión.",
    ob8BonusTitle: "📥 Bonus: Guía rápida para profesores",
    ob8BonusDesc: "¿Quieres apoyar a los profesores desde el primer día? Comparte este material directo y práctico:",
    ob8BonusLink: "📖 Guía práctica para profesores que quieren destacar",
    ob8CodeTitle: "🔐 Cómo completar este paso:",
    ob8CodeDesc1: "Después del entrenamiento (en vivo o grabado), los profesores deben enviarte el código mostrado al final.",
    ob8CodeDesc2: "¡Ingresa este código en el campo a continuación para completar el paso y desbloquear la misión final!",
    ob9Heading: "🚀 ¡Lanzamiento oficial de Gamefik!",
    ob9TimeTitle: "🎉 ¡Ha llegado el momento más esperado!",
    ob9TimeDesc1: "¡Felicitaciones por haber llegado hasta aquí! Ahora que todo está configurado, es hora de lanzar Gamefik oficialmente en tu escuela.",
    ob9TimeDesc2: "Este momento es especial: marca el inicio de la experiencia gamificada para tus alumnos — y puede ser el punto de inflexión para la participación escolar.",
    ob9PrereqTitle: "✅ Antes de lanzar, revisa los prerrequisitos:",
    ob9PrereqDesc: "Asegúrate de que todo esté listo para un lanzamiento inolvidable:",
    ob9PrereqItem1Title: "¿Los cards de los alumnos están listos?",
    ob9PrereqItem1Desc: "Son la llave de acceso a la experiencia gamificada.",
    ob9PrereqItem2Title: "¿Tótem o tablet posicionado?",
    ob9PrereqItem2Desc: "Lo ideal es que los alumnos puedan consultar y recoger monedas fácilmente.",
    ob9PrereqItem3Title: "¿Configuración del Segmento finalizada?",
    ob9PrereqItem3Desc: "Verifica que todos los pasos anteriores estén completados, con clases, jugadores, misiones y recompensas activas.",
    ob9PrereqItem4Title: "¿Tienda visible para los alumnos?",
    ob9PrereqItem4Desc: "Coloca los premios en una vitrina o imprime carteles con las recompensas disponibles — ¡esto genera curiosidad y expectativa!",
    ob9LaunchTitle: "📣 Cómo realizar el lanzamiento:",
    ob9LaunchDesc: "¡Ahora sí, vamos a poner el show en marcha! Aquí está el paso a paso:",
    ob9LaunchStep1Title: "📢 Comunica a alumnos y padres - ",
    ob9LaunchStep1Link: "Materiales que preparamos para usar en la divulgación",
    ob9LaunchStep1Desc: "Envía un aviso con la fecha oficial de inicio de Gamefik. Usa canales como agenda, WhatsApp o correo electrónico.",
    ob9LaunchStep2Title: "🗣️ Presenta Gamefik a los alumnos",
    ob9LaunchStep2Desc1: "Pasa de salón en salón explicando cómo funciona y entrega los cards individualmente.",
    ob9LaunchStep2Desc2: "¡O haz un evento especial con todos los alumnos para anunciar el inicio del segmento! 🎊",
    ob9LaunchStep3Title: "👀 Acompaña la primera colecta",
    ob9LaunchStep3Desc: "Indica a alguien de tu equipo para que esté cerca del tótem el día del lanzamiento. Esto asegura que los alumnos aprendan a usarlo y se sientan acogidos en la experiencia.",
    ob9BestTitle: "🔍 Buenas prácticas de otras escuelas",
    ob9BestDesc: "Nada como inspirarse en quienes ya lo hicieron. Mira esta serie de videos con ejemplos reales de lanzamientos exitosos:",
    ob9BestVideo: "🎥 [Buenas prácticas de lanzamiento (próximamente)]",
    ob9DoneTitle: "🪙 ¿Cuándo se completa este paso?",
    ob9DoneDesc1: "El paso se finalizará automáticamente después de que el 10% de los alumnos realicen su primera colecta en el sistema.",
    ob9DoneDesc2: "Es decir: ¡solo lanza oficialmente, y los alumnos hacen el resto! 😉",
  },

  missionApprove: {
    pageName: "Aprobar misiones",
    updating: "(Actualizando...)",
    selectMission: "Selecciona una misión",
    pending: "pendiente",
    exportCsv: "Exportar CSV",
    loadingProofs: "Cargando comprobantes...",
    selectMissionsToExport: "Seleccionar misiones para exportar",
    loadError: "Hubo un error al cargar los datos.",
    checkConnection: "Verifica tu conexión e intenta nuevamente.",
    tryAgain: "Intentar de nuevo",
    loadingData: "Cargando datos...",
    exportCsvTitle: "Exportar conclusiones en CSV",
    exportCsvDesc: "Selecciona las misiones a exportar.",
    selectAll: "Seleccionar todas",
    deselectAll: "Desmarcar todas",
    concluded: "completada(s)",
    cancel: "Cancelar",
    export: "Exportar",
    missionNotFound: "Misión no encontrada",
    backToSelection: "Volver a la selección",
    noMissionsAvailable: "Ninguna misión disponible",
    participation: "Participación",
    studentsParticipatedPercent: "{{percent}}% de los alumnos participaron",
    completionRate: "Tasa de Misiones Completadas",
    pendingToApprove: "{{count}} misiones pendientes de aprobar",
    information: "Información",
    valueLabel: "Valor:",
    createdByLabel: "Creado por:",
    dateLabel: "Fecha:",
    continuousLabel: "Continua:",
    yes: "Sí",
    no: "No",
    unknown: "Desconocido",
    unknownDate: "Fecha desconocida",
    preApprovedByAI: "Comprobantes pre-aprobados por la IA",
    viewAll: "Ver todos",
    approveAll: "Aprobar todos",
    searchByStudentOrClass: "Buscar por nombre del alumno o clase",
    classFilterLabel: "Clase:",
    allClasses: "Todas",
    gameFilterLabel: "Segmento:",
    allGames: "Todos",
    reject: "Rechazar",
    approve: "Aprobar",
    noProofsFound: "Ningún comprobante encontrado con los filtros seleccionados.",
    preRejectedByAI: "Comprobantes pre-rechazados por la IA",
    rejectAll: "Rechazar todos",
    proofApprovedSuccess: "¡Comprobante aprobado con éxito!",
    proofRejectedSuccess: "¡Comprobante rechazado con éxito!",
    failedToApprove: "Error al aprobar comprobante",
    failedToReject: "Error al rechazar comprobante",
    noProofsToApprove: "Ningún comprobante disponible para aprobar",
    allApprovedSuccess: "{{count}} comprobante(s) aprobado(s) con éxito!",
    failedToApproveAll: "Error al aprobar comprobantes",
    noProofsToReject: "Ningún comprobante disponible para rechazar",
    allRejectedSuccess: "{{count}} comprobante(s) rechazado(s) con éxito!",
    failedToRejectAll: "Error al rechazar comprobantes",
    noClass: "Sin clase",
    noGame: "Sin segmento",
    noDate: "Sin fecha",
    textLabel: "Texto",
    thumbnail: "Miniatura",
    expandedProof: "Comprobante expandido",
    noDescAvailable: "Sin descripción disponible",
    sentOn: "Enviado el",
    at: "a las",
    missionCompleted: "¡Misión completada, Felicidades!!",
    notCompleted: "No completado",
  },
  proofReviewModal: {
    title: "Revisión de comprobantes",
    aiReviewBadge: "Revisión con IA",
    missionLabel: "Misión: {{title}}",
    tabs: {
      review: "Revisar",
      pending: "Pendientes",
      approved: "Aprobados",
      retry: "Reintentar",
      notSent: "No enviaron",
      collected: "Recogidos",
    },
    tabTooltips: {
      review: "Comprobantes esperando tu decisión — la IA sugiere aprobar o rechazar, tú confirmas",
      pending: "Comprobantes enviados esperando tu revisión",
      approved: "Aprobados por ti o automáticamente por la IA — recompensa liberada para que el alumno la recoja",
      retry: "Rechazados — el alumno necesita reenviar el comprobante",
      notSent: "Alumnos de la misión que aún no enviaron comprobante",
      collected: "Comprobantes cuya recompensa el alumno ya recogió en la app",
    },
    searchPlaceholder: "Buscar alumno o clase...",
    studentCount: "{{count}} alumno(s)",
    clearCount: "Limpiar ({{count}})",
    approveBulk: "Aprobar",
    rejectBulk: "Rechazar",
    selectAll: "Seleccionar todos",
    empty: {
      noStudents: "Ningún alumno",
      allSent: "Todos los alumnos ya enviaron",
      noPendingRetry: "Ningún comprobante esperando reintento",
      nothingToReview: "Nada para revisar",
      noStudentsInFilter: "No hay alumnos en este filtro",
      noCollected: "Ninguna recompensa recogida todavía",
    },
    tag: {
      youApproved: "Tú aprobaste",
      retry: "Reintentar",
      iaApproved: "IA aprobó",
      approved: "Aprobado",
      iaRejected: "IA rechazó",
      pending: "Pendiente",
      newAttempt: "Nuevo intento",
      collected: "Recogido",
      iaSuggestApprove: "IA sugirió aprobar",
    },
    proofSentLabel: "Comprobante enviado",
    expand: "Expandir",
    noImage: "Sin imagen",
    viewList: "Ver en lista",
    viewGrid: "Ver en cuadrícula",
    proofAlt: "Comprobante de {{name}}",
    expandedAlt: "Comprobante expandido",
    aiFeedbackTitle: "Feedback de la IA",
    aiSuggestedReject: "IA sugirió rechazar",
    aiSuggestedApprove: "IA sugirió aprobar",
    waitingForReview: "Esperando tu revisión",
    reviewAndDecide: "Revisa y decide manualmente",
    approve: "Aprobar",
    reject: "Rechazar",
    approveAnyway: "Aprobar de todos modos",
    confirmApproval: "Confirmar aprobación",
    alreadyReceived: "Ya recibió",
    iaApprovedAuto: "IA aprobó automáticamente",
    iaApprovedDesc: "El alumno ya recibió feedback positivo",
    iaApprovedPending: "IA aprobó — confirma para concluir",
    iaApprovedPendingDesc: "Confirma para concluir la misión y liberar la recompensa del alumno",
    undoIaApproval: "Deshacer aprobación de la IA",
    undoApproval: "Deshacer aprobación",
    rewardCollected: "Recompensa ya recogida por el alumno",
    proofApproved: "Comprobante aprobado",
    approvedByYou: "Aprobado por ti",
    waitingRetry: "Esperando nuevo intento",
    needsResubmit: "El alumno necesita reenviar el comprobante",
    notSentDescription: "Este alumno aún no envió el comprobante de la misión",
    validateManually: "Validar manualmente",
    selectStudent: "Selecciona un alumno",
    selectStudentDesc: "Elige un alumno de la lista para ver y revisar",
    unknownStudent: "Alumno fuera de la misión",
    dates: {
      today: "Hoy",
      yesterday: "Ayer",
    },
    sentOn: "Enviado {{date}}, {{time}}",
    toast: {
      updateError: "Error al actualizar comprobante. Inténtalo de nuevo.",
      alreadyApproved: "Este alumno ya tiene un comprobante aprobado para esta misión.",
      approved: "Comprobante aprobado",
      rejected: "Comprobante rechazado, el alumno puede intentar de nuevo",
      undoIa: "Aprobación de la IA deshecha",
      approvalUndone: "Aprobación deshecha, el alumno podrá intentarlo de nuevo",
      manualValidation: "Alumno validado manualmente",
      manualValidationError: "Error al validar alumno. Inténtalo de nuevo.",
      noEligibleProofs: "Ningún comprobante elegible para aprobación.",
      bulkApproved: "{{count}} comprobante(s) aprobado(s)",
      bulkApproveError: "Error al aprobar comprobantes. Inténtalo de nuevo.",
      bulkRejected: "{{count}} comprobante(s) rechazado(s)",
      bulkRejectError: "Error al rechazar comprobantes. Inténtalo de nuevo.",
    },
    feedback: {
      missionCompleted: "Misión completada con éxito",
      rejected: "El comprobante no cumple los requisitos de la misión",
      undoApproval: "Aprobación deshecha, el alumno puede intentar de nuevo",
    },
  },
  missionCreate: {
    basicInfo: "Información básica",
    selectGames: "Seleccionar segmentos",
    deadlinesAndSettings: "Plazos y configuraciones",
    titleLabel: "Título",
    activeLabel: "Activo",
    descriptionLabel: "Descripción",
    continuousMission: "Misión continua (puede realizarse varias veces)",
    proofLabel: "Comprobación",
    defineGameAndValue: "Define el segmento y valor de la misión",
    willExpireAt: "Expira el ",
    willStartAt: "Comienza el",
    classesLabel: "Clases",
    teacherCanValidate: "Los profesores pueden validar esta misión",
    titlePlaceholder: "Título de la misión",
    descriptionPlaceholder: "Escriba aquí la descripción de la misión, explicando lo que el alumno necesita saber para completarla.",
    proofPlaceholder: "Detalle cómo el alumno comprobará que completó la misión.",
    willExpireAtCalendar: "📅 Expira el",
    willStartAtCalendar: "📅 Comienza el",
    problemsFound: "Problemas encontrados",
    missionNeedsTitle: "La misión debe tener un título.",
    missionNeedsDescription: "La misión debe tener una descripción.",
    missionNeedsGameAndReward: "La misión debe tener un segmento y una recompensa",
    missionNeedsRewardCoverage: "La(s) clase(s) {{turmas}} no tienen recompensa configurada para su segmento. Agrega una recompensa en el segmento correcto — sin eso la misión no aparece para los alumnos de esa(s) clase(s).",
    missionCantExpireNow: "¡La misión no puede expirar ahora! Da más tiempo a tus alumnos.",
    missionNeedsClass: "La misión debe tener al menos una clase.",
    back: "volver",
    next: "Siguiente",
    pageTitle: "Crear misión",
    stepOf: "Paso {{current}} de {{total}}",
    addCoverOptional: "Agregar portada (opcional)",
    changeCover: "Cambiar portada",
    enableCoins: "Habilitar monedas",
    enableCoinsHint: "Para misiones sin monedas, los alumnos seguirán ganando cofres y gemas en la app de Gamefik",
    wantProofInApp: "¿Quieres crear una misión con comprobación dentro de la app?",
    withProof: "Con envío de comprobante",
    withProofDesc: "En esta opción los jugadores envían un comprobante y nuestra IA va a analizar y ayudar en la validación de las misiones.",
    withoutProof: "Sin envío de comprobante",
    withoutProofDesc: "En esta opción los jugadores comprueban fuera de la app, y la validación se hace manualmente aquí en el manager.",
    additionalCost: "Comprobante incluido en la creación de la actividad",
    selected: "Seleccionado",
    selectBtn: "Seleccionar",
    notifyStudents: "Notificar alumnos",
    teachersCanValidateToggle: "Los profesores pueden validar",
    creatingMission: "Creando misión...",
    createMission: "Crear misión",
    iaCreditsInsufficient: "Créditos de IA insuficientes para crear misión con comprobación. Necesarios: {{needed}}. Disponibles: {{remaining}}. Contrate un plan o agregue créditos para continuar.",
    errorCreatingMission: "Error al crear misión.",
    autoApprovalByAI: "Aprobación automática por IA (HMG)",
  },
  missionCreateWithAi: {
    checkingCredits: "Verificando créditos/plan de IA...",
    cannotCheckCredits: "No fue posible verificar sus créditos de IA ahora. Intenta nuevamente más tarde.",
    letsCreateMission: "Vamos a crear tu misión,",
    butFirst: "pero antes...",
    detailMission: "Describe la misión con pocas palabras",
    whatToCreate: "¿Qué quieres crear?",
    generateMission: "Generar misión",
    generatingMission: "Generando misión",
    missionPreview: "Vista previa de la misión",
    proofPreviewLabel: "Comprobación: ",
    coinsLimitExceeded: "El límite de monedas por clase ha sido superado.",
    teachersCanSeeMission: "Los profesores pueden ver esta misión",
  },
  missionBank: {
    goBack: "Volver",
    title: "Banco de Misiones",
    description: "Explore nuestra colección de misiones listas para usar. Agréguelas directamente a su lista de misiones.",
    searchPlaceholder: "Buscar misiones",
    popularTags: "Tags populares",
    all: "Todos",
    favorites: "Favoritos",
    removedFromFavorites: "La misión fue eliminada de sus favoritos.",
    addedToFavorites: "La misión fue agregada a sus favoritos.",
    filters: "Filtros",
    educationLevel: "Nivel educativo",
    subject: "Materia",
    difficulty: "Dificultad",
    duration: "Duración",
    filtersApplied: "Filtros aplicados",
    noFiltersApplied: "Sin filtros aplicados",
    clearFilters: "Limpiar filtros",
    clearAllFilters: "Limpiar todos los filtros",
    noFavoritesYet: "Aún no tienes misiones favoritas",
    noMissionsFound: "No se encontró ninguna misión",
    clickStarToFavorite: "Haz clic en la estrella de cualquier misión para agregarla a tus favoritos.",
    tryAdjustingFilters: "Intenta ajustar tus filtros o eliminar las tags seleccionadas.",
    add: "Agregar",
    removeFromFavorites: "Eliminar de favoritos",
    addToFavorites: "Agregar a favoritos",
    seeMore: "Ver más",
  },
  missionsOld: {
    pageName: "Misiones",
    allGames: "Todos los segmentos",
    allClasses: "Todas las clases",
    allTeachers: "Todos los profesores",
    allDefault: "Todos",
    deleteMissions: "Eliminar misiones",
    createWithAi: "Crear misión con IA",
    checking: "Verificando...",
    createFromScratch: "Crear desde cero",
    missionsDisabled: "Misiones 2.0 desactivadas",
    searchByName: "Buscar por nombre",
    pendingProofs: "Comprobantes pendientes",
    perPage50: "50 por página",
    perPage100: "100 por página",
    perPage200: "200 por página",
    previous: "Anterior",
    nextPage: "Siguiente",
    noAiCreditsTitle: "Sin crédito de IA disponible",
    noAiCreditsDesc: "La cuenta de tu escuela no tiene créditos de IA. Crea tu misión manualmente o contacta al gestor de la cuenta.",
    cancel: "Cancelar",
    createManualMission: "Crear misión manual",
    editMission: "Editar misión",
    cancelBtn: "Cancelar",
    saveBtn: "Guardar",
    missionUpdatedSuccess: "¡Misión actualizada con éxito!",
    missionUpdatedError: "Hubo un error al actualizar la misión, intente nuevamente",
    missionDeletedSuccess: "¡Misión eliminada con éxito!",
    missionsDeletedSuccess: "¡Misiones eliminadas con éxito!",
    createdBy: "Creado por",
    game: "Segmento",
    activeClass: "Clase",
    activeMissions: "Misiones activas",
  },
  missionCard: {
    viewRejectedProofs: "Ver comprobantes rechazados",
    somePlayersAlreadyReceived: "¡Algunos jugadores ya recibieron esta misión!",
    playersSelected: "{{count}} jugadores seleccionados",
    onePlayerSelected: "1 jugador seleccionado",
    conclusionsLabel: "Conclusiones:",
    descriptionPrefix: "Descripción: ",
    createdByPrefix: "Creado por:",
    allClassesLabel: "todas",
    seeMore: "Ver más",
    missionDeletedSuccess: "¡Misión eliminada con éxito!",
    missionUpdatedSuccess: "¡Misión actualizada con éxito!",
    missionUpdateError: "Hubo un error al actualizar la misión",
    disableAction: "desactivar",
    deleteAction: "eliminar",
    missionThumbnail: "miniatura de la misión",
    pendingProofsCount: "{{count}} comprobante(s) por aprobar",
    noPendingProofs: "Ningún comprobante por aprobar",
    daysRemaining: "{{days}} días restantes",
    lastDay: "¡Último día!",
    expired: "Expirada",
    noExpiration: "Sin plazo",
    approveProofs: "Aprobar comprobantes",
    edit: "Editar",
    disableMission: "Desactivar misión",
    enableMission: "Activar misión",
    deleteMission: "Eliminar misión",
    validateManually: "Validación manual",
    aiValidation: "Validación por IA",
    searchPlayerByName: "Buscar jugador por nombre",
    orderAlphabetically: "Ordenar por nombre",
    orderByProofs: "Ordenar por comprobantes",
    selectAllFiltered: "Seleccionar todos filtrados",
    deselectAll: "Desmarcar todos",
    approveMission: "Aprobar misión",
    approveMissionFor: "Aprobar misión para",
    player: "jugador",
    players: "jugadores",
    confirmApproval: "Confirmar aprobación",
    approvalSuccess: "¡Misión aprobada con éxito! {{count}} jugador(es)",
    approvalError: "Error al aprobar misión, intente nuevamente",
    close: "Cerrar",
    undoCollection: "Revertir recolección",
    undoCollectionTitle: "Revertir recolección de misión",
    undoCollectionDesc: "¿Estás seguro de que deseas revertir la recolección de esta misión para el jugador {{name}}?",
    undoCollectionConfirm: "Revertir recolección",
    undoCollectionSuccess: "Recolección revertida con éxito",
    undoCollectionError: "Error al revertir recolección de misión",
    debugTitle: "Info de Debug",
    approveProofsTitle: "Aprobar Comprobantes",
    allProofs: "Todos",
    approvedByAi: "Aprobados por IA",
    rejectedByAi: "Rechazados por IA",
    pendingReview: "Pendientes",
    feedbackLabel: "Feedback:",
    aiFeedbackLabel: "Feedback de IA:",
    proofDateLabel: "Fecha:",
    approved: "Aprobado",
    rejected: "Rechazado",
    pendingStatus: "Pendiente",
    rewarded: "Recompensado",
    approveBtn: "Aprobar",
    rejectBtn: "Rechazar",
    approvedSuccessToast: "¡Comprobante(s) aprobado(s) con éxito!",
    rejectedSuccessToast: "¡Comprobante(s) rechazado(s) con éxito!",
    errorUpdatingProofs: "Error al actualizar los comprobantes",
    missionCompletedFeedback: "¡Misión completada, Felicidades!!",
    notCompletedFeedback: "No completado",
    noProofsAvailable: "Ningún comprobante por aprobar.",
    selectAllVisible: "Seleccionar Todos Visibles",
    approveSelected: "Aprobar Seleccionados",
    rejectSelected: "Rechazar Seleccionados",
    debugJson: "Debug JSON",
    debugJsonTitle: "Debug JSON",
    jsonSerializationError: "Error al serializar JSON:",
    periodLabel: "Período",
    missionExpiredOn: "Misión expiró el",
    willStartOn: "Comienza el",
    noGamesAlert: "Ningún segmento asignado a esta misión",
    teachersCanValidate: "Los profesores pueden validar",
    teachersCantValidate: "Los profesores no pueden validar",
    selectClassPlaceholder: "Seleccionar clase",
    clearFilter: "Limpiar filtro",
    sortByLabel: "Ordenar por",
    selectedLabel: "Seleccionado",
    clearSelection: "Limpiar selección",
    confirmRejection: "Confirmar rechazo",
    confirmBatchAction: "Confirmar acción en lote para {{count}} comprobante(s)",
    processingBatch: "Procesando en lote...",
    cancelBtn: "Cancelar",
    proofTitle: "Comprobante",
    addedToSelection: "Agregado a la selección",
    selectPlayersTitle: "Seleccionar alumnos",
    collectedCount: "Recolectado",
    receivedCount: "Recibido",
    rejectedCount: "Rechazado",
    collected: "Recolectado",
    received: "Recibido",
    alreadyCollected: "Ya recolectado",
    alreadyReceived: "Ya recibido",
    noProofsForStudent: "No se encontraron comprobantes para este alumno",
    selectProofToUncollect: "Seleccionar comprobante para revertir recolección",
    undoCollectionConfirmMsg: "¿Estás seguro de que deseas revertir la recolección de este comprobante?",
    approvingLabel: "Aprobando...",
    loading: "Cargando...",
    selectAtLeastOnePlayer: "Selecciona al menos un alumno",
  },
  missionAlertBeforeDisable: {
    confirmDisable: "¿Estás seguro de que deseas {{action}} esta misión?",
    playersNotCollected: "Todos estos jugadores <strong>aún no han colectado la misión!!</strong>, ¿está seguro que desea {{action}} esta misión sin distribuir las recompensas?",
    andMoreStudents: "Y {{count}} más alumnos...",
    disablingMessage: "Esta acción desactivará la misión para todos los participantes, impidiéndoles completarla.",
    deletingMessage: "Esta acción es irreversible, toda la información de la misión se perderá completamente.",
    cancel: "Cancelar",
    distributeAndAction: "Distribuir y {{action}}",
    disableAction: "desactivar",
    deleteAction: "eliminar",
  },
  missionIAFileConfirm: {
    title: "Confirmar archivo",
    fileLabel: "Archivo:",
    sizeLabel: "Tamaño:",
    typeLabel: "Tipo:",
    preview: "Vista previa",
    noPreview: "Vista previa no disponible para este tipo de archivo.",
    cancel: "Cancelar",
    confirm: "Confirmar",
    loading: "Cargando...",
    imageAlt: "Vista previa del archivo",
  },
  missionIASelectStudents: {
    title: "Seleccionar alumnos con IA",
    description: "Describe cuáles alumnos quieres seleccionar o envía un archivo.",
    promptPlaceholder: "Ej: Selecciona los 5 mejores alumnos del 3er año",
    orSendFile: "o envía un archivo",
    selectFile: "Seleccionar archivo",
    processing: "Procesando...",
    processingDesc: "La IA está analizando su solicitud...",
    selectedStudents: "Alumnos seleccionados",
    studentsCount: "{{count}} alumno(s) seleccionado(s)",
    confirmSelection: "Confirmar selección",
    cancel: "Cancelar",
    send: "Enviar",
    errorProcessing: "Error al procesar la solicitud",
    noStudentsFound: "Ningún alumno encontrado",
    sendingData: "Enviando datos...",
    deterministicCode: "Código Determinístico",
    aiProcessing: "procesamiento de IA",
    iaProcessedSelection: "IA procesó la selección",
    configuration: "Configuración",
    configDescription: "Describe tu regla y, opcionalmente, envía una hoja de cálculo.",
    clickOrDragFile: "Haz clic o arrastra y suelta el archivo aquí",
    supportedFormats: "(.csv, .xlsx, .pdf, imágenes)",
    removeFile: "Eliminar",
    aiPromptLabel: "Escriba aquí cómo nuestra IA debe seleccionar alumnos",
    aiPromptPlaceholder: "Ej: Seleccionar alumnos que hicieron la tarea en la fecha 28/05",
    processWithAi: "Procesar con IA",
    aiAnalysis: "Análisis de la IA",
    preview: "Vista previa",
    selectedCountLabel: "Seleccionados: {{count}}",
    searchStudent: "Buscar alumno",
    liveAiResponse: "Respuesta de la IA en vivo",
    processingStatus: "Procesando...",
    iaProcessingError: "Error al procesar IA",
    notSentToAi: "Aún no enviado a la IA",
    iaFoundNoStudents: "La IA no encontró alumnos",
    hideLogs: "Ocultar logs",
    viewAllLogs: "Ver todos los logs",
    viewProcessingLogs: "Ver todos los logs del procesamiento",
    debugIa: "🔍 Debug IA",
    studentHeader: "Alumno",
    actionsHeader: "Acciones",
    removeStudent: "Eliminar",
    removeStudentTitle: "¿Eliminar alumno?",
    removeStudentConfirm: "¿Desea eliminar a {{name}} de la selección?",
    thisStudent: "este alumno",
    cancelBtn: "Cancelar",
    closeBtn: "Cerrar",
    applySelection: "Aplicar selección",
    fileSelectedReady: "Archivo seleccionado. Listo para procesar con IA.",
    debugHistoryTitle: "🔍 Debug IA — Historial completo de conversaciones",
    downloadJson: "⬇ Descargar JSON",
    attempt: "intento",
    step: "paso",
    promptSent: "📤 Prompt enviado",
    codeGenerated: "💻 Código generado",
    responseResult: "📥 Respuesta / resultado",
    selectionRegistered: "Selección registrada en el historial.",
    selectionMayNotBeSaved: "El registro del historial puede no haberse guardado.",
    failedToRegisterSelection: "Error al registrar la selección.",
    validationFailed: "La validación falló después de 2 intentos: {{reason}}",
    inconsistentResult: "resultado inconsistente",
    failedToProcessAi: "Error al procesar la selección por IA",
    completed: "¡Completado!",
  },
  missionCreateWithAiModal: {
    title: "Crear misión con IA",
    promptLabel: "¿Qué quieres crear?",
    promptPlaceholder: "Describe la misión que quieres crear...",
    generating: "Generando...",
    generate: "Generar misión",
    generatingPreview: "Vista previa de la misión",
    titleLabel: "Título:",
    descriptionLabel: "Descripción:",
    proofLabel: "Comprobación:",
    cancel: "Cancelar",
    create: "Crear misión",
    aiDescription: "La IA generará una misión basada en su descripción. Esta es una función inteligente que puede requerir créditos de IA.",
    errorGenerating: "Error al generar misión con IA",
  },
  missionManualValidation: {
    title: "Validación manual",
    description: "Selecciona los alumnos que completaron la misión",
    searchPlaceholder: "Buscar alumno por nombre",
    filterByClass: "Filtrar por clase",
    allClasses: "Todas las clases",
    filterByGame: "Filtrar por segmento",
    allGames: "Todos los segmentos",
    selectAll: "Seleccionar todos",
    deselectAll: "Desmarcar todos",
    noStudentsFound: "Ningún alumno encontrado",
    cancel: "Cancelar",
    confirm: "Confirmar",
    selectedCount: "{{count}} seleccionado(s)",
    collectedCount: "Recolectado(s): {{count}}",
    collected: "Recolectado",
    receivedCount: "Recibido(s): {{count}}",
    received: "Recibido",
    approvalSuccess: "¡Misión aprobada con éxito!",
    approvalError: "Error al aprobar misión",
    noStudentsSubtitle: "Ningún alumno ha participado en esta misión aún",
  },
  missionProofsModal: {
    title: "Comprobantes de la misión",
    searchByName: "Buscar por nombre del alumno",
    filterByGame: "Filtrar por segmento",
    filterByClass: "Filtrar por clase",
    allGames: "Todos",
    allClasses: "Todas",
    allProofs: "Todos",
    approvedByAi: "Aprobados por IA",
    rejectedByAi: "Rechazados por IA",
    pending: "Pendientes",
    noProofsFound: "Ningún comprobante encontrado",
    proofDate: "Fecha del comprobante",
    playerName: "Nombre del alumno",
    className: "Clase",
    gameName: "Segmento",
    status: "Estado",
    actions: "Acciones",
    approve: "Aprobar",
    reject: "Rechazar",
    close: "Cerrar",
  },
  missionsFilter: {
    filterBtn: "Filtrar",
    selectFiltersTitle: "Selecciona sus filtros",
    selectFilterType: "Selecciona el tipo de filtro",
    clearFilter: "Limpiar filtro",
    selectFilterValue: "Selecciona un valor para filtrar",
    activeNoValue: "Misiones activas no tienen un valor asignado",
    cancel: "Cancelar",
    applyFilters: "Aplicar filtros",
    createdBy: "Creado por",
    game: "Segmento",
    activeMissions: "Misiones activas",
  },
  verComprovantesModal: {
    title: "Comprobantes",
    searchPlaceholder: "Buscar por nombre del alumno",
    filterMission: "Filtrar por misión",
    allMissions: "Todas las misiones",
    filterStatus: "Estado",
    allStatuses: "Todos",
    approved: "Aprobados",
    rejected: "Rechazados",
    pendingStatus: "Pendientes",
    noProofs: "Ningún comprobante encontrado",
    approve: "Aprobar",
    reject: "Rechazar",
    approveAll: "Aprobar todos",
    rejectAll: "Rechazar todos",
    close: "Cerrar",
    proofDetails: "Detalles del comprobante",
    playerLabel: "Alumno:",
    classLabel: "Clase:",
    gameLabel: "Segmento:",
    dateLabel: "Fecha:",
    statusLabel: "Estado:",
    feedbackLabel: "Feedback:",
    aiFeedbackLabel: "Feedback de IA:",
    historyTitle: "Historial de intentos",
    attemptNumber: "Intento {{number}}",
    noFeedback: "Sin feedback",
    approvedStatus: "Aprobado",
    rejectedStatus: "Rechazado",
    pendingReview: "Pendiente",
    rewardedStatus: "Recompensado",
    successApproved: "¡Comprobante(s) aprobado(s) con éxito!",
    successRejected: "¡Comprobante(s) rechazado(s) con éxito!",
    errorUpdating: "Error al actualizar comprobante(s)",
    missionCompletedFeedback: "¡Misión completada, Felicidades!!",
    notCompletedFeedback: "No completado",
    unknown: "Desconocido",
    noClass: "Sin clase",
    noGame: "Sin segmento",
    proofApprovedSuccess: "¡Comprobante aprobado con éxito!",
    proofRejectedSuccess: "¡Comprobante rechazado con éxito!",
    failedToApproveProof: "Error al aprobar comprobante",
    failedToRejectProof: "Error al rechazar comprobante",
    noProofsAvailable: "Ningún comprobante disponible",
    batchApprovedSuccess: "{{count}} comprobante(s) aprobado(s) con éxito!",
    batchRejectedSuccess: "{{count}} comprobante(s) rechazado(s) con éxito!",
    failedToApproveAll: "Error al aprobar comprobantes",
    failedToRejectAll: "Error al rechazar comprobantes",
    collectedBadge: "Recolectado",
    approvedBadge: "Aprobado",
    rejectedBadge: "Rechazado",
    approvedByAiBadge: "Aprobado IA",
    pendingBadge: "Pendiente",
    noContent: "Sin contenido",
    videoLabel: "Video",
    proofOfPlayer: "Comprobante de {{name}}",
    firstSubmission: "Esta es la primera entrega del alumno para esta misión.",
    attemptLabel: "Intento {{number}}",
    atTime: "a las",
    mediaSent: "Medios enviados",
    noDescription: "Sin descripción",
    selectMission: "Selecciona una misión",
    proofsCount: "{{count}} comprobantes",
    backToList: "Volver a la lista",
    aiFeedback: "Feedback de la IA",
    teacherFeedback: "Feedback del Profesor",
    sendFeedbackToStudent: "Enviar feedback al alumno",
    feedbackPlaceholder: "Escriba su feedback para el alumno...",
    rejectBtn: "Rechazar",
    approveBtn: "Aprobar",
    attemptHistory: "Historial de intentos",
    searchByNameOrClass: "Buscar por nombre del alumno o clase",
    classFilterAll: "Todas",
    classFilterPrefix: "Clase:",
    gameFilterAll: "Todos",
    gameFilterPrefix: "Segmento:",
    tabAll: "Todos ({{count}})",
    tabApprovedAi: "Aprobados IA ({{count}})",
    tabRejectedAi: "Rechazados IA ({{count}})",
    tabPending: "Pendientes ({{count}})",
    noProofsWithFilters: "No se encontraron comprobantes con los filtros seleccionados.",
    aiApprovedProofs: "Comprobantes aprobados por la IA",
    rejectAllBtn: "Rechazar todos",
    approveAllBtn: "Aprobar todos",
    noAiApprovedProofs: "No se encontraron comprobantes aprobados por la IA.",
    aiRejectedProofs: "Comprobantes rechazados por la IA",
    noAiRejectedProofs: "No se encontraron comprobantes rechazados por la IA.",
    pendingProofsForReview: "Comprobantes pendientes de evaluación",
    noPendingProofsFound: "No se encontraron comprobantes pendientes.",
  },
  relatorioMissoesModal: {
    title: "Resultados: {{name}}",
    subtitleQuiz: "Informe detallado de la actividad",
    subtitleMission: "Informe detallado de la misión",
    eligibleOne: "1 alumno elegible",
    eligibleMany: "{{count}} alumnos elegibles",
    completedOne: "1 completado",
    completedMany: "{{count}} completados",
    pendingOne: "1 pendiente",
    pendingMany: "{{count}} pendientes",
    classesOne: "1 clase",
    classesMany: "{{count}} clases",
    loadingQuiz: "Cargando datos del quiz...",
    loadingMission: "Cargando datos de la misión...",
    noEligibleTitleQuiz: "Ningún alumno elegible para este quiz",
    noEligibleTitleMission: "Ningún alumno elegible para esta misión",
    noEligibleBodyQuiz:
      "Los filtros de clase o los segmentos configurados en el quiz no coinciden con ningún alumno registrado. Revise las clases seleccionadas o los segmentos del quiz para habilitar la participación.",
    noEligibleBodyMission:
      "Los filtros de clase o los segmentos configurados en la misión no coinciden con ningún alumno registrado. Revise las clases seleccionadas o los segmentos de la misión para habilitar la participación.",
    completionRateTitle: "Tasa de finalización",
    rateHigh: "Alta",
    rateMedium: "Media",
    rateLow: "Baja",
    noEligibleStudentsRate: "Sin alumnos elegibles",
    completionProgress: "{{completed}} de {{total}} alumnos completaron",
    studyTimeTitle: "Tiempo de estudio",
    comingSoon: "Próximamente",
    metricUnavailableQuiz: "Esta métrica aún no está disponible para quizzes.",
    metricUnavailableMission: "Esta métrica aún no está disponible para misiones.",
    studyTimeDescription: "Tiempo total de estudio de los alumnos",
    insightLabel: "Insight:",
    insightBest: "{{name}} lidera con {{pct}}% de finalización",
    worstNeedsAttention: "{{name}} necesita atención con {{pct}}%",
    rankingSectionTitle: "Finalización por clase",
    rankingSectionHintQuiz: "Clases ordenadas por porcentaje de finalización del quiz",
    rankingSectionHintMission: "Clases ordenadas por porcentaje de finalización de la misión",
    noClassTitle: "Ninguna clase disponible",
    noClassBecauseNoEligible: "Como no hay alumnos elegibles, aún no hay clases para mostrar.",
    noClassOtherQuiz:
      "Los participantes de este quiz no están vinculados a clases, o las clases filtradas no tienen alumnos elegibles.",
    noClassOtherMission:
      "Los participantes de esta misión no están vinculados a clases, o las clases filtradas no tienen alumnos elegibles.",
    percentCompleted: "{{pct}}% de finalización",
    studentsCompletedRatio: "{{done}}/{{total}} alumnos completaron",
    pendingSuffixOne: "1 pendiente",
    pendingSuffixMany: "{{count}} pendientes",
    participantsTitle: "Participantes",
    completedRatioBadge: "{{done}}/{{total}} completados",
    completionPerStudent: "Registro de finalización por alumno",
    noneCompletedYetQuiz:
      "Ningún alumno completó el quiz aún. Puede haber sido creado recientemente.",
    noneCompletedYetMission:
      "Ningún alumno completó la misión aún. Puede haber sido creada recientemente o estar esperando la aprobación de comprobantes.",
    allClassesFilter: "Todas las clases",
    classesCountSelected: "{{count}} clases",
    searchClassPlaceholder: "Buscar clase...",
    noClassFound: "No se encontró ninguna clase.",
    clearSelection: "Borrar selección ({{count}})",
    allGames: "Todos los segmentos",
    gameQuiz: "Quiz",
    gameMission: "Misión",
    gameTrail: "Ruta",
    gameChallenge: "Desafío",
    statusAll: "Todos",
    statusCompleted: "Completado",
    statusNotCompleted: "No completado",
    searchByNamePlaceholder: "Buscar por nombre",
    colName: "Nombre",
    colClass: "Clase",
    colStatus: "Estado",
    colCompletionDate: "Fecha de finalización",
    loadingParticipants: "Cargando participantes...",
    noEligibleParticipants: "Ningún participante elegible",
    noParticipantsForFilters: "Ningún participante con los filtros aplicados",
    adjustFiltersHintQuiz: "Ajuste las clases o los segmentos del quiz para incluir alumnos.",
    adjustFiltersHintMission: "Ajuste las clases o los segmentos de la misión para incluir alumnos.",
    tryClearFilters: "Intente borrar la búsqueda o cambiar los filtros de clase y estado.",
    statusBadgeCompleted: "Completado",
    statusBadgeNotCompleted: "No completado",
    showingParticipants: "Mostrando {{shown}} de {{total}} participantes",
    dash: "\u2014",
  },
  missionBncc: {
    bnccCorrelation: "Correlación con la BNCC",
    proposedAction: "Acción propuesta:",
    justification: "Justificación:",
    noBnccData: "Sin datos BNCC disponibles",
    title: "BNCC",
    close: "Cerrar",
    bnccCodes: "Códigos BNCC",
    noteLabel: "Nota:",
    noteText: "Para más detalles sobre la Base Nacional Común Curricular (BNCC), consulte el documento oficial del MEC.",
  },
  bnccSelectionModal: {
    title: "Seleccionar competencias BNCC",
    searchPlaceholder: "Buscar competencia...",
    categories: "Categorías",
    competencies: "Competencias",
    selectedCount: "{{count}} seleccionada(s)",
    confirm: "Confirmar",
    cancel: "Cancelar",
    noResults: "Sin resultados",
    clearSelection: "Limpiar selección",
    bnccTitle: "Selección de Competencia BNCC",
    home: "Inicio",
    searchByNameDescCode: "Buscar por nombre, descripción o código...",
    back: "Volver",
    loadingBncc: "Cargando datos del BNCC...",
    loadError: "Error al cargar datos del BNCC.",
    ensureFileAvailable: "Asegúrese de que el archivo bncc-competencias.json esté disponible.",
    competencyCount: "{{count}} competencia",
    competencyCountPlural: "{{count}} competencias",
    noSearchResults: "No se encontraron resultados para su búsqueda.",
    noCategoriesAvailable: "No hay categorías ni competencias disponibles en este nivel.",
  },
  settingsAdvanced: {
    pageTitle: "Configuraciones Avanzadas | Gamefik Escuelas",
    pageDescription: "Administra configuraciones avanzadas, segmentos, facturas y usuarios de tu escuela en Gamefik.",
    heading: "Configuraciones Avanzadas",
    subheading: "Administra todas las configuraciones de tu escuela",
    loadingConfig: "Cargando configuraciones...",
    loadError: "No se pudieron cargar las configuraciones.",
    tabSettings: "Configuraciones",
    tabFinancial: "Financiero",
    tabGames: "Segmentos",
    tabClasses: "Clases",
    tabUsers: "Usuarios",
    tabAutomations: "Automatizaciones",
    tabHistory: "Historial",
    systemSettingsTitle: "Configuraciones del Sistema",
    systemSettingsDescription: "Configura las preferencias generales del sistema",
    globalTestFlagTitle: "Prueba global habilitada",
    globalTestFlagDescription: "Este bloque solo aparece para usuarios del Manager en cuentas New Manager Global cuando la feature flag feature-flag-global-test está activa.",
    globalTestFlagEnabled: "Flag activa",
    languageTitle: "Idioma de la plataforma",
    languageDescription: "Elige en qué idioma debe mostrarse el panel administrativo.",
    languagePreferenceTitle: "Idioma del panel",
    languagePreferenceDescription: "En la primera visita, el sistema usa automáticamente el idioma del dispositivo y recurre al inglés cuando no está soportado.",
    xpManagementTitle: "Gestión de XP",
    xpActive: "Activo",
    xpDisabled: "Desactivado",
    xpManagementDescription: "Active o desactive el XP de todas las actitudes, misiones y quizzes",
    xpIsActive: "XP está activo",
    xpIsDisabled: "XP está desactivado",
    xpActiveDescription: "Todas las actitudes, misiones y quizzes están otorgando XP normalmente.",
    xpDisabledDescription: "Desactivado el {date}{user}. {count} registros afectados.",
    xpDisabledByUser: " por {user}",
    xpDisabledUnknownDate: "fecha desconocida",
    xpToggleLabel: "Activar/Desactivar XP",
    xpHowItWorks: "Cómo funciona:",
    xpDisableExplanation: "Elimina el XP de todas las actitudes, misiones y quizzes, guardando los valores para restauración",
    xpEnableExplanation: "Restaura los valores de XP originales guardados anteriormente",
    xpCoinsUnaffected: "Los valores de monedas (coins) no se ven afectados",
    xpDisableTitle: "Desactivar XP",
    xpDisableWarning: "Esta acción eliminará el XP de todas las actitudes, misiones y quizzes. Los valores se guardarán y podrán restaurarse posteriormente.",
    xpWhatWillBeAffected: "Lo que será afectado:",
    xpAttitudesZeroed: "Todas las actitudes tendrán el XP en cero",
    xpMissionsZeroed: "Todas las misiones tendrán el XP en cero",
    xpQuizzesZeroed: "Todos los quizzes tendrán el XP en cero",
    xpCoinsUnchanged: "Los valores de monedas (coins) permanecerán inalterados",
    xpConfirmDisable: "Confirmar Desactivación",
    xpSuccessDisabled: "¡XP desactivado con éxito! {count} registros afectados.",
    xpSuccessEnabled: "¡XP restaurado con éxito! {count} registros restaurados.",
    xpErrorDisable: "Error al desactivar XP",
    xpErrorEnable: "Error al activar XP",
    iaEnhancementTitle: "Mejora con IA",
    iaOptionalAddon: "Complemento Opcional",
    iaEnhancementDescription: "Agregue recursos con IA a cualquier plan. El precio de la IA se basa en el número de estudiantes.",
    iaResourcesTitle: "✨ Recursos de IA Gamefik",
    iaActive: "Activo",
    iaMonthlyPlan: "Plan Mensual",
    iaInactiveDescription: "Mejore su experiencia Gamefik con insights basados en IA",
    iaProcessing: "Procesando...",
    iaCancelScheduled: "Cancelación programada para {date}. El acceso permanece activo hasta entonces.",
    iaCancelEndOfMonth: "fin de mes",
    iaReactivationBlocked: "La reactivación solo estará disponible después del fin de mes.",
    iaToggleLabel: "Activar Recursos de IA",
    iaActivatedSuccess: "¡IA activada con éxito!",
    iaActivateError: "Error al activar IA",
    iaDeactivatedSuccess: "¡IA desactivada con éxito!",
    iaDeactivateError: "Error al desactivar IA",
    iaPricingError: "No fue posible calcular la tarificación de la IA.",
    invoicesTitle: "Facturas",
    invoicesDescription: "Visualice y administre sus facturas",
    noInvoicesFound: "No se encontraron facturas",
    invoiceStatusPaid: "Pagado",
    invoiceStatusOpen: "Pendiente",
    invoiceStatusDraft: "Borrador",
    invoiceHeaderStatus: "Estado",
    invoiceHeaderAmount: "Valor",
    invoiceHeaderSentDate: "Fecha de Envío",
    invoiceHeaderDueDate: "Vencimiento",
    invoiceHeaderActions: "Acciones",
    invoicePayWithPix: "Pagar con Pix",
    invoicePay: "Pagar",
    invoiceView: "Visualizar",
    gamesTitle: "Segmentos",
    gamesDescription: "Crea y administra los segmentos de tu escuela",
    newGame: "Nuevo Segmento",
    noGamesYet: "Ningún segmento creado todavía",
    createFirstGame: "Crear su primer segmento",
    coinIconTitle: "Icono de Coin",
    coinIconDescription: "Personaliza el icono de moneda mostrado en todos los segmentos",
    coinIconGlobalHint: "Esta configuración aplica a todos los segmentos de la escuela — panel, app del alumno y tienda.",
    coinIconCurrent: "Vista previa",
    coinIconUpload: "Subir icono",
    coinIconUploading: "Subiendo...",
    coinIconSaving: "Guardando...",
    coinIconSaveSuccess: "Icono de coin actualizado para todos los segmentos.",
    coinIconSaveError: "Error al guardar el icono de coin.",
    coinIconUploadError: "Error al subir la imagen.",
    resetGamesTitle: "Reiniciar Segmentos",
    resetGamesDescription: "Acción irreversible: elimina todos los puntos de los estudiantes",
    resetGamesWarning: "Es común y recomendado reiniciar los puntos al final del semestre o año lectivo. Esta acción no puede deshacerse.",
    classesTitle: "Clases",
    classesDescription: "Administra las clases de tu escuela",
    usersTitle: "Gestión de Usuarios",
    usersDescription: "Administra profesores y administradores",
    automationsTitle: "Automatizaciones",
    automationsDescription: "Configura recurrencias automáticas para actitudes",
    historyTitle: "Historial de Actividades",
    historyDescription: "Visualice todas las actividades realizadas en el sistema",
    gameSavedSuccess: "Segmento guardado con éxito.",
    gameSaveError: "Error al guardar segmento",
    gameDeleteConfirm: "¿Estás seguro de que deseas eliminar este segmento?",
    gameNameRequired: "Necesita definir un nombre para el Segmento",
    cancel: "Cancelar",
    close: "Cerrar",
    save: "Guardar",
    checkoutCancelled: "Pago cancelado. Puede elegir otro plan o intentarlo de nuevo.",
    planActivatedSuccess: "Plan activado con éxito.",
    checkoutPaymentPending: "No pudimos confirmar el pago. Tu cuenta permanece en el plan Free; puedes intentar completar el pago nuevamente.",
    checkoutConfirmError: "No fue posible confirmar el pago.",
    iaPricingTier0To100: "IA para escuelas de 0 a 100 alumnos",
    iaPricingTier100To200: "IA para escuelas de 100 a 200 alumnos",
    iaPricingTier200To400: "IA para escuelas de 200 a 400 alumnos",
    iaPricingTier400To600: "IA para escuelas de 400 a 600 alumnos",
    iaPricingTier600To1000: "IA para escuelas de 600 a 1000 alumnos",
    iaPricingTierAbove1000: "IA para escuelas por encima de 1000 alumnos",
  },
  contractModal: {
    title: "Paquete IA Ilimitada",
    closeLabel: "Cerrar",
    createMissionsWithAI: "Crea misiones con IA",
    createQuizzesWithAI: "Crea quizzes con IA",
    missionApprovalWithAI: "Aprobación de misiones con IA",
    andMoreComing: "Y mucho más por venir 👀",
    calculatingPricing: "Calculando precios según el número de estudiantes...",
    endsIn: "Termina en:",
    lifetimeOff: "20% OFF Vitalicio",
    detectedStudents: "Detectamos <strong>{count}</strong> estudiantes. Plan: <strong>{tier}</strong>.",
    lifetimeDiscountUntil: "20% de descuento vitalicio para suscripciones realizadas hasta {date}.",
    lifetimeDiscountEnded: "Oferta de 20% vitalicia finalizada. El valor vigente es {price} por mes.",
    perMonth: "/mes",
    agreeWithTerms: "Acepto los",
    termsOfService: "términos de servicio",
    mustAgreeToTerms: "Debe aceptar los términos de servicio para continuar.",
    addToSubscription: "Agregar a mi suscripción",
    expired: "Finalizada",
  },
  cancelModal: {
    title: "Cancelar Plan IA Ilimitada",
    reviewConditions: "Revise las condiciones de cancelación antes de continuar.",
    cancellationRules: "Reglas de Cancelación:",
    ruleEndOfPeriod: "La cancelación se efectúa al final del período corriente (último día del mes)",
    ruleUseUntilEnd: "Las funcionalidades de IA pueden utilizarse hasta el final del período corriente",
    ruleNoRefund: "No hay reembolso como se indica en los términos de servicio",
    cancellationReasonLabel: "Motivo de la cancelación:",
    cancellationReasonPlaceholder: "Por favor, cuéntenos el motivo de la cancelación...",
    keepPlan: "Mantener Plan",
    confirmCancellation: "Confirmar Cancelación",
  },
  termsModal: {
    title: "Términos de Uso",
    readAndAccept: "He Leído y Acepto",
    documentTitle: "Términos de Uso – Paquete de IA Ilimitada Gamefik",
    lastUpdated: "Última actualización: 15/08/2025",
    intro: "Los presentes Términos de Uso (\"Términos\") regulan la contratación y utilización del Paquete de IA Ilimitada ofrecido por Gamefik (\"Plataforma\") por parte de la institución educativa contratante (\"Escuela\"). Al adherirse a este paquete, la Escuela declara estar consciente y de acuerdo con las condiciones aquí descritas.",
    section1Title: "1. Objeto",
    section1Content: "El Paquete de IA Ilimitada ofrece acceso irrestricto a las funcionalidades de inteligencia artificial proporcionadas por Gamefik durante el período contratado, según se describe en las comunicaciones y materiales comerciales de la empresa.",
    section2Title: "2. Condiciones Comerciales",
    section21Title: "2.1. Cargo Proporcional en el Primer Mes",
    section21Item1: "La adhesión puede realizarse en cualquier momento.",
    section21Item2: "El día 1 del mes siguiente a la contratación, se emitirá un cargo proporcional al número de días de uso en el mes de adhesión, incluido en la factura vigente de la Escuela como valor adicional.",
    section22Title: "2.2. Cargo Íntegro a Partir del Segundo Mes",
    section22Content: "A partir del segundo mes, el valor íntegro vigente del Paquete de IA Ilimitada se cobrará mensualmente, de forma recurrente, como adicional en la factura de la Escuela, independientemente de la frecuencia de uso.",
    section23Title: "2.3. Cancelación y Cargo Proporcional",
    section23Item1: "La Escuela podrá cancelar el paquete en cualquier momento, utilizando el propio sistema de Gamefik para ello.",
    section23Item2: "En caso de cancelación, se cobrará el valor íntegro del mes de cancelación y el acceso a las funcionalidades de IA estará disponible hasta el final del período corriente.",
    section23Item3: "Si la plataforma es contratada y cancelada en el mismo mes, se cobrará el valor prorrateado desde el día de la contratación hasta el final del período corriente.",
    section3Title: "3. Forma de Pago",
    section3Content: "El valor del Paquete de IA Ilimitada se cobrará junto con la factura mensual de la Escuela ya contratante de Gamefik, constando como ítem adicional discriminado. En caso de incumplimiento, se aplicarán las reglas previstas en el contrato principal, incluidas eventuales multas y suspensión de servicios.",
    section4Title: "4. Cambios en el Valor",
    section4Content: "Gamefik podrá actualizar el valor del Paquete de IA Ilimitada, mediante comunicación a la Escuela con una anticipación mínima de 30 (treinta) días.",
    section5Title: "5. Vigencia",
    section5Content: "Los presentes Términos entran en vigor en la fecha de adhesión y permanecen válidos mientras la Escuela mantenga activa la contratación del Paquete de IA Ilimitada.",
    section6Title: "6. Cancelación por Gamefik",
    section6Intro: "Gamefik se reserva el derecho de suspender o cancelar el acceso al Paquete de IA Ilimitada, sin costo para la Escuela, en los siguientes casos:",
    section6Item1: "Uso indebido o incompatible con la finalidad educativa de la Plataforma.",
    section6Item2: "Violación de los Términos de Uso generales de Gamefik.",
    section7Title: "7. Disposiciones Generales",
    section7Item1: "Estos Términos complementan e integran el Contrato Principal y los Términos de Uso de Gamefik ya aceptados por la Escuela.",
    section7Item2: "En caso de conflicto entre estos Términos y el Contrato Principal, prevalecerán las condiciones específicas del presente documento en lo que respecta al Paquete de IA Ilimitada.",
    section7Item3: "Se elige el fuero de la comarca de la sede de Gamefik para dirimir cualquier controversia derivada de estos Términos.",
    agreementNote: "Al hacer clic en \"He Leído y Acepto\" o equivalente, la Escuela declara haber leído, comprendido y aceptado todas las condiciones establecidas en estos Términos.",
  },
  pixModal: {
    title: "Pagar con Pix",
    invoiceAmount: "Valor de la factura",
    dueDate: "Vencimiento: {date}",
    qrCodeExpiresIn: "El QR Code expira en:",
    expired: "Expirado",
    paymentConfirmed: "✓ ¡Pago confirmado!",
    generatingQrCode: "Generando QR Code...",
    paymentConfirmedLabel: "Pago confirmado",
    qrCodeUnavailable: "QR Code temporalmente no disponible",
    qrCodeError: "Error al generar QR Code",
    qrCodePix: "QR Code Pix",
    scanWithBank: "Escanee con la app de su banco",
    paymentConfirmedSuccess: "¡Pago confirmado con éxito!",
    orCopyCode: "O copie el código:",
    copy: "Copiar",
    codeCopied: "¡Código copiado!",
    howToPay: "Cómo pagar:",
    step1: "1. Abra la app de su banco",
    step2: "2. Elige pagar con Pix QR Code o Pix Copiar y Pegar",
    step3: "3. Escanee el código o pegue el código de arriba",
    step4: "4. Confirme el pago",
    pixPaymentError: "Error al crear pago PIX",
    paymentConfirmedToast: "¡Pago confirmado con éxito!",
  },
  settingsForm: {
    loginWithoutQrCode: "Login sin QR Code",
    loginWithoutQrCodeDesc: "Permite login simplificado para pruebas",
    studentEmailLogin: "Login de estudiantes por correo",
    studentEmailLoginDesc: "Permite que los estudiantes de esta unidad ingresen con su correo registrado y un código temporal",
    controlledGame: "Segmento Controlado",
    controlledGameDesc: "Modo especial de control para segmentos",
    missions2WithAI: "Misiones 2.0 con IA",
    missions2WithAIDesc: "Comprobantes validados automáticamente por IA",
    classSelection: "Selección de Clases",
    classSelectionDesc: "El profesor puede elegir sus propias clases",
    teacherMissions: "Misiones del Profesor",
    teacherMissionsDesc: "Permite que los profesores creen misiones",
    appSounds: "Sonidos en la Aplicación",
    appSoundsDesc: "Efectos de sonido y notificaciones",
    studentRanking: "Ranking de Estudiantes",
    studentRankingDesc: "Clasificación visible para estudiantes",
    rankingDisableTooltip: "Al desactivar, el ranking queda oculto para los jugadores",
    studentShop: "Tienda para Estudiantes",
    studentShopDesc: "Acceso a la tienda de recompensas",
    shopDisableTooltip: "Al desactivar, la tienda queda oculta para los jugadores",
    authSection: "Autenticación",
    authSectionDesc: "Configuraciones de login y acceso",
    gamesSection: "Segmentos",
    gamesSectionDesc: "Configuraciones específicas de los segmentos",
    featuresSection: "Funcionalidades",
    featuresSectionDesc: "Recursos y capacidades del sistema",
    studentExperienceSection: "Experiencia del Estudiante",
    studentExperienceSectionDesc: "Interfaz y recursos para estudiantes",
    testEnvironment: "Ambiente de Prueba",
    loadError: "Error al cargar configuraciones",
    updateSuccess: "¡Configuración actualizada con éxito!",
    updateError: "Error al actualizar configuración",
    loadingConfig: "Cargando configuración...",
  },
  teacherCoinLimits: {
    title: "Límites de monedas de educadores",
    description: "Define si los educadores pueden crear actividades y el límite de monedas por segmento.",
    activitiesEnabled: "Actividades de educadores habilitadas",
    activitiesDisabled: "Actividades de educadores deshabilitadas",
    unlimited: "Ilimitado",
    controlled: "Controlado",
    limit: "Límite de monedas",
    segment: "Segmento",
    window30Days: "El consumo se calcula en una ventana móvil de 30 días.",
    save: "Guardar",
    saving: "Guardando...",
    success: "Configuración de límites guardada con éxito.",
    failure: "No fue posible guardar la configuración de límites.",
    loading: "Cargando límites de educadores...",
    empty: "No hay segmentos disponibles para configurar.",
    explanationIndividual: "El límite se aplica individualmente a cada educador y clase.",
  },
  gameFormDialog: {
    editGame: "Editar Segmento",
    createNewGame: "Crear Nuevo Segmento",
    updateGameSettings: "Actualice las configuraciones del segmento",
    configureNewGame: "Configura un nuevo segmento para tu escuela",
    basicInfo: "Información Básica",
    gameName: "Nombre del Segmento",
    required: "Obligatorio",
    gameNamePlaceholder: "Ej: Matemáticas Divertidas, English Quest...",
    gameNameRequired: "El nombre del segmento es obligatorio",
    monthlyCoinsLimit: "Límite Mensual de Monedas",
    monthlyCoinsLimitTooltip: "Defina el máximo de monedas que los profesores pueden dar a los estudiantes por mes",
    configureMaxMonthlyCoins: "Configura el límite máximo mensual de monedas para este segmento",
    limitEnabled: "Límite Activado",
    noLimit: "Sin Límite",
    controlled: "Controlado",
    unlimited: "Ilimitado",
    limitEnabledDescription: "Los profesores tendrán un límite máximo de monedas por mes para crear misiones y quizzes",
    noLimitDescription: "Los profesores pueden dar monedas ilimitadamente (sin control mensual)",
    maxMonthlyLimit: "Límite Máximo Mensual",
    unlimitedModeActive: "Modo Ilimitado Activo",
    unlimitedModeDescription: "Los profesores pueden dar cuantas monedas quieran a los estudiantes sin restricciones mensuales.",
    gameLanguage: "Idioma del Segmento",
    gameLanguageTooltip: "El idioma se elige solo al crear el segmento y no puede cambiarse después",
    selectLanguage: "Selecciona el idioma para los textos predeterminados del segmento",
    fillRequiredFields: "Completa todos los campos obligatorios",
    updatingGame: "Actualizando segmento...",
    creatingGame: "Creando segmento...",
    waitAMoment: "Espere un momento...",
    updateGame: "Actualizar Segmento",
    createGame: "Crear Segmento",
    processError: "Error al procesar solicitud",
  },
  gameLevelingConfig: {
    levelsAndRewards: "Configuración de Niveles y Recompensas",
    levelsConfigured: "{count} niveles configurados",
    level: "Nivel {order}",
    confirmDelete: "Confirmar Eliminación",
    confirmDeleteDescription: "¿Estás seguro de que deseas eliminar el Nivel {order}? Esta acción no puede deshacerse.",
    levelImage: "Imagen del Nivel",
    xpConfig: "Configuración de XP",
    xpForNextLevel: "XP necesario para el próximo nivel",
    range: "Rango: {min} - {max} XP",
    difference: "Diferencia: {diff} XP",
    rewards: "Recompensas",
    addNewLevel: "Agregar Nuevo Nivel",
    deleteAction: "Eliminar",
    cancel: "Cancelar",
  },
  levelsConfig: {
    pageTitle: "Editar niveles del segmento",
    gameSavedSuccess: "Segmento guardado con éxito.",
    gameSaveError: "Ocurrió un error al procesar tu solicitud. Intenta nuevamente más tarde.",
    saveLevels: "Guardar niveles",
  },
  gamesSelect: {
    allGames: "Todos los segmentos",
    gamesSelected: "{count} segmentos seleccionados",
    searchGames: "Buscar segmentos...",
    noGamesFound: "No se encontraron segmentos.",
    noGamesAvailable: "No hay segmentos disponibles",
    selectGames: "Selecciona los segmentos",
    selectAGame: "Selecciona un segmento",
  },
  resetGamesForm: {
    whichGamesReset: "Cuáles segmentos serán reiniciados",
    whichPointsReset: "Cuáles puntos serán reiniciados",
    pointsTooltip: "Selecciona cuál o cuáles monedas desea reiniciar, se aplicará a todos los jugadores del segmento seleccionado.",
    missions: "Misiones",
    missionsTooltip: "Marque solo si desea reiniciar las misiones y permitir que los estudiantes puedan realizarlas nuevamente.",
    resetMissions: "Reiniciar misiones",
    reset: "Reiniciar",
    confirmResetTitle: "¿Estás seguro de que deseas reiniciar los segmentos?",
    confirmResetDescription: "Reiniciar el segmento es una acción irreversible, al realizarla todos los campos seleccionados serán reiniciados y no podrán recuperarse. ¿Realmente desea continuar?",
    yesImSure: "¡Sí, estoy seguro!",
    selectAtLeastOne: "Necesita seleccionar al menos un segmento y al menos un punto para continuar.",
    importFinished: "¡Proceso de importación finalizado!",
  },
  activeSubscriptions: {
    yourPlans: "Sus Planes",
    yourPlansDescription: "Sus planes y próximo cobro",
    plan: "plan",
    plans: "planes",
    noPlanFound: "No se encontró ningún plan",
    errorLoadingPlans: "Error al cargar información de los planes. Intenta nuevamente más tarde.",
    nextInvoice: "Próxima factura",
    errorLoadingBreakdown: "Error al cargar desglose de la factura.",
    description: "Descripción",
    qty: "Cant",
    unitPrice: "Precio unitario",
    amount: "Valor",
    invoiceItem: "Ítem de factura",
    item: "Ítem",
    proRata: "pro-rata",
    discount: "descuento",
    discounts: "Descuentos",
    subtotal: "Subtotal",
    tax: "Impuesto",
    total: "Total",
    nextCharge: "Próximo Cobro",
    nextChargeOn: "Próximo cobro el {{date}}",
    statusActive: "Activo",
    statusPastDue: "Vencido",
    statusCanceled: "Cancelado",
    statusIncomplete: "Incompleto",
    statusTrialing: "Período de Prueba",
    statusUnpaid: "No Pagado",
    statusPaused: "Pausado",
    statusExpired: "Expirado",
    perDay: "por día",
    perWeek: "por semana",
    perMonth: "por mes",
    perYear: "por año",
    every: "cada {count} {interval}",
  },
  plans: {
    teacherPlanTitle: "Elige tu plan de profesor",
    schoolPlanTitle: "Elige el plan de tu escuela",
    teacherPlanSubtitle: "Elige cómo quieres unirte a Gamefik con el mismo diseño de las nuevas páginas de planes, sin perder checkout, trial y selección de signup.",
    schoolPlanSubtitle: "Último paso antes de empezar a gamificar tu escuela.",
    loadingPlans: "Cargando tus planes...",
    previewLocalhost: "Preview localhost",
    month: "mes",
    year: "año",
    freeMonths: "{{count}} meses gratis",
    yearlySavings: "Mayor ahorro en el anual",
    onRequest: "Bajo consulta",
    free: "Gratis",
    processing: "Procesando...",
    compareFeatures: "Comparar todas las funcionalidades",
    feature: "Funcionalidad",
    noPlansFound: "No se encontraron planes para este perfil en este momento. Inténtalo de nuevo en unos momentos.",
    dayLeft: "1 día restante",
    daysLeft: "{{count}} días restantes",
    trialEndsOn: "El trial termina el {{date}}. Después de eso, la cuenta vuelve al plan Free si no se activa ninguna suscripción.",
    plans: "Planes",
    inTrial: "en trial",
    schoolSelector: {
      socialProof: "Escuelas en todo el mundo confían en Gamefik",
      trialTitle: "Ya casi. Empieza tu prueba de 14 días sin cobro.",
      trialDescription: "Tarjeta en la próxima pantalla · Sin cobro durante la prueba · Correo 3 días antes del fin · Cancela y no se debita nada.",
      monthly: "Mensual",
      yearly: "Anual",
      yearlyBadge: "Mayor ahorro en el anual",
      cta: "Empezar prueba de 14 días",
      ctaSubtext: "Cobro solo tras la prueba · Cancela cuando quieras",
      processing: "Procesando...",
      equivalentTo: "Equivale a {{price}} por mes",
      economyOf: "Ahorro de {{percent}}%",
      saveWithYearly: "Paga anual y ahorra {{percent}}%",
      addonHint: "¿Necesitas más? Paquetes adicionales de alumnos disponibles",
      proExtrasTitle: "En Pro, además de todo lo del Starter, ganas:",
      proExtras: "moneda de la escuela · catálogo de recompensas · onboarding asistido · soporte dedicado con SLA",
      helpQuestion: "¿Dudas entre los planes?",
      helpLink: "Habla con nuestro equipo",
      stripeNotice: "Pago procesado por Stripe",
      noCommitment: "Sin permanencia ni penalización",
      starterTag: "Empieza pequeño",
      starterTagline: "Para escuelas pequeñas que quieren crecer",
      starterBestFor: "Hasta 100 alumnos · 15 profesores",
      starterFeat1: "Hasta 100 alumnos activos",
      starterFeat2: "Hasta 15 profesores",
      starterFeat3: "200 créditos de IA por profesor / mes",
      starterFeat4: "Muro, anuncios e informes",
      starterFeat5: "Soporte por email",
      proTag: "Más popular",
      proTagline: "Ideal para escuelas en crecimiento",
      proBestFor: "Hasta 300 alumnos · profesores ilimitados",
      proFeat1: "Hasta 300 alumnos activos",
      proFeat2: "Profesores ilimitados",
      proFeat3: "500 créditos de IA por profesor / mes",
      proFeat4: "Moneda de la escuela y recompensas",
      proFeat5: "Onboarding asistido",
      proFeat6: "Soporte dedicado con SLA",
    },
  },
  plansManagement: {
    tabLabel: "Planes",
    heading: "Gestionar plan",
    subheading: "Gestiona tu suscripción, cambia de plan y sigue los cobros.",
    currentPlan: "Plan actual",
    currentPlanDescription: "Detalles de tu suscripción activa",
    noPlanActive: "Ningún plan activo",
    noPlanActiveDescription: "Estás en Gamefik Free. Haz upgrade para desbloquear más funciones.",
    planLabel: "Plan",
    statusLabel: "Estado",
    cycleLabel: "Ciclo",
    currencyLabel: "Moneda",
    renewsOn: "Renueva el {{date}}",
    trialEndsOn: "Prueba termina el {{date}}",
    trialDaysLeft: "{{count}} días restantes de prueba",
    manageBilling: "Gestionar en Stripe",
    manageBillingDescription: "Abre el portal de Stripe para gestionar métodos de pago, facturas y cancelaciones.",
    changeOnStripe: "Cambiar en Stripe",
    changePlan: "Cambiar de plan",
    changePlanDescription: "Elige un nuevo plan para tu cuenta.",
    upgradeCta: "Hacer upgrade",
    monthly: "Mensual",
    yearly: "Anual",
    proRataTitle: "Reglas de cambio de plan",
    proRataUpgrade: "Upgrade a mitad de ciclo: cobro proporcional inmediato por el periodo restante.",
    proRataDowngrade: "Downgrade: crédito proporcional aplicado automáticamente en la próxima factura.",
    proRataCycleChange: "Cambio de ciclo (mensual a anual): cobro del valor anual con crédito del período mensual restante.",
    proRataNote: "Todos los cambios son procesados por Stripe con cálculo automático de prorrateo.",
    selectPlan: "Seleccionar este plan",
    currentPlanBadge: "Actual",
    contactSales: "Hablar con ventas",
    nextInvoice: "Próxima factura",
    nextInvoiceDescription: "Previsión del próximo cobro basado en la suscripción activa.",
    billingProfileSection: "Datos de facturación",
    free: "Gratuito",
    perMonth: "/mes",
    perYear: "/año",
    perTeacherShort: "/prof",
    closePlanSelector: "Cerrar",
    openingStripe: "Abriendo Stripe...",
    plansTitle: "Planes Gamefik",
    plansSubtitle: "Desbloquea todo el potencial de la plataforma",
    billingPeriodToggle: "Alternar período de cobro",
    cancelationScheduled: "Cancelación programada",
    keepPlan: "Mantener plan",
    cancelNow: "Cancelar ahora",
    cancelToFree: "Cancelar a Free",
    downgradeCta: "Hacer downgrade",
    switchToYearly: "Cambiar a anual",
    switchToMonthly: "Cambiar a mensual",
    cancellationConfirmed: "Cancelación confirmada",
    nextPlanBadge: "Tu próximo plan",
    consumptionHeading: "Tu consumo actual",
    consumptionDescription: "Sigue el uso de los recursos de tu plan.",
    limit: "Límite",
    almostThere: "Casi llegas",
    unlimited: "Ilimitado",
    noLimit: "sin límite",
    ofMax: "de {{max}}",
    dayLeft: "día restante",
    daysLeft: "días restantes",
    accessUntil: "Acceso hasta",
    cancellationInfo: "Todavía tienes acceso a todas las funcionalidades de {{plan}} hasta el final del período. Después de eso, tu cuenta vuelve automáticamente al plan Gamefik Free.",
    cancelNowWarning: "Cancelar ahora termina el acceso inmediatamente, sin esperar el final del período. No generamos reembolso automático del valor proporcional.",
    compareFeatures: "Comparar todas las funcionalidades",
    feature: "Funcionalidad",
    syncTimedOut: "La sincronización con Stripe está tardando más de lo esperado. La pantalla mostrará el último estado conocido hasta que llegue la actualización.",
    stripeSyncingChange: "Esperando que Stripe sincronice tu cambio de plan...",
    stripeSyncingUpdate: "Esperando que Stripe sincronice la actualización de la suscripción...",
    syncingAutomatically: "Estamos sincronizando automáticamente el estado de la suscripción. Esto puede tomar unos segundos.",
    updateStatusNow: "Actualizar estado ahora",
    viewPlanOptions: "Ver opciones de plan",
    planSaved: "Plan guardado",
    stripeSyncing: "Sincronizando Stripe",
    planSavedDescription: "Tu plan actual está guardado en el registro de la cuenta.",
    stripeSyncingDescription: "Tu plan ya fue guardado. Estamos esperando que la suscripción llegue desde Stripe.",
    paymentProblem: "Tu plan tiene problemas de pago ({{status}}). Tu consumo está temporalmente limitado al plan {{plan}} hasta regularizar.",
    activeUntil: "Activo hasta {{date}}",
    endOfPeriod: "el final del período",
    classes: "Clases",
    students: "Alumnos",
    activitiesCreated: "Actividades creadas",
    wallPosts: "Comunicados en el muro",
    aiCredits: "Créditos IA",
    syncSuccess: "Plan sincronizado con Stripe.",
    syncTimeoutWarning: "Stripe aún está sincronizando tu cambio. Actualiza de nuevo en unos momentos.",
    syncError: "Error al sincronizar planes con Stripe:",
    cannotOpenStripe: "No se pudo abrir el portal de Stripe ahora. Intenta de nuevo.",
    cannotStartCheckout: "No se pudo iniciar el checkout ahora. Intenta de nuevo.",
    cannotIdentifySubscription: "No se pudo identificar la suscripción actual para cambiar de plan.",
    cannotIdentifySubscriptionItem: "No se pudo identificar el item de la suscripción para cambiar de plan.",
    cannotOpenPlanChange: "No se pudo abrir el cambio de plan en Stripe ahora. Intenta de nuevo.",
    changingPlan: "Cambiando plan...",
    syncing: "Sincronizando...",
    planChangedSuccess: "Plan cambiado con éxito manteniendo los días restantes de prueba.",
    done: "¡Listo!",
    cannotChangeTrialPlan: "No se pudo cambiar el plan de prueba ahora.",
    noActiveSubscription: "No hay suscripción activa para cancelar.",
    canceling: "Cancelando...",
    updatingData: "Actualizando datos...",
    cancelScheduledSuccess: "Cancelación programada. Tu plan actual sigue activo hasta la fecha de vencimiento.",
    cannotCancelSubscription: "No se pudo cancelar la suscripción ahora.",
    addonUpdateUnavailable: "Las actualizaciones de complementos no están disponibles temporalmente. Espera la actualización del sistema e inténtalo de nuevo.",
    aiCoverageIncomplete: "Cobertura incompleta de IA Ilimitada",
    aiCoverageIncompleteBadge: "Cobertura incompleta",
    aiSeatsPurchased: "Asientos contratados",
    aiTeachersEligible: "Profesores elegibles",
    aiCoverageDeficit: "Deficit",
    aiCoverageSyncCta: "Ajustar a {{count}} asientos",
    aiCoverageSyncSuccess: "Cantidad de asientos actualizada correctamente.",
    aiCoverageSyncError: "No se pudieron actualizar los asientos de IA Ilimitada.",
    aiCoverageUnknown: "La cobertura de IA aun no fue confirmada por el servidor. La compra permanece bloqueada hasta que se actualice.",
    aiNoEligibleTeachers: "No hay profesores elegibles en esta cuenta. No se puede crear ningun cargo de IA.",
    aiAddonRedundant: "La IA ilimitada ya esta incluida en el plan base.",
    aiAddonRedundantDescription: "Este add-on es redundante y puede seguir generando cargos. Cancelalo sin aumentar la cantidad.",
    aiAddonCancelRedundant: "Cancelar add-on redundante",
    cancelingNow: "Cancelando ahora...",
    cancelImmediatelySuccess: "Plan cancelado inmediatamente. Tu cuenta volvió a Gamefik Free.",
    cannotCancelNow: "No se pudo cancelar ahora.",
    reverting: "Revirtiendo...",
    revertSuccess: "¡Cancelación revertida! Tu plan se mantuvo.",
    cannotRevertCancellation: "No se pudo revertir la cancelación ahora.",
  },
  planFeatures: {
    teacher: {
      activeClasses: "Clases activas",
      totalStudents: "Alumnos totales",
      activitiesPerMonth: "Actividades/mes",
      trails: "Trails",
      aiCreditsPerMonth: "Créditos de IA/mes",
      xpAndBadges: "XP y badges",
      gems: "Gemas (moneda por defecto)",
      customCurrency: "Moneda personalizada",
      rewards: "Recompensas",
      announcementsPerMonth: "Comunicados/mes",
    },
    school: {
      activeStudentsBase: "Alumnos activos (base)",
      teachers: "Profesores",
      addon50Students: "Add-on +50 alumnos",
      activities: "Actividades",
      aiCreditsPerTeacher: "Créditos de IA (por prof)",
      addonUnlimitedAI: "Add-on IA ilimitada",
      xpAndBadges: "XP y badges",
      customCurrency: "Moneda personalizada",
      rewardCatalog: "Catálogo de recompensas",
      rewardsPerClass: "Recompensas por clase",
      adminPanel: "Panel admin",
      assistedOnboarding: "Onboarding asistido",
      lmsIntegration: "Integración LMS",
      dedicatedSupport: "Soporte dedicado + SLA",
    },
    unlimited: "Ilimitado",
    unlimitedFem: "Ilimitadas",
    unlimitedMasc: "Ilimitados",
    upTo2: "Hasta 2",
    upTo30: "Hasta 30",
    upTo50: "Hasta 50",
    upTo100: "Hasta 100",
    upTo15: "Hasta 15",
    upTo300: "Hasta 300",
    perMonth: "/mes",
    included: "Incluido",
    nA: "N/A",
    consumesCredits: "Consume créditos",
    oneTotal: "1 total",
    threePerMonth: "3 por mes",
    yes: "Sí",
    no: "No",
    highlights: {
      upTo2Classes: "Clases ilimitadas",
      upTo30Students: "Hasta 50 alumnos",
      fiveActivitiesMonth: "5 actividades/mes",
      twoHundredAiCreditsMonth: "200 créditos de IA/mes",
      xpAndBadges: "XP y badges",
      gemsDefaultCurrency: "Gemas (moneda por defecto)",
      unlimitedClasses: "Clases ilimitadas",
      unlimitedActivities: "Actividades ilimitadas",
      fiveHundredAiCreditsMonth: "500 créditos de IA/mes",
      unlimitedAnnouncements: "Comunicados ilimitados",
      customCurrency: "Moneda personalizada",
      unlimitedAI: "IA ilimitada",
      exclusiveRewards: "Recompensas exclusivas",
      rewardStore: "Tienda de recompensas",
      prioritySupport: "Soporte prioritario",
      upTo100Students: "Hasta 100 alunos",
      upTo15Teachers: "Hasta 15 profesores",
      adminPanel: "Panel administrativo",
      consolidatedReports: "Reportes consolidados",
      upTo300Students: "Hasta 300 alumnos",
      unlimitedTeachers: "Profesores ilimitados",
      rewardCatalog: "Catálogo de recompensas",
      unlimitedStudents: "Alumnos ilimitados",
      oneTrailTotal: "1 ruta total",
      threeAnnouncementsMonth: "3 comunicados por mes",
      unlimitedTeacherCore: "Clases, alumnos y actividades ilimitados",
      unlimitedAIIncluded: "IA ilimitada incluida",
      rewardsPerClass: "Recompensas por clase",
      lmsIntegration: "Integración LMS",
      multiUnits: "Multi-unidades",
      customContract: "Contrato personalizado",
    },
    presentation: {
      freeTitle: "Gamefik Free",
      freeCta: "Empezar gratis",
      freePriceLabel: "Gratis",
      freePriceDetail: "Para siempre",
      epicSubtitle: "Desbloquea todo el potencial",
      epicHighlightIntro: "Todo de Free, y más:",
      epicBadge: "Más popular",
      epicCta: "Suscribirse ahora",
      epicMonthlyFootnote: "Cancela cuando quieras",
      shinySubtitle: "El máximo de la gamificación",
      shinyHighlightIntro: "Recursos premium para tu gamificación:",
      shinyBadge: "Exclusivo",
      shinyCta: "Hacerme Shiny",
      shinyMonthlyFootnote: "Cancela cuando quieras",
      starterCta: "Empezar prueba de 14 días",
      starterMonthlyFootnote: "Prueba 14 días - tarjeta obligatoria",
      proSubtitle: "Ideal para escuelas en crecimiento",
      proHighlightIntro: "Todo de Starter, y más:",
      proBadge: "Más popular",
      proCta: "Empezar prueba de 14 días",
      proMonthlyFootnote: "Prueba 14 días",
      enterpriseSubtitle: "Todo de Pro, y más:",
      enterpriseCta: "Hablar con ventas",
      enterprisePriceLabel: "Bajo consulta",
    },
  },
  billingProfile: {
    title: "Datos de Facturación",
    description: "Información utilizada en cobros y facturas",
    stripeAccount: "Cuenta en Stripe",
    nameLabel: "Nombre/Razón Social",
    emailLabel: "E-mail",
    phoneLabel: "Teléfono",
    addressLine1: "Dirección (línea 1)",
    addressLine2: "Complemento",
    city: "Ciudad",
    state: "Estado",
    postalCode: "Código Postal",
    country: "País",
    taxDocument: "Documento Fiscal",
    number: "Número",
    select: "Selecciona",
    saveSuccess: "Datos de facturación actualizados",
    saveError: "Error al guardar datos de facturación",
    addressManagedInStripe: "La dirección de facturación se gestiona directamente en Stripe.",
    editAddressOnStripe: "Editar dirección en Stripe",
    vatEU: "VAT (UE)",
    other: "Otro",
  },
  gameList: {
    noGameFound: "No se encontró ningún segmento",
    createFirstGame: "Crea tu primer segmento para empezar a administrar puntos y recompensas para tus jugadores.",
    game: "Segmento",
    scoring: "Puntuación",
    coinsLimit: "Límite de Coins",
    limitNotDefined: "Límite no definido",
    noLimitLabel: "Sin límite",
    openMenu: "Abrir menú",
    editGame: "Editar Segmento",
    configureLevels: "Configurar Niveles",
    deleteGame: "Eliminar Segmento",
  },
  modalGameLimit: {
    teacherMissions: "Misiones de los profesores",
    attentionTeacherMissions: "Sus profesores ahora pueden crear y aprobar misiones.",
    defineCoinsLimit: "Defina abajo el límite de coins que cada profesor recibirá por mes para aplicar en cada una de sus clases.",
    unlimitedLabel: "Ilimitado",
    withLimit: "Con límite",
    coinsPerMonth: "{count} coins/mes",
    schoolsWithTeacherMissions: "¡Las escuelas donde los profesores crean misiones tienen un resultado significativamente mejor con Gamefik!",
    featureEnabled: "Recurso activado",
    featureDisabled: "Recurso desactivado",
    featureToggleSuccess: "Recurso {status} con éxito",
    enabled: "activado",
    disabled: "desactivado",
    featureToggleError: "Error al activar/desactivar recurso",
    updateCoinsError: "Error al actualizar límite de coins",
  },
  coinsLimits: {
    checkCoinsLimitByClass: "Verifica abajo cuál es el límite de monedas por clase",
    classesCannotCreateMissions: "Las siguientes clases no pueden crear misiones:",
    limitReached: "{name}: límite alcanzado ({used} / {total})",
    classColumn: "Clase",
    usedLimit: "Límite Utilizado",
    remainingCoins: "Coins restantes",
    available: "Disponible",
    classMissions: "Misiones de esta clase",
    viewMissions: "misiones",
    createdBy: "Creado por:",
    createdAt: "Creado el:",
    checkLimit: "Consultar límite",
    returnButton: "Regresar",
  },
  userManagement: {
    addUser: "Agregar Usuario",
    importLabel: "Importar",
    importUsersTitle: "Importar Usuarios",
    importUsersDescription: "Importe múltiples usuarios usando un archivo CSV",
    startImport: "Iniciar Importación",
    importUsersBatchTitle: "Importar Usuarios en Lote",
    importUsersBatchDescription: "Importe múltiples usuarios a la vez usando un archivo CSV",
    downloadTemplate: "Descargue el modelo del archivo",
    downloadTemplateDescription: "Primero, descargue el archivo modelo, llénelo con los correos de los usuarios y envíelo aquí.",
    downloadTemplateButton: "Descargar Modelo",
    alreadyHaveFile: "Ya tengo el archivo completo",
    sendSpreadsheet: "Envíe la hoja de cálculo completada",
    verifyEmails: "Verifica que todos los correos estén correctos antes de enviar las invitaciones.",
    selectCsvFile: "Selecciona el archivo CSV con los correos de los profesores",
    noValidEmails: "No se encontraron correos válidos en el archivo. Verifica si la columna se llama 'Email' o 'E-mail'.",
    emailsFound: "¡{count} correo(s) encontrado(s)! Desplácese hacia abajo para ver la vista previa y enviar las invitaciones.",
    previewUsers: "Vista Previa de Usuarios ({count})",
    verifyBeforeSending: "Verifica los correos antes de enviar las invitaciones",
    email: "Correo",
    status: "Estado",
    sent: "Enviado",
    error: "Error",
    waiting: "Esperando",
    continue: "Continuar",
    sendInvites: "Enviar Invitaciones ({{count}})",
    inviteSentSuccess: "Invitación enviada con éxito",
    inviteSendError: "Error al enviar invitación",
    totalUsers: "Total de Usuarios",
    administrators: "Administradores",
    teachers: "Profesores",
    pendingInvites: "Invitaciones Pendientes",
    userListTitle: "Lista de Usuarios",
    userListDescription: "Visualice y administre todos los usuarios del sistema",
    user: "Usuario",
    roles: "Funciones",
    classes: "Clases",
    actions: "Acciones",
    pending: "Pendiente",
    active: "Activo",
    registered: "Registrado",
    resendingInvite: "Reenviando invitación...",
    inviteResentTitle: "Invitación Reenviada con Éxito",
    inviteResentDescription: "El enlace de invitación ha sido generado. Puede copiarlo o enviarlo por correo.",
    accessLink: "Enlace de acceso:",
    copyButton: "Copiar",
    attentionAutoFail: "Si el envío automático falla, puede enviar la invitación manualmente.",
    sendEmailManually: "Enviar correo manualmente",
    inviteResentSuccess: "¡Invitación reenviada con éxito!",
    resendInviteError: "Error al reenviar invitación",
    linkCopied: "¡Enlace copiado al portapapeles!",
    generatingAccess: "Generando acceso seguro...",
    openingAccess: "Abriendo acceso en nueva pestaña...",
    generateTokenError: "Error al generar token de acceso",
    impersonateNotAllowed: "No puedes acceder como este usuario: su nivel de acceso no es menor que el tuyo.",
    noName: "Sin nombre",
    accessAsUser: "Acceder como Usuario",
    viewEdit: "Ver/Editar",
    resendInvite: "Reenviar Invitación",
    manageClasses: "Administrar Clases",
    removeUser: "Eliminar Usuario",
    noUsersFound: "No se encontraron usuarios",
    addFirstUser: "Agregar primer usuario",
    searchUsersPlaceholder: "Buscar por nombre o correo...",
    searchUsersAriaLabel: "Buscar usuarios por nombre o correo",
    clearSearch: "Limpiar búsqueda",
    searchResultsCount: "{count} de {total} usuarios",
    noUsersForSearch: "No se encontraron usuarios para \"{search}\"",
    noUsersForSearchHint: "Intenta buscar por otro nombre o correo.",
    noClasses: "Ninguna clase",
    classesNotFound: "Clases no encontradas",
    classesCount: "{count} clases",
    roleAdmin: "Administrador",
    roleManager: "Gestor",
    roleSecretary: "Secretario",
    roleTeacher: "Profesor",
    roleSchoolTeacher: "Profesor de la escuela",
    roleAdminFull: "Administrador(a)",
    roleManagerFull: "Gestor(a)",
    roleSecretaryFull: "Secretario(a)",
    roleTeacherFull: "Profesor(a)",
    roleSchoolTeacherFull: "Profesor(a) de la escuela",
    inviteSubject: "Invitación para acceso al sistema",
    inviteBody: "¡Hola!\n\nHa sido invitado para acceder al sistema. Use el enlace a continuación para completar su registro:\n\n{link}\n\nAtentamente.",
    importLimitedByPlan: "Tu plan permite agregar {{remaining}} profesor(es) más. {{excess}} email(s) fueron eliminados de la importación.",
  },
  modalRemoveUser: {
    title: "Quitar acceso a la escuela",
    subtitle: "Revisa el impacto antes de quitar a {name}.",
    scopeTitle: "El usuario no será eliminado",
    scopeDescription: "Esta acción solo quita el acceso a la escuela actual. Se conservarán las cuentas de otras escuelas, el contenido creado y la autoría histórica.",
    loadingImpact: "Verificando el impacto",
    loadingImpactDescription: "Estamos consultando las clases vinculadas en la fuente de datos principal.",
    previewErrorTitle: "No se pudo verificar el impacto",
    previewErrorDescription: "No se realizó ningún cambio. Vuelve a cargar los datos antes de confirmar.",
    retry: "Intentar de nuevo",
    ownerBlockTitle: "El propietario no puede ser removido",
    ownerBlockDescription: "Primero transfiere la propiedad de la escuela a otro administrador y luego vuelve a esta pantalla.",
    impactTitle: "Qué se verá afectado",
    impactDescription: "Al confirmar, el vínculo con esta escuela se eliminará de forma segura.",
    classesAffected: "clases vinculadas",
    preservedTitle: "Qué se conservará",
    preserved: {
      other_accounts: "El acceso del usuario a otras escuelas",
      historical_authorship: "La autoría y el historial de acciones realizadas",
      school_content: "Las clases, actividades y contenidos de la escuela",
    },
    progressTitle: "Remoción en curso",
    progressDescription: "Estamos revocando el vínculo con esta escuela. No cierres esta ventana; un reintento seguro usa la misma operación.",
    partialErrorTitle: "La remoción se completó parcialmente",
    partialErrorDescription: "Algunos pasos ya se aplicaron. Intenta de nuevo para continuar la misma operación sin duplicar cambios.",
    removeErrorTitle: "No se pudo quitar el acceso",
    removeErrorDescription: "No se recibió confirmación de finalización. Intenta de nuevo o contacta con soporte si el problema continúa.",
    successTitle: "Acceso removido de forma segura",
    successDescription: "El vínculo con esta escuela se revocó de forma segura.",
    cancelButton: "Cancelar",
    deleteButton: "Quitar acceso",
    finishButton: "Finalizar",
  },
  voiceSearch: {
    start: "Buscar por voz",
    stop: "Detener búsqueda por voz",
    error: "No se pudo usar la búsqueda por voz. Continúa escribiendo.",
  },
  modalSelectClasses: {
    selectClassesFor: "Selecciona las clases de {name}",
    classesPlaceholder: "Clases",
    addButton: "Agregar",
    addSuccess: "Clase(s) agregada(s) con éxito",
    addError: "Hubo un error al agregar clase",
    searchPlaceholder: "Buscar clase...",
    noClassFound: "No se encontraron clases.",
    selectedCount: "{{count}} clase(s) seleccionada(s)",
    loadError: "No se pudieron cargar las clases del usuario.",
    retry: "Intentar de nuevo",
    segmentLoading: "Cargando segmento...",
    segmentsLoadError: "Segmentos no disponibles",
    segmentUnavailable: "Segmento no identificado",
  },
  sendInvitation: {
    sendInvite: "Enviar Invitación",
    emailLabel: "E-mail *",
    emailPlaceholder: "Ingresa el e-mail",
    permissionLabel: "Permiso *",
    selectPermission: "Selecciona un permiso",
    classesLabel: "Clases *",
    searchClasses: "Escriba para buscar clases...",
    noClassSelected: "Ninguna clase seleccionada",
    noClassFound: "Ninguna clase encontrada",
    clickToSelect: "Haz clic para seleccionar/deseleccionar clases",
    selected: "Seleccionado",
    selectAtLeastOneClass: "Selecciona al menos una clase para enviar la invitación",
    sending: "Enviando...",
    sendButton: "Enviar Invitación",
    invitesSentSuccess: "Invitaciones enviadas con éxito",
    invitesSentPartially: "¡Invitaciones enviadas parcialmente!",
    segmentLoading: "Cargando segmento...",
    segmentsLoadError: "Segmentos no disponibles",
    segmentUnavailable: "Segmento no identificado",
  },
  viewUser: {
    editUser: "Editar Usuario",
    editUserDescription: "Visualice y edite la información y permisos del usuario",
    noName: "Sin nombre",
    verified: "Verificado",
    notVerified: "No verificado",
    personalInfo: "Información Personal",
    fullName: "Nombre Completo",
    emailLabel: "E-mail",
    genderLabel: "Género",
    genderMale: "Masculino",
    genderFemale: "Femenino",
    genderOther: "Otro",
    genderNotInformed: "No informado",
    settingsTitle: "Configuraciones",
    groupPermission: "Grupo/Permiso",
    selectGroup: "Selecciona un grupo",
    birthDate: "Fecha de Nacimiento",
    memberSince: "Miembro desde",
    notInformed: "No informado",
    invalidDate: "Fecha inválida",
    permissionChangeWarning: "Está cambiando los permisos de este usuario de <strong>{from}</strong> a <strong>{to}</strong>. Esta acción afectará el acceso del usuario al sistema.",
    selectGroupError: "Por favor, seleccione un grupo para el usuario",
    updateSuccess: "¡Permisos del usuario actualizados con éxito!",
    updateError: "Error al actualizar permisos del usuario",
    saving: "Guardando...",
    saveChanges: "Guardar Cambios",
  },
  userTypeTag: {
    legacyAdmin: "Admin · Legado",
    legacyManager: "Gestor · Legado",
    legacySecretary: "Secretario · Legado",
    legacyTeacher: "Profesor · Legado",
    nmgTeacher: "Profesor · NMG",
    nmgSchool: "Escuela · NMG",
    nmgSchoolTeacher: "Profesor-Escuela · NMG",
  },
  rowUser: {
    editPermissions: "Editar permisos",
    editClasses: "Editar clases",
    resendInviteLabel: "Reenviar invitación",
    remove: "Eliminar",
    emailVerified: "E-mail verificado",
    emailNotVerified: "E-mail no verificado",
    loading: "Cargando...",
    lastUsedOn: "Último uso el {date}",
    neverUsed: "Nunca lo usó",
    userCreatedOn: "Usuario creado el {date}",
    unknown: "Desconocido",
  },
  registerUser: {
    next: "SIGUIENTE",
    previous: "ANTERIOR",
    stepOf: "Paso {step} de {total}",
    wantToKnowMore: "Queremos saber un poco más sobre usted",
    invalidName: "Nombre inválido",
    fullName: "Nombre completo",
    sex: "Sexo",
    male: "Masculino",
    female: "Femenino",
    preferNotToSay: "Prefiero no informar",
    birthDate: "Fecha de Nacimiento",
    schoolRole: "¿Cuál es su rol en la escuela?",
    teacher: "Profesor",
    coordinator: "Coordinador",
    secretary: "Secretario(a)",
    others: "Otros",
    registrationSuccess: "¡Felicitaciones, su registro está completo!",
    registrationError: "Lo sentimos, ocurrió un error al completar su registro, por favor contacte al soporte.",
  },
  dialogRegisterAdmin: {
    newAccountIntro: "Conozca la nueva cuenta Gamefik",
    newAccountDescription: "A partir de ahora podrá tener una cuenta con una contraseña exclusiva para acceder a la cuenta Gamefik de su escuela y también crear una cuenta exclusiva con acceso a la información de su escuela para cada miembro de su equipo.",
    readyToCreate: "¿Y? ¿Le gustó? ¿Creamos su cuenta?",
    areYouManager: "¿Es usted un(a) gestor(a)?",
    yes: "Sí",
    no: "No",
    whatIsYourEmail: "¿Cuál es su e-mail?",
    invalidEmail: "E-mail inválido",
    chooseNewPassword: "Elige una <strong>nueva contraseña</strong> para su usuario individual.",
    passwordRequirements: "La contraseña debe contener al menos 6 caracteres. La contraseña no debe contener símbolos (@,#,%,ˆ,&)",
    invalidPassword: "Contraseña inválida",
    newPassword: "Nueva contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    passwordsDontMatch: "Las contraseñas no coinciden",
    almostThere: "¡Ya casi!",
    confirmData: "Necesitamos que confirme los datos que nos proporcionó. Después de hacer clic en continuar, no será posible deshacer esta acción.",
    name: "Nombre:",
    emailConfirm: "E-mail:",
    gender: "Género:",
    birthDateConfirm: "Fecha de nacimiento:",
    schoolName: "Nombre de la escuela:",
    contact: "Contacto:",
    createUserError: "¡Ocurrió un error al crear el usuario, por favor intente nuevamente o contacte al soporte!",
    emailVerificationCode: "Recibió en su e-mail (<strong>{email}</strong>) un <strong>código</strong> para la validación de sus datos. Por favor, ingrese este código en el campo a continuación.",
    code: "Código",
    resend: "Reenviar",
    accountCreatedSuccess: "Su cuenta ha sido creada con éxito.",
    addTeamMembers: "Ahora puede agregar otros miembros de su equipo haciendo clic",
    here: "aquí",
    onlyManagerAction: "¡Solo el gestor puede realizar esta acción!",
    contactManager: "Por favor comuníquese con el gestor de su escuela.",
    schoolInfoNeeded: "Necesitamos alguna información sobre su escuela para completar el registro.",
    schoolNameLabel: "Nombre de la escuela",
    nameTooShort: "Nombre muy corto",
    telephone: "Teléfono",
    invalidNumber: "Número Inválido",
    next: "SIGUIENTE",
    cancelButton: "CANCELAR",
  },
  dialogRegisterAccount: {
    welcome: "¡Bienvenido a Gamefik!",
    welcomeDescription: "Para continuar con su registro necesitaremos algunos datos. ¿Vamos?",
    choosePassword: "Elige una <strong>contraseña</strong> para su usuario individual.",
    profession: "Profesión",
    professionConfirm: "Profesión:",
    schoolCode: "El código de su escuela es: {code}",
    explorePlatform: "Ahora puede conocer nuestra plataforma haciendo clic",
  },
  seletorUnidade: {
    switchUnitError: "Error al cambiar de unidad",
  },
  iaCreditsExhausted: {
    creditsExhausted: "Créditos Agotados",
    monthlyCreditsExhausted: "Sus créditos de IA del mes se agotaron",
    missionsQuizzesWithAI: "Misiones/Quizzes con IA",
    wantUnlimitedAI: "¿Desea contratar el paquete de IA ilimitada?",
    contractUnlimitedAI: "Contratar IA Ilimitada",
    contactAdminToContract: "Hable con el administrador de la escuela para contratar IA ilimitada.",
    notNow: "Ahora no",
    creditsNeeded: "Necesita {{needed}} créditos para crear con IA",
    adjustNeeded: "Cada ajuste en el chat cuesta 10 créditos",
    muralAdjustNeeded: "Cada sugerencia de texto del Mural cuesta 10 créditos",
    creditsAvailable: "Créditos disponibles",
    usedThisMonth: "{{count}} comprometidos este mes",
    quizContext: "Contexto: quiz",
    missionContext: "Contexto: misión",
    trailContext: "Contexto: ruta",
    muralContext: "Contexto: Mural",
    teacherEpicName: "Teacher Epic",
    teacherShinyName: "Teacher Shiny",
    mostPopular: "Más popular",
    exclusive: "Exclusivo",
    unlimitedClasses: "Clases ilimitadas",
    unlimitedStudents: "Alumnos ilimitados",
    unlimitedActivities: "Actividades ilimitadas",
    aiCreditsPerMonth: "{{count}} créditos de IA/mes",
    customCurrency: "Moneda personalizada",
    unlimitedAI: "IA ilimitada",
    exclusiveRewards: "Recompensas exclusivas",
    onboardingAssisted: "Onboarding asistido",
    rewardStore: "Tienda de recompensas",
    prioritySupport: "Soporte prioritario",
    monthShort: "/mes",
    unlockWithEpic: "Desbloquear con Epic",
    becomeShiny: "Hacerme Shiny",
  },
  iaUpgrade: {
    upgradeToAI: "Upgrade a Recursos de IA",
    reachedFreeLimit: "Ha alcanzado el límite mensual de creaciones gratuitas de {type}",
    activateForUnlimited: "Active la IA para creaciones ilimitadas de {type}",
    currentPlanFree: "Plan Actual - Gratuito",
    aiCreationsThisMonth: "Creaciones de {type} con IA este mes:",
    remainingFreeCreations: "Quedan {count} creaciones gratuitas este mes",
    monthlyLimitReached: "Límite mensual alcanzado - upgrade necesario para continuar",
    planWithAI: "Plan con IA",
    recommended: "Recomendado",
    enhanceExperience: "Mejore su experiencia Gamefik con recursos basados en IA",
    unlimitedCreations: "Creaciones ilimitadas de {type} con IA",
    autoAnalysis: "Análisis automático de comprobantes por IA",
    smartFeedback: "Feedback inteligente para estudiantes",
    autoSuggestions: "Sugerencias automáticas de mejoras",
    advancedReports: "Informes avanzados con insights de IA",
    continueFreePlan: "Continuar con Plan Gratuito",
    activateAIResources: "Activar Recursos de IA",
    freeResetInfo: "El límite de creaciones gratuitas se reinicia el 1° de cada mes",
  },
  xpResetModal: {
    xpResetDescription: "Queremos asegurarnos de que entiendas tu elección",
    xpSystemUpdate: "Actualización del Sistema de XP",
    configureXpMigration: "Configura cómo desea migrar el XP de los estudiantes",
    newAppLaunched: "Gamefik ha lanzado la <strong>Nueva App del estudiante</strong> con un viaje increíble y cambios importantes. Ahora las escuelas no necesitan gestionar la evolución de nivel, nuestro sistema se encarga automáticamente. Los estudiantes pueden alcanzar el <strong>nivel 100</strong>.",
    wantToKnowMore: "¿Quiere saber más?",
    clickHere: "Haz clic aquí",
    suggestResetXp: "Sugerimos fuertemente reiniciar el XP para que todos aprovechen el 100% de la experiencia de la nueva app.",
    dontReset: "No Reiniciar",
    resetXp: "Reiniciar XP",
    areYouSure: "¿Estás seguro?",
    ensureChoice: "Queremos asegurarnos de que entienda su elección",
    recommendReset: "Recomendamos reiniciar el XP para que todos aprovechen el 100% de la experiencia de la nueva app.",
    newSystemDescription: "El nuevo sistema ofrece un viaje completo y equilibrado desde el inicio, con niveles hasta 100 y evolución automática.",
    understoodDontReset: "Entendido, pero no voy a reiniciar",
    understoodWantReset: "Entendido, quiero Reiniciar XP",
  },
  xpResetMigrationGate: {
    noGamesToReset: "No encontramos segmentos para reiniciar el XP. Intenta nuevamente en unos segundos.",
    xpResetSuccess: "¡XP reiniciado con éxito!",
    xpResetSaveError: "XP reiniciado, pero no fue posible guardar su elección. El aviso puede aparecer nuevamente.",
    xpResetError: "No fue posible reiniciar el XP. Intenta nuevamente.",
    decisionSaveError: "No fue posible guardar su elección. El aviso puede aparecer nuevamente.",
    decisionRegistered: "Opción registrada. No se realizaron cambios en el XP de los estudiantes.",
    noGamesForReset: "No hay segmentos para reiniciar.",
  },
  aiCreditsDisplay: {
    iaCredits: "créditos IA",
    iaCreditsTitle: "Créditos de IA",
    creditsAvailable: "{count} créditos disponibles",
    lowCredits: "¡Créditos bajos! Considere recargar.",
    monthlyMovements: "Movimientos de IA (mes actual)",
    loadingLabel: "Cargando...",
    loadError: "Error al cargar movimientos de créditos de IA.",
    noMovements: "No se registraron movimientos este mes.",
    creationWithAI: "Creación con IA",
    zeroedHere: "Se agotó aquí",
    unlimitedAI: "IA Ilimitada",
    unlimitedAIDescription: "Crea cuantas misiones, quizzes y contenidos quieras con IA, sin preocuparte por créditos.",
    contract: "Contratar",
    contactAdminToContract: "Hable con el administrador de la escuela para contratar",
    unlimitedFromPlan: "IA ilimitada según su plan actual",
    currentPlanBudget: "Presupuesto de IA del plan actual",
    planLabel: "Plan",
    limitSourceLabel: "Origen del límite",
    monthlyLimitLabel: "Límite mensual",
    usedInMonthLabel: "Usado en el mes",
    availableLabel: "Disponible",
    unlimitedLabel: "Ilimitado",
    overrideAppliedBadge: "Override aplicado en la cuenta",
    sourceAccountOverride: "Override configurado en la cuenta",
    sourcePlanLimit: "Límite del plan actual",
    sourcePlanUnlimited: "Plan con IA ilimitada",
    sourcePremium: "Paquete IA premium",
    sourceLegacy: "Límite legado de la cuenta",
    modalSubtitle: "Tu consumo mensual",
    remainingCreditsLabel: "Créditos restantes",
    reservedInProgress: "{{count}} créditos reservados en generaciones en curso",
    renewsOnFirstOfMonth: "Se renueva el 1 de {{month}}",
    recentActivityTitle: "Actividad reciente",
    needMoreCreditsCta: "¿Necesitas más créditos?",
    planEpicMonthly: "500 créditos/mes",
    viewPlanButton: "Ver plan {{plan}}",
    backButton: "Volver",
    detailRowType: "Tipo",
    detailRowReason: "Motivo",
    detailRowWhen: "Cuándo",
    detailRowUser: "Usuario",
    detailRowCost: "Costo",
    detailRowId: "ID",
    costCreditsOne: "{{count}} crédito",
    costCreditsOther: "{{count}} créditos",
    reasonCreateMissionAI: "Creación de misión con IA",
    reasonCreateQuizAI: "Creación de quiz con IA",
    reasonAdjustChatAI: "Ajuste/iteración en el chat con IA",
    reasonComprovantesOnCreation: "Comprobante incluido en la creación de la actividad",
    reasonDefault: "Consumo de créditos",
    itemQuiz: "Quiz",
    itemMission: "Misión",
    dateToday: "Hoy, {{time}}",
    dateYesterday: "Ayer, {{time}}",
  },
  iaContractCta: {
    unlimitedAIActive: "IA Ilimitada activa",
    unlimitedAIPackage: "Paquete IA Ilimitada",
    manageDescription: "Su paquete IA Ilimitada está activo. Puede administrar su suscripción y cobro en las configuraciones.",
    upgradeDescription: "Su cuenta no tiene créditos de IA. Contrate el paquete de IA Ilimitada para habilitar la creación con IA inmediatamente.",
    managePlan: "Administrar plan",
    contractNow: "Contratar IA ahora",
    contactAdminToContract: "Hable con el administrador de la escuela para contratar o administrar el plan de IA.",
    timeRemaining: "Faltan",
  },
  iaPlanIndicator: {
    unlimitedAI: "IA ilimitada",
  },
  iaUsageNotice: {
    loadingStatus: "Cargando estado de IA...",
    checkError: "No fue posible verificar sus créditos de IA ahora.",
    unlimitedActive: "IA ilimitada activa — ningún crédito será descontado.",
    creditsAvailable: "Su cuenta tiene {{count}} créditos de IA disponibles.",
    creditsCost: "Se descontará de {{min}} a {{max}} crédito(s) al crear con IA.",
    contractUnlimited: "Contrate ahora IA ilimitada",
    contactAdminToContract: "Hable con el administrador de la escuela para contratar IA ilimitada.",
  },
  iaUsageProgress: {
    premiumResources: "Recursos de IA Premium",
    activeLabel: "Activo",
    unlimitedCreations: "Creaciones ilimitadas disponibles",
    includedResources: "Recursos Incluidos:",
    unlimitedQuizzesMissions: "Quizzes y Misiones con IA ilimitados",
    autoAnalysis: "Análisis automático de comprobantes",
    smartFeedback: "Feedback inteligente personalizado",
    advancedReports: "Informes avanzados con insights",
    freeAICreations: "Creaciones Gratuitas con IA",
    remainingCreations: "Quedan <strong>{count}</strong> creaciones gratuitas este mes",
    monthlyLimitReached: "Límite mensual alcanzado - active la IA para crear más",
    nextReset: "Próximo reinicio: <strong>{date}</strong>",
    days: "{count} días",
    availableInFreePlan: "Creaciones disponibles en el plan gratuito:",
    quizzesWithAI: "Quizzes con IA",
    missionsWithAI: "Misiones con IA",
    freePlanLimitations: "Limitaciones del plan gratuito:",
    manualAnalysis: "Análisis manual de comprobantes",
    basicReports: "Informes básicos sin insights de IA",
    standardFeedback: "Feedback estándar para estudiantes",
    upgradeToUnlimited: "¡Upgrade a IA ilimitada y mucho más!",
    lastCreation: "¡Última creación disponible - considere el upgrade!",
  },
  teacherModal: {
    noAICredits: "Sin crédito de IA disponible",
    noCreditsDescription: "La cuenta de tu escuela no tiene créditos de IA. Crea tu misión manualmente o contacta al gestor de la cuenta.",
    createManualMission: "Crear misión manual",
  },
  trilhas: {
    pageTitle: "Rutas de aprendizaje | Gamefik",
    pageDescription:
      "Crea rutas de aprendizaje personalizadas con cuestionarios, flashcards y contenidos en recorridos completos para tus alumnos.",
    title: "Rutas de aprendizaje",
    comingSoon: "Próximamente",
    description:
      "Estamos preparando una experiencia increíble para que crees rutas de aprendizaje personalizadas al estilo Duolingo. Combina cuestionarios, flashcards y contenidos en itinerarios completos para tus alumnos.",
    flashcards: "Flashcards",
    quizzes: "Quizzes",
    quests: "Misiones",
    accessLinkButtonAria: "Enlace de acceso a la ruta",
    accessLinkModalTitle: "Enlace de Acceso",
    accessLinkModalScanHint: "Escanea el código QR o copia el enlace de abajo",
    accessLinkModalShareHint:
      "Comparte este enlace con tus alumnos. Al acceder, crean una cuenta y entran automáticamente en la ruta.",
    accessLinkModalPrintPdf: "Imprimir PDF",
    accessLinkModalPrintTitle: "Acceso - {{name}}",
    accessLinkModalPrintSubtitle: "Plataforma de Gamificación Educativa",
    accessLinkModalPrintCardLabel: "Enlace de Acceso a la Ruta",
    accessLinkModalPrintInstructions:
      "Escanea el código QR de arriba o accede al enlace de abajo para entrar en la ruta",
    accessLinkModalQrAlt: "Código QR",
    accessLinkCopy: "Copiar",
    accessLinkCopied: "Copiado",
    accessLinkDisabledHint: "Disponible tras publicar la ruta",
    testEnv: {
      viewAnyway: "Ver rutas (entorno de prueba)",
    },
    header: {
      eyebrow: "Biblioteca — Comunidad global",
      title: "Rutas",
      createFromScratch: "Crear ruta desde cero",
    },
    tabs: {
      community: "Banco de la comunidad",
      myTrails: "Mis rutas",
    },
    my: {
      searchPlaceholder: "Buscar tus rutas...",
      filters: {
        turmas: "Clases",
        subject: "Asignatura",
      },
      clearFilters: "Limpiar ({{count}})",
      stats: {
        active: "{{count}} activas",
        drafts: "{{count}} borradores",
        inactive: "{{count}} inactivas",
        expired: "{{count}} expiradas",
      },
      statusActive: "Activa",
      statusInactive: "Inactiva",
      statusScheduled: "Programada",
      statusExpired: "Expirada",
    },
    card: {
      createTitle: "Crear nueva ruta",
      createSubtitle: "Empezar desde cero",
      phases: "{{count}} fases",
      activities: "{{count}} actividades",
      participants: "{{count}} alumnos",
      studentProgress: "Progreso de los alumnos",
      studentProgressAverage: "Progreso medio de los alumnos",
      classes: "{{count}} clases",
      viewDetails: "Ver detalles",
      openDetails: "Abrir detalles de {{title}}",
      reactivate: "Reactivar ruta",
      deactivate: "Desactivar ruta",
    },
    report: {
      title: "Informe: {{title}}",
      subtitle: "Rendimiento de los alumnos en la ruta",
      noClassesTitle: "Ninguna clase vinculada",
      noClassesDescription:
        "Vincula clases a esta ruta para ver el informe de rendimiento de los alumnos.",
      understood: "Entendido",
      loadErrorTitle: "No se pudo cargar el informe",
      loadErrorDescription: "Comprueba tu conexión e inténtalo de nuevo.",
      completionRate: "Tasa de finalización",
      completionRateHint: "{{completed}} de {{total}} alumnos completaron",
      averageProgress: "Progreso medio",
      averageProgressHint: "Media de todos los alumnos",
      totalStudents: "Total de alumnos",
      totalStudentsHint: "En {{count}} {{unit}}",
      classUnit: "clase",
      classesUnit: "clases",
      phasesTitle: "Rendimiento por fase",
      phasesSubtitle: "Identifica dónde tienen más dificultad los alumnos",
      attention: "Atención",
      difficultActivity: "Actividad con dificultad:",
      studentsHere: "{{count}} alumnos aquí",
      completion: "Finalización",
      accuracy: "Tasa de aciertos",
      averageTime: "Tiempo medio: {{minutes}}min",
      classesTitle: "Finalización por clase",
      classesSubtitle: "Clases ordenadas por porcentaje de finalización",
      completedRatio: "{{completed}}/{{total}} completaron",
      classAverage: "Media: {{percent}}%",
      statusIncomplete: "No completada",
      criteriaAllSteps: "Criterio: completar todas las etapas",
      criteriaMinScore: "Criterio: puntuación mínima de {{score}}%",
      hint: "Pista",
      openAttachment: "Abrir archivo adjunto",
      missionResponseUnavailable: "La finalización fue registrada. Este informe no proporciona la respuesta o la evidencia enviada para esta misión.",
      studentsTitle: "Finalización y respuestas de los alumnos",
      studentsSubtitle: "Consulta la finalización de cada alumno y abre las actividades para ver respuestas y detalles.",
      responses: "Respuestas",
      viewStudentResponses: "Ver respuestas",
      viewStudentResponsesLabel: "Ver respuestas de {{name}}",
      noStudentsFound: "No se encontraron alumnos. Ajusta los filtros para continuar.",
      filterAllClasses: "Todas las clases",
      filterClassesCount: "{{count}} clases",
      searchClassPlaceholder: "Buscar clase...",
      noClassFound: "Ninguna clase encontrada.",
      clearSelection: "Limpiar selección ({{count}})",
      filterAllStatus: "Todos los estados",
      statusCompleted: "Completado",
      statusInProgress: "En progreso",
      statusNotStarted: "No inició",
      statusAtRisk: "En riesgo",
      searchStudentPlaceholder: "Buscar por nombre",
      colStudent: "Alumno",
      colClass: "Clase",
      colCurrentPhase: "Fase actual",
      colProgress: "Progreso",
      colActivities: "Actividades",
      colAccuracy: "Tasa de aciertos",
      showingStudents: "Mostrando {{shown}} de {{total}} participantes",
    },
    detailModal: {
      phasesLabel: "Fases",
      activitiesLabel: "Actividades",
      participantsLabel: "Alumnos",
      classesLabel: "Clases",
      linkedClasses: "Clases",
      linkedClassesHint: "{{count}} clases vinculadas · gestionar",
      linkedClassesHintAll: "Todas las clases de la escuela · gestionar",
      classesAllShort: "Todas",
      editTrail: "Editar ruta",
      structureTitle: "Estructura de la ruta",
      structureSubtitle: "{{phases}} fases con {{activities}} actividades",
      phaseActivities: "{{count}} actividades",
      noPhases: "Esta ruta aún no tiene fases.",
      structureLoadError: "No se pudo cargar la estructura de la ruta.",
      backToStructure: "Volver a la estructura",
      exploreHint: "Haz clic en cualquier elemento para ver más detalles",
      overviewTitle: "Resumen de la ruta",
      descriptionLabel: "Descripción",
      themeLabel: "Tema",
      gradeLabel: "Curso",
      localeLabel: "Idioma",
      creatorLabel: "Creada por",
      creatorUnavailable: "Usuario eliminado o no disponible",
      statusTitle: "Estado de la ruta",
      phasesOverviewTitle: "Todas las fases",
      activitiesOverviewTitle: "Todas las actividades",
      classesOverviewTitle: "Clases",
      classesPanel: {
        search: "Buscar clase…",
        filterAll: "Todas",
        filterLinked: "Vinculadas",
        filterUnlinked: "No vinculadas",
        addVisible: "Vincular visibles",
        removeVisible: "Desvincular visibles",
        openToAll: "Abrir a todas las clases",
        allClassesHint:
          "Sin restricción: todos los alumnos de la escuela pueden acceder a esta ruta. Selecciona una clase abajo para restringir el acceso.",
        allClassesHintReadonly:
          "Sin restricción: todos los alumnos de la escuela pueden acceder a esta ruta.",
        unlinkDisabledHint:
          "Solo se pueden desvincular clases mientras la ruta está en borrador.",
        keepOneClassHint:
          "Agrega otra clase antes de quitar la última clase vinculada.",
        linkedTitle: "Clases vinculadas a esta ruta ({{count}})",
        noLinked: "Todavía no hay clases vinculadas.",
        addTitle: "Agregar clase",
        restrictTitle: "Restringir a una clase",
        statusLinked: "Vinculada",
        statusUnlinked: "No vinculada",
        addOne: "Vincular {{name}}",
        removeOne: "Desvincular {{name}}",
        noResults: "Ninguna clase coincide con este filtro.",
        loading: "Cargando clases…",
        saveSuccess: "Clases de la ruta actualizadas.",
        saveError: "No se pudieron actualizar las clases.",
      },
      classDetailTitle: "Clase",
      phaseDetailTitle: "Detalles de la fase",
      phaseDescriptionLabel: "Descripción",
      activityDetailTitle: "Detalles de la actividad",
      activityInPhase: "En la fase: {{phase}}",
      stepsLabel: "{{count}} pasos",
      stepsLabelOne: "1 paso",
      orderInPhase: "Orden {{order}} en la fase",
      completionLabel: "Criterio de finalización",
      completionAllSteps: "Completar todos los pasos",
      completionMinScore: "Puntuación mínima del {{score}}%",
      deadlineLabel: "Fecha límite",
      noDescription: "Sin descripción registrada",
      filterTypeTitle: "{{type}} en la ruta",
      filterTypeCount: "{{count}} actividades de este tipo",
      openInEditor: "Abrir en el editor",
      rewardsLabel: "Recompensas",
      finalRewardTitle: "Recompensa final",
      finalRewardValue: "+{{coins}} coins",
      finalRewardGames: "Configurada para {{count}} segmento(s) vinculado(s)",
      curriculumTagsLabel: "Referencias curriculares",
      viewPhase: "Ver fase {{n}}",
      viewActivity: "Ver actividad",
      clearFilter: "Limpiar filtro",
      subjectLabel: "Asignatura",
      updatedLabel: "Actualizada el",
      updatedAtValue: "Actualizada el {{date}}",
      endsAtValue: "Finaliza el {{date}} a las 23:59",
      expiredAtValue: "Expiró el {{date}}",
      expiredNotice: "Los alumnos ya no pueden completar nuevas actividades en esta ruta.",
      tabStructure: "Estructura",
      tabStudentsProgress: "Progreso de los alumnos",
      studentsProgressSummary: "Promedio de la clase en la ruta",
      studentsProgressEligible: "{{count}} elegibles",
      studentsProgressStarted: "{{count}} iniciaron",
      studentsProgressCompleted: "{{count}} completaron",
      studentsProgressActivitiesTotal: "{{count}} actividades en la ruta",
      studentsProgressActivitiesDone: "{{done}} de {{total}} actividades",
      studentsProgressSearch: "Buscar alumno…",
      studentsProgressFilterTurmas: "Clases",
      studentsProgressFilterTurmasSearch: "Buscar clase…",
      studentsProgressFilterTurmasNoResults: "No se encontraron clases",
      studentsProgressFilterTurmasClear: "Limpiar clases",
      studentsProgressEmpty: "No hay alumnos elegibles para esta ruta.",
      studentsProgressNoSearch: "Ningún alumno coincide con este filtro.",
      studentsProgressNoClassFilter: "No hay alumnos en las clases seleccionadas.",
      studentsProgressLoadError: "No se pudo cargar el progreso de los alumnos.",
      studentsProgressUnknownName: "Alumno",
      studentsProgressNoClass: "Sin clase",
      studentDetail: {
        pageTitle: "Progreso del alumno en la ruta",
        back: "Volver",
        backToList: "Volver a la lista de alumnos",
        trailLabel: "Ruta",
        overallProgress: "Progreso general",
        completedAt: "Completó el {{date}}",
        phasesTitle: "Fases y actividades",
        phaseProgress: "{{done}} de {{total}} actividades",
        activityNotStarted: "Aún no realizada",
        activityCompleted: "Completada",
        activityScore: "Puntuación {{score}}",
        loadError: "No se pudo cargar el progreso de este alumno.",
        noPhases: "Esta ruta no tiene fases registradas.",
        backToPhases: "Volver a las fases",
      },
      studentActivity: {
        quizTitle: "Preguntas del quiz",
        writeTitle: "Respuestas escritas",
        flashcardsTitle: "Flashcards",
        flashcardTrueFalseTitle: "Verdadero o falso",
        trueAnswer: "Verdadero",
        falseAnswer: "Falso",
        studentTrueFalseAnswer: "Respuesta del alumno",
        contentTitle: "Contenido",
        missionTitle: "Misión",
        correctAnswer: "Correcta",
        selectedAnswer: "Elegida por el alumno",
        answerNotRecorded: "La respuesta del alumno no se registró.",
        legacySubmissionHint:
          "Esta finalización se realizó antes de que se almacenaran las respuestas detalladas. Las opciones correctas aparecen abajo; es posible que la elección del alumno no esté disponible.",
        questionN: "Pregunta {{n}}",
        scorePercent: "{{score}}% de aciertos",
      },
    },
    list: {
      title: "Rutas",
      loadErrorTitle: "No se pudieron cargar tus rutas",
      loadErrorDescription:
        "Algo salió mal al obtener la lista. Comprueba tu conexión e inténtalo de nuevo.",
      subtitle: "{{count}} rutas · {{published}} publicadas",
      subtitleLoading: "Cargando rutas...",
      createWithAi: "Crear con IA",
      createWithAiShort: "IA",
      createManual: "Crear manual",
      createManualShort: "Manual",
      createWithAiDialog: {
        title: "Crear ruta con IA",
        hint: "Describe el tema, el curso y lo que quieres en la ruta, o añade PDFs e imágenes como fuentes. Abriremos el editor y tu pedido se enviará al chat de IA.",
        placeholder:
          "Ej.: Ruta sobre la Revolución Industrial para 3.º de ESO, con quiz y una misión de investigación…",
        submit: "Crear ruta",
        cancel: "Cancelar",
        promptRequired: "Describe lo que deseas crear o añade un archivo",
      },
      searchPlaceholder: "Buscar rutas...",
      filters: {
        all: "Todas",
      },
      status: {
        draft: "Borrador",
        generating: "Generando",
        published: "Publicada",
        archived: "Archivada",
      },
      columns: {
        title: "Título",
        status: "Estado",
        phases: "Fases",
        classes: "Clases",
        createdAt: "Creada",
        actions: "Acciones",
      },
      mobileMeta: "{{phases}} fases · {{classes}}",
      empty: {
        title: "Crea tu primera ruta",
        description:
          "Usa IA o crea manualmente rutas de aprendizaje gamificadas para tus alumnos.",
      },
      emptyFiltered: {
        title: "No se encontraron rutas",
        description: "Prueba otro término de búsqueda o cambia el filtro de estado.",
      },
      actions: {
        menuLabel: "Acciones",
        select: "Seleccionar",
        edit: "Editar",
        publish: "Publicar",
        unpublish: "Despublicar",
        shareLink: "Enlace de acceso",
        shareLinkDisabledHint: "Publica para habilitar",
        viewReport: "Ver informe",
        delete: "Eliminar",
      },
      selection: {
        selectedCount: "{{count}} seleccionada(s)",
        selectedShort: "seleccionadas",
        toolbarAria: "Acciones de selección múltiple",
        enterMode: "Seleccionar varias",
        enterModeTooltip: "Seleccionar rutas para eliminar en masa",
        selectAll: "Seleccionar todas",
        deselectAll: "Desmarcar todas",
        cancel: "Cancelar selección",
        moreActions: "Más acciones",
        cancelTooltip: "Salir de la selección",
        deleteSelected: "Eliminar seleccionadas ({{count}})",
        deleteTooltip: "Eliminar {{count}} seleccionada(s)",
        cardAria: "Seleccionar ruta {{title}}",
      },
      deleteDialog: {
        title: "Eliminar ruta",
        description:
          "¿Seguro que deseas eliminar \"{{title}}\"? Esta acción no se puede deshacer.",
        cancel: "Cancelar",
        confirm: "Eliminar",
        deleting: "Eliminando...",
      },
      bulkDeleteDialog: {
        title: "Eliminar rutas seleccionadas",
        description:
          "¿Seguro que deseas eliminar {{count}} rutas? Esta acción no se puede deshacer.",
        cancel: "Cancelar",
        confirm: "Eliminar",
        deleting: "Eliminando...",
      },
      qr: {
        copySuccess: "¡Enlace copiado!",
        download: "Descargar QR",
        error: "Error al generar el código QR",
      },
      toast: {
        deleted: "Ruta eliminada",
        deleteError: "Error al eliminar la ruta",
        deletedMany: "{{count}} rutas eliminadas",
        deleteManyError: "No se pudieron eliminar todas las rutas seleccionadas",
        published: "Ruta publicada",
        unpublished: "Ruta despublicada",
        unpublishError: "Error al despublicar la ruta",
      },
      publishing: "Publicando...",
    },
    publish: {
      title: "Publicar ruta",
      description: "Define el plazo y las clases para publicar esta ruta.",
    },
    create: {
      back: "Rutas",
      loadErrorTitle: "No se pudo cargar esta ruta",
      loadErrorDescription:
        "Algo salió mal al abrir la ruta para editar. Inténtalo de nuevo o vuelve a la lista.",
      headerEditor: "Editor",
      saveDraft: "Guardar borrador",
      headerMoreActions: "Más opciones",
      openChat: "Conversar con la IA",
      closeChat: "Cerrar conversación",
      resizeChat: "Redimensionar chat IA",
      resizeChatHint: "Arrastra para ajustar el ancho. Usa las flechas, Home o End. Haz doble clic o pulsa Enter para restaurar el tamaño predeterminado.",
      mobileBackToChat: "Volver al chat",
      mobileViewTrail: "Ver ruta",
      sectionOverview: "Información de la ruta",
      sectionStructure: "Estructura de la ruta",
      metadataPhases: "{{count}} fases",
      metadataActivities: "{{count}} actividades",
      titleNew: "Crear ruta",
      titleEdit: "Editar ruta",
      modeAi: "Crear con IA",
      modeManual: "Crear manualmente",
      preview: "Vista previa",
      panelEdit: "Editar",
      panelPreview: "Vista previa",
      save: "Guardar",
      publish: "Publicar",
      qrCode: "Código QR",
      devJson: "JSON (dev)",
      devJsonDialog: {
        title: "JSON completo de la ruta",
        hint: "Formulario, API, job, visibilidad en la app (estado/turmas) y turmas/segmentos de la escuela (patrón chat-ia). Solo localhost.",
        copy: "Copiar JSON",
        copied: "¡JSON copiado!",
        close: "Cerrar",
      },
      generating: "Generando ruta...",
      generatingProgress: "{{completed}}/{{total}} fases generadas",
      resumingProgress: "Reanudando el seguimiento de la generación…",
      fields: {
        title: "Título",
        titleRequired: "El título es obligatorio para guardar",
        titlePlaceholder: "Nombre de la ruta",
        description: "Descripción",
        descriptionPlaceholder: "Breve descripción",
        subjectLabel: "Asignatura",
        subjectPlaceholder: "Selecciona la asignatura",
        subjectSearchPlaceholder: "Buscar asignatura…",
        subjectNotFound: "No se encontró ninguna asignatura",
        theme: "Tema / contenido",
        themePlaceholder: "Ej: Fracciones, Revolución Francesa",
        grade: "Curso",
        gradePlaceholder: "Ej: 8º curso",
        detailsToggle: "Asignatura, tema y curso",
      },
      subjects: {
        matematica: "Matemáticas",
        portugues: "Portugués",
        ingles: "Inglés",
        espanhol: "Español",
        ciencias: "Ciencias",
        fisica: "Física",
        quimica: "Química",
        biologia: "Biología",
        historia: "Historia",
        geografia: "Geografía",
        filosofia: "Filosofía",
        sociologia: "Sociología",
        ed_fisica: "Educación Física",
        arte: "Arte",
        musica: "Música",
        computacao: "Tecnología",
        financas: "Finanzas",
        redacao: "Redacción",
        religiao: "Religión",
        outra: "Otra",
      },
      moreActions: "Más acciones",
      publishDialog: {
        optionsTitle: "¡Ruta lista! 🎉",
        optionsDescription: "¿Cómo quieres usar esta ruta ahora?",
        title: "Enviar como tarea",
        classesLabel: "Clases",
        classesHint: "Selecciona las clases que tendrán acceso a esta ruta",
        noClasses: "No se encontraron clases",
        finalRewardLabel: "Recompensa final",
        finalRewardValue:
          "{{coins}} coins al completar la ruta ({{count}} segmentos vinculados)",
        finalRewardNone: "Sin coins finales configurados",
        cancel: "Cancelar",
        confirm: "Publicar",
      },
      finalReward: {
        title: "Recompensa final en coins",
        description:
          "Define cuántos coins recibe el alumno al completar todas las fases de la ruta. Esta recompensa se paga una sola vez.",
        coinsLabel: "Coins al completar",
        coinsPlaceholder: "Ej: 50",
        toggleLabel: "Activar recompensa final",
        activeHint:
          "La recompensa se vinculará a {{count}} segmentos de las clases seleccionadas. Sin clases seleccionadas, aplica a todas las clases.",
        disabledHint: "Actívala para configurar una recompensa final en coins.",
        emptyEnabledHint: "Ingresa la cantidad de coins para activar la recompensa final.",
        noGamesHint:
          "No se encontraron segmentos en las clases seleccionadas. La ruta puede publicarse, pero los coins no se generarán hasta que haya segmentos vinculados.",
        lockedTitle: "Disponible en planes con recompensas.",
        lockedDescription:
          "Esta configuración queda bloqueada en el plan actual, pero las rutas existentes mantienen su contrato de recompensa.",
      },
      previewIframeTitle: "Vista previa de la ruta en la app del alumno",
      previewIframePreparing: "Preparando la vista previa de la app…",
      previewDialog: {
        title: "Vista previa en la app",
        emptyPhases: "Añade fases para visualizar",
        start: "INICIAR",
      },
      unsavedChangesConfirm:
        "Tienes cambios sin guardar. ¿Seguro que quieres salir?",
      toast: {
        saved: "Ruta guardada",
        saveError: "Error al guardar",
        generateError: "Error al generar la ruta",
        published: "¡Ruta publicada!",
        publishError: "Error al publicar la ruta. Inténtalo de nuevo.",
        contentMissingTitle: "Hay actividades sin contenido",
        contentMissingHelp: "Añade texto, una imagen, un vídeo o un archivo a las actividades indicadas e inténtalo de nuevo.",
        contentMissingPhase: "Fase {{number}}",
        contentMissingPhaseUnknown: "Fase no identificada",
        contentMissingUntitled: "Actividad sin título",
        turmasWithoutSegment: "No se pudo publicar: la(s) clase(s) {{turmas}} no tienen segmento definido o tienen un segmento eliminado. Define un segmento valido para esas clases (en Clases) antes de publicar; de lo contrario los alumnos no reciben la recompensa.",
        linkCopied: "¡Enlace copiado!",
      },
      qr: {
        title: "Código QR",
        download: "Descargar QR",
      },
    },
    addMenu: {
      manual: "Añadir manualmente",
      withAi: "Añadir con IA",
      aiDialogTitle: "Describe qué añadir",
      aiDialogHint:
        "Tu mensaje se enviará al chat de IA con el contexto de dónde estás en el editor.",
      aiPromptPlaceholder: "Ej.: un quiz de 3 preguntas sobre alimentación saludable…",
      sendToChat: "Enviar al chat",
      cancel: "Cancelar",
      sentToChat: "Solicitud enviada al chat de IA",
      aiUnavailable: "Usa el modo IA o edita una ruta guardada para añadir con el asistente",
    },
    chat: {
      title: "Professor Gamefik",
      subtitle: "Copiloto de Gamefik",
      welcomeNew:
        "¡Hola! Soy el Professor Gamefik, tu copiloto para crear rutas. Describe el tema o contenido que quieres convertir en una ruta de aprendizaje.",
      placeholderNew: "Ej: Brasil colonial, 8º curso",
      placeholderEdit: "Pide un ajuste en esta fase...",
      suggestionsLabel: "Acciones rápidas",
      quickChipAddActivity: "+ Añadir actividad",
      quickChipMoreContent: "Más contenido",
      quickChipReorder: "Reordenar actividades",
      quickChipDeletePhase: "Eliminar fase",
      quickChipMorePhases: "Añadir más fases",
      quickChipDifficulty: "Cambiar nivel de dificultad",
      quickChipRewards: "Añadir recompensas",
      quickChipReformulate: "Reformular actividades",
      phaseProgress: "Fase {{completed}} de {{total}} generada",
      generationStarted:
        "Voy a crear tu ruta según lo que describiste. Sigue el progreso de las fases abajo.",
      runQueued: "Solicitud recibida. La ejecución continuará aunque cierres esta pestaña.",
      v2: {
        placeholder: "Conversa sobre la ruta o pide un cambio…",
        pdfStudyTitle: "Usar como base de estudio",
        pdfStudyDescription: "Crear explicaciones y actividades a partir de los materiales enviados.",
        pdfCopyTitle: "Copiar los ejercicios 1:1",
        pdfCopyDescription: "Mantener enunciados, opciones y orden de los ejercicios, sin reescribir.",
        title: "Chat IA v2",
        legacy: "Chat anterior",
        versionLabel: "Versión del chat",
        draftTitle: "Nueva ruta",
        running: "La IA está preparando la ruta completa con el contexto de la conversación.",
        subtitle: "Conversación completa y ruta en el mismo contexto",
        historyError: "No se pudo cargar la conversación. Inténtalo de nuevo antes de enviar un mensaje.",
        retry: "Intentar de nuevo",
        source: "Contexto del material {{count}} usado por la IA",
      },
      runRecovering: "Retomando la ejecución guardada en el servidor…",
      runRunning: "La IA está trabajando en este cambio. Puedes cerrar la pestaña y volver después.",
      runRunningProgress: "Ejecución en curso: {{completed}} de {{total}} fases completadas.",
      generationDone: "¡Generación completada! Ya puedes ver y editar las fases.",
      generationError: "Error en la generación: {{error}}. Inténtalo de nuevo.",
      sendError: "Error al enviar el mensaje. Inténtalo de nuevo.",
      noCreditsError:
        "Tus créditos de IA se agotaron. Necesarios: {{needed}}. Disponibles: {{remaining}}. Contrata un plan o agrega créditos para continuar.",
      actionApplied: "Cambio aplicado en la ruta. Revísalo en el editor.",
      sendAria: "Enviar mensaje",
      addAttachment: "Añadir PDF o imagen",
      removeAttachment: "Eliminar archivo {{name}}",
      attachmentsOnlyPrompt: "Usa los archivos adjuntos como fuentes para crear o actualizar la ruta.",
      uploadProgress: "Subiendo archivos",
      attachmentRejected: {
        type: "El archivo \"{{name}}\" no es compatible. Usa PDF o imagen.",
        empty: "El archivo \"{{name}}\" está vacío.",
        size: "El archivo \"{{name}}\" supera el límite de 50 MB.",
        count: "El límite es de 4 archivos por mensaje.",
        total: "Los archivos superan el límite total de 100 MB.",
      },
      memoryManage: "Memorias",
      memoryManageAria: "Gestionar memorias del asistente",
      aiSettingsTrigger: "IA",
      aiSettingsManageAria: "Configurar tipos de actividad generados por IA",
      aiSettingsTitle: "Generación por tipo de actividad",
      aiSettingsDescription:
        "Elige qué tipos puede crear el asistente al generar o editar rutas con IA.",
      aiSettingsLocalhostOnly: "Visible solo en localhost. Los valores se guardan en el navegador.",
      aiSettingsReset: "Restaurar valores predeterminados",
      memoryDialogTitle: "Memorias guardadas",
      memoryDialogDescription:
        "Datos generales que el asistente recuerda sobre ti en esta escuela. Las preferencias de formato (p. ej. sin misiones) se aplican en generaciones con IA; tema y estructura siguen lo que pidas en cada ruta.",
      memoryEmpty:
        "Aún no hay memorias guardadas. Habla con el asistente — puede anotar tu público, preferencias y otros detalles estables.",
      memoryLoadError: "No se pudieron cargar las memorias.",
      memoryRetry: "Reintentar",
      memoryDeleteAria: "Eliminar memoria",
      memoryCategoryIdentity: "Identidad",
      memoryCategoryAudience: "Público",
      memoryCategoryPreferences: "Preferencias",
      memoryCategoryTeaching: "Enseñanza",
      memoryCategoryOther: "Otro",
      memoryAddSection: "Añadir memoria",
      memoryAdd: "Añadir",
      memoryCategoryLabel: "Categoría",
      memoryCustomCategoryLabel: "Nombre de la categoría",
      memoryCustomCategoryPlaceholder: "Ej.: Metodología / Rutina de la clase",
      activitySuggestionTitle: "Parece una actividad suelta",
      activitySuggestionDescription:
        "Los quizzes, misiones y flashcards sueltos se crean en el Chat IA. ¿Quieres continuar allí con esta solicitud?",
      activitySuggestionGo: "Crear en el Chat IA",
      activitySuggestionStay: "Continuar como ruta",
      memoryContentLabel: "Descripción",
      memoryAddPlaceholder: "Ej.: Trabajo con 7.º de ESO",
      memoryAddEmpty: "Escribe una descripción para guardar.",
      memoryAddTooLong: "Máximo {{max}} caracteres.",
      memoryAddError: "No se pudo guardar. Prueba otra descripción.",
      memoryMaxReached: "Límite de {{max}} memorias alcanzado. Elimina una para añadir otra.",
      pdfUsage: {
        legend: "¿Cómo quieres usar este PDF?",
        required: "Elección obligatoria",
        description: "Elige una opción para continuar.",
        inspirationTitle: "Usar como inspiración",
        inspirationDescription: "Usa las ideas del material para crear o adaptar la ruta.",
        faithfulTitle: "Copiar fielmente",
        faithfulDescription: "Mantiene el orden y el contenido del documento.",
        faithfulSelectedDescription:
          "Los contenidos, cuestionarios y tarjetas usarán solo lo presentado en el PDF.",
        faithfulMultipleError:
          "Para una copia fiel, adjunta solo un PDF a la vez, sin imágenes ni archivos adicionales.",
        selected: "Modo elegido: {{mode}}",
      },
      pdfChapters: {
        analysisErrorTitle: "No pude analizar los capítulos del PDF",
        analysisErrorDescription:
          "El archivo sigue adjunto. Comprueba tu conexión e intenta analizarlo de nuevo.",
        retry: "Intentar analizar de nuevo",
        multipleTitle: "Envía un PDF a la vez para organizar por capítulos",
        multipleDescription:
          "Hay más de un PDF adjunto. Puedes generar con todos los archivos sin organización por capítulos o reenviar solo un PDF para elegir los capítulos.",
        changeFiles: "Cambiar archivos",
        notFoundTitle: "No pude identificar capítulos de forma fiable",
        notFoundDescription:
          "Aún puedes generar una ruta con el PDF completo, pero no se organizará por capítulos.",
        faithfulNoHierarchyDescription:
          "El PDF tiene texto buscable, pero no contiene capítulos identificables. Puedes copiar el documento completo conservando el orden y el contenido de las páginas.",
        ocrRequiredDescription:
          "Este PDF parece estar escaneado y necesita reconocimiento de texto. Aún puedes generar una ruta con el archivo completo.",
        generateNormally: "Generar con el PDF completo",
        copyFullPdf: "Copiar el PDF completo",
        choiceTitle: "Encontré {{count}} capítulos en el PDF",
        choiceDescription:
          "El archivo tiene {{pages}} páginas. Elige cómo quieres transformar el contenido en una ruta.",
        completeTitle: "Crear una ruta completa",
        completeDescription: "Se creará una fase por capítulo, en {{count}} fases.",
        completeGroupedDescription:
          "Se crearán {{count}} fases (el máximo es 10), agrupando capítulos contiguos en una misma fase.",
        generateComplete: "Generar ruta completa",
        specificTitle: "Usar solo un capítulo",
        specificDescription: "Elige el capítulo que se usará como fuente de la ruta.",
        chapterOption: "Capítulo {{order}} — {{title}}",
        generateSpecific: "Generar con este capítulo",
        faithfulUnsupportedTitle: "No se puede copiar este PDF con fidelidad",
        faithfulOcrError: "No fue posible reconocer suficiente contenido en este PDF. Prueba con un archivo más nítido o elige usarlo como inspiración.",
        faithfulMultipleError: "La copia fiel acepta exactamente un PDF a la vez. Cambia los archivos o elige usarlos como inspiración.",
        useInspirationInstead: "Usar como inspiración",
        scopeTitle: "¿Qué parte del PDF deseas usar?",
        scopePlaceholder: "Selecciona el PDF, un macrogrupo o un capítulo",
        fullPdfOption: "PDF completo",
        groupOption: "Macrogrupo — {{title}}",
        childOption: "↳ {{parent}} — {{title}}",
        leafOption: "Capítulo — {{title}}",
        scopeHint: "Elige el PDF completo, un macrogrupo o un capítulo específico.",
        groupDescription: "Este macrogrupo tiene {{count}} capítulos. Se creará una fase por cada capítulo hijo.",
        groupGroupedDescription: "Este macrogrupo tiene {{count}} capítulos. Para respetar el máximo de {{phases}} fases, se agruparán capítulos hijos contiguos.",
        leafDescription: "La ruta se creará solo con el contenido de “{{title}}”.",
        generateSelection: "Generar con esta selección",
      },
      userFallback: "Tú",
    },
    editor: {
      phaseLabel: "Fase {{n}}",
      activityCount: "{{count}} actividades",
      activityCountOne: "1 actividad",
      updating: "Actualizando...",
      removing: "Eliminando...",
      generatingContent: "Generando contenido...",
      generatingPhase: "Generando nueva fase...",
      addActivity: "Añadir actividad",
      dropInPhase: "Suelta en Fase {{n}}: {{title}}",
      dragReorderInPhase: "Reordenando «{{title}}» en Fase {{phase}}",
      dragMoveToPhase:
        "Moviendo «{{title}}» de Fase {{from}} a Fase {{to}}: {{phaseName}}",
      addPhase: "Añadir fase",
      deletePhase: "Eliminar fase",
      deleteActivity: "Eliminar actividad",
      renamePhase: "Renombrar fase",
      moveActivityUp: "Mover actividad hacia arriba",
      moveActivityDown: "Mover actividad hacia abajo",
      movePhaseUp: "Mover fase hacia arriba",
      movePhaseDown: "Mover fase hacia abajo",
      activityActionsLabel: "Más acciones de la actividad",
      phaseActionsLabel: "Más acciones de la fase",
      expandPhase: "Expandir fase",
      collapsePhase: "Contraer fase",
      activityRemovedToast: "Actividad eliminada",
      phaseRemovedToast: "Fase eliminada",
      undo: "Deshacer",
      tasksCount: "{{count}} tareas",
      tasksCountOne: "1 tarea",
      blocksCount: "{{count}} bloques",
      blocksCountOne: "1 bloque",
      deletePhaseDialog: {
        title: "Eliminar fase",
        description:
          "¿Eliminar \"{{title}}\" y todas las actividades de esta fase? Esta acción no se puede deshacer.",
        cancel: "Cancelar",
        confirm: "Eliminar",
      },
      activityModal: {
        written: {
          add: "Añadir pregunta escrita",
          title: "Respuesta escrita · corrección automática con IA",
          hint: "La IA evalúa la respuesta del alumno y explica la corrección. El resultado cuenta para la puntuación del quiz y sigue el criterio de finalización seleccionado.",
          expectedAnswer: "Respuesta esperada (opcional)",
          expectedPlaceholder: "Ej.: pharmacy o drugstore. Aceptar respuestas equivalentes.",
          expectedHint: "Orienta a la IA con la respuesta esperada y los criterios de aceptación. Sin referencia, la IA usa el enunciado. El alumno no ve esta orientación.",
          correto: "Correcto",
          incorreto: "Incorrecto",
          incompleto: "Incompleto",
          review: "Corrección automática con IA",
        },
        title: "Editar actividad",
        editTypeTitle: "Editar {{type}}",
        save: "Guardar cambios",
        close: "Cerrar",
        titlePlaceholder: "Escribe el título",
        markCorrectHint: "haz clic en el círculo para marcar correcta",
        questionLabel: "Pregunta {{n}}",
        questionOf: "de {{total}}",
        contentHint: "Añade texto, vídeos o archivos para que los alumnos estudien",
        flashcardFrontPlaceholder: "Escribe la pregunta o término…",
        flashcardBackPlaceholder: "Escribe la respuesta o explicación…",
        flashcardFlipHint: "Haz clic en la tarjeta para girar",
        flashcardOf: "Tarjeta {{current}} de {{total}}",
        hintPlaceholder: "Pista para el alumno",
        missionDescriptionPlaceholder: "Describe lo que el alumno debe hacer en esta tarea…",
        addMissionStep: "Añadir etapa",
        removeBlock: "Eliminar bloque {{n}}",
        fields: {
          title: "Título de la actividad",
          type: "Tipo",
          completion: "Criterio de finalización",
          minScore: "Mín. %",
        },
        types: {
          quiz: "Quiz",
          flashcard: "Flashcard",
          flashcard_true_false: "Verdadero o falso",
          content: "Contenido",
          mission: "Misión",
        },
        trueLabel: "Verdadero",
        falseLabel: "Falso",
        trueFalseCorrectLabel: "Respuesta correcta",
        addTrueFalseCard: "Añadir tarjeta",
        completion: {
          allSteps: "Todos los pasos",
          minScore: "Puntuación mínima",
        },
        steps: "Pasos ({{count}})",
        addQuestion: "Añadir pregunta",
        addFlashcard: "Añadir flashcard",
        addBlock: "Añadir bloque",
        stepLabels: {
          question: "Pregunta {{n}}",
          flashcard: "Flashcard {{n}}",
          block: "Bloque {{n}}",
          task: "Tarea {{n}}",
        },
        statementLabel: "Enunciado",
        statementPlaceholder: "Enunciado de la pregunta",
        alternativesLabel: "Alternativas",
        alternativePlaceholder: "Alternativa {{n}}",
        markCorrect: "Marcar alternativa {{n}} como correcta",
        removeAlternative: "Eliminar alternativa {{n}}",
        removeQuestion: "Eliminar pregunta {{n}}",
        addAlternative: "Añadir alternativa",
        front: "Frente",
        back: "Volver a la ruta",
        cardBack: "Reverso",
        hint: "Pista (opcional)",
        contentMd: "Contenido (Markdown)",
        contentRich: "Contenido",
        missionDescription: "Descripción de la tarea",
        mediaUrl: "URL de medio (opcional)",
        media: {
          label: "Medio (opcional)",
          hint: "Imagen, vídeo, PDF, audio, hoja de cálculo u otros archivos — como en crear misión con IA.",
          dropzoneTitle: "Haz clic o arrastra el archivo aquí",
          dropzoneSubtitle: "Vídeo, PDF, imágenes, audio, CSV, Excel y más",
          remove: "Quitar",
          uploading: "Subiendo archivo…",
          uploaded: "Medio guardado.",
          uploadError: "Error al subir el archivo.",
          previewTitle: "Vista previa",
          loadingPreview: "Cargando vista previa…",
          noPreview: "Vista previa no disponible para este tipo.",
          noTablePreview: "No se pudo leer la hoja de cálculo.",
          openFile: "Abrir archivo",
        },
        verification: "Verificación",
        verificationTeacher: "Aprobación del profesor",
        verificationPhoto: "Foto",
        verificationAuto: "Automática",
      },
      chooseActivityType: {
        title: "Tipo de actividad",
        hint: "Elige el formato antes de añadirlo a la fase.",
      },
      activityTypes: {
        quiz: "Quiz",
        flashcard: "Flashcard",
        flashcardTrueFalse: "Verdadero o falso",
        content: "Contenido",
        mission: "Misión",
      },
      stepsCount: "{{count}} pasos",
      stepsCountOne: "1 paso",
      cardsCount: "{{count}} tarjetas",
      cardsCountOne: "1 tarjeta",
    },
  },
  exportButton: {
    exportData: "Exportar datos",
    records: "{count} registros",
    exportError: "Error al exportar datos",
  },
  rewardsShoppingDomain: {
    pageSubtitle: "Gestiona el catálogo de recompensas y sigue los pedidos de los alumnos.",
    redeemError: "Ocurrió un error al procesar tu solicitud",
    rewardDeletedSuccess: "Recompensa eliminada con éxito.",
    newRewardTitle: "Nueva Recompensa",
    confirmDeleteTitle: "Confirmar eliminación",
    confirmDeleteDescription: "¿Estás seguro de que deseas eliminar las siguientes recompensas?",
    cancelButton: "Cancelar",
    pageTitle: "Recompensas | Gamefik Escuelas al máximo nivel.",
    browse: "Buscar",
    removeImage: "Eliminar",
    productNamePlaceholder: "Nombre que aparecerá para los alumnos",
    description: "Descripción",
    descriptionPlaceholder: "Breve descripción del artículo",
    selectCategory: "Categoría",
    quantity: "Cantidad disponible",
    quantityPlaceholder: "Cantidad de inventario",
    limitPerPlayer: "Límite por jugador",
    allGames: "¿En qué segmentos es aplicable esta recompensa?",
    scheduledStart: "Programar",
    noStoreGames: "¡Sin segmentos!",
    outOfStoreStock: "Fuera de la tienda",
    rewardsGeneratorClose: "Cerrar",
    rewardsDialogDescription: "Elige las recompensas que desea canjear",
    redeemSuccess: "Recompensas canjeadas con éxito.",
    editRewardPageTitle: "Editar recompensa | Gamefik Escuelas al máximo nivel.",
    noButton: "No",
    rarityCommonName: "común",
    rarityUncommonName: "poco común",
    rarityRareName: "raro",
    rarityEpicName: "épico",
    rarityLegendaryName: "legendario",
    rarityCommonTime: "Tiempo hasta el canje: 1 a 2 semanas",
    rarityUncommonTime: "Tiempo hasta el canje: 2 a 4 semanas",
    rarityRareTime: "Tiempo hasta el canje: 1 a 3 meses",
    rarityEpicTime: "Tiempo hasta el canje: 3 a 6 meses",
    rarityLegendaryTime: "Tiempo hasta el canje: 6 a 10 meses",
    uploadImage: "Suba una imagen",
    rarityImportantInfo: "Información importante sobre la rareza de la recompensa",
    useThisValue: "🪙 Usar este valor 🪙",
    defineValueIn: "Defina el valor en {{point}}",
    savingReward: "Espere, guardando recompensa...",
    fillRewardName: "Completa el nombre de la recompensa",
    fillRewardDescription: "Completa la descripción de la recompensa",
    fillAvailableQuantity: "Completa la cantidad disponible",
    selectAtLeastOneGame: "Selecciona al menos un segmento",
    saveButton: "Guardar",
    insufficientScore: "El alumno no tiene puntuación suficiente para esta compra.",
    duplicatedTransaction: "Transacción duplicada.",
    insufficientBalance: "Saldo insuficiente para esta recompensa.",
    rewardNotFound: "Recompensa no encontrada o no disponible.",
    playerNotFound: "Jugador no encontrado.",
    gameNotFound: "Segmento no encontrado.",
    rewardAlreadyRedeemed: "La recompensa ya ha sido canjeada anteriormente.",
    purchaseFinishError: "Hubo un error al finalizar esta compra. Verifica su conexión e intente de nuevo.",
    playerNotLinked: "El jugador seleccionado no está vinculado a un segmento.",
    cannotAssignMultipleGames: "No es posible asignar recompensas a alumnos vinculados en segmentos diferentes.",
    allOthersRedeemed: "Todas las demás recompensas fueron canjeadas correctamente.",
    errorRedeemingReward: "Error al canjear la recompensa",
    forPlayer: "para el",
    errorType: "Tipo",
    errorDetails: "Detalles",
    genericError: "Error Genérico",
    duplicatedTransactionType: "Transacción Duplicada",
    insufficientBalanceType: "Saldo Insuficiente",
    rewardNotFoundType: "Recompensa No Encontrada",
    playerNotFoundType: "Jugador No Encontrado",
    gameNotFoundType: "Segmento No Encontrado",
    alreadyRedeemedType: "Recompensa Ya Canjeada",
    technicalError: "Error Técnico",
    unknownError: "Error desconocido.",
    startCreatingRewards: "Comienza creando tu primera recompensa para motivar a tus alumnos.",
    gameLabel: "Segmento",
    classLabel: "Clase",
    totalLabel: "Total",
    selectItemAria: "seleccionar ítem",
    internalError: "Ocurrió un problema interno.",
    invalidProductCode: "Código de producto inválido. Verifica si el producto aún está disponible.",
    insufficientBalancePurchase: "Saldo insuficiente para realizar la compra.",
    playerNotFoundPurchase: "Jugador no encontrado. Verifica si el jugador aún está activo.",
    gameNotFoundPurchase: "Segmento no encontrado. Verifica si el segmento aún está activo.",
    purchaseAlreadyProcessed: "Este pedido ya fue procesado anteriormente.",
    processingError: "Ocurrió un error al procesar el pedido. Contacte al soporte.",
    connectionError: "Problema de conexión. Verifica su internet e intente de nuevo.",
    timeoutError: "La operación tardó demasiado en responder. Intente de nuevo.",
    serverError: "Error de comunicación con el servidor.",
    receiptMessageTitle: "Mensaje del recibo",
    readAndAcceptTerms: "He leído y acepto los términos de uso",
    finishWithBalance: "Finalizar con Saldo",
    clearCart: "Vaciar",
    termsIntroTitle: "1. INTRODUCCIÓN",
    termsIntroText: "Al optar por agregar saldo a su cuenta Gamefik, usted acepta los siguientes Términos de Uso. Estos términos abordan las reglas asociadas con la adición de saldos, compra de Gift Cards y otros aspectos relevantes.",
    termsServiceTitle: "2. DESCRIPCIÓN DEL SERVICIO",
    termsServiceText: "Gamefik ofrece a los usuarios la opción de agregar saldo a su cuenta y luego utilizar ese saldo para adquirir Gift Cards de varias empresas asociadas.",
    termsAddBalanceTitle: "3. AGREGANDO SALDO",
    termsAddBalanceMinValue: "a) El monto mínimo para agregar saldo es de R$50,00.",
    termsAddBalanceRefund: "b) Si lo desea, el usuario podrá solicitar el reembolso total del saldo agregado dentro de los 7 días posteriores a la compra, siempre que no se haya adquirido ningún Gift Card.",
    termsGiftCardsTitle: "4. ADQUISICIÓN DE GIFT CARDS",
    termsGiftCardsNoReturn: "a) Una vez adquirido un Gift Card, no puede ser devuelto ni reembolsado.",
    termsGiftCardsCodes: "b) Los códigos de los Gift Cards solo serán visibles para el jugador en el momento de la compra confirmada. Estos códigos no son accesibles a través de la interfaz de gestión.",
    termsGiftCardsUnique: "c) El código es único y se genera solo una vez, en el acto de compra por el jugador.",
    termsGiftCardsProblems: "d) Si hay problemas con el código, el jugador deberá verificar el procedimiento de activación o contactar directamente con la empresa proveedora del Gift Card.",
    termsGiftCardsIntermediary: "e) Gamefik actúa solo como intermediaria en la venta de Gift Cards, y los códigos son proporcionados por las respectivas empresas. No nos responsabilizamos por eventuales problemas con los códigos.",
    termsResponsibilitiesTitle: "5. RESPONSABILIDADES Y OBLIGACIONES DEL USUARIO",
    termsResponsibilitiesA: "a) El usuario es responsable de todas las transacciones realizadas en su cuenta.",
    termsResponsibilitiesB: "b) Gamefik se reserva el derecho de bloquear el saldo y funciones de la tienda si el cliente está en mora con la plataforma.",
    termsResponsibilitiesC: "c) Al cancelar la suscripción de Gamefik, el usuario perderá el acceso y derechos sobre el saldo y los Gift Cards adquiridos.",
    termsIPTitle: "6. PROPIEDAD INTELECTUAL",
    termsIPText: "Todos los derechos, títulos e intereses asociados al servicio Gamefik, incluyendo, pero no limitado a su diseño, texto, gráficos y todos los softwares y códigos asociados, son propiedad de Gamefik.",
    termsPrivacyTitle: "7. POLÍTICA DE PRIVACIDAD",
    termsPrivacyText: "Al aceptar estos términos, usted acepta nuestra Política de Privacidad. Recomendamos leer nuestra Política de Privacidad disponible en nuestro sitio web.",
    termsChangesTitle: "8. CAMBIOS EN LOS TÉRMINOS",
    termsChangesText: "Estos Términos de Uso pueden actualizarse ocasionalmente. Al continuar utilizando el servicio después de cualquier actualización, usted acepta los nuevos términos. Notificaremos a los usuarios sobre cualquier cambio significativo a través de los canales de comunicación habituales.",
    boletoPix: "Boleto/Pix",
    boletoMethod: "Boleto",
    creditCardPayment: "Tarjeta de crédito",
    adminPayment: "Admin",
    pixPayment: "PIX",
    notInformed: "No informado",
    giftPurchaseType: "Compra de Gift",
    refundType: "Reembolso",
    userOrigin: "Usuario",
    adminAddBalance: "Admin - Agregar saldo",
    adminRemoveBalance: "Admin - Eliminar saldo",
    balancePayment: "Saldo",
    recommendCoinsOnly: "Recomendamos que se asigne solo valor en monedas a las recompensas, para que el jugador no pierda experiencia. ¿Desea continuar?",
    invalidProductType: "Producto Inválido",
    orderAlreadyProcessedType: "Pedido Ya Procesado",
    connectionProblemType: "Problema de Conexión",
    timeoutType: "Timeout",
    communicationErrorType: "Error de Comunicación",
    basicInfo: "Información Básica",
    descriptionLabel2: "Descripción:",
    noDescription: "Sin descripción",
    typeLabel: "Tipo:",
    rewardType: "Recompensa",
    priceLabel: "Precio:",
    giftCardValue: "Valor del Gift Card:",
    datesLabel: "Fechas",
    createdAtLabel: "Creado en:",
    lastUpdateLabel: "Última actualización:",
    statusAndStock: "Estado e Inventario",
    statusLabel: "Estado:",
    inStockLabel: "En stock",
    outOfStockLabel: "Fuera de stock",
    indicatorsLabel: "Indicadores:",
    noGameSelected: "Ningún segmento seleccionado",
    priceLabel2: "Precio",
    availableStockLabel: "Stock disponible",
    creationDateLabel: "Fecha de creación:",
    priceLabel3: "Precio:",
    confirmDeletion: "Confirmar eliminación",
    confirmDeletionDescription: "¿Estás seguro de que deseas eliminar las siguientes recompensas?",
    cancelAction: "Cancelar",
    rewardsPageTitle: "Recompensas | Gamefik Escuelas al máximo nivel.",
    tipCreateRewards: "Crea recompensas atractivas",
    tipCreateRewardsDesc: "Ofrezca recompensas variadas que motiven diferentes tipos de alumnos.",
    tipCreateRewardsPlaceholder: "Video mostrando cómo crear recompensas efectivas",
    tipStrategicPrices: "Configura precios estratégicos",
    tipStrategicPricesDesc: "Equilibra el valor de las monedas para mantener la participación sin hacer las recompensas demasiado fáciles.",
    tipStrategicPricesPlaceholder: "Video sobre estrategias de precios de recompensas",
    tipAISuggestions: "Use la IA para sugerencias",
    tipAISuggestionsDesc: "Aproveche la generación automática de recompensas para ahorrar tiempo.",
    tipAISuggestionsPlaceholder: "Video tutorial sobre cómo usar IA para crear recompensas",
    tipMonitorStock: "Monitoree el inventario",
    tipMonitorStockDesc: "Mantenga control sobre las recompensas disponibles y reponga cuando sea necesario.",
    tipMonitorStockPlaceholder: "Video sobre gestión de inventario de recompensas",
    tipAnalyzePopularity: "Analice la popularidad",
    tipAnalyzePopularityDesc: "Vea cuáles recompensas son más buscadas y ajuste su estrategia.",
    tipAnalyzePopularityPlaceholder: "Video sobre análisis de datos de recompensas",
    errorProcessingRequest: "Ocurrió un error al procesar tu solicitud",
    editButton: "Editar",
    editReward: "Editar recompensa",
    deleteButton: "Eliminar",
    newReward: "Nueva Recompensa",
    editRewardTitle: "Editar Recompensa",
    myStore: "Mi Tienda",
    // redesign page
    redesignPageTitle: "Recompensas — Gamefik",
    newRewardShort: "Nueva",
    filterAllRewards: "Todas",
    filterActiveRewards: "Activas",
    filterInactiveRewards: "Inactivas",
    filters: "Filtros",
    activeFilter: "{{count}} filtro activo",
    activeFilters: "{{count}} filtros activos",
    segmentFilter: "Segmento",
    allSegments: "Todos los segmentos",
    rewardFilter: "Recompensa",
    allRewards: "Todas las recompensas",
    classFilter: "Clase",
    allClasses: "Todas las clases",
    periodFilter: "Período",
    allDates: "Cualquier fecha",
    today: "Hoy",
    last7Days: "Últimos 7 días",
    last30Days: "Últimos 30 días",
    clearFilters: "Limpiar filtros",
    viewList: "Ver en lista",
    viewGrid: "Ver en cuadrícula",
    statementTab: "Extracto",
    // stock de gift cards comprados (cart-checkout) — sección en la pestaña Recompensas
    giftStockTitle: "Gift cards comprados",
    giftStockSubtitle: "Tu stock pagado. Publícalo en la tienda para que los alumnos lo canjeen con monedas.",
    giftStockAvailable: "{{count}} disponible",
    giftStockAvailablePlural: "{{count}} disponibles",
    giftStockPublishedBadge: "En la tienda",
    giftStockPublishCta: "Publicar en la tienda",
    giftStockModalTitle: "Publicar gift card en la tienda",
    giftStockModalDescription: "Define cuántas monedas pagan los alumnos para canjear este gift card.",
    giftStockPriceLabel: "Precio en monedas",
    giftStockQuantityLabel: "Cantidad a publicar",
    giftStockLimitLabel: "Límite por alumno",
    giftStockClassesLabel: "Clases",
    giftStockSelectAllClasses: "Todas las clases",
    giftStockSubmit: "Publicar",
    giftStockSubmitting: "Publicando...",
    giftStockSuccess: "¡Gift card disponible en la tienda!",
    giftStockError: "No se pudo publicar el gift card. Inténtalo de nuevo.",
    statementLoadError: "No se pudo cargar el extracto.",
    statementRetry: "Intentar de nuevo",
    statementShowMore: "Ver {{count}} ítems más",
    statementShowLess: "Ver menos",
    searchRewardPlaceholder: "Buscar recompensa...",
    searchOrdersPlaceholder: "Buscar pedido o alumno...",
    tryAnotherSearch: "Intenta buscar por otro nombre",
    noRewardsRegistered: "Sin recompensas registradas",
    clickToCreateFirstReward: "Haz clic en Nueva Recompensa para comenzar",
    noOrdersFound: "No se encontraron pedidos",
    adjustFilters: "Intenta ajustar los filtros",
    ordersWillAppearHere: "Los pedidos de los alumnos aparecerán aquí",
    statusUpdatedSuccess: "Estado actualizado con éxito",
    statusUpdatedError: "Error al actualizar el estado",
    rewardDeletedSuccessMsg: "Recompensa eliminada con éxito",
    rewardDeletedErrorMsg: "Error al eliminar la recompensa",
  },
  schoolDetails: {
    active: "Activa",
    inactive: "Inactiva",
    email: "Correo electrónico",
    status: "Estado",
    engagement: "Participación",
    noTags: "Sin etiquetas",
  },
  exportModal: {
    exportTitle: "Exportar datos",
    selectColumns: "Seleccionar columnas",
    selectAll: "Seleccionar todas",
    deselectAll: "Deseleccionar todas",
    export: "Exportar",
    cancel: "Cancelar",
    exporting: "Exportando...",
    recommendedForAnalysis: "Recomendado para análisis",
    compatibleWithAny: "Compatible con cualquier programa",
    noSorting: "Sin ordenación",
    descending: "Descendente",
    ascending: "Ascendente",
    exportSummary: "Resumen de exportación",
  },
  filterTable: {
    searchPlaceholder: "Buscar...",
    noResults: "No se encontraron resultados",
    showing: "Mostrando",
    of: "de",
    results: "resultados",
    previous: "Anterior",
    next: "Siguiente",
  },
  selectFrequency: {
    daily: "Diariamente",
    weekly: "Semanalmente",
    biweekly: "Quincenal",
    monthly: "Mensualmente",
    selectFrequency: "Frecuencia",
    monToFri: "Lun. a Vie.",
    custom: "Personalizado",
    daysOfWeek: "Días de la Semana",
  },
  multipleSelect: {
    selectAll: "Seleccionar todos",
    deselectAll: "Deseleccionar todos",
    selected: "seleccionado(s)",
    search: "Buscar...",
    allClassesCanSee: "Todas las clases podrán ver esta misión",
    allYourClassesCanSee: "Todas tus clases podrán ver esta misión",
    selectGameToSeeClasses: "Selecciona un segmento para ver las clases",
  },
  infoModal: {
    close: "Cerrar",
    gotIt: "Entendido",
  },
  carousel: {
    previous: "Anterior",
    next: "Siguiente",
  },
  aiMaterialPreview: {
    description: "{{type}} · {{size}}",
    unknownType: "Tipo desconocido",
    imageAlt: "Vista previa de {{name}}",
    pdfTitle: "PDF {{name}}",
    unavailable: "La vista previa no está disponible para este formato.",
    openNewTab: "Abrir en una pestaña nueva",
    openPreview: "Ver {{name}}",
    remove: "Eliminar material {{name}}",
    materialsUsed: "Materiales usados",
  },
  chatIa: {
    titlePlaceholder: "Título de la actividad",
    descriptionPlaceholder: "Una línea explicando de qué se trata",
    deleteCardTitle: "¿Eliminar la tarjeta {{n}}?",
    deleteCardDescription: "El frente y el reverso de esta tarjeta desaparecen. No se puede deshacer.",
    deleteCardCancel: "Mantener la tarjeta",
    copilotSeeAnswer: "Ver qué cambió",
    copilotSendToApply: "Pulsa enviar para aplicar · {{cost}} créditos de IA",
    leaveGuardGeneratingTitle: "La IA todavía está creando",
    leaveGuardGeneratingDescription: "Si sales ahora, se detiene a mitad y los créditos de IA de esta petición no se devuelven.",
    leaveGuardGeneratingStay: "Esperar a que termine",
    leaveGuardUnsentTitle: "¿Salir sin enviar a la clase?",
    leaveGuardUnsentDescription: "Guardamos tu borrador, pero la actividad aún no ha llegado a ningún alumno.",
    deleteQuestionTitle: "¿Eliminar la pregunta {{n}}?",
    deleteQuestionDescription: "La pregunta y sus alternativas desaparecen. No se puede deshacer.",
    deleteQuestionCancel: "Mantener la pregunta",
    deleteQuestionConfirm: "Eliminar",
    copilotTriggerLabel: "Editar con IA",
    stateEditing: "Editando...",
    stateSavedNow: "Guardado",
    stateUnsaved: "Cambios sin guardar",
    leaveGuardTitle: "¿Salir sin guardar?",
    leaveGuardDescription: "Editaste esta actividad y aún no la guardaste. Si sales ahora, los cambios se pierden.",
    leaveGuardStay: "Seguir editando",
    leaveGuardLeave: "Salir de todos modos",
    removeQuestion: "Eliminar esta pregunta",
    discardDraft: "Descartar borrador",
    attachFile: "Adjuntar archivo",
    send: "Enviar",
    // --- GFK-166: copiloto como barra + panel bajo demanda ---
    copilotName: "Profesor Gamefik",
    copilotSubtitleQuiz: "Ajusta este cuestionario",
    copilotSubtitleFlashcard: "Ajusta estas tarjetas",
    copilotSubtitleMissao: "Ajusta esta misión",
    copilotSubtitleTrilha: "Ajusta esta ruta",
    copilotOpenConversation: "Conversación",
    copilotCloseConversation: "Cerrar conversación",
    copilotNewAnswer: "Nueva respuesta del copiloto",
    copilotToolsLabel: "Qué quieres cambiar",
    copilotHistoryLabel: "Conversación",
    copilotCostHint: "Cada petición usa {{cost}} créditos de IA",
    copilotBalance: "Tienes {{balance}}",
    copilotEditPlaceholder: "Pide un cambio. Ej.: haz la pregunta 5 más fácil",
    copilotEditPlaceholderFlashcard: "Pide un cambio. Ej.: añade 2 tarjetas sobre el tema",
    copilotEditPlaceholderMissao: "Pide un cambio. Ej.: acepta vídeo además de foto",
    copilotEditPlaceholderTrilha: "Pide un cambio. Ej.: junta las fases 2 y 3",
    aiChangedBadge: "la IA cambió",
    aiChangedGoTo: "Ir a {{target}}",
    aiChangedTargetQuestion: "la pregunta {{n}}",
    aiChangedTargetCard: "la tarjeta {{n}}",
    aiChangedTargetMission: "la misión",
    aiChangedTargetPhase: "la fase {{n}}",
    useWithClass: "Usar con la clase",
    endOfQuiz: "Fin del cuestionario.",
    endOfFlashcards: "Fin de las tarjetas.",
    endOfMission: "Fin de la misión.",
    reviewedCount: "{{count}} elementos, revisados.",
    draftSavedAuto: "Guardado automáticamente",
    draftSaving: "Guardando...",
    quickChipMoreCards: "+ Más tarjetas",
    quickChipSimpler: "Más simple",
    quickChipChangeProof: "Cambiar el comprobante",
    quickChipChangeReward: "Cambiar la recompensa",
    manualQuizReady: "¡Quiz en blanco listo! Edítalo en el editor y publícalo cuando quieras. Pídeme ayuda por aquí si lo necesitas.",
    manualMissionReady: "¡Misión en blanco lista! Edítala en el editor y publícala cuando quieras. Pídeme ayuda por aquí si lo necesitas.",
    manualQuizToast: "Quiz en blanco creado.",
    manualMissionToast: "Misión en blanco creada.",
    manualFlashcardReady: "¡Mazo de flashcards en blanco listo! Edita las tarjetas en el editor y publica cuando quieras. Pídeme ayuda por aquí si la necesitas.",
    manualFlashcardToast: "Flashcards en blanco creados.",
    heroTitle: "Qué vamos a",
    heroTitleHighlight: "crear hoy?",
    heroSubtitle: "Describe un tema, pega un texto o adjunta material. La IA genera un quiz o una misión listos para editar y guardar.",
    textareaPlaceholder: "Ej: Quiz sobre fotosíntesis para 7o grado con 5 preguntas de opción múltiple...",
    options: "Opciones",
    typeAuto: "Tipo: Auto",
    typeQuiz: "Quiz",
    typeMission: "Misión",
    difficultyAuto: "Dificultad: Auto",
    difficultyChild: "Niños (4-6 años)",
    difficultyElementary1: "Educación Primaria (7-10 años)",
    difficultyElementary2: "ESO (11-14 años)",
    difficultyHighSchool: "Bachillerato",
    difficultyExam: "Nivel Examen",
    difficultyCollege: "Nivel Universidad",
    difficultyPostGrad: "Posgrado",
    questionsAuto: "Preguntas: Auto",
    questionsCount: "{{count}} preguntas",
    typeFlashcard: "Flashcards",
    typeFlashcardVf: "Flashcards V/F",
    retryGeneration: "Intentar de nuevo",
    flashcardVfStatement: "Afirmación",
    flashcardVfExplanation: "Explicación",
    flashcardVfAnswerLabel: "La afirmación es...",
    flashcardVfTrue: "Verdadera",
    flashcardVfFalse: "Falsa",
    flashcardVariantLabel: "Tipo:",
    flashcardVariantClassic: "Reverso",
    flashcardVariantVf: "Verdadero o Falso",
    cardsAuto: "Tarjetas: Auto",
    cardsCount: "{{count}} tarjetas",
    maxCardsReached: "El mazo puede tener como maximo 30 tarjetas.",
    minCards: "El mazo debe mantener al menos una tarjeta.",
    flashcardCards: "Tarjetas del mazo",
    flashcardCardsCount: "{{count}} tarjetas",
    flashcardCardNumber: "Tarjeta {{current}}",
    flashcardOf: "Tarjeta {{current}} de {{total}}",
    flashcardRemoveCard: "Eliminar tarjeta",
    flashcardFront: "Anverso",
    flashcardBack: "Reverso",
    flashcardFrontPlaceholder: "Concepto, termino o pregunta",
    flashcardBackPlaceholder: "Explicacion o respuesta",
    flashcardAddCard: "Agregar tarjeta",
    flashcardTapToFlip: "Toca para girar",
    flashcardPrevCard: "Tarjeta anterior",
    flashcardNextCard: "Siguiente tarjeta",
    flashcardPreviewEmpty: "Agrega tarjetas para previsualizar el mazo.",
    flashcardPublishError: "No fue posible publicar las flashcards: {{message}}",
    flashcardUpdatedSuccess: "¡Flashcards actualizadas con éxito!",
    flashcardNeedsOneCard: "Completa al menos una tarjeta completa (anverso y reverso).",
    languageAuto: "Idioma: Auto",
    languagePtBr: "Portugués (Brasil)",
    languageEnUs: "Inglés",
    languageEsEs: "Español",
    clear: "Limpiar",
    attachPdf: "Adjuntar PDF o imagen",
    createWithAi: "Crear con IA",
    generating: "Generando...",
    processing: "Procesando...",
    connecting: "Conectando con la IA...",
    processingDescription: "Estamos procesando tu solicitud. Esto puede tardar unos segundos...",
    applyingChanges: "Aplicando cambios...",
    phaseRouter: "Analizando intención...",
    phasePlanner: "Planificando operación...",
    phaseExecutor: "Generando contenido...",
    phaseReviewer: "Revisando calidad...",
    phasePatch: "Aplicando cambios...",
    phaseClarification: "Preparando pregunta...",
    phaseDefault: "Iniciando...",
    phaseRouterDesc: "La IA está analizando tu solicitud...",
    phasePlannerDesc: "Definiendo la estrategia para crear o modificar tu actividad...",
    phaseReviewerDesc: "Verificando si el contenido generado cumple con tu solicitud...",
    phasePatchDesc: "Aplicando los cambios en la actividad...",
    phaseClarificationDesc: "Preparando una pregunta de aclaración...",
    fileNotSupported: "El archivo \"{{name}}\" no es compatible.",
    chatTitle: "Chat IA",
    chatSubtitle: "Gamefik IA",
    describeActivity: "Describe tu actividad...",
    quickChipMoreQuestions: "+ Más preguntas",
    quickChipHarder: "Más difícil",
    quickChipEasier: "Más fácil",
    quickChipChangeTheme: "Cambiar tema",
    quickChipAddImages: "Agregar imágenes",
    welcomeMessage: "¡Hola! Describe la actividad que quieres crear o envía materiales en PDF/imagen. Genero un quiz o una misión completos para ti.",
    trailSuggestionTitle: "Parece una ruta",
    trailSuggestionDescription:
      "Las rutas completas (fases con varias actividades) se crean en el editor de rutas. ¿Quieres llevar esta solicitud allí?",
    trailSuggestionGo: "Crear como ruta",
    trailSuggestionStay: "Continuar aquí",
    generatingActivity: "Generando actividad con la IA...",
    unsavedChangesConfirm: "Tienes cambios sin guardar. ¿Salir de todos modos?",
    thinkingWord1: "Pensando",
    thinkingWord2: "Analizando",
    thinkingWord3: "Creando",
    thinkingWord4: "Actuando",
    thinkingWord5: "Organizando",
    activityGenerated: "Actividad generada con éxito.",
    activityGeneratedFallback: "Actividad creada con éxito. Revisa los detalles en el editor de al lado.",
    currentActivityInvalid: "Hubo un problema al cargar la actividad actual. Creando una nueva actividad.",
    noActivityEmpty: "La IA generará la actividad aquí. Comienza describiendo lo que necesitas en el chat.",
    noActivityTitle: "Ninguna actividad generada aún",
    save: "Guardar",
    saving: "Guardando...",
    quiz: "Quiz",
    mission: "Misión",
    tabInfo: "Información",
    tabQuestions: "Preguntas",
    title: "Título",
    description: "Descripción",

    statement: "Enunciado",
    points: "Puntos",
    alternatives: "Alternativas",
    addQuestion: "Agregar pregunta",
    addAlternative: "Agregar alternativa",
    proofType: "Tipo de comprobación",
    proofPhoto: "Foto",
    proofVideo: "Video",
    proofText: "Texto",
    proofFile: "Archivo",
    validationType: "Validación",
    validationAi: "IA",
    validationManual: "Manual",
    validationAuto: "Automática",
    validationAiFull: "IA Automática",
    validationAutoFull: "Auto-validación",
    validationAiDescription: "El alumno envía comprobante y la IA lo valida al instante",
    validationManualDescription: "El alumno envía comprobante y el profesor lo valida",
    validationAutoDescription: "Sin comprobante: el alumno solo confirma la finalización",
    proofPhotoDescription: "Imagen como comprobante",
    proofVideoDescription: "Grabación de video",
    proofTextDescription: "Respuesta escrita",
    proofFileDescription: "PDF o documento",
    missionApprovalSection: "Comprobación y aprobación",
    missionHasProofLabel: "La misión tendrá comprobantes",
    missionHasProofDescription: "El alumno envía una foto como comprobante",
    missionAiApprovalLabel: "Aprobación automática con IA",
    missionTeacherApprovalLabel: "Los profesores pueden aprobar",
    missionTeacherApprovalDescription: "El profesor puede aprobar la misión manualmente, con o sin comprobante",
    missionNoProofHint: "El alumno solo confirma la finalización y recoge la recompensa",
    missionNoProofTeacherHint: "El alumno confirma la finalización y el profesor la aprueba manualmente",
    missionNoProofBadge: "Sin comprobante",
    richTextPhoto: "Foto",
    richTextVideo: "Video",
    richTextPdf: "PDF",
    bold: "Negrita",
    italic: "Cursiva",
    taskSentTitle: "¡Tarea creada!",
    missionSentTitle: "¡Misión creada!",
    taskSentDescription: "Tus alumnos deben descargar la app para realizar esta tarea",
    shareWithStudents: "Comparte el enlace con tus alumnos",
    copyActivityLink: "Copiar enlace de la actividad",
    linkCopied: "¡Enlace copiado!",
    downloadAppTitle: "Descarga la app Gamefik:",
    nextStepsTitle: "Próximos pasos:",
    nextStep1: "Agrega a tus alumnos en Gamefik en la página Clases",
    nextStep2: "Comparte el enlace de acceso",
    nextStep3: "¡Tus alumnos descargan la app y aprenden divirtiéndose!",
    finish: "Finalizar",
    attachmentContext: "Contexto de adjuntos",
    maxQuestionsReached: "Un quiz puede tener como máximo 30 preguntas.",
    minQuestions: "Un quiz debe tener al menos una pregunta.",
    maxAlternatives: "Cada pregunta puede tener como máximo 6 alternativas.",
    minAlternatives: "Cada pregunta debe tener al menos 2 alternativas.",
    generateOrLoad: "Genera o carga una actividad antes de guardar.",
    fillRequired: "Completa todos los campos obligatorios antes de guardar.",
    errorTooManyQuestions: "Demasiadas preguntas",
    errorTooManyQuestionsDesc: "Esta solicitud supero el limite actual de preguntas que la interfaz puede organizar a la vez.",
    errorTooManyQuestionsSuggestion: "Intenta pedir menos preguntas o divide en dos solicitudes.",
    errorApiKeyMissing: "Configuración de IA ausente",
    errorApiKeyMissingDesc: "La clave de IA no está configurada correctamente en este entorno.",
    errorApiKeyMissingSuggestion: "Verifica la configuración de la clave de IA e intenta de nuevo.",
    errorInvalidJson: "Respuesta de IA en formato inesperado",
    errorInvalidJsonDesc: "La respuesta recibida no pudo interpretarse con seguridad.",
    errorInvalidJsonSuggestion: "Intenta de nuevo con una solicitud más específica.",
    errorUnsupportedFile: "Formato de archivo no compatible",
    errorUnsupportedFileDesc: "Actualmente solo se aceptan imagenes y archivos PDF como adjuntos.",
    errorUnsupportedFileSuggestion: "Envia un PDF o una imagen e intenta de nuevo.",
    errorFileTooLarge: "Archivo demasiado grande",
    errorFileTooLargeDesc: "Uno de los adjuntos superó el tamaño máximo permitido.",
    errorFileTooLargeSuggestion: "Reduce el archivo a menos de 50 MB e intenta de nuevo.",
    errorNoContext: "Falta contexto para generar la actividad",
    errorNoContextDesc: "No se envió texto ni adjunto para que la IA trabaje.",
    errorNoContextSuggestion: "Describe la actividad deseada o envia material de apoyo.",
    errorAiFailed: "La IA no pudo completar esta solicitud",
    errorAiFailedDesc: "El sistema intentó refinar la respuesta pero no logró una operación segura para aplicar.",
    errorAiFailedSuggestion: "Reformula la solicitud con más claridad e intenta de nuevo.",
    errorGeneric: "No fue posible completar tu solicitud",
    errorGenericDesc: "Ocurrió un problema durante la generación o edición de la actividad.",
    errorGenericSuggestion: "Intenta de nuevo en un momento o reformula la solicitud.",
    operationCheckingTitle: "Estamos confirmando tu generación",
    operationCheckingDesc: "La conexión se interrumpió, pero la operación aún puede estar en curso.",
    operationCheckingSuggestion: "Espera mientras verificamos el resultado sin generar ni cobrar de nuevo.",
    operationAuthTitle: "Tu sesión debe renovarse",
    operationAuthDesc: "No pudimos confirmar esta generación porque tu sesión expiró o no tiene acceso.",
    operationAuthSuggestion: "Inicia sesión de nuevo o recarga la página. No inicies otra generación mientras tanto.",
    operationInvalidTitle: "No pudimos confirmar esta operación",
    operationInvalidDesc: "La verificación de la generación recibió una solicitud inválida.",
    operationInvalidSuggestion: "Recarga la página antes de intentar generar de nuevo.",
    committedNoResultTitle: "La actividad terminó, pero el resultado no llegó",
    committedNoResultDesc: "Los créditos fueron confirmados, pero esta pantalla no recibió el resultado final.",
    committedNoResultSuggestion: "No vuelvas a generarla ahora. Actualiza la página o revisa tus actividades en unos instantes.",
    noAttachmentContext: "No se usó ningún contexto de adjunto en esta actividad.",
    details: "Detalles",
    clickCircleHint: "haz clic en el círculo para marcar la correcta",
    selectCorrectAnswer: "Selecciona la alternativa correcta",
    questionNumber: "Pregunta {{current}}",
    ofTotal: "de {{total}}",
    removeAlternative: "Eliminar alternativa",
    streamingFailed: "No fue posible completar la generación en streaming.",
    needMoreDetails: "Necesito más detalles para continuar.",
    generateFromAttachment: "Generar actividad a partir del adjunto \"{{name}}\".",
    generateFromAttachments: "Generar actividad usando {{count}} adjuntos enviados.",
    errorGenericFallback: "No fue posible generar la actividad en este momento.",
    back: "Volver",
    chat: "Chat",
    edit: "Editar",
    openChat: "Conversar con la IA",
    closeChat: "Cerrar conversación",
    editActivity: "Editar actividad",
    editMission: "Editar mision",
    newActivity: "Nueva actividad",
    draft: "Borrador",
    updateDraft: "Guardar como borrador",
    publish: "Publicar",
    publishing: "Publicando...",
    preview: "Vista previa",
    invalidEditContext: "Contexto de edicion invalido.",
    editContextNotFound: "No se encontro el contexto de edicion.",
    editContextMismatch: "El contexto de edicion no coincide con la actividad abierta.",
    editLoadFailed: "No se pudo cargar la actividad para editar.",
    attemptLabel: "---- Intento {{count}} ----",
    loadedActivityMismatchQuiz: "La actividad cargada no coincide con el quiz original.",
    loadedActivityMismatchMission: "La actividad cargada no coincide con la mision original.",
    loadedActivityMismatchFlashcard: "La actividad cargada no coincide con los flashcards originales.",
    quizUpdatedSuccess: "Quiz actualizado con exito!",
    missionUpdatedSuccess: "Mision actualizada con exito!",
    quizPublishedSuccess: "Quiz publicado con exito!",
    missionPublishedSuccess: "Mision publicada con exito!",
    insufficientCredits: "Creditos de IA insuficientes. Necesitas {{needed}}, pero solo tienes {{remaining}}.",
    publishErrorFallback: "Error al publicar la actividad. Intentalo de nuevo.",
    teacherCoinLimitPreviewTitle: "Saldo de monedas por clase",
    teacherCoinLimitPreviewDescription: "Revisa el consumo antes de publicar.",
    teacherCoinLimitPreviewValues: "Solicitado: {{requested}} · Saldo: {{remaining}}",
    teacherCoinLimitUnlimited: "Ilimitado",
    teacherCoinLimitDisabled: "Las actividades con monedas están deshabilitadas para los educadores.",
    teacherCoinLimitExceeded: "Una o más clases superan el límite de monedas. Ajusta el valor o las clases para volver a intentarlo.",
    teacherCoinLimitUnavailable: "No fue posible verificar los límites de monedas ahora. Inténtalo de nuevo en unos instantes.",
    turmasWithoutSegmentError: "No se pudo enviar: la(s) clase(s) {{turmas}} no tienen segmento definido o tienen un segmento eliminado. Define un segmento valido para esas clases (en Clases) antes de enviar; de lo contrario los alumnos no reciben la recompensa.",
    draftUpdatedSuccess: "Borrador actualizado con exito!",
    draftSavedSuccess: "Borrador guardado con exito!",
    draftErrorFallback: "Error al guardar el borrador. Intentalo de nuevo.",
    assistantAvatarAlt: "Asistente IA",
    attachAction: "Adjuntar",
    enterToSend: "Enter para enviar",
    createAction: "Crear",
    footerTagline: "Gamefik IA · Creacion inteligente de actividades educativas",
    suggestionCapitals: "Quiz sobre las Siete Maravillas del Mundo",
    suggestionReadingMission: "Mision de lectura en familia",
    suggestionMultiplicationQuiz: "Quiz divertido de multiplicacion",
    suggestionScienceChallenge: "Desafio de ciencias",
    startDateAfterEndDate: "La fecha de inicio no puede ser posterior a la fecha final",
    coverImage: "Imagen de portada",
    coverImageAlt: "Portada",
    addCoverImage: "Agregar imagen de portada",
    chooseFromBank: "Elegir del banco",
    startDate: "Fecha de inicio",
    endDate: "Fecha final",
    selectDate: "Selecciona una fecha",
    continuousMissionLabel: "Misión continua",
    continuousMissionHint: "Puede completarse y aprobarse varias veces por los alumnos.",
    continuousMissionNoDeadline: "Sin plazo (continua)",
    classes: "Clases",
    selectClasses: "Selecciona clases",
    allClasses: "Todas las clases",
    classesSelectedSingle: "1 clase",
    classesSelectedMultiple: "{{count}} clases",
    selectAllClasses: "Seleccionar todas",
    noClassesFound: "No se encontraron clases",
    selectAtLeastOneClass: "Selecciona al menos una clase para publicar.",
    selectEndDate: "Selecciona una fecha límite para publicar.",
    coins: "Monedas",
    coinOptionEasy: "Facil",
    coinOptionMedium: "Medio",
    coinOptionHard: "Dificil",
    customCoinValue: "Valor personalizado",
    coinsLockedTitle: "Recompensas con monedas no disponibles",
    coinsLockedDescription: "Tu plan actual no incluye moneda personalizada. Actualiza para desbloquear la distribución de monedas.",
    coinsLockedCta: "Ver planes",
    coinsInvalidTitle: "Plan con pago pendiente",
    coinsInvalidDescription: "Tu suscripción tiene el pago atrasado o fue cancelada. Regulariza tu plan para distribuir monedas a los alumnos.",
    coinsInvalidCta: "Regularizar plan",
    debugIaButton: "Debug IA",
    debugActive: "activo",
    previewAspectRatioLabel: "Aspecto",
    previewAspectTallPhone: "Alto 9:19.5",
    previewAspectPhone: "Celular 9:16",
    previewAspectTablet: "Tablet 3:4",
    previewAspectSquare: "Cuadrado 1:1",
    previewPreparing: "Preparando vista previa en tiempo real...",
    previewIframeTitle: "Vista previa del quiz en la app del alumno",
    previewEmptyTitle: "Genera una actividad para visualizar",
    previewEmptyDescription: "En cuanto la IA responda, la vista previa del alumno aparecera aqui.",
    previewCorrectFeedback: "Bien! Esa es la alternativa correcta.",
    previewIncorrectFeedback: "Esa no es la correcta. Puedes avanzar igual o cambiar tu respuesta.",
    previewResult: "Resultado: {{correct}} de {{total}} aciertos",
    previewRestart: "Reiniciar vista previa",
    previewNextQuestion: "Siguiente pregunta",
    previewStartHint: "Toca \"Jugar este Quiz\" para iniciar la experiencia del alumno.",
    previewRetake: "Rehacer vista previa",
    previewPlayQuiz: "Jugar este Quiz",
    previewStartMission: "Iniciar mision",
    previewCreatedBy: "Creado por",
    previewTeacherName: "Profesor Gamefik",
    generatingAltThinking: "Shiny pensando",
    generatingAltHappy: "Shiny feliz",
    generatingStepIdeas: "Dibujando ideas...",
    generatingStepCreativity: "Rellenando de creatividad...",
    generatingStepMixing: "Mezclando ingredientes magicos...",
    generatingStepFun: "Anadiendo un poco de diversion...",
    generatingStepKnowledge: "Sazonando con conocimiento...",
    generatingStepSpecialTouch: "Agregando un toque especial...",
    generatingStepShapingQuestions: "Dando forma a las preguntas...",
    generatingStepShining: "Haciendo que todo brille...",
    generatingStepAdjusting: "Ajustando los detalles...",
    generatingStepAlmostDone: "Casi listo...",
    testAsStudent: "Probar como estudiante",
    testAsStudentSubtitle: "Mira la demo de esta actividad",
    openDemo: "Abrir demo",
    sendAsTask: "Enviar como tarea",
    sendAsTaskDescription: "Define una fecha límite. Cada alumno lo hace a su ritmo.",
    playLive: "Jugar en vivo",
    playLiveDescription: "Todos juegan ahora, juntos, desde el celular.",
    comingSoon: "Próximamente",
    present: "Presentar",
    presentDescription: "Tú guías la discusión, los alumnos siguen.",
    backToEditor: "Volver al editor",
    autoSave: "Tus cambios se guardan automáticamente",
    activityReady: "¡Actividad lista!",
    howToUseNow: "¿Cómo quieres usarla ahora?",
    studentPreviewTitle: "Vista previa del alumno",
    studentPreviewSubtitle: "Interactúa con la app de abajo para probarla",
    shinyThumbsUpAlt: "Shiny dando el pulgar arriba",
    quizCreatedTitle: "¡Quiz creado con éxito!",
    missionCreatedTitle: "¡Misión creada con éxito!",
    newQuiz: "Nuevo Quiz",
    newMission: "Nueva Misión",
    activityPublishedDescription: "Tu actividad fue publicada y ya está disponible para los alumnos.",
    viewMyActivities: "Ver mis actividades",
    redirectingIn: "Redirigiendo en {{seconds}}s...",
    selectClassesPlaceholder: "Seleccionar clases",
    add: "Agregar",
    startDateLabel: "Inicio",
    deadlineLabel: "Plazo",
    selectPlaceholder: "Seleccionar",
    classesWillReceive: "Selecciona las clases que recibirán esta actividad",
    sendMission: "Enviar misión",
    sendTask: "Enviar tarea",
    sendTaskDescription: "Configura las opciones de la tarea antes de enviar a los alumnos",
    startLiveSession: "Iniciar sesión en vivo",
    startLiveSessionDescription: "Elige las clases y las monedas antes de iniciar la sesión",
  },
  home: {
    greeting: {
      morning: "Buenos días, {name} 👋",
      afternoon: "Buenas tardes, {name} 👋",
      evening: "Buenas noches, {name} 👋",
      morningNoName: "Buenos días 👋",
      afternoonNoName: "Buenas tardes 👋",
      eveningNoName: "Buenas noches 👋",
      subtitle: "¿Qué vamos a crear hoy?",
    },
    chatBar: {
      placeholder: "✨ Describe lo que quieres crear — la IA hace el resto",
      placeholderMobile: "✨ ¿Qué crear?",
      create: "Crear",
      createWithAi: "Crear con IA ✨",
      attach: "Adjuntar PDF o imagen",
      attachHint: "o arrastra y suelta aquí",
      dropHere: "Suelta para adjuntar",
      suggestionsLabel: "Ejemplos:",
      attachLimit: "Máximo de {count} archivos, {size}MB cada uno",
      typeLabel: "Tipo de actividad",
      suggestion1: "Quiz sobre el sistema solar · 6º grado",
      suggestion2: "Misión de lectura con foto de comprobación",
      expandedPlaceholder: {
        quiz: "¿Sobre qué será tu quiz? Ej.: fracciones para 5º grado, 10 preguntas",
        missao: "¿Cuál será la misión? Ej.: leer un capítulo y enviar foto del resumen",
        flashcard: "¿Sobre qué serán las tarjetas? Ej.: vocabulario de inglés",
        flashcard_vf: "¿Sobre qué serán las afirmaciones? Ej.: hechos de la historia de Brasil",
        trilha: "Describe el recorrido. Ej.: ruta de matemáticas básicas con 5 etapas",
      },
    },
    checklist: {
      title: "Tus primeros pasos",
      progress: "{completed} de {total}",
      dismiss: "Ocultar",
      reopen: "Primeros pasos",
      completeTitle: "¡Tu clase ya puede jugar! 🎉",
      completeSubtitle: "Completaste todos los pasos. Ahora solo queda hacer seguimiento.",
      footer: "Completa los pasos y tu clase estará jugando esta misma semana 🚀",
      heroes: {
        microcopy: "Completa los {total} pasos y libera a los héroes 🔓",
        bubble: "¡Psst! Necesitamos tu ayuda 👀",
        imageAltCaged: "Héroes de Gamefik atrapados en una jaula",
        imageAltFree: "Héroes de Gamefik libres, celebrando",
        imageButtonLabel: "Libera a los héroes de Gamefik",
        modalTitle: "Libera a los héroes de Gamefik",
        modalSpeech:
          "¡Hola, profe! Quedamos atrapados aquí y solo tú puedes liberarnos: completa tus primeros pasos. Hay una recompensa esperando: un descuento exclusivo en el plan Shiny. 🎁",
        modalSpeechSchool:
          "¡Hola! Quedamos atrapados aquí y solo tú puedes liberarnos: completa los primeros pasos y deja tu escuela lista para motivar a los alumnos. 💪",
        modalStepsTitle: "Pasos que faltan",
        rewardLocked: "Completa todo para revelar tu cupón",
        rewardHint: "Cupón de {percent}% de por vida en el plan Shiny",
        modalCta: "Continuar",
        celebrationTitle: "¡Liberaste a los héroes! 🎉",
        celebrationSubtitle:
          "Todos los pasos completos. Toda Gamefik desbloqueada, y te dejaron un regalo:",
        couponNote: "{percent}% de descuento de por vida en el plan Shiny",
        couponCopy: "Copiar",
        couponCopied: "¡Copiado!",
        celebrationCta: "Hazte Shiny",
        completedSubtitle: "Todos los pasos completados. Tu recompensa te está esperando.",
        completedSubtitleSchool: "Todos los pasos completados. ¡Tu escuela está lista para motivar a los alumnos!",
        rewardCta: "Reclamar recompensa",
        rewardCountdown: "Tu recompensa vence en {time}",
        rewardClaimed: "Recompensa reclamada",
        rewardPitch:
          "Desbloqueaste toda Gamefik. Con el plan Shiny tu clase llega aún más lejos: potencial máximo, sin límites.",
      },
      journey: {
        title: "Completa el recorrido y libera a los héroes",
        subtitle: "Libera el potencial máximo de Gamefik y gana un regalo. 🎁",
        subtitleSchool: "Configura tu escuela y libera el potencial máximo de Gamefik.",
        remainingSingle: "¡Falta 1 paso para liberarlos!",
        remainingPlural: "Faltan {count} pasos para liberarlos",
        stepDone: "completado",
        stepCurrent: "paso actual",
        stepLocked: "aún no iniciado",
      },
      topbar: {
        label: "Primeros pasos",
        ariaLabel: "Primeros pasos: {completed} de {total} completados",
        tooltip: "Sigue tus primeros pasos aquí",
        currentStep: "Paso actual",
        continue: "Continuar",
        seeJourney: "Ver recorrido completo",
        rewardCta: "Canjear recompensa",
        rewardClaimed: "Recompensa canjeada",
        celebration: "¡Recorrido completo!",
        celebrationTitle: "¡Tu escuela está lista!",
        celebrationBody: "Todos los primeros pasos completados. Ahora toca motivar a los alumnos.",
      },
      sidebar: {
        bubble1: "holaaa, ¿estás ahí? 👀",
        bubble2: "¡No te olvides de soltarnos! 🔓",
        bubble3: "¡Socorro! Ayúdanos 🙏",
        bubble4: "¡Casi! Sigue así 💪",
        bubble5: "¡Psst! Por aquí 😄",
        bubble6: "¡Creemos en ti! ⭐",
      },
      toast: {
        stepDone: "¡{title} completado!",
        remainingSingle: "Falta 1 paso para liberar a los héroes",
        remainingPlural: "Faltan {count} pasos para liberar a los héroes",
        nextStep: "Siguiente paso",
        allDoneTitle: "¡Liberaste a los héroes!",
        allDoneBody: "Todos los primeros pasos completados.",
        seeCelebration: "Ver celebración",
      },
      emptyState: {
        chip: "Paso {number} del recorrido",
      },
      stepModal: {
        close: "Cerrar",
        watchVideo: "Ver video",
        videoSubtitle: "Tutorial rápido de cómo hacerlo",
        backToSteps: "Volver a los pasos",
        downloadApp: "Descargar la app de Gamefik",
      },
      steps: {
        conta: { title: "Cuenta creada" },
        trilha: {
          title: "Crea tu 1ª ruta",
          cta: "Crear ruta",
          time: "~3 min",
          detail: "Fases, logros y progreso: arma una ruta de aprendizaje y la clase avanza como en un segmento.",
          tutorial1: "Haz clic en Crear ruta (o describe tu idea en el chat)",
          tutorial2: "Dile el tema a la IA y ella arma las fases por ti",
          tutorial3: "Revisa las fases y actividades en el editor",
          tutorial4: "Publica cuando esté lista",
        },
        // Recorrido de la ESCUELA: "atividade_ia" (junto con turma/recompensa/
        // convidar_professores) es un paso del checklist del admin. Ids propios
        // porque el backend siembra los legados en el registro de la escuela.
        atividade_ia: {
          title: "Crea una actividad con IA",
          cta: "Crear con IA",
          time: "~2 min",
          detail: "Describe lo que quieres enseñar y la IA crea la actividad lista para revisar y publicar a tus clases.",
          tutorial1: "Aquí en la home, crea con IA o elige uno de los tipos de actividad. Cuantos más detalles des (tema, grado, número de preguntas), mejor el resultado",
          tutorial2: "Haz clic en Crear y revisa lo que generó la IA. Conversa con ella para refinar preguntas, dificultad o tema",
          tutorial3: "Cuando esté lista, haz clic en Publicar",
          tutorial4: "Elige cómo aplicarla: como tarea (cada alumno a su ritmo), en vivo (todos juntos en clase) o transmitida en pantalla (tú la conduces)",
          tutorial5: "Completa la configuración de inicio y término, valor en coins y clases, y confirma el envío",
        },
        turma: {
          title: "Crea clases y comparte el acceso",
          cta: "Importar clases",
          time: "~3 min",
          detail: "Trae tus clases en minutos: importa la planilla de alumnos y descarga los accesos listos para compartir. Este paso se completa cuando al menos 1 alumno entra con su acceso.",
          tutorial1: "Ve a Clases, haz clic en Importar clases y descarga el modelo de planilla",
          tutorial2: "Completa el modelo con el nombre del alumno y la clase y guárdalo como .csv",
          tutorial3: "Vuelve a la app, sube la planilla completa y confirma en Importar clases",
          tutorial4: "En la pantalla de Clases, haz clic en Seleccionar varias, elige la clase y abre Acceso alumnos en el menú ⋮",
          tutorial5: "Descárgalo en PDF o planilla: viene con usuario, contraseña y código QR de cada alumno para entrar a la app",
        },
        recompensa: {
          title: "Agrega una recompensa",
          cta: "Crear recompensa",
          time: "~2 min",
          detail: "Las recompensas dan valor real a las coins que ganan los alumnos. Es lo que dispara el compromiso.",
          tutorial1: "Ve a Recompensas y haz clic en + Nueva Recompensa",
          tutorial2: "Completa los campos y cuida la foto: las recompensas con imagen atraen muchos más canjes",
          tutorial3: "Define el precio en coins. Si lo necesitas, usa la calculadora para convertir el valor desde tu moneda",
          tutorial4: "Haz clic en Crear Recompensa",
        },
        preview_aluno: {
          title: "Ver cómo lo recibe el alumno",
          cta: "Ver vista previa",
          detail: "Mira exactamente la pantalla que verán tus alumnos en la app, antes de publicar para la clase.",
          tutorial1: "Crea o abre una actividad en el editor",
          tutorial2: "Haz clic en Probar como alumno",
          tutorial3: "Mira la pantalla exacta que verá tu alumno en la app",
          tutorial4: "Ajusta lo que necesites antes de publicar de verdad",
        },
        convidar_professores: {
          title: "Invita a tus profesores",
          cta: "Invitar profesores",
          time: "~1 min",
          detail: "Invita a los profesores de la escuela: cada uno crea actividades con IA y acompaña sus propias clases.",
          tutorial1: "Haz clic en tu nombre de usuario (esquina superior derecha) y abre Configuración",
          tutorial2: "En la pestaña Usuarios, haz clic en + Agregar usuario",
          tutorial3: "Completa el correo, el permiso y las clases a las que el profesor tendrá acceso",
          tutorial4: "Haz clic en Enviar. El profesor recibe por correo un enlace para definir su contraseña y entrar a Gamefik",
        },
        alunos: {
          title: "Importa a tus alumnos",
          cta: "Importar alumnos",
          time: "~2 min",
          detail: "¡Es súper simple! Trae a tu clase en minutos y deja todo listo para jugar.",
          tutorial1: "Ve a Clases y elige (o crea) una clase",
          tutorial2: "Haz clic en Importar alumnos",
          tutorial3: "Pega la lista de nombres o sube la planilla",
          tutorial4: "¡Listo! La clase ya puede recibir rutas y actividades",
        },
        aplicar_turma: {
          title: "Enviar la actividad a la clase",
          cta: "Enviar",
          detail: "Elige la clase y el plazo para que tus alumnos empiecen a jugar.",
          tutorial1: "En el editor de la actividad, haz clic en Publicar",
          tutorial2: "Elige Enviar como tarea",
          tutorial3: "Selecciona la clase y define el plazo",
          tutorial4: "Los alumnos reciben el acceso automáticamente",
        },
        app: {
          title: "Comparte con tus alumnos",
          cta: "Abrir app del alumno",
          time: "~1 min",
          detail: "Muestra el app del alumno y comparte el acceso: así es como la magia llega a la clase.",
          tutorial1: "Pide a tus alumnos que descarguen la app de Gamefik (enlaces abajo)",
          tutorial2: "Abre App del alumno en el menú para ver los accesos de la clase",
          tutorial3: "Copia el acceso individual del alumno, o imprime el de toda la clase",
          tutorial4: "Con la app y el acceso en mano, la clase ya puede jugar",
        },
      },
    },
    types: {
      title: "Crear una actividad",
      quiz: { title: "Quiz", description: "Preguntas y alternativas" },
      missao: { title: "Misión", description: "Desafíos con foto o video" },
      flashcard: { title: "Flashcards", description: "Tarjetas de memorización" },
      flashcard_vf: { title: "V o F", description: "Verdadero o falso rápido" },
    },
    trail: {
      title: "Ruta estilo Duolingo",
      chipLabel: "Ruta",
      subtitle: "Niveles, logros y progreso: la clase aprende avanzando como en un segmento",
      cta: "Crear ruta",
    },
    recent: {
      title: "Sigue a tu clase",
      draft: "Borrador",
      continue: "Continuar",
      review: "Revisar",
      pendingProofsSingle: "{{count}} comprobante para revisar",
      pendingProofsPlural: "{{count}} comprobantes para revisar",
      responsesSingle: "{{count}} respuesta",
      responsesPlural: "{{count}} respuestas",
      viewAll: "Ver todas las actividades",
    },
    celebration: {
      title: "🎉 ¡Tus alumnos empezaron a jugar!",
      subtitle: "{count} alumno(s) ya se unieron a tu ruta.",
      cta: "Ver resultados",
    },
  },
  onboarding: {
    professor: {
      step0: {
        title: "¡Bienvenido a Gamefik!",
        subtitle: "Tu cuenta Free está lista. Crea actividades gamificadas y engancha a tu clase.",
        description: "Mejora a Epic o Shiny cuando quieras para desbloquear todo.",
      },
      stepApp: {
        title: "Una experiencia increíble para tus alumnos",
        descriptionBefore: "Tú creas actividades y tus alumnos se divierten aprendiendo! Al completar las actividades, coleccionan",
        descriptionHighlight: "Leyendas increíbles",
        descriptionAfter: "y ganan monedas para canjear por recompensas.",
      },
      stepAi: {
        title: "Crea Quizzes y Misiones con IA",
        descriptionBefore: "Describe un tema o elige una acción rápida y nuestra",
        descriptionHighlight: "Inteligencia Artificial",
        descriptionAfter: "genera actividades completas en segundos. ¡Quizzes, misiones y mucho más!",
      },
      stepHow: {
        title: "¿Cómo funciona?",
        item1Title: "Agrega clases y alumnos",
        item1Desc: "En la página de Clases, registra tus clases y alumnos",
        item2Title: "Comparte la app",
        item2Desc: "Envía el código de acceso para que los alumnos entren a la app",
        item3Title: "Crea actividades y la magia sucede",
        item3Desc: "Usa la IA para crear quizzes y misiones en segundos",
      },
      step1: {
        title: "¡Casi listo!",
        subtitle: "Dinos qué materia enseñas y ¡empecemos!",
      },
      step2: {
        title: "Completa tu perfil",
        subtitle: "Agrega una foto e ingresa el nombre de tu escuela",
      },
      step3: {
        title: "¡Todo listo! 🎉",
        subtitle: "Explora Gamefik y engancha a tus alumnos de una forma nueva.",
        trialDays: "Tienes {{days}} días de prueba restantes.",
        trialExpired: "Tu prueba ha expirado. Considera actualizar para continuar.",
      },
      subject: {
        matematica: "Matemáticas",
        portugues: "Portugués",
        ciencias: "Ciencias",
        historia: "Historia",
        geografia: "Geografía",
        ingles: "Inglés",
        fisica: "Física",
        quimica: "Química",
        biologia: "Biología",
        ed_fisica: "Ed. Física",
        arte: "Arte",
        outra: "Otra",
      },
      stepFinal: {
        title: "¡Todo listo! ¿Empezamos?",
        subtitle: "Explora Gamefik y engancha a tus alumnos de una forma completamente nueva.",
      },
      btn: {
        start: "Comenzar",
        skip: "Omitir por ahora",
        next: "Siguiente",
        complete: "Finalizar",
        close: "Omitir",
        back: "Volver",
        continue: "Continuar",
        continueIn: "Continuar en {{countdown}}s",
        explore: "Empezar a explorar",
        exploreSolo: "Explorar solo",
      },
      photoOptional: "Foto opcional",
      schoolLabel: "Escuela donde enseñas",
      schoolPlaceholder: "Ej: Colegio Nacional San Martín",
      countryLabel: "País",
      countryPlaceholder: "Selecciona tu país",
      countrySearch: "Buscar país...",
      countryNotFound: "No se encontró ningún país.",
      phoneLabel: "Celular / Teléfono",
      phonePlaceholder: "Número de teléfono",
      phoneOptional: "Opcional",
      phoneInvalid: "Número inválido para el país seleccionado.",
    },
    escola: {
      step1: {
        title: "¡Bienvenido a Gamefik, {{schoolName}}!",
        subtitle: "Tu prueba de {{days}} días ha comenzado. Configuremos todo en pocos minutos.",
        subtitleNoTrial: "Configuremos todo en pocos minutos.",
      },
      step2: {
        title: "Engancha a tus alumnos con Gamefik",
        subtitle: "Misiones con IA y cuestionarios alineados al currículo mejorarán {{schoolGoal}}.",
        card1: "Misiones y cuestionarios creados con IA",
        card2: "Gestión de clases y alumnos",
        card3: "Gamificación para mantener a tus alumnos súper comprometidos",
      },
      step3: {
        title: "¿Listo para activar tu escuela?",
        subtitle: "Hemos preparado una guía rápida paso a paso para comenzar",
      },
      btn: {
        next: "Siguiente",
        back: "Volver",
        start: "Comenzar configuración",
        explore: "Explorar por mi cuenta",
        close: "Cerrar",
      },
    },
    schoolWelcomeModal: {
      defaultSchoolName: "Escuela",
      shinyGifAlt: "Mascota Shiny feliz",
      appExperienceAlt: "Experiencia Gamefik en la app",
      aiCreateAlt: "Creación de actividades con IA",
      classesAlt: "Clases Gamefik",
      teacherIllustrationAlt: "Profesor",
      step1: {
        title: "¡Bienvenido a Gamefik, {{schoolName}}!",
        subtitle: "Tu prueba de {{days}} días ha comenzado. Configuremos todo en pocos minutos.",
      },
      step2: {
        title: "Una experiencia increíble para los alumnos",
        descriptionBefore:
          "Los profesores crean actividades y los alumnos se divierten aprendiendo. Al completarlas, coleccionan",
        descriptionHighlight: "Leyendas increíbles",
        descriptionAfter: "y ganan monedas para canjear por recompensas.",
      },
      step3: {
        title: "Datos que transforman las decisiones",
        descriptionBefore: "Sigue el",
        descriptionHighlight1: "compromiso de los alumnos",
        descriptionMiddle: ", el desempeño de las",
        descriptionHighlight2: "clases y profesores",
        descriptionAfter: ", todo en tiempo real para tomar decisiones basadas en datos.",
        reportAltEngagement: "Compromiso general de los alumnos",
        reportAltClasses: "Comparativo entre clases",
        reportAltTeachers: "Actividad de los profesores",
        reportAltActivities: "Desempeño de las actividades",
        tabEngagement: "Compromiso",
        tabClasses: "Clases",
        tabTeachers: "Profesores",
        tabActivities: "Actividades",
      },
      step4: {
        title: "Creación de actividades con IA",
        descriptionBefore: "Tus profesores podrán crear",
        descriptionHighlight: "Quizzes, Misiones y Flashcards",
        descriptionAfter: "en segundos con nuestra Inteligencia Artificial, ahorrando horas de trabajo.",
      },
      step6: {
        title: "Agrega tus profesores",
        subtitle:
          "Ofrece a tus profesores una herramienta de IA que ahorra tiempo y genera datos valiosos de compromiso para la escuela.",
        benefit1: "Ahorra horas de preparación de clases",
        benefit2: "Datos precisos de compromiso y desempeño",
        benefit3: "Mejora los resultados de aprendizaje",
      },
      step7: {
        title: "¿Listo para activar tu escuela?",
        subtitle:
          "Hemos preparado una guía rápida paso a paso para empezar a transformar la educación en tu escuela.",
      },
      btn: {
        next: "Siguiente",
        back: "Volver",
        continue: "Continuar",
        startSetup: "Comenzar configuración",
        exploreSolo: "Explorar por mi cuenta",
      },
    },
    primeiros_passos: {
      header: {
        title: "Primeros pasos",
        subtitle: "Configura tu cuenta en pocos minutos",
      },
      video: {
        timeLabel: "Tutorial en video - 25 minutos",
        title: "Cómo usar Gamefik",
        playPrompt: "Haz clic para ver el tutorial completo",
        playDesc: "Aprende todo sobre la plataforma en 25 minutos",
        fallbackLabel: "Mira el video de este paso",
      },
      tutorial: { heading: "Paso a paso" },
      checklist: {
        title: "Lista de configuración",
        auto: "Tareas completadas automáticamente por la plataforma",
        done: "¡Felicidades! Todos los pasos han sido completados.",
      },
      celebration: {
        title: "¡Configuración completa!",
        subtitle: "Tu cuenta está lista para usar Gamefik",
      },
      btn: {
        back: "Volver al inicio",
        view: "Ver cómo",
        close: "Cerrar",
      },
      footer: "{{count}} de {{total}} completos",
      steps: {
        alunos: {
          title: "Agrega tus alumnos",
          description: "Crea clases y agrega tus primeros alumnos",
          videoLabel: "Mira cómo crear clases y agregar alumnos",
          tutorial: {
            t1: { title: "Accede a la página de clases", description: "En el menú lateral, haz clic en 'Clases' para acceder a la lista de clases de tu escuela." },
            t2: { title: "Crea una nueva clase y accede a ella", description: "Haz clic en '+ Nueva Clase', completa los datos y luego haz clic en la clase creada para acceder." },
            t3: { title: "Agrega tu primer alumno", description: "Dentro de la clase, haz clic en 'Agregar Alumno' y completa los datos del alumno." },
            t4: { title: "Comparte el código del alumno", description: "Cada alumno recibe un código único de acceso. Compártelo para que ingrese a la plataforma." },
          },
        },
        atividade: {
          title: "Crea tu primera actividad",
          description: "Crea un cuestionario o misión con ayuda de la IA",
          videoLabel: "Aprende a crear actividades increíbles con IA",
          tutorial: {
            t1: { title: "Accede a la página Chat", description: "En el menú lateral, haz clic en 'Chat' para abrir el asistente de creación con IA." },
            t2: { title: "Describe lo que quieres crear hoy", description: "Escribe lo que quieres crear. ¡Cuantos más detalles, mejor el resultado!" },
            t3: { title: "Visualiza y edita la actividad", description: "Después de crear, puedes ver cómo la verán tus alumnos y también puedes editarla." },
            t4: { title: "Ajusta los detalles y publica", description: "Ajusta los detalles en la pestaña de información y publícala para tus alumnos." },
          },
        },
        professores: {
          title: "Invita a tus profesores",
          description: "Agrega otros usuarios a tu escuela",
          videoLabel: "Aprende cómo agregar usuarios a tu escuela",
          tutorial: {
            t1: { title: "Accede a configuración desde tu foto de perfil", description: "Haz clic en tu foto de perfil en la esquina superior derecha y selecciona 'Configuración'." },
            t2: { title: "Accede a la página de usuarios", description: "En el menú de configuración, haz clic en 'Usuarios' para ver la lista de usuarios de la escuela." },
            t3: { title: "Agrega un nuevo usuario", description: "Haz clic en 'Agregar Usuario' para invitar a un nuevo profesor o coordinador." },
            t4: { title: "Completa los campos y confirma", description: "Completa nombre, email y cargo. El usuario agregado recibirá un email para finalizar el registro." },
          },
        },
        app: {
          title: "Accede a la app de los alumnos",
          description: "Mira cómo tus alumnos usarán la plataforma",
          videoLabel: "¡Aprende todo sobre la app del alumno en este video!",
          tutorial: {
            t1: { title: "Tienes 2 formas de ver la experiencia de tus alumnos", description: "Elige la forma más conveniente para explorar la app de los alumnos." },
            t2: { title: "1ª forma: Accede a la página App Alumno desde aquí mismo", description: "En el menú lateral, haz clic en 'App Alumno', selecciona un alumno y espera a que cargue." },
            t3: { title: "2ª forma: Descarga la app Gamefik", description: "Descárgala en Play Store o App Store buscando 'Gamefik'." },
            t4: { title: "Explora las funcionalidades", description: "Explora las funcionalidades y crea actividades para elevar el aprendizaje de tus alumnos." },
          },
        },
      },
    },
  },
  limitModal: {
    limitReachedBadge: "Límite alcanzado",
    limitReachedTitle: "Límite de {{type}} alcanzado",
    classesLimitDesc: "Alcanzaste el límite de {{count}} clases del plano Free.",
    studentsLimitDesc: "Alcanzaste el límite de {{count}} alumnos del plano Free.",
    activitiesLimitDesc: "Alcanzaste el límite de {{count}} actividades por mes del plano Free.",
    aiCreditsLimitDesc: "Usaste todos los {{count}} créditos de IA del plano Free este mes.",
    schoolClassesLimitDesc: "Tu escuela alcanzó el límite de clases del plano Starter. Haz upgrade a Pro para tener clases ilimitadas.",
    schoolStudentsLimitDesc: "Tu escuela alcanzó el límite de {{count}} alumnos del plano Starter. Haz upgrade a Pro o agrega un paquete de +50 alumnos.",
    schoolTeachersLimitDesc: "Tu escuela alcanzó el límite de {{count}} profesores del plano Starter. Haz upgrade a Pro y ten profesores ilimitados.",
    schoolAICreditsLimitDesc: "Tus profesores usaron todos los {{count}} créditos de IA del plano Starter este mes. Agrega el add-on de IA Ilimitada.",
    upgradeToContinue: "Haz upgrade para continuar usando sin límites",
    unlockWith: "Desbloquear con {{plan}}",
    keepCurrentPlan: "Mantén tu plan actual",
    addOnlyWhatYouNeed: "Agrega solo lo que necesitas",
    cancelAnytime: "Cancela cuando quieras",
    addonBadge: "Add-on",
    addon50StudentsName: "+50 Alumnos",
    addon50StudentsDesc: "Agrega 50 alumnos más a tu plan",
    addonUnlimitedAIName: "IA Ilimitada",
    addonUnlimitedAIDesc: "Créditos ilimitados por profesor/mes",
    upgradeToPro: "Hacer upgrade a Pro",
    addAddon: "Agregar {{name}}",
  },
  trialEndedModal: {
    title: "Vaya, {{name}}... tu prueba terminó",
    body: "¡Fueron {{days}} días increíbles juntos! Tus alumnos extrañarán la gamificación completa.",
    statsActivities: "actividades creadas",
    statsStudents: "alumnos comprometidos",
    unlockWith: "Desbloquear con {{plan}}",
  },
  loginTestimonials: {
    badgeLabel: "Testimonios",
    slides: {
      s1: {
        quote: "A los alumnos les encanta cumplir misiones, ganar monedas y subir de nivel. Esto aumentó mucho la participación en las actividades.",
        title: "Profesor de Historia",
      },
      s2: {
        quote: "Gamefik ayuda mucho a mantener a los alumnos enfocados y motivados. Quieren participar y seguir su progreso.",
        title: "Profesora de Ciencias",
      },
      s3: {
        quote: "La gamificación transformó mi aula en un ambiente mucho más dinámico y lleno de aprendizaje significativo.",
        title: "Profesora de Matemáticas",
      },
      s4: {
        quote: "Gamefik ayudó mucho a los profesores en la gestión del aula. Los alumnos estuvieron más atentos y eso redujo bastante el tiempo dedicado a intervenciones pedagógicas y procesos administrativos.",
        title: "Coordinadora Pedagógica – TFLA Idioma",
      },
      s5: {
        quote: "Somos socios de Gamefik desde hace más de 4 años. Cuando empezamos, nuestra escuela tenía unos 80 alumnos y hoy ya superamos los 400. La gamificación se ha convertido en un gran diferencial para las nuevas matrículas y también ha ayudado mucho en la retención de estudiantes.",
        title: "Director del Colegio Alvorecer",
      },
      s6: {
        quote: "Mi hijo se animó mucho más con la escuela después de que empezaron a usar Gamefik. Llega a casa contando las misiones.",
        title: "Madre de un alumno",
      },
    },
  },
  helpChip: {
    label: "Ayuda",
    tourTitle: "Tour guiado",
    tourSubtitle: "Aprende paso a paso",
    videoTitle: "Ver video",
    videoSubtitle: "Tutorial completo",
    helpCenterTitle: "Centro de ayuda",
    helpCenterSubtitle: "Artículos y FAQs",
    videoTitleDefault: "Tutorial en video",
    videoModalSubtitle: "Mira el tutorial completo",
    videoComingSoonTitle: "Video próximamente",
    videoComingSoonDescription: "El tutorial en video de esta página aún está siendo preparado. Mientras tanto, visita el Centro de ayuda para resolver tus dudas.",
    closeAria: "Cerrar",
  },
  interactiveHint: {
    previewBefore: "Esta es la app del alumno.",
    previewEmphasis: "¡Prueba la actividad!",
    arrowJogar: "Haz clic en Jugar",
    arrowEdit: "Edita aquí",
    dismissAria: "Cerrar pista",
  },
  tour: {
    loading: "Cargando...",
    skip: "Saltar tour",
    next: "Siguiente",
    previous: "Anterior",
    finish: "Finalizar",
    stepCounter: "Paso {{current}} de {{total}}",
    mobileNotAvailable: "El tour guiado solo está disponible en escritorio. Ábrelo en una computadora para verlo paso a paso.",
    welcome: {
      defaultTitle: "¡Bienvenido!",
      defaultDescription: "Parece que es tu primera vez aquí. ¿Quieres que te muestre cómo usar esta página?",
      startCta: "Iniciar tour guiado",
      exploreCta: "Explorar por mi cuenta",
    },
    complete: {
      defaultTitle: "¡Felicidades!",
      defaultDescription: "Has terminado el tour de esta página. ¡Ya puedes empezar a usarla!",
      cta: "Empezar a usar",
    },
    chatIa: {
      welcomeTitle: "¡Vamos a crear tu primera actividad!",
      welcomeDescription: "Recorrido rápido del Chat IA — desde generar la actividad hasta publicarla para los alumnos.",
      completeTitle: "¡Listo para crear!",
      completeDescription: "Ya sabes cómo generar una actividad con IA, previsualizarla como un alumno, editar y publicar. ¡A disfrutar!",
      steps: {
        create: {
          title: "Crea con IA",
          description: "Escribe aquí el tema de tu actividad (ej: 'Quiz sobre fotosíntesis para 7º grado') y haz clic en Crear. ¡La IA lo genera todo en segundos! Continúa el tour cuando termine de generar.",
        },
        editWithAi: {
          title: "Edita con IA",
          description: "Una vez generada la actividad, este chat sigue disponible para que pidas ediciones con IA. Prueba: 'más difícil', 'agrega 3 preguntas más', 'cambia el tema a Brasil colonial'.",
        },
        preview: {
          title: "Vista previa",
          description: "Una vez que la IA genere la actividad, este panel muestra exactamente cómo la verá el alumno en la app móvil. Revisa todo antes de publicar.",
        },
        editor: {
          title: "Edita la actividad",
          description: "Haz clic en Editar para ajustar título, descripción, preguntas, alternativas, fechas y monedas. Tienes control total antes de publicar.",
        },
        publish: {
          title: "Publicar",
          description: "Cuando esté listo, haz clic en Publicar para enviar la actividad a las clases que elijas. ¡Los alumnos la verán en la app al instante!",
        },
      },
    },
    classDetail: {
      welcomeTitle: "¡Bienvenido a esta clase!",
      welcomeDescription: "¿Quieres un tour rápido para entender cómo gestionar tus alumnos aquí?",
      completeTitle: "¡Todo listo!",
      completeDescription: "Ya sabes cómo agregar alumnos, otorgar actitudes y compartir acceso. ¡A disfrutar!",
      steps: {
        welcome: {
          title: "Esta es tu clase",
          description: "Aquí gestionas a todos los alumnos de esta clase. Te mostraremos las acciones principales.",
        },
        addStudent: {
          title: "Agregar alumno",
          description: "Haz clic aquí para agregar un alumno. Dentro del modal también puedes hacer clic en 'Importar muchos alumnos' y pegar una lista directamente desde Word o Excel (Ctrl+C / Ctrl+V) para registrar varios a la vez.",
        },
        selectStudent: {
          title: "Seleccionar un alumno",
          description: "Haz clic en la tarjeta de un alumno para seleccionarlo. Aparecerá una marca indicando que está seleccionado. Puedes seleccionar cuantos quieras al mismo tiempo.",
        },
        launch: {
          title: "Otorgar actitudes y puntos",
          description: "Selecciona uno o más alumnos haciendo clic en sus tarjetas y usa este botón para otorgar actitudes, puntos, monedas o logros en masa.",
        },
        shareAccess: {
          title: "Compartir acceso de varios alumnos",
          description: "Selecciona varios alumnos, abre este menú de acciones y elige 'Acceso alumnos'. Generarás las instrucciones de acceso (QR + enlace) de todos los alumnos seleccionados a la vez — perfecto para entregar a los padres.",
        },
        final: {
          title: "¡Listo para empezar!",
          description: "Explora la clase con libertad. Para volver a ver este tour, solo haz clic en 'Ayuda' en la parte superior.",
        },
      },
    },
    classes: {
      welcomeTitle: "¡Bienvenido a Clases!",
      welcomeDescription: "Parece que es tu primera vez aquí. ¿Quieres que te muestre cómo usar esta página?",
      completeTitle: "¡Tour completado!",
      completeDescription: "Ya sabes cómo crear clases, importar alumnos en masa y abrir una clase. ¡Manos a la obra!",
      steps: {
        welcome: {
          title: "¡Bienvenido a Clases!",
          description: "Aquí gestionas todas tus clases y alumnos. Te mostraremos cómo usar cada función.",
        },
        newClass: {
          title: "Crear nueva clase",
          description: "Haz clic aquí para crear una nueva clase. Define el nombre y luego agrega los alumnos.",
        },
        classCard: {
          title: "Abrir una clase",
          description: "Haz clic en cualquier clase para ver los alumnos y gestionarla. Puedes lanzar actividades, agregar alumnos y mucho más.",
        },
        import: {
          title: "Importar clases y alumnos",
          description: "¿Necesitas registrar muchas clases a la vez? Haz clic en Importar, descarga la plantilla, completa con el nombre de la clase y del alumno, y haz el upload. ¡El sistema crea todo automáticamente!",
        },
        final: {
          title: "¡Todo listo!",
          description: "Ahora ya sabes cómo crear e importar clases. ¡Explora la plataforma y empieza a gamificar tus clases!",
        },
      },
    },
  },
  reportsDashboard: reportsDashboardEsES,
  roomTools: roomToolsEsES,
  tooltips: {
    classes: {
      editClass: "Editar el nombre y la configuración de la clase",
      lancarSelected: "Otorga puntos, monedas o logros a los alumnos seleccionados",
      lancarEmpty: "Selecciona alumnos para otorgar",
      moreActions: "Más acciones (acceso, mover, eliminar)",
      copyLink: "Copiar el enlace de acceso de la clase",
      classAccessLink: "Enlace de acceso de la clase",
    },
    chatIa: {
      title: "El título aparece para los alumnos en la app. ¡Sé claro y directo!",
      description: "Describe la actividad con claridad para que el alumno entienda qué hacer",

      coverImage: "Imagen que aparece como portada de la actividad en la app del alumno",
      startDate: "A partir de esta fecha, los alumnos podrán ver e iniciar la actividad",
      endDate: "Después de esta fecha, los alumnos no podrán responder más",
      coins: "Monedas que el alumno gana al completar. ¡Pueden cambiarse por recompensas!",
    },
  },
  onboardingB: {
    welcome: { title: "¡Bienvenido a Gamefik!", subtitle: "Crea clases que realmente enganchan — donde el alumno no quiere parar de aprender.", cta: "¡Vamos!" },
    nome: { eyebrow: "Sobre ti", title: "¿Cuál es tu nombre?", placeholder: "Tu nombre", cta: "Continuar" },
    pais: { eyebrow: "Sobre ti", title: "¿Dónde enseñas?", paisLabel: "País", phoneLabel: "Teléfono (opcional)", phoneHint: "Para avisarte cuando tu clase juegue. Sin spam.", cta: "Continuar" },
    motivacao: { eyebrow: "Cuéntanos", title: "¿Qué es lo que más quieres para tu clase?", engajar: "Enganchar a la clase", engajarSub: "Quiero alumnos participando de verdad", tempo: "Ahorrar tiempo", tempoSub: "Preparar clase en minutos, no horas", resultados: "Seguir resultados", resultadosSub: "Ver quién aprendió, en tiempo real", diversao: "Clase más divertida", diversaoSub: "Convertir el contenido en un juego", comportamento: "Mejorar el comportamiento", comportamentoSub: "Una clase más enfocada y participativa", cta: "Continuar" },
    loop: { eyebrow: "Cómo funciona", title: "De la idea a la actividad publicada en segundos.", subtitle: "Un proceso de aprendizaje personalizado y adaptativo en pocos toques.", step1: "Describe el tema", step1Sub: "En una frase, di qué quieres enseñar.", step2: "La IA crea la actividad", step2Sub: "Preguntas, opciones y corrección — listas.", step3: "Publica para tu clase", step3Sub: "Compártela y sigue los resultados.", cta: "Continuar" },
    alunoApp: { eyebrow: "Tu clase", title: "Juegan la ruta en la app Gamefik.", subtitle: "Para la mejor experiencia, tus alumnos descargan la app Gamefik y avanzan por la ruta como en un juego — puntos, fases y ranking.", storeHint: "Gratis para descargar", cta: "Vamos a crear la tuya" },
    materia: { eyebrow: "Tu asignatura", title: "¿Qué asignatura enseñas?", cta: "Continuar" },
    tema: { eyebrow: "El tema de la ruta", title: "¿Qué va a enseñar la ruta?", placeholder: "Ej: fracciones", hint: "Escribe un tema o toca un ejemplo", cta: "Montar mi ruta" },
    montando: { eyebrow: "Creando tu ruta", title: "Tu ruta de {{tema}} está naciendo.", phasesProgress: "{{done}} de {{total}} etapas generadas", preparing: "Preparando tu ruta…", genErrorHint: "Continúa para finalizar tu registro — podrás crear tus rutas después.", step1: "Ruta", step1Sub: "Las fases del contenido", step2: "Recompensas", step2Sub: "Puntos y logros", step3: "Ranking", step3Sub: "La clase compitiendo", task1: "Creando las fases y actividades…", task1Done: "Fases y actividades creadas", task2: "Generando recompensas y ranking…", task2Done: "Recompensas y ranking listos", task3: "Preparando el enlace para compartir con tus alumnos…", task3Done: "Enlace listo para compartir", cta: "Continuar" },
    mais: { eyebrow: "Hay mucho más", title: "Y hay mucho más para transformar tu aula", subtitle: "En Gamefik creas varios tipos de actividad gamificada para que los alumnos jueguen y aprendan.", atividadesIa: "Crea actividades gamificadas con IA en segundos", gestaoTurmas: "Gestión de clases", relatorios: "Informes pedagógicos", trilhas: "Rutas de aprendizaje", muralTurma: "Muro de la clase", recompensas: "Recompensas", more: "y mucho más", cta: "Continuar" },
    resultados: { eyebrow: "Resultados de verdad", title: "¿Quieres estos resultados para tus alumnos?", statEngajamentoValue: "90%", statEngajamentoLabel: "de compromiso de la clase", statProfessoresValue: "+10 mil", statProfessoresLabel: "profesores ya usan Gamefik", statTempoValue: "+2h", statTempoLabel: "ahorradas por semana", statMelhoraValue: "90%", statMelhoraLabel: "de los alumnos mejoran su desempeño", quote: "La gamificación transformó mi aula en un ambiente mucho más envolvente.", quoteAuthor: "Juliana Martins", quoteRole: "Profesora de Matemáticas", cta: "¡Sí, lo quiero para mi clase!" },
    preview: { eyebrow: "Listo", title: "¡Tu ruta de {{tema}} está lista!", ready: "Lista para publicar", phaseLabel: "Fase {{n}}", studentsHint: "Tus alumnos juegan todo esto en la app Gamefik", cta: "Continuar" },
    planos: { eyebrow: "Desbloquea todo", title: "Prueba Gamefik completa, gratis.", subtitle: "Tarjeta obligatoria. Cancela cuando quieras.", priceSuffix: "/mes", yearlyCaption: "facturado {{price}}/año · ahorra {{percent}}%", cycleMonthly: "Mensual", cycleYearly: "Anual", yearlyBadge: "Mayor ahorro en el anual", shinyName: "Shiny", shinyBadge: "Más completo", shinyTrial: "7 días gratis", shinyCta: "Empezar 7 días gratis", shinyF1: "Clases, alumnos y actividades ilimitados", shinyF2: "IA ilimitada (uso justo)", shinyF3: "Rutas ilimitadas", shinyF4: "Recompensas y moneda personalizada", skip: "Ahora no, ver mi ruta", skipQuiz: "Ahora no, ver mi cuestionario" },
    payoff: {
      gamificacao: {
        eyebrow: "Compromiso de verdad",
        title: "Tus alumnos no querrán dejar de estudiar",
        sub: "Cada actividad da puntos: los alumnos ganan gemas, las cambian por leyendas y desbloquean logros.",
        tarefa: "Completan las tareas",
        gema: "Ganan gemas",
        lenda: "Compran leyendas",
        badge: "Desbloquean logros",
      },
      produtividade: {
        eyebrow: "Menos trabajo, más claridad",
        title: "De la idea a la actividad publicada en segundos",
        sub: "Crea actividades y minijuegos en segundos y observa, en informes, dónde se atasca la clase.",
        relatorios: "Informes que muestran dónde la clase necesita ayuda",
      },
      comportamento: {
        eyebrow: "Una clase más enfocada",
        title: "Refuerza el buen comportamiento",
        sub: "Envía comentarios personalizados y premia a los alumnos que destacan — el estímulo justo, en el momento justo.",
        feedback: "Comentarios personalizados",
        bonificar: "Premia el buen comportamiento",
      },
      cta: "Quiero esto en mi clase",
    },
    criar: {
      eyebrow: "Empecemos",
      title: "¿Creamos tu primera actividad gamificada?",
      cta: "Crear mi actividad",
      trilha: "Ruta estilo Duolingo",
      trilhaSub: "Un recorrido de fases que engancha.",
      quiz: "Quiz",
      quizSub: "Preguntas rápidas para fijar el contenido.",
      flashcard: "Tarjetas",
      flashcardSub: "Memoriza con tarjetas.", emBreveHint: "Las tarjetas llegan pronto — elige Ruta o Quiz para continuar.",
      emBreve: "Próximamente",
    },
    temaQuiz: {
      title: "¿Sobre qué será tu quiz?",
      placeholder: "Ej.: revolución industrial",
      cta: "Montar mi quiz",
    },
    montandoQuiz: {
      eyebrow: "Casi listo",
      title: "Creando tu quiz sobre {{tema}}",
      task1: "Escribiendo las preguntas",
      task1Done: "Preguntas escritas",
      task2: "Armando las alternativas",
      task2Done: "Alternativas listas",
      task3: "Revisando el quiz",
      task3Done: "Quiz revisado",
    },
    previewQuiz: {
      title: "Tu quiz sobre {{tema}} está listo",
      ready: "Listo para publicar",
    },
  },
  liveSession: {
    lobby: {
      exit: "Salir",
      typeMission: "Misión",
      typeQuiz: "Quiz",
      typeFlashcard: "Flashcards",
      coins: "monedas",
      exitFullscreen: "Salir de pantalla completa",
      enterFullscreen: "Pantalla completa",
      joinAt: "Entra en",
      linkCopied: "¡Enlace copiado!",
      copyLink: "Copiar enlace",
      gamePin: "PIN del juego",
      copied: "¡Copiado!",
      copyPin: "Copiar PIN",
      scanToJoin: "Escanea para entrar",
      playerCompleted: "{{count}} jugador completó",
      playersCompleted: "{{count}} jugadores completaron",
      waitingMore: "Esperando más jugadores...",
      waitingPlayers: "Esperando que los jugadores terminen...",
      shareHint: "Comparte el PIN o código QR con la clase",
      finishGame: "Finalizar juego",
      waitAtLeastOne: "Espera al menos 1 jugador para terminar",
    },
    results: {
      back: "Volver",
      finalResult: "Resultado Final",
      podium: "Podio",
      report: "Informe",
    },
    report: {
      noAnswers: "Aún no hay respuestas registradas.",
      title: "Rendimiento por pregunta",
      subtitle: "Todas las preguntas respondidas",
      questionFallback: "Pregunta {{number}}",
      correct: "{{count}} correctas",
      wrong: "{{count}} errores",
      outOf: "de {{count}}",
    },
    podium: {
      defaultName: "Jugador",
    },
  },
} as const;
